
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireddd6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireddd6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("begxM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VNode = module.exports.VNodeMeta = void 0;

var $ceFTv = parcelRequire("ceFTv");

var $f6zvo = parcelRequire("f6zvo");

var $8uN2z = parcelRequire("8uN2z");
var $82cdd5c8e1b1606d$var$VNodeMeta = /** @class */ function() {
    function VNodeMeta() {
        this.children = [];
    }
    return VNodeMeta;
}();
module.exports.VNodeMeta = $82cdd5c8e1b1606d$var$VNodeMeta;
var $82cdd5c8e1b1606d$var$VNode = /** @class */ function(_super) {
    $ceFTv.__extends(VNode, _super);
    function VNode(_b) {
        var e_1, _c, _d, e_2, _e;
        var _this = this;
        var children = _b.children, meta = $ceFTv.__rest(_b, [
            "children"
        ]);
        _this = _super.call(this) || this;
        _this.children = [];
        Object.assign(_this, meta);
        try {
            for(var _f = $ceFTv.__values(children || []), _g = _f.next(); !_g.done; _g = _f.next()){
                var vNode = _g.value;
                (_d = _this.children).push.apply(_d, $ceFTv.__spreadArray([], $ceFTv.__read(_a.isFragment(vNode) ? vNode.children || [] : [
                    vNode
                ]), false));
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _h = $ceFTv.__values(_this.children), _j = _h.next(); !_j.done; _j = _h.next()){
                var child = _j.value;
                child.parent = _this;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_e = _h.return)) _e.call(_h);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var tagName = meta.tagName, is = meta.is, props = meta.props;
        if (!tagName && !(props === null || props === void 0 ? void 0 : props.className) && !is) return _this;
        _this.selector = [
            tagName === null || tagName === void 0 ? void 0 : tagName.toLowerCase(),
            (props === null || props === void 0 ? void 0 : props.className) && ".".concat(props.className.trim().replace(/\s+/, '.')),
            is && "[is=\"".concat(is, "\"]")
        ].filter(Boolean).join('');
        return _this;
    }
    VNode.prototype.walkUp = function() {
        var current;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    current = this;
                    _b.label = 1;
                case 1:
                    if (!(current = current.parent)) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        current
                    ];
                case 2:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.namespaceOf = function(tagName) {
        var e_3, _b;
        if ($8uN2z.XMLNamespace[tagName]) return $8uN2z.XMLNamespace[tagName];
        try {
            for(var _c = $ceFTv.__values(this.walkUp()), _d = _c.next(); !_d.done; _d = _c.next()){
                var namespace = _d.value.namespace;
                if (namespace) return namespace;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return $8uN2z.XMLNamespace.html;
    };
    VNode.prototype.createDOM = function(document1) {
        if (document1 === void 0) document1 = globalThis.document;
        var _b = this, tagName = _b.tagName, is = _b.is, text = _b.text;
        return this.node = text ? document1.createTextNode(text) : !tagName ? document1.createDocumentFragment() : document1.createElementNS(this.namespace || (this.namespace = this.namespaceOf(tagName)), tagName, {
            is: is
        });
    };
    VNode.prototype.toJSON = function() {
        var _b = this, key = _b.key, text = _b.text, selector = _b.selector, namespace = _b.namespace, tagName = _b.tagName, is = _b.is, props = _b.props, style = _b.style, children = _b.children;
        return JSON.parse(JSON.stringify({
            key: key,
            text: text,
            selector: selector,
            namespace: namespace,
            tagName: tagName,
            is: is,
            props: props,
            style: style,
            children: children
        }));
    };
    VNode.prototype.generateElementXML = function() {
        var _b, tagName, props, style, children, node, body, shadowRoots, innerHTML, restProps, _c, _d, _e, _i, key, _f, _g, _h, _j, key, children_1, children_1_1, child, e_4_1;
        var e_4, _k;
        return $ceFTv.__generator(this, function(_l) {
            switch(_l.label){
                case 0:
                    _b = this, tagName = _b.tagName, props = _b.props, style = _b.style, children = _b.children, node = _b.node;
                    if (!(tagName.includes('-') && (0, $8uN2z.elementTypeOf)(tagName) === 'html')) return [
                        3 /*break*/ ,
                        2
                    ];
                    body = ((node === null || node === void 0 ? void 0 : node.ownerDocument) || document).implementation.createHTMLDocument().body;
                    body.innerHTML = "<".concat(tagName, "></").concat(tagName, ">");
                    shadowRoots = $ceFTv.__spreadArray([], $ceFTv.__read((0, $f6zvo.findShadowRoots)(body)), false);
                    return [
                        4 /*yield*/ ,
                        body.getHTML({
                            serializableShadowRoots: true,
                            shadowRoots: shadowRoots
                        })
                    ];
                case 1:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 2:
                    innerHTML = props.innerHTML, restProps = $ceFTv.__rest(props, [
                        "innerHTML"
                    ]);
                    return [
                        4 /*yield*/ ,
                        "<".concat(tagName)
                    ];
                case 3:
                    _l.sent();
                    _c = restProps;
                    _d = [];
                    for(_e in _c)_d.push(_e);
                    _i = 0;
                    _l.label = 4;
                case 4:
                    if (!(_i < _d.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    _e = _d[_i];
                    if (!(_e in _c)) return [
                        3 /*break*/ ,
                        6
                    ];
                    key = _e;
                    return [
                        4 /*yield*/ ,
                        " ".concat(_a.propsMap[key] || key, "=\"").concat(restProps[key], "\"")
                    ];
                case 5:
                    _l.sent();
                    _l.label = 6;
                case 6:
                    _i++;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 7:
                    if (!style) return [
                        3 /*break*/ ,
                        14
                    ];
                    return [
                        4 /*yield*/ ,
                        " style=\""
                    ];
                case 8:
                    _l.sent();
                    _f = style;
                    _g = [];
                    for(_h in _f)_g.push(_h);
                    _j = 0;
                    _l.label = 9;
                case 9:
                    if (!(_j < _g.length)) return [
                        3 /*break*/ ,
                        12
                    ];
                    _h = _g[_j];
                    if (!(_h in _f)) return [
                        3 /*break*/ ,
                        11
                    ];
                    key = _h;
                    return [
                        4 /*yield*/ ,
                        "".concat((0, $8uN2z.toHyphenCase)(key), ":").concat(style[key], ";")
                    ];
                case 10:
                    _l.sent();
                    _l.label = 11;
                case 11:
                    _j++;
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 12:
                    return [
                        4 /*yield*/ ,
                        "\""
                    ];
                case 13:
                    _l.sent();
                    _l.label = 14;
                case 14:
                    if (!innerHTML) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        ">".concat(innerHTML, "</").concat(tagName, ">")
                    ];
                case 15:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 16:
                    if (!children[0]) return [
                        3 /*break*/ ,
                        27
                    ];
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 17:
                    _l.sent();
                    _l.label = 18;
                case 18:
                    _l.trys.push([
                        18,
                        23,
                        24,
                        25
                    ]);
                    children_1 = $ceFTv.__values(children), children_1_1 = children_1.next();
                    _l.label = 19;
                case 19:
                    if (!!children_1_1.done) return [
                        3 /*break*/ ,
                        22
                    ];
                    child = children_1_1.value;
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(child.generateXML())
                    ];
                case 20:
                    _l.sent();
                    _l.label = 21;
                case 21:
                    children_1_1 = children_1.next();
                    return [
                        3 /*break*/ ,
                        19
                    ];
                case 22:
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 23:
                    e_4_1 = _l.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        25
                    ];
                case 24:
                    try {
                        if (children_1_1 && !children_1_1.done && (_k = children_1.return)) _k.call(children_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 25:
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 26:
                    _l.sent();
                    return [
                        3 /*break*/ ,
                        29
                    ];
                case 27:
                    return [
                        4 /*yield*/ ,
                        tagName === 'script' ? '></script>' : ' />'
                    ];
                case 28:
                    _l.sent();
                    _l.label = 29;
                case 29:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.prototype.generateXML = function() {
        var mode;
        return $ceFTv.__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    if (!_a.isFragment(this)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        '<template'
                    ];
                case 1:
                    _b.sent();
                    mode = (this.node || {}).mode;
                    if (!mode) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        " shadowrootmode=\"".concat(mode, "\"")
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    return [
                        4 /*yield*/ ,
                        '>'
                    ];
                case 4:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 5:
                    if (!(this.text != null)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        this.text
                    ];
                case 6:
                    _b.sent();
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(this.generateElementXML())
                    ];
                case 8:
                    _b.sent();
                    _b.label = 9;
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    VNode.isFragment = function(_b) {
        var key = _b.key, node = _b.node, children = _b.children, rest = $ceFTv.__rest(_b, [
            "key",
            "node",
            "children"
        ]);
        for(var key_1 in rest)if (!(0, $8uN2z.isEmpty)(rest[key_1])) return false;
        return true;
    };
    VNode.fromDOM = function(node) {
        var _this = this;
        if (node instanceof Text) return new _a({
            node: node,
            text: node.nodeValue
        });
        if (!(node instanceof Element)) return new _a({
            node: node
        });
        var _b = node, namespaceURI = _b.namespaceURI, tagName = _b.tagName, attributes = _b.attributes, style = _b.style, childNodes = _b.childNodes;
        var vNode = {
            node: node,
            namespace: namespaceURI,
            tagName: tagName.toLowerCase(),
            is: node.getAttribute('is')
        };
        var props = Array.from(attributes, function(_b) {
            var name = _b.name, value = _b.value;
            return name !== 'style' && [
                _this.attrsMap[name] || name,
                value
            ];
        }).filter(Boolean);
        if (props[0]) vNode.props = Object.fromEntries(props);
        var styles = Array.from(style, function(key) {
            return [
                key,
                style[key]
            ];
        });
        if (styles[0]) vNode.style = Object.fromEntries(styles);
        var children = Array.from(childNodes, function(node) {
            return _a.fromDOM(node);
        });
        if (children[0]) vNode.children = children;
        return new _a(vNode);
    };
    var _a;
    _a = VNode;
    VNode.propsMap = {
        httpEquiv: 'http-equiv',
        className: 'class',
        htmlFor: 'for'
    };
    VNode.attrsMap = Object.fromEntries(Object.entries(_a.propsMap).map(function(item) {
        return item.reverse();
    }));
    return VNode;
}($82cdd5c8e1b1606d$var$VNodeMeta);
module.exports.VNode = $82cdd5c8e1b1606d$var$VNode;

});
parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $8e874a2fb001c377$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $8e874a2fb001c377$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $8e874a2fb001c377$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $8e874a2fb001c377$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $8e874a2fb001c377$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $8e874a2fb001c377$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $8e874a2fb001c377$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $8e874a2fb001c377$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("f6zvo", function(module, exports) {
var $aff2f5296aba9eed$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $aff2f5296aba9eed$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $aff2f5296aba9eed$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $aff2f5296aba9eed$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
(function(factory) {
    if (typeof module.exports === "object") {
        var v = factory(undefined, module.exports);
        if (v !== undefined) module.exports = v;
    } else if (typeof define === "function" && define.amd) define([
        "require",
        "exports"
    ], factory);
})(function(require1, exports1) {
    "use strict";
    var _a, _b, _c, _d;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.findShadowRoots = findShadowRoots;
    exports1.generateHTML = generateHTML;
    exports1.getHTML = getHTML;
    exports1.attachDeclarativeShadowRoots = attachDeclarativeShadowRoots;
    exports1.setHTMLUnsafe = setHTMLUnsafe;
    exports1.parseHTMLUnsafe = parseHTMLUnsafe;
    var xmlSerializer = new XMLSerializer(), attachShadow = HTMLElement.prototype.attachShadow, shadowDOMs = new WeakMap();
    HTMLElement.prototype.attachShadow = function(options) {
        var shadowRoot = attachShadow.call(this, options);
        shadowDOMs.set(this, shadowRoot);
        return shadowRoot;
    };
    function findShadowRoots(root) {
        var walker, currentNode, shadowRoot;
        return $aff2f5296aba9eed$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
                        acceptNode: function(node) {
                            return node instanceof HTMLElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
                        }
                    });
                    currentNode = null;
                    _a.label = 1;
                case 1:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        5
                    ];
                    shadowRoot = shadowDOMs.get(currentNode);
                    if (!shadowRoot) return [
                        3 /*break*/ ,
                        4
                    ];
                    return [
                        4 /*yield*/ ,
                        shadowRoot
                    ];
                case 2:
                    _a.sent();
                    return [
                        5 /*yield**/ ,
                        $aff2f5296aba9eed$var$__values(findShadowRoots(shadowRoot))
                    ];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    function generateHTML(root, _a) {
        var walker, currentNode, tagName, attributes, shadowRoot, shadowRootHTML, nextSibling, parentElement;
        var _b = _a === void 0 ? {} : _a, serializableShadowRoots = _b.serializableShadowRoots, shadowRoots = _b.shadowRoots;
        return $aff2f5296aba9eed$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    shadowRoots = (shadowRoots === null || shadowRoots === void 0 ? void 0 : shadowRoots.filter(Boolean)) || [];
                    if (!(!serializableShadowRoots || !shadowRoots[0])) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        root.innerHTML
                    ];
                case 1:
                    _c.sent();
                    return [
                        2 /*return*/ 
                    ];
                case 2:
                    walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, {
                        acceptNode: function(node) {
                            return node === root || node instanceof SVGElement ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
                        }
                    });
                    currentNode = null;
                    _c.label = 3;
                case 3:
                    if (!(currentNode = walker.nextNode())) return [
                        3 /*break*/ ,
                        19
                    ];
                    if (!(currentNode instanceof CDATASection)) return [
                        3 /*break*/ ,
                        5
                    ];
                    return [
                        4 /*yield*/ ,
                        "<![CDATA[".concat(currentNode.nodeValue, "]]>")
                    ];
                case 4:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 5:
                    if (!(currentNode instanceof Text)) return [
                        3 /*break*/ ,
                        7
                    ];
                    return [
                        4 /*yield*/ ,
                        currentNode.nodeValue || ""
                    ];
                case 6:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 7:
                    if (!(currentNode instanceof Comment)) return [
                        3 /*break*/ ,
                        9
                    ];
                    return [
                        4 /*yield*/ ,
                        "<!--".concat(currentNode.nodeValue, "-->")
                    ];
                case 8:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 9:
                    if (!(currentNode instanceof SVGElement)) return [
                        3 /*break*/ ,
                        11
                    ];
                    return [
                        4 /*yield*/ ,
                        xmlSerializer.serializeToString(currentNode)
                    ];
                case 10:
                    _c.sent();
                    return [
                        3 /*break*/ ,
                        16
                    ];
                case 11:
                    if (!(currentNode instanceof Element)) return [
                        3 /*break*/ ,
                        16
                    ];
                    tagName = currentNode.tagName.toLowerCase(), attributes = $aff2f5296aba9eed$var$__spreadArray([], $aff2f5296aba9eed$var$__read(currentNode.attributes), false).map(function(_a) {
                        var name = _a.name, value = _a.value;
                        return "".concat(name, "=").concat(JSON.parse(value));
                    }), shadowRoot = shadowDOMs.get(currentNode);
                    return [
                        4 /*yield*/ ,
                        "<".concat($aff2f5296aba9eed$var$__spreadArray([
                            tagName
                        ], $aff2f5296aba9eed$var$__read(attributes), false).join(" "), ">")
                    ];
                case 12:
                    _c.sent();
                    if (!(shadowRoot && shadowRoots.includes(shadowRoot))) return [
                        3 /*break*/ ,
                        14
                    ];
                    shadowRootHTML = $aff2f5296aba9eed$var$__spreadArray([], $aff2f5296aba9eed$var$__read(generateHTML(shadowRoot, {
                        serializableShadowRoots: serializableShadowRoots,
                        shadowRoots: shadowRoots
                    })), false).join("");
                    return [
                        4 /*yield*/ ,
                        "<template shadowrootmode=\"".concat(shadowRoot.mode, "\">").concat(shadowRootHTML, "</template>")
                    ];
                case 13:
                    _c.sent();
                    _c.label = 14;
                case 14:
                    if (!!currentNode.childNodes[0]) return [
                        3 /*break*/ ,
                        16
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(tagName, ">")
                    ];
                case 15:
                    _c.sent();
                    _c.label = 16;
                case 16:
                    nextSibling = currentNode.nextSibling, parentElement = currentNode.parentElement;
                    if (!(!nextSibling && parentElement && parentElement !== root)) return [
                        3 /*break*/ ,
                        18
                    ];
                    return [
                        4 /*yield*/ ,
                        "</".concat(parentElement.tagName.toLowerCase(), ">")
                    ];
                case 17:
                    _c.sent();
                    _c.label = 18;
                case 18:
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getHTML}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/getHTML}
     */ function getHTML(options) {
        if (options === void 0) options = {};
        return $aff2f5296aba9eed$var$__spreadArray([], $aff2f5296aba9eed$var$__read(generateHTML(this, options)), false).join("");
    }
    function attachDeclarativeShadowRoots(root) {
        var e_1, _a;
        var templates = root.querySelectorAll("template[shadowrootmode]");
        try {
            for(var templates_1 = $aff2f5296aba9eed$var$__values(templates), templates_1_1 = templates_1.next(); !templates_1_1.done; templates_1_1 = templates_1.next()){
                var template = templates_1_1.value;
                var parentElement = template.parentElement, content = template.content;
                var shadowRoot = parentElement.attachShadow({
                    mode: template.getAttribute("shadowrootmode")
                });
                shadowRoot.append(content);
                template.remove();
                attachDeclarativeShadowRoots(shadowRoot);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (templates_1_1 && !templates_1_1.done && (_a = templates_1.return)) _a.call(templates_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setHTMLUnsafe}
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/setHTMLUnsafe}
     */ function setHTMLUnsafe(html) {
        this.innerHTML = html;
        attachDeclarativeShadowRoots(this);
    }
    var domParser = new DOMParser(), initDocument = function(_a) {
        var _b = _a === void 0 ? document : _a, documentElement = _b.documentElement;
        return attachDeclarativeShadowRoots(documentElement);
    };
    /**
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Document/parseHTMLUnsafe_static}
     */ function parseHTMLUnsafe(html) {
        var document1 = domParser.parseFromString(html, "text/html");
        initDocument(document1);
        return document1;
    }
    (_a = Element.prototype).getHTML || (_a.getHTML = getHTML);
    (_b = Element.prototype).setHTMLUnsafe || (_b.setHTMLUnsafe = setHTMLUnsafe);
    (_c = ShadowRoot.prototype).getHTML || (_c.getHTML = getHTML);
    (_d = ShadowRoot.prototype).setHTMLUnsafe || (_d.setHTMLUnsafe = setHTMLUnsafe);
    Document.parseHTMLUnsafe || (Document.parseHTMLUnsafe = parseHTMLUnsafe);
    new Promise(function(resolve) {
        if (document.readyState === "complete") resolve();
        else {
            document.addEventListener("DOMContentLoaded", resolve);
            window.addEventListener("load", resolve);
        }
    }).then(function() {
        return initDocument();
    });
});

});

parcelRegister("8uN2z", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $62f72a7963d2b328$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "toHyphenCase", () => $62f72a7963d2b328$export$3f34ca2fef821bbd);
$parcel$export(module.exports, "toCamelCase", () => $62f72a7963d2b328$export$86f54f62aa7a7514);
$parcel$export(module.exports, "uniqueID", () => $62f72a7963d2b328$export$89912e019eef22aa);
$parcel$export(module.exports, "DiffStatus", () => $62f72a7963d2b328$export$2ddabb89308e1a22);
$parcel$export(module.exports, "diffKeys", () => $62f72a7963d2b328$export$14527669107aa301);
$parcel$export(module.exports, "groupBy", () => $62f72a7963d2b328$export$3f063810d7bf01bd);
$parcel$export(module.exports, "likeArray", () => $62f72a7963d2b328$export$b5a4d6f439a5044d);
$parcel$export(module.exports, "isTypedArray", () => $62f72a7963d2b328$export$b119cc7e1840e59c);
$parcel$export(module.exports, "makeArray", () => $62f72a7963d2b328$export$7b85fd78dd236198);
$parcel$export(module.exports, "splitArray", () => $62f72a7963d2b328$export$697c3df919c0e61a);
$parcel$export(module.exports, "countBy", () => $62f72a7963d2b328$export$1d012a0dff3dab06);
$parcel$export(module.exports, "createAsyncIterator", () => $62f72a7963d2b328$export$86c18c6347f4a8c4);
$parcel$export(module.exports, "Day", () => $62f72a7963d2b328$export$7a9a31a911eb9a20);
$parcel$export(module.exports, "formatDate", () => $62f72a7963d2b328$export$3ae94a2503e890a1);
$parcel$export(module.exports, "changeMonth", () => $62f72a7963d2b328$export$62ad822b3a5fd9a0);
$parcel$export(module.exports, "parseJSON", () => $62f72a7963d2b328$export$27924e57e9afff7f);
$parcel$export(module.exports, "isXDomain", () => $62f72a7963d2b328$export$71e6483fc2b024eb);
$parcel$export(module.exports, "parseURLData", () => $62f72a7963d2b328$export$eb9b2aadbe449a20);
$parcel$export(module.exports, "buildURLData", () => $62f72a7963d2b328$export$13397a83aa5915d6);
$parcel$export(module.exports, "XMLNamespace", () => $62f72a7963d2b328$export$f5a4056b78c72efa);
$parcel$export(module.exports, "templateOf", () => $62f72a7963d2b328$export$2ee022bbbc550b25);
$parcel$export(module.exports, "elementTypeOf", () => $62f72a7963d2b328$export$a549dd5cef7f8327);
$parcel$export(module.exports, "isHTMLElementClass", () => $62f72a7963d2b328$export$8eece510bcb9c62c);
$parcel$export(module.exports, "tagNameOf", () => $62f72a7963d2b328$export$b8a1af58c024fefd);
$parcel$export(module.exports, "stringifyDOM", () => $62f72a7963d2b328$export$b0709844452f8b6b);
$parcel$export(module.exports, "getVisibleText", () => $62f72a7963d2b328$export$be4650432daa84fd);
$parcel$export(module.exports, "importCSS", () => $62f72a7963d2b328$export$7cd14c57bbb84350);
$parcel$export(module.exports, "scrollTo", () => $62f72a7963d2b328$export$3f99968195accfaf);
$parcel$export(module.exports, "formToJSON", () => $62f72a7963d2b328$export$86d7c59254d6a2c9);
$parcel$export(module.exports, "delegate", () => $62f72a7963d2b328$export$10b1921597150314);
$parcel$export(module.exports, "documentReady", () => $62f72a7963d2b328$export$3e2b244719956741);
$parcel$export(module.exports, "serviceWorkerUpdate", () => $62f72a7963d2b328$export$d635d04af3887bbe);
function $62f72a7963d2b328$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $62f72a7963d2b328$var$$9b05bcda60cc529c$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $62f72a7963d2b328$export$61cc6ed0f143570b;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $62f72a7963d2b328$export$dd1bc94b04021eeb;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $62f72a7963d2b328$export$a09f818797e212c4;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $62f72a7963d2b328$export$170f4e08cad8229d;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $62f72a7963d2b328$export$2a489b3f92f4996a;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $62f72a7963d2b328$export$67a6ce548ae77071;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $62f72a7963d2b328$export$a48f0734ac7c2329;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $62f72a7963d2b328$export$3f34ca2fef821bbd;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $62f72a7963d2b328$export$86f54f62aa7a7514;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $62f72a7963d2b328$export$89912e019eef22aa;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $62f72a7963d2b328$export$8fb536984ec8b4d7;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $62f72a7963d2b328$export$94fdf11bafc8de6b;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $62f72a7963d2b328$export$1c8ba402144543e5;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $62f72a7963d2b328$export$2ddabb89308e1a22;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $62f72a7963d2b328$export$14527669107aa301;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $62f72a7963d2b328$export$3f063810d7bf01bd;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $62f72a7963d2b328$export$b5a4d6f439a5044d;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $62f72a7963d2b328$export$b119cc7e1840e59c;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $62f72a7963d2b328$export$7b85fd78dd236198;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $62f72a7963d2b328$export$697c3df919c0e61a;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $62f72a7963d2b328$export$1d012a0dff3dab06;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $62f72a7963d2b328$export$e6b5ff3168b5942b;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $62f72a7963d2b328$export$9cd59f9826255e47;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $62f72a7963d2b328$export$fbc9cd6af26fa64f;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $62f72a7963d2b328$export$69a3209f1a06c04d;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $62f72a7963d2b328$export$86c18c6347f4a8c4;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $62f72a7963d2b328$export$dce9414bed0662c;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $62f72a7963d2b328$export$271f7c16f175f804;
});
var $62f72a7963d2b328$var$$6a9944941b4c1893$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "sum", function() {
    return $62f72a7963d2b328$export$8a63f25cc62965f1;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $62f72a7963d2b328$export$e1f36757ecda301d;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $62f72a7963d2b328$export$8e694e1eafd55acb;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $62f72a7963d2b328$export$57d7c52a66287430;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $62f72a7963d2b328$export$2b4693832ca3ce16;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $62f72a7963d2b328$export$5b784e078da1ce6;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $62f72a7963d2b328$export$17ec9c9f4f23588c;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $62f72a7963d2b328$export$595dbf49c602a1f;
});
function $62f72a7963d2b328$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $62f72a7963d2b328$export$e1f36757ecda301d(...data) {
    return $62f72a7963d2b328$export$8a63f25cc62965f1(...data) / data.length;
}
function $62f72a7963d2b328$export$8e694e1eafd55acb(data, sample = false) {
    const average = $62f72a7963d2b328$export$e1f36757ecda301d(...data);
    const summary = $62f72a7963d2b328$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $62f72a7963d2b328$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($62f72a7963d2b328$export$8e694e1eafd55acb(data, sample));
}
function $62f72a7963d2b328$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($62f72a7963d2b328$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $62f72a7963d2b328$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $62f72a7963d2b328$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $62f72a7963d2b328$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $62f72a7963d2b328$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $62f72a7963d2b328$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $62f72a7963d2b328$export$dd1bc94b04021eeb = (value)=>$62f72a7963d2b328$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $62f72a7963d2b328$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $62f72a7963d2b328$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $62f72a7963d2b328$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $62f72a7963d2b328$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $62f72a7963d2b328$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $62f72a7963d2b328$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $62f72a7963d2b328$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $62f72a7963d2b328$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $62f72a7963d2b328$export$8fb536984ec8b4d7 = (input)=>btoa(String.fromCharCode(...new TextEncoder().encode(input)));
const $62f72a7963d2b328$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.from(atob(input), (char)=>char.charCodeAt(0)));
const $62f72a7963d2b328$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $62f72a7963d2b328$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $62f72a7963d2b328$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $62f72a7963d2b328$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $62f72a7963d2b328$export$b5a4d6f439a5044d(data) {
    if ($62f72a7963d2b328$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $62f72a7963d2b328$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $62f72a7963d2b328$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($62f72a7963d2b328$export$61cc6ed0f143570b(data)) return [];
    if ($62f72a7963d2b328$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $62f72a7963d2b328$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $62f72a7963d2b328$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $62f72a7963d2b328$export$1d012a0dff3dab06(list, iteratee) {
    const group = $62f72a7963d2b328$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $62f72a7963d2b328$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $62f72a7963d2b328$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $62f72a7963d2b328$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $62f72a7963d2b328$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $62f72a7963d2b328$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $62f72a7963d2b328$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $62f72a7963d2b328$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $62f72a7963d2b328$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $62f72a7963d2b328$export$271f7c16f175f804 extends $62f72a7963d2b328$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $62f72a7963d2b328$var$$f872d8bba1c0f79f$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $62f72a7963d2b328$export$c489aa6f7fd82b1a;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $62f72a7963d2b328$export$cbd942915f33be50;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $62f72a7963d2b328$export$9b886f8493244014;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $62f72a7963d2b328$export$e99cbb807a5bb10d;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $62f72a7963d2b328$export$7a9a31a911eb9a20;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $62f72a7963d2b328$export$fca4f8121099df57;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $62f72a7963d2b328$export$6ce2f08d515512;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $62f72a7963d2b328$export$951c8378cdfec6e6;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $62f72a7963d2b328$export$1a4097b876a13bf7;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $62f72a7963d2b328$export$d9bcbd5e1ff81430;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $62f72a7963d2b328$export$506c8e8f8c8edda;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $62f72a7963d2b328$export$3ae94a2503e890a1;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $62f72a7963d2b328$export$7e1c707225b48c34;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $62f72a7963d2b328$export$62ad822b3a5fd9a0;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $62f72a7963d2b328$export$9e85258502147ffb;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $62f72a7963d2b328$export$3c1f2e5bc03748e2;
});
const $62f72a7963d2b328$export$c489aa6f7fd82b1a = 1000;
const $62f72a7963d2b328$export$cbd942915f33be50 = $62f72a7963d2b328$export$c489aa6f7fd82b1a * 60;
const $62f72a7963d2b328$export$9b886f8493244014 = $62f72a7963d2b328$export$cbd942915f33be50 * 15;
const $62f72a7963d2b328$export$e99cbb807a5bb10d = $62f72a7963d2b328$export$9b886f8493244014 * 4;
const $62f72a7963d2b328$export$7a9a31a911eb9a20 = $62f72a7963d2b328$export$e99cbb807a5bb10d * 24;
const $62f72a7963d2b328$export$fca4f8121099df57 = $62f72a7963d2b328$export$7a9a31a911eb9a20 * 7;
const $62f72a7963d2b328$export$6ce2f08d515512 = $62f72a7963d2b328$export$7a9a31a911eb9a20 * 365;
const $62f72a7963d2b328$export$951c8378cdfec6e6 = $62f72a7963d2b328$export$6ce2f08d515512 / 12;
const $62f72a7963d2b328$export$1a4097b876a13bf7 = $62f72a7963d2b328$export$951c8378cdfec6e6 * 3;
class $62f72a7963d2b328$export$d9bcbd5e1ff81430 extends $62f72a7963d2b328$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $62f72a7963d2b328$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $62f72a7963d2b328$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $62f72a7963d2b328$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $62f72a7963d2b328$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $62f72a7963d2b328$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $62f72a7963d2b328$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $62f72a7963d2b328$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $62f72a7963d2b328$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $62f72a7963d2b328$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $62f72a7963d2b328$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const [year, month, day, hour, minute, second, millisecond] = new Date(time).toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $62f72a7963d2b328$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $62f72a7963d2b328$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $62f72a7963d2b328$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $62f72a7963d2b328$export$9e85258502147ffb = (date, unit, delta)=>unit === $62f72a7963d2b328$export$6ce2f08d515512 ? $62f72a7963d2b328$export$7e1c707225b48c34(date, delta) : unit === $62f72a7963d2b328$export$951c8378cdfec6e6 ? $62f72a7963d2b328$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $62f72a7963d2b328$export$6ce2f08d515512,
    7: $62f72a7963d2b328$export$951c8378cdfec6e6,
    10: $62f72a7963d2b328$export$7a9a31a911eb9a20,
    13: $62f72a7963d2b328$export$e99cbb807a5bb10d,
    16: $62f72a7963d2b328$export$cbd942915f33be50,
    19: $62f72a7963d2b328$export$c489aa6f7fd82b1a
};
function $62f72a7963d2b328$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $62f72a7963d2b328$export$9e85258502147ffb(startedAt, $62f72a7963d2b328$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $62f72a7963d2b328$var$$ba0e5dc395660a7c$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $62f72a7963d2b328$export$27924e57e9afff7f;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $62f72a7963d2b328$export$7ea17d45ecdcf634;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $62f72a7963d2b328$export$bb8626e4916f587b;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $62f72a7963d2b328$export$88182f6768071c72;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $62f72a7963d2b328$export$2427785258f88523;
});
function $62f72a7963d2b328$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $62f72a7963d2b328$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $62f72a7963d2b328$export$7ea17d45ecdcf634(raw) {
    const parsed = $62f72a7963d2b328$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
function $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($62f72a7963d2b328$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $62f72a7963d2b328$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$62f72a7963d2b328$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$62f72a7963d2b328$export$1c8ba402144543e5(row, data[0]));
}
const $62f72a7963d2b328$export$88182f6768071c72 = async (raw)=>Array.fromAsync($62f72a7963d2b328$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($62f72a7963d2b328$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $62f72a7963d2b328$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $62f72a7963d2b328$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $62f72a7963d2b328$export$1c8ba402144543e5(row, headerRow) : row;
}
var $62f72a7963d2b328$var$$083124ac4b1a50a0$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $62f72a7963d2b328$export$71e6483fc2b024eb;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $62f72a7963d2b328$export$eb9b2aadbe449a20;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $62f72a7963d2b328$export$13397a83aa5915d6;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $62f72a7963d2b328$export$fd89523fba250fa4;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $62f72a7963d2b328$export$504fbde693c1771c;
});
const $62f72a7963d2b328$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $62f72a7963d2b328$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($62f72a7963d2b328$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $62f72a7963d2b328$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $62f72a7963d2b328$export$b5a4d6f439a5044d(value) ? $62f72a7963d2b328$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $62f72a7963d2b328$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$62f72a7963d2b328$export$dd1bc94b04021eeb(value) && [
            key,
            $62f72a7963d2b328$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $62f72a7963d2b328$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $62f72a7963d2b328$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $62f72a7963d2b328$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $62f72a7963d2b328$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = Uint8Array.from(data, (char)=>char.charCodeAt(0));
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $62f72a7963d2b328$var$$d677628cc2ac1e37$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $62f72a7963d2b328$export$d0eaf3e94be578f6;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $62f72a7963d2b328$export$110700823644f4a6;
});
const $62f72a7963d2b328$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $62f72a7963d2b328$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $62f72a7963d2b328$var$$50872bf213056663$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $62f72a7963d2b328$export$1b9ac4d3de3ffd2e;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$50872bf213056663$exports, "makeSHA", function() {
    return $62f72a7963d2b328$export$d51f3b55e8d1aa73;
});
const $62f72a7963d2b328$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $62f72a7963d2b328$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $62f72a7963d2b328$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $62f72a7963d2b328$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
var $62f72a7963d2b328$var$$93a3089d2937b23f$exports = {};
var $62f72a7963d2b328$var$$3e0a089cc13f69ad$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $62f72a7963d2b328$export$f5a4056b78c72efa;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $62f72a7963d2b328$export$2ee022bbbc550b25;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $62f72a7963d2b328$export$a549dd5cef7f8327;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $62f72a7963d2b328$export$8eece510bcb9c62c;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $62f72a7963d2b328$export$b8a1af58c024fefd;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $62f72a7963d2b328$export$a2cf0d4bb6e06de4;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $62f72a7963d2b328$export$d66b332881d9723f;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $62f72a7963d2b328$export$b0709844452f8b6b;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $62f72a7963d2b328$export$5118471ee5d5453b;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $62f72a7963d2b328$export$6e196edbcc00e5bc;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $62f72a7963d2b328$export$be4650432daa84fd;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $62f72a7963d2b328$export$578e38b4a3e0b255;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $62f72a7963d2b328$export$7cd14c57bbb84350;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $62f72a7963d2b328$export$5100419dfae0456d;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $62f72a7963d2b328$export$28d9d24a8cd0ffc2;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $62f72a7963d2b328$export$3f99968195accfaf;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $62f72a7963d2b328$export$eafdbaa868ea9975;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $62f72a7963d2b328$export$36a0c1ca2ae264fa;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $62f72a7963d2b328$export$86d7c59254d6a2c9;
});
const $62f72a7963d2b328$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $62f72a7963d2b328$var$$3e0a089cc13f69ad$var$templateMap = {};
function $62f72a7963d2b328$export$2ee022bbbc550b25(tagName) {
    if ($62f72a7963d2b328$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $62f72a7963d2b328$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $62f72a7963d2b328$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $62f72a7963d2b328$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $62f72a7963d2b328$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $62f72a7963d2b328$export$8eece510bcb9c62c = (Class)=>$62f72a7963d2b328$export$170f4e08cad8229d(Class, HTMLElement);
const $62f72a7963d2b328$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $62f72a7963d2b328$export$b8a1af58c024fefd(Class) {
    const name = $62f72a7963d2b328$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $62f72a7963d2b328$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $62f72a7963d2b328$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $62f72a7963d2b328$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $62f72a7963d2b328$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $62f72a7963d2b328$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $62f72a7963d2b328$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($62f72a7963d2b328$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $62f72a7963d2b328$export$5118471ee5d5453b(node, type);
}
function $62f72a7963d2b328$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $62f72a7963d2b328$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $62f72a7963d2b328$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $62f72a7963d2b328$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $62f72a7963d2b328$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $62f72a7963d2b328$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$62f72a7963d2b328$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$62f72a7963d2b328$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $62f72a7963d2b328$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $62f72a7963d2b328$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $62f72a7963d2b328$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $62f72a7963d2b328$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $62f72a7963d2b328$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $62f72a7963d2b328$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $62f72a7963d2b328$export$7ea17d45ecdcf634(defaultValue);
                else if ($62f72a7963d2b328$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$62f72a7963d2b328$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $62f72a7963d2b328$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $62f72a7963d2b328$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$62f72a7963d2b328$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $62f72a7963d2b328$var$$bb23e0c794fefbef$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $62f72a7963d2b328$export$e772c8ff12451969;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $62f72a7963d2b328$export$57207d71b8c929c8;
});
function $62f72a7963d2b328$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $62f72a7963d2b328$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $62f72a7963d2b328$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $62f72a7963d2b328$var$$19ed8aeb7905a045$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $62f72a7963d2b328$export$10b1921597150314;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $62f72a7963d2b328$export$3e2b244719956741;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $62f72a7963d2b328$export$1d1d2ed6b55cf67f;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $62f72a7963d2b328$export$2155c0b5a4b77fb8;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $62f72a7963d2b328$export$9d97473344489dfc;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $62f72a7963d2b328$export$d635d04af3887bbe;
});
function $62f72a7963d2b328$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $62f72a7963d2b328$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $62f72a7963d2b328$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $62f72a7963d2b328$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $62f72a7963d2b328$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $62f72a7963d2b328$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $62f72a7963d2b328$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $62f72a7963d2b328$var$$7a08303ce13c49c5$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $62f72a7963d2b328$export$1b88f6b6d432a52a;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $62f72a7963d2b328$export$b70f6380221b1350;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $62f72a7963d2b328$export$75d6cbe4503e149;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $62f72a7963d2b328$export$b2618d51188815c2;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $62f72a7963d2b328$export$490814474ddbb428;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $62f72a7963d2b328$export$3ea201dffb50dfef;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $62f72a7963d2b328$export$d1012c7198c6b460;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $62f72a7963d2b328$export$a35a418b7b17958e;
});
class $62f72a7963d2b328$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $62f72a7963d2b328$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $62f72a7963d2b328$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $62f72a7963d2b328$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $62f72a7963d2b328$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $62f72a7963d2b328$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $62f72a7963d2b328$export$75d6cbe4503e149(type, element)))
    ]);
}
function $62f72a7963d2b328$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $62f72a7963d2b328$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $62f72a7963d2b328$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $62f72a7963d2b328$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $62f72a7963d2b328$export$490814474ddbb428(element, className, display = 'block') {
    return $62f72a7963d2b328$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $62f72a7963d2b328$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $62f72a7963d2b328$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $62f72a7963d2b328$export$d1012c7198c6b460(element, className, remove) {
    return $62f72a7963d2b328$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $62f72a7963d2b328$export$a35a418b7b17958e(element, className, remove) {
    return $62f72a7963d2b328$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $62f72a7963d2b328$var$$69bd9f0117925302$exports = {};
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$69bd9f0117925302$exports, "describe", function() {
    return $62f72a7963d2b328$export$cd5450f3a47e3789;
});
$62f72a7963d2b328$var$$parcel$export($62f72a7963d2b328$var$$69bd9f0117925302$exports, "it", function() {
    return $62f72a7963d2b328$export$3486a10f30cf1ee4;
});
async function $62f72a7963d2b328$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $62f72a7963d2b328$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$62f72a7963d2b328$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});


parcelRegister("bGdIT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOMRenderer = void 0;

var $ceFTv = parcelRequire("ceFTv");
parcelRequire("8BuuC");

var $blFED = parcelRequire("blFED");

var $8uN2z = parcelRequire("8uN2z");

var $begxM = parcelRequire("begxM");
var $880e4313be73e0b7$var$DOMRenderer = /** @class */ function() {
    function DOMRenderer() {
        var _this = this;
        this.eventPattern = /^on[A-Z]/;
        this.ariaPattern = /^aira[A-Z]/;
        this.document = globalThis.document;
        this.treeCache = new WeakMap();
        this.signalCache = new WeakMap();
        this.keyOf = function(_a, index) {
            var key = _a.key, text = _a.text, props = _a.props, selector = _a.selector;
            return (key === null || key === void 0 ? void 0 : key.toString()) || (props === null || props === void 0 ? void 0 : props.id) || (text || selector || '') + index;
        };
        this.vNodeOf = function(list, key) {
            return list.find(function(vNode, index) {
                return "".concat(_this.keyOf(vNode, index)) === String(key);
            });
        };
        this.propsKeyOf = function(key) {
            return key.startsWith('aria-') ? (0, $8uN2z.toCamelCase)(key) : _this.eventPattern.test(key) ? key.toLowerCase() : key;
        };
        this.attrsNameOf = function(key) {
            return $begxM.VNode.propsMap[key] || key;
        };
        this.removeProperty = function(node, key) {
            return _this.eventPattern.test(key) ? node[key.toLowerCase()] = null : node.removeAttribute(_this.ariaPattern.test(key) ? (0, $8uN2z.toHyphenCase)(key) : _this.attrsNameOf(key));
        };
        this.setProperty = function(node, key, value) {
            var isXML = (0, $8uN2z.templateOf)(node.tagName) && (0, $8uN2z.elementTypeOf)(node.tagName) === 'xml';
            if (isXML || key.includes('-')) node.setAttribute(_this.attrsNameOf(key), value);
            else try {
                var name_1 = _this.propsKeyOf(key);
                if (_this.eventPattern.test(key) && !(name_1 in node)) _this.handleCustomEvent(node, name_1.slice(2));
                node[name_1] = value;
            } catch (_a) {
                node.setAttribute(_this.attrsNameOf(key), value);
            }
        };
    }
    DOMRenderer.prototype.updateProps = function(node, oldProps, newProps, onDelete, onAdd) {
        var e_1, _a, e_2, _b;
        if (oldProps === void 0) oldProps = {};
        if (newProps === void 0) newProps = {};
        var group = (0, $8uN2z.diffKeys)(Object.keys(oldProps), Object.keys(newProps)).group;
        try {
            for(var _c = $ceFTv.__values(group[$8uN2z.DiffStatus.Old] || []), _d = _c.next(); !_d.done; _d = _c.next()){
                var _e = $ceFTv.__read(_d.value, 1), key = _e[0];
                onDelete === null || onDelete === void 0 || onDelete(node, key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var _f = $ceFTv.__values($ceFTv.__spreadArray($ceFTv.__spreadArray([], $ceFTv.__read(group[$8uN2z.DiffStatus.Same] || []), false), $ceFTv.__read(group[$8uN2z.DiffStatus.New] || []), false)), _g = _f.next(); !_g.done; _g = _f.next()){
                var _h = $ceFTv.__read(_g.value, 1), key = _h[0];
                if (oldProps[key] !== newProps[key]) {
                    if (onAdd instanceof Function) onAdd(node, key, newProps[key]);
                    else Reflect.set(node, key, newProps[key]);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    DOMRenderer.prototype.deleteNode = function(_a) {
        var ref = _a.ref, node = _a.node, children = _a.children;
        if (node instanceof DocumentFragment) children === null || children === void 0 || children.forEach(this.deleteNode);
        else if (node) {
            node.remove();
            ref === null || ref === void 0 || ref();
        }
    };
    DOMRenderer.prototype.commitChild = function(root, node, index) {
        if (index === void 0) index = 0;
        var targetNode = root.childNodes[index];
        if (targetNode === node) return;
        if (!targetNode) root.append(node);
        else targetNode.before(node);
    };
    DOMRenderer.prototype.diffVChildren = function(oldVNode, newVNode) {
        var _a, map, group, deletingGroup, _b, _c, _d, index, newVChild, key, oldVChild, e_3_1, _e, _f, _g, _i, selector, _h, _j, oldVNode_1, e_4_1;
        var e_3, _k, e_4, _l;
        var _this = this;
        var _m;
        return $ceFTv.__generator(this, function(_o) {
            switch(_o.label){
                case 0:
                    newVNode.children = newVNode.children.map(function(vNode) {
                        return new $begxM.VNode(vNode);
                    });
                    _a = (0, $8uN2z.diffKeys)(oldVNode.children.map(this.keyOf), newVNode.children.map(this.keyOf)), map = _a.map, group = _a.group;
                    deletingGroup = group[$8uN2z.DiffStatus.Old] && (0, $8uN2z.groupBy)(group[$8uN2z.DiffStatus.Old].map(function(_a) {
                        var _b = $ceFTv.__read(_a, 1), key = _b[0];
                        return _this.vNodeOf(oldVNode.children, key);
                    }), function(_a) {
                        var selector = _a.selector;
                        return selector + '';
                    });
                    _o.label = 1;
                case 1:
                    _o.trys.push([
                        1,
                        7,
                        8,
                        9
                    ]);
                    _b = $ceFTv.__values(newVNode.children.entries()), _c = _b.next();
                    _o.label = 2;
                case 2:
                    if (!!_c.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    _d = $ceFTv.__read(_c.value, 2), index = _d[0], newVChild = _d[1];
                    key = this.keyOf(newVChild, index);
                    oldVChild = map[key] === $8uN2z.DiffStatus.Same ? this.vNodeOf(oldVNode.children, key) : (_m = deletingGroup === null || deletingGroup === void 0 ? void 0 : deletingGroup[newVChild.selector]) === null || _m === void 0 ? void 0 : _m.shift();
                    return [
                        4 /*yield*/ ,
                        {
                            index: index,
                            oldVNode: oldVChild,
                            newVNode: newVChild
                        }
                    ];
                case 3:
                    _o.sent();
                    if (!((oldVChild === null || oldVChild === void 0 ? void 0 : oldVChild.children[0]) || newVChild.children[0])) return [
                        3 /*break*/ ,
                        5
                    ];
                    oldVChild || (oldVChild = new $begxM.VNode($ceFTv.__assign($ceFTv.__assign({}, newVChild), {
                        children: []
                    })));
                    return [
                        5 /*yield**/ ,
                        $ceFTv.__values(this.diffVChildren(oldVChild, newVChild))
                    ];
                case 4:
                    _o.sent();
                    _o.label = 5;
                case 5:
                    _c = _b.next();
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_3_1 = _o.sent();
                    e_3 = {
                        error: e_3_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_c && !_c.done && (_k = _b.return)) _k.call(_b);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    _e = deletingGroup;
                    _f = [];
                    for(_g in _e)_f.push(_g);
                    _i = 0;
                    _o.label = 10;
                case 10:
                    if (!(_i < _f.length)) return [
                        3 /*break*/ ,
                        19
                    ];
                    _g = _f[_i];
                    if (!(_g in _e)) return [
                        3 /*break*/ ,
                        18
                    ];
                    selector = _g;
                    _o.label = 11;
                case 11:
                    _o.trys.push([
                        11,
                        16,
                        17,
                        18
                    ]);
                    _h = (e_4 = void 0, $ceFTv.__values(deletingGroup[selector])), _j = _h.next();
                    _o.label = 12;
                case 12:
                    if (!!_j.done) return [
                        3 /*break*/ ,
                        15
                    ];
                    oldVNode_1 = _j.value;
                    return [
                        4 /*yield*/ ,
                        {
                            oldVNode: oldVNode_1
                        }
                    ];
                case 13:
                    _o.sent();
                    _o.label = 14;
                case 14:
                    _j = _h.next();
                    return [
                        3 /*break*/ ,
                        12
                    ];
                case 15:
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 16:
                    e_4_1 = _o.sent();
                    e_4 = {
                        error: e_4_1
                    };
                    return [
                        3 /*break*/ ,
                        18
                    ];
                case 17:
                    try {
                        if (_j && !_j.done && (_l = _h.return)) _l.call(_h);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 18:
                    _i++;
                    return [
                        3 /*break*/ ,
                        10
                    ];
                case 19:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    DOMRenderer.prototype.handleCustomEvent = function(node, event) {
        var handler;
        Object.defineProperty(node, "on".concat(event), {
            set: function(value) {
                if (handler) node.removeEventListener(event, handler);
                node.addEventListener(event, handler = value);
            },
            get: function() {
                return handler;
            }
        });
    };
    DOMRenderer.prototype.patchNode = function(oldVNode, newVNode) {
        this.updateProps(oldVNode.node, oldVNode.props, newVNode.props, this.removeProperty, this.setProperty);
        this.updateProps(oldVNode.node.style, oldVNode.style, newVNode.style, function(style, key) {
            return style.removeProperty((0, $8uN2z.toHyphenCase)(key));
        }, function(style, key, value) {
            return style.setProperty((0, $8uN2z.toHyphenCase)(key), value);
        });
        newVNode.node || (newVNode.node = oldVNode.node);
        return newVNode;
    };
    DOMRenderer.prototype.generateDOM = function(oldVRoot, newVRoot) {
        var _a, _b, _c, index, oldVNode, newVNode, inserting, tagName, node, parent_1, e_5_1;
        var e_5, _d;
        var _e;
        return $ceFTv.__generator(this, function(_f) {
            switch(_f.label){
                case 0:
                    if ($begxM.VNode.isFragment(newVRoot)) newVRoot = new $begxM.VNode($ceFTv.__assign($ceFTv.__assign({}, oldVRoot), {
                        children: newVRoot.children
                    }));
                    return [
                        4 /*yield*/ ,
                        this.patchNode(oldVRoot, newVRoot)
                    ];
                case 1:
                    _f.sent();
                    _f.label = 2;
                case 2:
                    _f.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _a = $ceFTv.__values(this.diffVChildren(oldVRoot, newVRoot)), _b = _a.next();
                    _f.label = 3;
                case 3:
                    if (!!_b.done) return [
                        3 /*break*/ ,
                        6
                    ];
                    _c = _b.value, index = _c.index, oldVNode = _c.oldVNode, newVNode = _c.newVNode;
                    if (!newVNode) {
                        this.deleteNode(oldVNode);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    }
                    inserting = !oldVNode;
                    if (oldVNode) newVNode.node = oldVNode.node;
                    else {
                        newVNode.createDOM(this.document);
                        tagName = newVNode.tagName, node = newVNode.node, parent_1 = newVNode.parent;
                        oldVNode = new $begxM.VNode({
                            tagName: tagName,
                            node: node,
                            parent: parent_1
                        });
                    }
                    if (newVNode.text) oldVNode.node.nodeValue = newVNode.text;
                    else if (!$begxM.VNode.isFragment(newVNode)) this.patchNode(oldVNode, newVNode);
                    if (oldVNode.parent) {
                        this.commitChild(oldVNode.parent.node, newVNode.node, index);
                        if (inserting) (_e = newVNode.ref) === null || _e === void 0 || _e.call(newVNode, newVNode.node);
                    }
                    return [
                        4 /*yield*/ ,
                        newVNode
                    ];
                case 4:
                    _f.sent();
                    _f.label = 5;
                case 5:
                    _b = _a.next();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 6:
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 7:
                    e_5_1 = _f.sent();
                    e_5 = {
                        error: e_5_1
                    };
                    return [
                        3 /*break*/ ,
                        9
                    ];
                case 8:
                    try {
                        if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                    return [
                        7 /*endfinally*/ 
                    ];
                case 9:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    };
    DOMRenderer.prototype.patch = function(oldVRoot, newVRoot) {
        var e_6, _a;
        var count = 0;
        try {
            for(var _b = $ceFTv.__values(this.generateDOM(oldVRoot, newVRoot)), _c = _b.next(); !_c.done; _c = _b.next()){
                var newVNode = _c.value;
                if (++count === 1) newVRoot = newVNode;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return newVRoot;
    };
    DOMRenderer.prototype.patchAsync = function(oldVRoot, newVRoot) {
        return $ceFTv.__awaiter(this, void 0, void 0, function() {
            var oldController, controller, count, _a, _b, newVNode, e_7_1;
            var e_7, _c;
            return $ceFTv.__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        oldController = this.signalCache.get(oldVRoot.node);
                        if (oldController) {
                            oldController.abort();
                            oldVRoot = $begxM.VNode.fromDOM(oldVRoot.node);
                        }
                        controller = new AbortController();
                        this.signalCache.set(oldVRoot.node, controller);
                        count = 0;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _a = $ceFTv.__values(this.generateDOM(oldVRoot, newVRoot)), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        newVNode = _b.value;
                        if (++count === 1) newVRoot = newVNode;
                        return [
                            4 /*yield*/ ,
                            scheduler.yield()
                        ];
                    case 3:
                        _d.sent();
                        if (controller.signal.aborted) {
                            this.signalCache.delete(oldVRoot.node);
                            controller.signal.throwIfAborted();
                        }
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_7_1 = _d.sent();
                        e_7 = {
                            error: e_7_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        } finally{
                            if (e_7) throw e_7.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        this.signalCache.delete(oldVRoot.node);
                        return [
                            2 /*return*/ ,
                            newVRoot
                        ];
                }
            });
        });
    };
    DOMRenderer.prototype.render = function(vNode, node, mode) {
        var _this = this;
        var _a;
        if (node === void 0) node = (_a = globalThis.document) === null || _a === void 0 ? void 0 : _a.body;
        if (mode === void 0) mode = 'sync';
        this.document = node.ownerDocument;
        var root = this.treeCache.get(node) || $begxM.VNode.fromDOM(node);
        var done = function(root) {
            return _this.treeCache.set(node, root) && root;
        };
        return mode === 'sync' ? done(this.patch(root, new $begxM.VNode($ceFTv.__assign($ceFTv.__assign({}, root), {
            children: [
                vNode
            ]
        })))) : this.patchAsync(root, new $begxM.VNode($ceFTv.__assign($ceFTv.__assign({}, root), {
            children: [
                vNode
            ]
        }))).then(done);
    };
    DOMRenderer.prototype.renderToStaticMarkup = function(tree) {
        return $ceFTv.__spreadArray([], $ceFTv.__read(tree.generateXML()), false).join('');
    };
    DOMRenderer.prototype.renderToReadableStream = function(tree) {
        return $blFED.ReadableStream.from(tree.generateXML());
    };
    return DOMRenderer;
}();
module.exports.DOMRenderer = $880e4313be73e0b7$var$DOMRenderer;

});
parcelRegister("8BuuC", function(module, exports) {
!function() {
    var t = [
        "user-blocking",
        "user-visible",
        "background"
    ];
    class i {
        constructor(){
            this.t = new MessageChannel, this.i = this.t.port2, this.l = {}, this.o = 1, this.t.port1.onmessage = (t)=>this.h(t);
        }
        u(t) {
            var i = this.o++;
            return this.l[i] = t, this.i.postMessage(i), i;
        }
        p(t) {
            delete this.l[t];
        }
        h(t) {
            var i = t.data;
            if (i in this.l) {
                var r = this.l[i];
                delete this.l[i], r();
            }
        }
    }
    function r() {
        return r.v || (r.v = new i), r.v;
    }
    class s {
        constructor(t, i, r){
            void 0 === r && (r = 0), this.k = t, this.T = null, this.C = null, this.m = !1, this._(i, r);
        }
        isIdleCallback() {
            return 0 === this.T;
        }
        I() {
            return 2 === this.T;
        }
        cancel() {
            if (!this.m) switch(this.m = !0, this.T){
                case 0:
                    cancelIdleCallback(this.C);
                    break;
                case 1:
                    clearTimeout(this.C);
                    break;
                case 2:
                    r().p(this.C);
                    break;
                default:
                    throw new TypeError("Unknown CallbackType");
            }
        }
        _(i, s) {
            if (s && s > 0) return this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            }, s));
            if (!t.includes(i)) throw new TypeError("Invalid task priority : " + i);
            return "background" === i && "function" == typeof requestIdleCallback ? (this.T = 0, void (this.C = requestIdleCallback(()=>{
                this.P();
            }))) : "function" == typeof MessageChannel ? (this.T = 2, void (this.C = r().u(()=>{
                this.P();
            }))) : (this.T = 1, void (this.C = setTimeout(()=>{
                this.P();
            })));
        }
        P() {
            this.m || this.k();
        }
    }
    var e = 0;
    class n {
        constructor(){
            this.j = null, this.M = null;
        }
        isEmpty() {
            return null == this.j;
        }
        push(t) {
            if ("object" != typeof t) throw new TypeError("Task must be an Object");
            t.A = e++, this.isEmpty() ? (t.N = null, this.j = t) : (t.N = this.M, this.M.O = t), t.O = null, this.M = t;
        }
        takeNextTask() {
            if (this.isEmpty()) return null;
            var t = this.j;
            return this.q(t), t;
        }
        merge(t, i) {
            if ("function" != typeof i) throw new TypeError("Must provide a selector function.");
            if (null == t) throw new Error("sourceQueue cannot be null");
            for(var r = this.j, s = null, e = t.j; e;){
                var n = e;
                if (e = e.O, i(n)) {
                    for(t.q(n); r && r.A < n.A;)s = r, r = r.O;
                    this.D(n, s), s = n;
                }
            }
        }
        D(t, i) {
            if (i != this.M) {
                var r = i ? i.O : this.j;
                t.O = r, r.N = t, t.N = i, null != i ? i.O = t : this.j = t;
            } else this.push(t);
        }
        q(t) {
            if (null == t) throw new Error("Expected task to be non-null");
            t === this.j && (this.j = t.O), t === this.M && (this.M = this.M.N), t.O && (t.O.N = t.N), t.N && (t.N.O = t.O);
        }
    }
    class l extends Event {
        constructor(i, r){
            if (!r || !t.includes(r.previousPriority)) throw new TypeError("Invalid task priority: '" + r.previousPriority + "'");
            super(i), this.previousPriority = r.previousPriority;
        }
    }
    class o extends AbortController {
        constructor(i){
            if (void 0 === i && (i = {}), super(), null == i && (i = {}), "object" != typeof i) throw new TypeError("'init' is not an object");
            var r, s, e = void 0 === i.priority ? "user-visible" : i.priority;
            if (!t.includes(e)) throw new TypeError("Invalid task priority: '" + e + "'");
            this.H = e, this.R = !1, s = (r = this).signal, Object.defineProperties(s, {
                priority: {
                    get: function() {
                        return r.H;
                    },
                    enumerable: !0
                },
                onprioritychange: {
                    value: null,
                    writable: !0,
                    enumerable: !0
                }
            }), s.addEventListener("prioritychange", (t)=>{
                s.onprioritychange && s.onprioritychange(t);
            });
        }
        setPriority(i) {
            if (!t.includes(i)) throw new TypeError("Invalid task priority: " + i);
            if (this.R) throw new DOMException("", "NotAllowedError");
            if (this.signal.priority !== i) {
                this.R = !0;
                var r = this.H;
                this.H = i;
                var s = new l("prioritychange", {
                    previousPriority: r
                });
                this.signal.dispatchEvent(s), this.R = !1;
            }
        }
    }
    void 0 === self.scheduler ? (self.scheduler = new class {
        constructor(){
            this.S = {}, t.forEach((t)=>{
                this.S[t] = [
                    new n,
                    new n
                ];
            }), this.U = null, this.W = new WeakMap;
        }
        yield() {
            return this.B(()=>{}, {
                priority: "user-visible"
            }, !0);
        }
        postTask(t, i) {
            return this.B(t, i, !1);
        }
        B(i, r, s) {
            if (void 0 !== (r = Object.assign({}, r)).signal) {
                if (null === r.signal || !("aborted" in r.signal) || "function" != typeof r.signal.addEventListener) return Promise.reject(new TypeError("'signal' is not a valid 'AbortSignal'"));
                if (r.signal && r.signal.priority && !t.includes(r.signal.priority)) return Promise.reject(new TypeError("Invalid task priority: '" + r.signal.priority + "'"));
            }
            if (void 0 !== r.priority && (null === r.priority || !t.includes(r.priority))) return Promise.reject(new TypeError("Invalid task priority: '" + r.priority + "'"));
            if (void 0 === r.delay && (r.delay = 0), r.delay = Number(r.delay), r.delay < 0) return Promise.reject(new TypeError("'delay' must be a positive number."));
            var e = {
                callback: i,
                options: r,
                resolve: null,
                reject: null,
                hostCallback: null,
                abortCallback: null,
                onTaskCompleted: function() {
                    this.options.signal && this.abortCallback && (this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null);
                },
                onTaskAborted: function() {
                    this.hostCallback && (this.hostCallback.cancel(), this.hostCallback = null), this.options.signal.removeEventListener("abort", this.abortCallback), this.abortCallback = null, this.reject(this.options.signal.reason);
                },
                isAborted: function() {
                    return this.options.signal && this.options.signal.aborted;
                },
                isContinuation: s
            }, n = new Promise((t, i)=>{
                e.resolve = t, e.reject = i;
            });
            return this._(e), n;
        }
        _(t) {
            var i = t.options.signal;
            if (i) {
                if (i.aborted) return void t.reject(i.reason);
                t.abortCallback = ()=>{
                    t.onTaskAborted();
                }, i.addEventListener("abort", t.abortCallback);
            }
            t.options.delay > 0 ? t.hostCallback = new s(()=>{
                t.hostCallback = null, this.F(t);
            }, null, t.options.delay) : (this.G(t), this.J());
        }
        F(t) {
            this.G(t), this.U && (this.U.cancel(), this.U = null), this.K();
        }
        L(t) {
            var i = this.W.get(t);
            if (void 0 === i) throw new Error("Attempting to change priority on an unregistered signal");
            if (i !== t.priority) {
                for(var r = 0; r < 2; r++)this.S[t.priority][r].merge(this.S[i][r], (i)=>i.options.signal === t);
                this.W.set(t, t.priority);
            }
        }
        K() {
            this.U = null, this.V(), this.J();
        }
        J() {
            var { priority: t } = this.X();
            null != t && ("background" !== t && this.U && this.U.isIdleCallback() && (this.U.cancel(), this.U = null), this.U || (this.U = new s(()=>{
                this.K();
            }, t, 0)));
        }
        G(i) {
            var r;
            if (!t.includes(r = i.options.priority ? i.options.priority : i.options.signal && i.options.signal.priority ? i.options.signal.priority : "user-visible")) throw new TypeError("Invalid task priority: " + r);
            if (i.options.signal && i.options.signal.priority) {
                var s = i.options.signal;
                this.W.has(s) || (s.addEventListener("prioritychange", ()=>{
                    this.L(s);
                }), this.W.set(s, s.priority));
            }
            this.S[r][i.isContinuation ? 0 : 1].push(i);
        }
        V() {
            var t = null;
            do {
                var { priority: i, type: r } = this.X();
                if (null == i) return;
                t = this.S[i][r].takeNextTask();
            }while (t.isAborted());
            try {
                var s = t.callback();
                t.resolve(s);
            } catch (i) {
                t.reject(i);
            } finally{
                t.onTaskCompleted();
            }
        }
        X() {
            for(var i = 0; i < t.length; i++)for(var r = t[i], s = 0; s < 2; s++)if (!this.S[r][s].isEmpty()) return {
                priority: r,
                type: s
            };
            return {
                priority: null,
                type: 0
            };
        }
    }, self.TaskController = o, self.TaskPriorityChangeEvent = l) : self.scheduler.yield || (self.scheduler.yield = function() {
        return self.scheduler.postTask(()=>{}, {
            priority: "user-blocking"
        });
    });
}();

});

parcelRegister("blFED", function(module, exports) {

$parcel$export(module.exports, "ReadableStream", () => $97e331d20788a982$export$5d3e1e5268af5f76);
/**
 * @license
 * web-streams-polyfill v4.2.0
 * Copyright 2025 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $97e331d20788a982$var$e() {}
function $97e331d20788a982$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $97e331d20788a982$var$r = $97e331d20788a982$var$e;
function $97e331d20788a982$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $97e331d20788a982$var$n = Promise, $97e331d20788a982$var$a = Promise.resolve.bind($97e331d20788a982$var$n), $97e331d20788a982$var$i = Promise.prototype.then, $97e331d20788a982$var$l = Promise.reject.bind($97e331d20788a982$var$n), $97e331d20788a982$var$s = $97e331d20788a982$var$a;
function $97e331d20788a982$var$u(e) {
    return new $97e331d20788a982$var$n(e);
}
function $97e331d20788a982$var$c(e) {
    return $97e331d20788a982$var$u((t)=>t(e));
}
function $97e331d20788a982$var$d(e) {
    return $97e331d20788a982$var$l(e);
}
function $97e331d20788a982$var$f(e, t, r) {
    return $97e331d20788a982$var$i.call(e, t, r);
}
function $97e331d20788a982$var$b(e, t, o) {
    $97e331d20788a982$var$f($97e331d20788a982$var$f(e, t, o), void 0, $97e331d20788a982$var$r);
}
function $97e331d20788a982$var$h(e, t) {
    $97e331d20788a982$var$b(e, t);
}
function $97e331d20788a982$var$m(e, t) {
    $97e331d20788a982$var$b(e, void 0, t);
}
function $97e331d20788a982$var$_(e, t, r) {
    return $97e331d20788a982$var$f(e, t, r);
}
function $97e331d20788a982$var$p(e) {
    $97e331d20788a982$var$f(e, void 0, $97e331d20788a982$var$r);
}
let $97e331d20788a982$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $97e331d20788a982$var$y = queueMicrotask;
    else {
        const e = $97e331d20788a982$var$c(void 0);
        $97e331d20788a982$var$y = (t)=>$97e331d20788a982$var$f(e, t);
    }
    return $97e331d20788a982$var$y(e);
};
function $97e331d20788a982$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $97e331d20788a982$var$g(e, t, r) {
    try {
        return $97e331d20788a982$var$c($97e331d20788a982$var$S(e, t, r));
    } catch (e) {
        return $97e331d20788a982$var$d(e);
    }
}
class $97e331d20788a982$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, a = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, a;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $97e331d20788a982$var$w = Symbol("[[AbortSteps]]"), $97e331d20788a982$var$R = Symbol("[[ErrorSteps]]"), $97e331d20788a982$var$T = Symbol("[[CancelSteps]]"), $97e331d20788a982$var$C = Symbol("[[PullSteps]]"), $97e331d20788a982$var$P = Symbol("[[ReleaseSteps]]");
function $97e331d20788a982$var$q(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $97e331d20788a982$var$B(e) : "closed" === t._state ? function(e) {
        $97e331d20788a982$var$B(e), $97e331d20788a982$var$A(e);
    }(e) : $97e331d20788a982$var$k(e, t._storedError);
}
function $97e331d20788a982$var$E(e, t) {
    return $97e331d20788a982$var$Or(e._ownerReadableStream, t);
}
function $97e331d20788a982$var$W(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $97e331d20788a982$var$j(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $97e331d20788a982$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$97e331d20788a982$var$P](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $97e331d20788a982$var$O(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $97e331d20788a982$var$B(e) {
    e._closedPromise = $97e331d20788a982$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $97e331d20788a982$var$k(e, t) {
    $97e331d20788a982$var$B(e), $97e331d20788a982$var$j(e, t);
}
function $97e331d20788a982$var$j(e, t) {
    void 0 !== e._closedPromise_reject && ($97e331d20788a982$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $97e331d20788a982$var$A(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $97e331d20788a982$var$z = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $97e331d20788a982$var$D = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $97e331d20788a982$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $97e331d20788a982$var$F(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $97e331d20788a982$var$I(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $97e331d20788a982$var$$(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $97e331d20788a982$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $97e331d20788a982$var$Y(e) {
    return Number(e);
}
function $97e331d20788a982$var$x(e) {
    return 0 === e ? 0 : e;
}
function $97e331d20788a982$var$Q(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $97e331d20788a982$var$x(o), !$97e331d20788a982$var$z(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $97e331d20788a982$var$x($97e331d20788a982$var$D(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $97e331d20788a982$var$z(o) && 0 !== o ? o : 0;
}
function $97e331d20788a982$var$N(e, t) {
    if (!$97e331d20788a982$var$Er(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $97e331d20788a982$var$H(e) {
    return new $97e331d20788a982$export$a890bf36e2af9168(e);
}
function $97e331d20788a982$var$V(e, t) {
    e._reader._readRequests.push(t);
}
function $97e331d20788a982$var$U(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $97e331d20788a982$var$G(e) {
    return e._reader._readRequests.length;
}
function $97e331d20788a982$var$X(e) {
    const t = e._reader;
    return void 0 !== t && !!$97e331d20788a982$var$J(t);
}
class $97e331d20788a982$export$a890bf36e2af9168 {
    constructor(e){
        if ($97e331d20788a982$var$$(e, 1, "ReadableStreamDefaultReader"), $97e331d20788a982$var$N(e, "First parameter"), $97e331d20788a982$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $97e331d20788a982$var$q(this, e), this._readRequests = new $97e331d20788a982$var$v;
    }
    get closed() {
        return $97e331d20788a982$var$J(this) ? this._closedPromise : $97e331d20788a982$var$d($97e331d20788a982$var$ee("closed"));
    }
    cancel(e) {
        return $97e331d20788a982$var$J(this) ? void 0 === this._ownerReadableStream ? $97e331d20788a982$var$d($97e331d20788a982$var$O("cancel")) : $97e331d20788a982$var$E(this, e) : $97e331d20788a982$var$d($97e331d20788a982$var$ee("cancel"));
    }
    read() {
        if (!$97e331d20788a982$var$J(this)) return $97e331d20788a982$var$d($97e331d20788a982$var$ee("read"));
        if (void 0 === this._ownerReadableStream) return $97e331d20788a982$var$d($97e331d20788a982$var$O("read from"));
        let e, t;
        const r = $97e331d20788a982$var$u((r, o)=>{
            e = r, t = o;
        });
        return $97e331d20788a982$var$K(this, {
            _chunkSteps: (t)=>e({
                    value: t,
                    done: !1
                }),
            _closeSteps: ()=>e({
                    value: void 0,
                    done: !0
                }),
            _errorSteps: (e)=>t(e)
        }), r;
    }
    releaseLock() {
        if (!$97e331d20788a982$var$J(this)) throw $97e331d20788a982$var$ee("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $97e331d20788a982$var$W(e);
            const t = new TypeError("Reader was released");
            $97e331d20788a982$var$Z(e, t);
        }(this);
    }
}
function $97e331d20788a982$var$J(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $97e331d20788a982$export$a890bf36e2af9168;
}
function $97e331d20788a982$var$K(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$97e331d20788a982$var$C](t);
}
function $97e331d20788a982$var$Z(e, t) {
    const r = e._readRequests;
    e._readRequests = new $97e331d20788a982$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $97e331d20788a982$var$ee(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $97e331d20788a982$var$te, $97e331d20788a982$var$re, $97e331d20788a982$var$oe;
function $97e331d20788a982$var$ne(e) {
    return e.slice();
}
function $97e331d20788a982$var$ae(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
Object.defineProperties($97e331d20788a982$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$a890bf36e2af9168.prototype.cancel, "cancel"), $97e331d20788a982$var$o($97e331d20788a982$export$a890bf36e2af9168.prototype.read, "read"), $97e331d20788a982$var$o($97e331d20788a982$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
let $97e331d20788a982$var$ie = (e)=>($97e331d20788a982$var$ie = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $97e331d20788a982$var$ie(e)), $97e331d20788a982$var$le = (e)=>($97e331d20788a982$var$le = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $97e331d20788a982$var$le(e));
function $97e331d20788a982$var$se(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $97e331d20788a982$var$ae(n, 0, e, t, o), n;
}
function $97e331d20788a982$var$ue(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $97e331d20788a982$var$ce(e) {
    try {
        const t = e.done, r = e.value;
        return $97e331d20788a982$var$f($97e331d20788a982$var$s(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $97e331d20788a982$var$d(e);
    }
}
const $97e331d20788a982$var$de = null !== ($97e331d20788a982$var$oe = null !== ($97e331d20788a982$var$te = Symbol.asyncIterator) && void 0 !== $97e331d20788a982$var$te ? $97e331d20788a982$var$te : null === ($97e331d20788a982$var$re = Symbol.for) || void 0 === $97e331d20788a982$var$re ? void 0 : $97e331d20788a982$var$re.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $97e331d20788a982$var$oe ? $97e331d20788a982$var$oe : "@@asyncIterator";
function $97e331d20788a982$var$fe(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $97e331d20788a982$var$ue(e, $97e331d20788a982$var$de))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $97e331d20788a982$var$be(e);
                        } catch (e) {
                            return $97e331d20788a982$var$d(e);
                        }
                        return $97e331d20788a982$var$ce(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $97e331d20788a982$var$ue(e.iterator, "return");
                            if (void 0 === t) return $97e331d20788a982$var$c({
                                done: !0,
                                value: r
                            });
                            o = $97e331d20788a982$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $97e331d20788a982$var$d(e);
                        }
                        return $97e331d20788a982$var$t(o) ? $97e331d20788a982$var$ce(o) : $97e331d20788a982$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($97e331d20788a982$var$fe(e, "sync", $97e331d20788a982$var$ue(e, Symbol.iterator)));
        } else o = $97e331d20788a982$var$ue(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $97e331d20788a982$var$S(o, e, []);
    if (!$97e331d20788a982$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $97e331d20788a982$var$be(e) {
    const r = $97e331d20788a982$var$S(e.nextMethod, e.iterator, []);
    if (!$97e331d20788a982$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $97e331d20788a982$var$he {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $97e331d20788a982$var$_(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise = this._ongoingPromise ? $97e331d20788a982$var$_(this._ongoingPromise, t, t) : t(), this._ongoingPromise;
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader;
        let t, r;
        const o = $97e331d20788a982$var$u((e, o)=>{
            t = e, r = o;
        });
        return $97e331d20788a982$var$K(e, {
            _chunkSteps: (e)=>{
                this._ongoingPromise = void 0, $97e331d20788a982$var$y(()=>t({
                        value: e,
                        done: !1
                    }));
            },
            _closeSteps: ()=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $97e331d20788a982$var$W(e), t({
                    value: void 0,
                    done: !0
                });
            },
            _errorSteps: (t)=>{
                this._ongoingPromise = void 0, this._isFinished = !0, $97e331d20788a982$var$W(e), r(t);
            }
        }), o;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $97e331d20788a982$var$E(t, e);
            return $97e331d20788a982$var$W(t), $97e331d20788a982$var$_(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $97e331d20788a982$var$W(t), $97e331d20788a982$var$c({
            value: e,
            done: !0
        });
    }
}
const $97e331d20788a982$var$me = {
    next () {
        return $97e331d20788a982$var$_e(this) ? this._asyncIteratorImpl.next() : $97e331d20788a982$var$d($97e331d20788a982$var$pe("next"));
    },
    return (e) {
        return $97e331d20788a982$var$_e(this) ? this._asyncIteratorImpl.return(e) : $97e331d20788a982$var$d($97e331d20788a982$var$pe("return"));
    },
    [$97e331d20788a982$var$de] () {
        return this;
    }
};
function $97e331d20788a982$var$_e(e) {
    if (!$97e331d20788a982$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $97e331d20788a982$var$he;
    } catch (e) {
        return !1;
    }
}
function $97e331d20788a982$var$pe(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($97e331d20788a982$var$me, $97e331d20788a982$var$de, {
    enumerable: !1
});
const $97e331d20788a982$var$ye = Number.isNaN || function(e) {
    return e != e;
};
function $97e331d20788a982$var$Se(e) {
    const t = $97e331d20788a982$var$se(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $97e331d20788a982$var$ge(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $97e331d20788a982$var$ve(e, t, r) {
    if ("number" != typeof (o = r) || $97e331d20788a982$var$ye(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $97e331d20788a982$var$we(e) {
    e._queue = new $97e331d20788a982$var$v, e._queueTotalSize = 0;
}
function $97e331d20788a982$var$Re(e) {
    return e === DataView;
}
class $97e331d20788a982$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$97e331d20788a982$var$Ce(this)) throw $97e331d20788a982$var$Ke("view");
        return this._view;
    }
    respond(e) {
        if (!$97e331d20788a982$var$Ce(this)) throw $97e331d20788a982$var$Ke("respond");
        if ($97e331d20788a982$var$$(e, 1, "respond"), e = $97e331d20788a982$var$Q(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($97e331d20788a982$var$le(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $97e331d20788a982$var$Ge(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$97e331d20788a982$var$Ce(this)) throw $97e331d20788a982$var$Ke("respondWithNewView");
        if ($97e331d20788a982$var$$(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($97e331d20788a982$var$le(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $97e331d20788a982$var$Xe(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($97e331d20788a982$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$fbcf11583158d2c.prototype.respond, "respond"), $97e331d20788a982$var$o($97e331d20788a982$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $97e331d20788a982$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$97e331d20788a982$var$Te(this)) throw $97e331d20788a982$var$Ze("byobRequest");
        return $97e331d20788a982$var$Ve(this);
    }
    get desiredSize() {
        if (!$97e331d20788a982$var$Te(this)) throw $97e331d20788a982$var$Ze("desiredSize");
        return $97e331d20788a982$var$Ue(this);
    }
    close() {
        if (!$97e331d20788a982$var$Te(this)) throw $97e331d20788a982$var$Ze("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $97e331d20788a982$var$xe(this);
    }
    enqueue(e) {
        if (!$97e331d20788a982$var$Te(this)) throw $97e331d20788a982$var$Ze("enqueue");
        if ($97e331d20788a982$var$$(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $97e331d20788a982$var$Qe(this, e);
    }
    error(e) {
        if (!$97e331d20788a982$var$Te(this)) throw $97e331d20788a982$var$Ze("error");
        $97e331d20788a982$var$Ne(this, e);
    }
    [$97e331d20788a982$var$T](e) {
        $97e331d20788a982$var$qe(this), $97e331d20788a982$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $97e331d20788a982$var$Ye(this), t;
    }
    [$97e331d20788a982$var$C](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $97e331d20788a982$var$He(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $97e331d20788a982$var$V(t, e), $97e331d20788a982$var$Pe(this);
    }
    [$97e331d20788a982$var$P]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $97e331d20788a982$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $97e331d20788a982$var$Te(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $97e331d20788a982$export$2047cf34091e94ac;
}
function $97e331d20788a982$var$Ce(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $97e331d20788a982$export$fbcf11583158d2c;
}
function $97e331d20788a982$var$Pe(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($97e331d20788a982$var$X(t) && $97e331d20788a982$var$G(t) > 0) return !0;
        if ($97e331d20788a982$var$nt(t) && $97e331d20788a982$var$ot(t) > 0) return !0;
        const r = $97e331d20788a982$var$Ue(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $97e331d20788a982$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $97e331d20788a982$var$Pe(e)), null), (t)=>($97e331d20788a982$var$Ne(e, t), null));
}
function $97e331d20788a982$var$qe(e) {
    $97e331d20788a982$var$Le(e), e._pendingPullIntos = new $97e331d20788a982$var$v;
}
function $97e331d20788a982$var$Ee(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $97e331d20788a982$var$Oe(t);
    "default" === t.readerType ? $97e331d20788a982$var$U(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $97e331d20788a982$var$We(e, t) {
    for(let r = 0; r < t.length; ++r)$97e331d20788a982$var$Ee(e, t[r]);
}
function $97e331d20788a982$var$Oe(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $97e331d20788a982$var$Be(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $97e331d20788a982$var$ke(e, t, r, o) {
    let n;
    try {
        n = $97e331d20788a982$var$se(t, r, r + o);
    } catch (t) {
        throw $97e331d20788a982$var$Ne(e, t), t;
    }
    $97e331d20788a982$var$Be(e, n, 0, o);
}
function $97e331d20788a982$var$je(e, t) {
    t.bytesFilled > 0 && $97e331d20788a982$var$ke(e, t.buffer, t.byteOffset, t.bytesFilled), $97e331d20788a982$var$Me(e);
}
function $97e331d20788a982$var$Ae(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, a = !1;
    const i = o - o % t.elementSize;
    i >= t.minimumFill && (n = i - t.bytesFilled, a = !0);
    const l = e._queue;
    for(; n > 0;){
        const r = l.peek(), o = Math.min(n, r.byteLength), a = t.byteOffset + t.bytesFilled;
        $97e331d20788a982$var$ae(t.buffer, a, r.buffer, r.byteOffset, o), r.byteLength === o ? l.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $97e331d20788a982$var$ze(e, o, t), n -= o;
    }
    return a;
}
function $97e331d20788a982$var$ze(e, t, r) {
    r.bytesFilled += t;
}
function $97e331d20788a982$var$De(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($97e331d20788a982$var$Ye(e), $97e331d20788a982$var$Br(e._controlledReadableByteStream)) : $97e331d20788a982$var$Pe(e);
}
function $97e331d20788a982$var$Le(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $97e331d20788a982$var$Fe(e) {
    const t = [];
    for(; e._pendingPullIntos.length > 0 && 0 !== e._queueTotalSize;){
        const r = e._pendingPullIntos.peek();
        $97e331d20788a982$var$Ae(e, r) && ($97e331d20788a982$var$Me(e), t.push(r));
    }
    return t;
}
function $97e331d20788a982$var$Ie(e, t, r, o) {
    const n = e._controlledReadableByteStream, a = t.constructor, i = function(e) {
        return $97e331d20788a982$var$Re(e) ? 1 : e.BYTES_PER_ELEMENT;
    }(a), { byteOffset: l, byteLength: s } = t, u = r * i;
    let c;
    try {
        c = $97e331d20788a982$var$ie(t.buffer);
    } catch (e) {
        return void o._errorSteps(e);
    }
    const d = {
        buffer: c,
        bufferByteLength: c.byteLength,
        byteOffset: l,
        byteLength: s,
        bytesFilled: 0,
        minimumFill: u,
        elementSize: i,
        viewConstructor: a,
        readerType: "byob"
    };
    if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $97e331d20788a982$var$rt(n, o);
    if ("closed" === n._state) {
        const e = new a(d.buffer, d.byteOffset, 0);
        return void o._closeSteps(e);
    }
    if (e._queueTotalSize > 0) {
        if ($97e331d20788a982$var$Ae(e, d)) {
            const t = $97e331d20788a982$var$Oe(d);
            return $97e331d20788a982$var$De(e), void o._chunkSteps(t);
        }
        if (e._closeRequested) {
            const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
            return $97e331d20788a982$var$Ne(e, t), void o._errorSteps(t);
        }
    }
    e._pendingPullIntos.push(d), $97e331d20788a982$var$rt(n, o), $97e331d20788a982$var$Pe(e);
}
function $97e331d20788a982$var$$e(e, t) {
    const r = e._pendingPullIntos.peek();
    $97e331d20788a982$var$Le(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $97e331d20788a982$var$Me(e);
        const r = e._controlledReadableByteStream;
        if ($97e331d20788a982$var$nt(r)) {
            const t = [];
            for(; t.length < $97e331d20788a982$var$ot(r);)t.push($97e331d20788a982$var$Me(e));
            $97e331d20788a982$var$We(r, t);
        }
    }(e, r) : function(e, t, r) {
        if ($97e331d20788a982$var$ze(0, t, r), "none" === r.readerType) {
            $97e331d20788a982$var$je(e, r);
            const t = $97e331d20788a982$var$Fe(e);
            return void $97e331d20788a982$var$We(e._controlledReadableByteStream, t);
        }
        if (r.bytesFilled < r.minimumFill) return;
        $97e331d20788a982$var$Me(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $97e331d20788a982$var$ke(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o;
        const n = $97e331d20788a982$var$Fe(e);
        $97e331d20788a982$var$Ee(e._controlledReadableByteStream, r), $97e331d20788a982$var$We(e._controlledReadableByteStream, n);
    }(e, t, r), $97e331d20788a982$var$Pe(e);
}
function $97e331d20788a982$var$Me(e) {
    return e._pendingPullIntos.shift();
}
function $97e331d20788a982$var$Ye(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $97e331d20788a982$var$xe(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize !== 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $97e331d20788a982$var$Ne(e, t), t;
                }
            }
            $97e331d20788a982$var$Ye(e), $97e331d20788a982$var$Br(t);
        }
    }
}
function $97e331d20788a982$var$Qe(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: a } = t;
    if ($97e331d20788a982$var$le(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const i = $97e331d20788a982$var$ie(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($97e331d20788a982$var$le(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $97e331d20788a982$var$Le(e), t.buffer = $97e331d20788a982$var$ie(t.buffer), "none" === t.readerType && $97e331d20788a982$var$je(e, t);
    }
    if ($97e331d20788a982$var$X(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $97e331d20788a982$var$He(e, t._readRequests.shift());
            }
        }(e), 0 === $97e331d20788a982$var$G(r)) $97e331d20788a982$var$Be(e, i, n, a);
        else {
            e._pendingPullIntos.length > 0 && $97e331d20788a982$var$Me(e);
            $97e331d20788a982$var$U(r, new Uint8Array(i, n, a), !1);
        }
    } else if ($97e331d20788a982$var$nt(r)) {
        $97e331d20788a982$var$Be(e, i, n, a);
        $97e331d20788a982$var$We(r, $97e331d20788a982$var$Fe(e));
    } else $97e331d20788a982$var$Be(e, i, n, a);
    $97e331d20788a982$var$Pe(e);
}
function $97e331d20788a982$var$Ne(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($97e331d20788a982$var$qe(e), $97e331d20788a982$var$we(e), $97e331d20788a982$var$Ye(e), $97e331d20788a982$var$kr(r, t));
}
function $97e331d20788a982$var$He(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $97e331d20788a982$var$De(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $97e331d20788a982$var$Ve(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($97e331d20788a982$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $97e331d20788a982$var$Ue(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $97e331d20788a982$var$Ge(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $97e331d20788a982$var$ie(r.buffer), $97e331d20788a982$var$$e(e, t);
}
function $97e331d20788a982$var$Xe(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $97e331d20788a982$var$ie(t.buffer), $97e331d20788a982$var$$e(e, o);
}
function $97e331d20788a982$var$Je(e, t, r, o, n, a, i) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $97e331d20788a982$var$we(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = i, t._pendingPullIntos = new $97e331d20788a982$var$v, e._readableStreamController = t;
    $97e331d20788a982$var$b($97e331d20788a982$var$c(r()), ()=>(t._started = !0, $97e331d20788a982$var$Pe(t), null), (e)=>($97e331d20788a982$var$Ne(t, e), null));
}
function $97e331d20788a982$var$Ke(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $97e331d20788a982$var$Ze(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $97e331d20788a982$var$et(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $97e331d20788a982$var$tt(e) {
    return new $97e331d20788a982$export$20068a30393fcc28(e);
}
function $97e331d20788a982$var$rt(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $97e331d20788a982$var$ot(e) {
    return e._reader._readIntoRequests.length;
}
function $97e331d20788a982$var$nt(e) {
    const t = e._reader;
    return void 0 !== t && !!$97e331d20788a982$var$at(t);
}
Object.defineProperties($97e331d20788a982$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$2047cf34091e94ac.prototype.close, "close"), $97e331d20788a982$var$o($97e331d20788a982$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $97e331d20788a982$var$o($97e331d20788a982$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $97e331d20788a982$export$20068a30393fcc28 {
    constructor(e){
        if ($97e331d20788a982$var$$(e, 1, "ReadableStreamBYOBReader"), $97e331d20788a982$var$N(e, "First parameter"), $97e331d20788a982$var$Wr(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$97e331d20788a982$var$Te(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $97e331d20788a982$var$q(this, e), this._readIntoRequests = new $97e331d20788a982$var$v;
    }
    get closed() {
        return $97e331d20788a982$var$at(this) ? this._closedPromise : $97e331d20788a982$var$d($97e331d20788a982$var$st("closed"));
    }
    cancel(e) {
        return $97e331d20788a982$var$at(this) ? void 0 === this._ownerReadableStream ? $97e331d20788a982$var$d($97e331d20788a982$var$O("cancel")) : $97e331d20788a982$var$E(this, e) : $97e331d20788a982$var$d($97e331d20788a982$var$st("cancel"));
    }
    read(e, t = {}) {
        if (!$97e331d20788a982$var$at(this)) return $97e331d20788a982$var$d($97e331d20788a982$var$st("read"));
        if (!ArrayBuffer.isView(e)) return $97e331d20788a982$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $97e331d20788a982$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $97e331d20788a982$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($97e331d20788a982$var$le(e.buffer)) return $97e331d20788a982$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $97e331d20788a982$var$L(e, t), {
                    min: $97e331d20788a982$var$Q(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $97e331d20788a982$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $97e331d20788a982$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $97e331d20788a982$var$Re(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $97e331d20788a982$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $97e331d20788a982$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $97e331d20788a982$var$d($97e331d20788a982$var$O("read from"));
        let n, a;
        const i = $97e331d20788a982$var$u((e, t)=>{
            n = e, a = t;
        });
        return $97e331d20788a982$var$it(this, e, o, {
            _chunkSteps: (e)=>n({
                    value: e,
                    done: !1
                }),
            _closeSteps: (e)=>n({
                    value: e,
                    done: !0
                }),
            _errorSteps: (e)=>a(e)
        }), i;
    }
    releaseLock() {
        if (!$97e331d20788a982$var$at(this)) throw $97e331d20788a982$var$st("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $97e331d20788a982$var$W(e);
            const t = new TypeError("Reader was released");
            $97e331d20788a982$var$lt(e, t);
        }(this);
    }
}
function $97e331d20788a982$var$at(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $97e331d20788a982$export$20068a30393fcc28;
}
function $97e331d20788a982$var$it(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : $97e331d20788a982$var$Ie(n._readableStreamController, t, r, o);
}
function $97e331d20788a982$var$lt(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $97e331d20788a982$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $97e331d20788a982$var$st(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $97e331d20788a982$var$ut(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($97e331d20788a982$var$ye(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $97e331d20788a982$var$ct(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $97e331d20788a982$var$dt(e, t) {
    $97e331d20788a982$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $97e331d20788a982$var$Y(r),
        size: void 0 === o ? void 0 : $97e331d20788a982$var$ft(o, `${t} has member 'size' that`)
    };
}
function $97e331d20788a982$var$ft(e, t) {
    return $97e331d20788a982$var$F(e, t), (t)=>$97e331d20788a982$var$Y(e(t));
}
function $97e331d20788a982$var$bt(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$g(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$ht(e, t, r) {
    return $97e331d20788a982$var$F(e, r), ()=>$97e331d20788a982$var$g(e, t, []);
}
function $97e331d20788a982$var$mt(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$S(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$_t(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r, o)=>$97e331d20788a982$var$g(e, t, [
            r,
            o
        ]);
}
function $97e331d20788a982$var$pt(e, t) {
    if (!$97e331d20788a982$var$gt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
Object.defineProperties($97e331d20788a982$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$20068a30393fcc28.prototype.cancel, "cancel"), $97e331d20788a982$var$o($97e331d20788a982$export$20068a30393fcc28.prototype.read, "read"), $97e331d20788a982$var$o($97e331d20788a982$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
class $97e331d20788a982$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $97e331d20788a982$var$I(e, "First parameter");
        const r = $97e331d20788a982$var$dt(t, "Second parameter"), o = function(e, t) {
            $97e331d20788a982$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, a = null == e ? void 0 : e.type, i = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $97e331d20788a982$var$bt(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $97e331d20788a982$var$ht(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $97e331d20788a982$var$mt(n, e, `${t} has member 'start' that`),
                write: void 0 === i ? void 0 : $97e331d20788a982$var$_t(i, e, `${t} has member 'write' that`),
                type: a
            };
        }(e, "First parameter");
        $97e331d20788a982$var$St(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $97e331d20788a982$var$ct(r);
        !function(e, t, r, o) {
            const n = Object.create($97e331d20788a982$export$9e6890cb9a51c7c2.prototype);
            let a, i, l, s;
            a = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            i = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$97e331d20788a982$var$c(void 0);
            l = void 0 !== t.close ? ()=>t.close() : ()=>$97e331d20788a982$var$c(void 0);
            s = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$97e331d20788a982$var$c(void 0);
            $97e331d20788a982$var$Ft(e, n, a, i, l, s, r, o);
        }(this, o, $97e331d20788a982$var$ut(r, 1), n);
    }
    get locked() {
        if (!$97e331d20788a982$var$gt(this)) throw $97e331d20788a982$var$Nt("locked");
        return $97e331d20788a982$var$vt(this);
    }
    abort(e) {
        return $97e331d20788a982$var$gt(this) ? $97e331d20788a982$var$vt(this) ? $97e331d20788a982$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $97e331d20788a982$var$wt(this, e) : $97e331d20788a982$var$d($97e331d20788a982$var$Nt("abort"));
    }
    close() {
        return $97e331d20788a982$var$gt(this) ? $97e331d20788a982$var$vt(this) ? $97e331d20788a982$var$d(new TypeError("Cannot close a stream that already has a writer")) : $97e331d20788a982$var$qt(this) ? $97e331d20788a982$var$d(new TypeError("Cannot close an already-closing stream")) : $97e331d20788a982$var$Rt(this) : $97e331d20788a982$var$d($97e331d20788a982$var$Nt("close"));
    }
    getWriter() {
        if (!$97e331d20788a982$var$gt(this)) throw $97e331d20788a982$var$Nt("getWriter");
        return $97e331d20788a982$var$yt(this);
    }
}
function $97e331d20788a982$var$yt(e) {
    return new $97e331d20788a982$export$9295348f005d6054(e);
}
function $97e331d20788a982$var$St(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $97e331d20788a982$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $97e331d20788a982$var$gt(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $97e331d20788a982$export$826849241f7970f8;
}
function $97e331d20788a982$var$vt(e) {
    return void 0 !== e._writer;
}
function $97e331d20788a982$var$wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $97e331d20788a982$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $97e331d20788a982$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const a = $97e331d20788a982$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = a, n || $97e331d20788a982$var$Ct(e, t), a;
}
function $97e331d20788a982$var$Rt(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $97e331d20788a982$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $97e331d20788a982$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $97e331d20788a982$var$or(o), $97e331d20788a982$var$ve(n = e._writableStreamController, $97e331d20788a982$var$Dt, 0), $97e331d20788a982$var$Mt(n), r;
}
function $97e331d20788a982$var$Tt(e, t) {
    "writable" !== e._state ? $97e331d20788a982$var$Pt(e) : $97e331d20788a982$var$Ct(e, t);
}
function $97e331d20788a982$var$Ct(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $97e331d20788a982$var$jt(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $97e331d20788a982$var$Pt(e);
}
function $97e331d20788a982$var$Pt(e) {
    e._state = "errored", e._writableStreamController[$97e331d20788a982$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $97e331d20788a982$var$v, void 0 === e._pendingAbortRequest) return void $97e331d20788a982$var$Et(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $97e331d20788a982$var$Et(e);
    $97e331d20788a982$var$b(e._writableStreamController[$97e331d20788a982$var$w](r._reason), ()=>(r._resolve(), $97e331d20788a982$var$Et(e), null), (t)=>(r._reject(t), $97e331d20788a982$var$Et(e), null));
}
function $97e331d20788a982$var$qt(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $97e331d20788a982$var$Et(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $97e331d20788a982$var$Jt(t, e._storedError);
}
function $97e331d20788a982$var$Wt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $97e331d20788a982$var$Zt(e);
    }(r) : $97e331d20788a982$var$or(r)), e._backpressure = t;
}
Object.defineProperties($97e331d20788a982$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$826849241f7970f8.prototype.abort, "abort"), $97e331d20788a982$var$o($97e331d20788a982$export$826849241f7970f8.prototype.close, "close"), $97e331d20788a982$var$o($97e331d20788a982$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $97e331d20788a982$export$9295348f005d6054 {
    constructor(e){
        if ($97e331d20788a982$var$$(e, 1, "WritableStreamDefaultWriter"), $97e331d20788a982$var$pt(e, "First parameter"), $97e331d20788a982$var$vt(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$97e331d20788a982$var$qt(e) && e._backpressure ? $97e331d20788a982$var$Zt(this) : $97e331d20788a982$var$tr(this), $97e331d20788a982$var$Gt(this);
        else if ("erroring" === t) $97e331d20788a982$var$er(this, e._storedError), $97e331d20788a982$var$Gt(this);
        else if ("closed" === t) $97e331d20788a982$var$tr(this), $97e331d20788a982$var$Gt(r = this), $97e331d20788a982$var$Kt(r);
        else {
            const t = e._storedError;
            $97e331d20788a982$var$er(this, t), $97e331d20788a982$var$Xt(this, t);
        }
        var r;
    }
    get closed() {
        return $97e331d20788a982$var$Ot(this) ? this._closedPromise : $97e331d20788a982$var$d($97e331d20788a982$var$Vt("closed"));
    }
    get desiredSize() {
        if (!$97e331d20788a982$var$Ot(this)) throw $97e331d20788a982$var$Vt("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $97e331d20788a982$var$Ut("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $97e331d20788a982$var$$t(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $97e331d20788a982$var$Ot(this) ? this._readyPromise : $97e331d20788a982$var$d($97e331d20788a982$var$Vt("ready"));
    }
    abort(e) {
        return $97e331d20788a982$var$Ot(this) ? void 0 === this._ownerWritableStream ? $97e331d20788a982$var$d($97e331d20788a982$var$Ut("abort")) : function(e, t) {
            return $97e331d20788a982$var$wt(e._ownerWritableStream, t);
        }(this, e) : $97e331d20788a982$var$d($97e331d20788a982$var$Vt("abort"));
    }
    close() {
        if (!$97e331d20788a982$var$Ot(this)) return $97e331d20788a982$var$d($97e331d20788a982$var$Vt("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $97e331d20788a982$var$d($97e331d20788a982$var$Ut("close")) : $97e331d20788a982$var$qt(e) ? $97e331d20788a982$var$d(new TypeError("Cannot close an already-closing stream")) : $97e331d20788a982$var$Bt(this);
    }
    releaseLock() {
        if (!$97e331d20788a982$var$Ot(this)) throw $97e331d20788a982$var$Vt("releaseLock");
        void 0 !== this._ownerWritableStream && $97e331d20788a982$var$At(this);
    }
    write(e) {
        return $97e331d20788a982$var$Ot(this) ? void 0 === this._ownerWritableStream ? $97e331d20788a982$var$d($97e331d20788a982$var$Ut("write to")) : $97e331d20788a982$var$zt(this, e) : $97e331d20788a982$var$d($97e331d20788a982$var$Vt("write"));
    }
}
function $97e331d20788a982$var$Ot(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $97e331d20788a982$export$9295348f005d6054;
}
function $97e331d20788a982$var$Bt(e) {
    return $97e331d20788a982$var$Rt(e._ownerWritableStream);
}
function $97e331d20788a982$var$kt(e, t) {
    "pending" === e._closedPromiseState ? $97e331d20788a982$var$Jt(e, t) : function(e, t) {
        $97e331d20788a982$var$Xt(e, t);
    }(e, t);
}
function $97e331d20788a982$var$jt(e, t) {
    "pending" === e._readyPromiseState ? $97e331d20788a982$var$rr(e, t) : function(e, t) {
        $97e331d20788a982$var$er(e, t);
    }(e, t);
}
function $97e331d20788a982$var$At(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $97e331d20788a982$var$jt(e, r), $97e331d20788a982$var$kt(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $97e331d20788a982$var$zt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        if (void 0 === e._strategySizeAlgorithm) return 1;
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $97e331d20788a982$var$Yt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $97e331d20788a982$var$d($97e331d20788a982$var$Ut("write to"));
    const a = r._state;
    if ("errored" === a) return $97e331d20788a982$var$d(r._storedError);
    if ($97e331d20788a982$var$qt(r) || "closed" === a) return $97e331d20788a982$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === a) return $97e331d20788a982$var$d(r._storedError);
    const i = function(e) {
        return $97e331d20788a982$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $97e331d20788a982$var$ve(e, t, r);
        } catch (t) {
            return void $97e331d20788a982$var$Yt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$97e331d20788a982$var$qt(o) && "writable" === o._state) $97e331d20788a982$var$Wt(o, $97e331d20788a982$var$xt(e));
        $97e331d20788a982$var$Mt(e);
    }(o, t, n), i;
}
Object.defineProperties($97e331d20788a982$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$9295348f005d6054.prototype.abort, "abort"), $97e331d20788a982$var$o($97e331d20788a982$export$9295348f005d6054.prototype.close, "close"), $97e331d20788a982$var$o($97e331d20788a982$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $97e331d20788a982$var$o($97e331d20788a982$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $97e331d20788a982$var$Dt = {};
class $97e331d20788a982$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$97e331d20788a982$var$Lt(this)) throw $97e331d20788a982$var$Ht("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$97e331d20788a982$var$Lt(this)) throw $97e331d20788a982$var$Ht("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$97e331d20788a982$var$Lt(this)) throw $97e331d20788a982$var$Ht("error");
        "writable" === this._controlledWritableStream._state && $97e331d20788a982$var$Qt(this, e);
    }
    [$97e331d20788a982$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $97e331d20788a982$var$It(this), t;
    }
    [$97e331d20788a982$var$R]() {
        $97e331d20788a982$var$we(this);
    }
}
function $97e331d20788a982$var$Lt(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $97e331d20788a982$export$9e6890cb9a51c7c2;
}
function $97e331d20788a982$var$Ft(e, t, r, o, n, a, i, l) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $97e331d20788a982$var$we(t), t._abortReason = void 0, t._abortController = function() {
        if ("function" == typeof AbortController) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = l, t._strategyHWM = i, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = a;
    const s = $97e331d20788a982$var$xt(t);
    $97e331d20788a982$var$Wt(e, s);
    $97e331d20788a982$var$b($97e331d20788a982$var$c(r()), ()=>(t._started = !0, $97e331d20788a982$var$Mt(t), null), (r)=>(t._started = !0, $97e331d20788a982$var$Tt(e, r), null));
}
function $97e331d20788a982$var$It(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $97e331d20788a982$var$$t(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $97e331d20788a982$var$Mt(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $97e331d20788a982$var$Pt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $97e331d20788a982$var$Dt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $97e331d20788a982$var$ge(e);
        const r = e._closeAlgorithm();
        $97e331d20788a982$var$It(e), $97e331d20788a982$var$b(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $97e331d20788a982$var$Kt(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $97e331d20788a982$var$Tt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $97e331d20788a982$var$b(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($97e331d20788a982$var$ge(e), !$97e331d20788a982$var$qt(r) && "writable" === t) {
                const t = $97e331d20788a982$var$xt(e);
                $97e331d20788a982$var$Wt(r, t);
            }
            return $97e331d20788a982$var$Mt(e), null;
        }, (t)=>("writable" === r._state && $97e331d20788a982$var$It(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $97e331d20788a982$var$Tt(e, t);
            }(r, t), null));
    }(e, r);
}
function $97e331d20788a982$var$Yt(e, t) {
    "writable" === e._controlledWritableStream._state && $97e331d20788a982$var$Qt(e, t);
}
function $97e331d20788a982$var$xt(e) {
    return $97e331d20788a982$var$$t(e) <= 0;
}
function $97e331d20788a982$var$Qt(e, t) {
    const r = e._controlledWritableStream;
    $97e331d20788a982$var$It(e), $97e331d20788a982$var$Ct(r, t);
}
function $97e331d20788a982$var$Nt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $97e331d20788a982$var$Ht(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $97e331d20788a982$var$Vt(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $97e331d20788a982$var$Ut(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $97e331d20788a982$var$Gt(e) {
    e._closedPromise = $97e331d20788a982$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $97e331d20788a982$var$Xt(e, t) {
    $97e331d20788a982$var$Gt(e), $97e331d20788a982$var$Jt(e, t);
}
function $97e331d20788a982$var$Jt(e, t) {
    void 0 !== e._closedPromise_reject && ($97e331d20788a982$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $97e331d20788a982$var$Kt(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $97e331d20788a982$var$Zt(e) {
    e._readyPromise = $97e331d20788a982$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $97e331d20788a982$var$er(e, t) {
    $97e331d20788a982$var$Zt(e), $97e331d20788a982$var$rr(e, t);
}
function $97e331d20788a982$var$tr(e) {
    $97e331d20788a982$var$Zt(e), $97e331d20788a982$var$or(e);
}
function $97e331d20788a982$var$rr(e, t) {
    void 0 !== e._readyPromise_reject && ($97e331d20788a982$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $97e331d20788a982$var$or(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($97e331d20788a982$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $97e331d20788a982$var$nr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $97e331d20788a982$var$ar = function() {
    const e = null == $97e331d20788a982$var$nr ? void 0 : $97e331d20788a982$var$nr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $97e331d20788a982$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $97e331d20788a982$var$ir(t, r, o, n, a, i) {
    const l = $97e331d20788a982$var$H(t), s = $97e331d20788a982$var$yt(r);
    t._disturbed = !0;
    let _ = !1, y = $97e331d20788a982$var$c(void 0);
    return $97e331d20788a982$var$u((S, g)=>{
        let v;
        if (void 0 !== i) {
            if (v = ()=>{
                const e = void 0 !== i.reason ? i.reason : new $97e331d20788a982$var$ar("Aborted", "AbortError"), o = [];
                n || o.push(()=>"writable" === r._state ? $97e331d20788a982$var$wt(r, e) : $97e331d20788a982$var$c(void 0)), a || o.push(()=>"readable" === t._state ? $97e331d20788a982$var$Or(t, e) : $97e331d20788a982$var$c(void 0)), q(()=>Promise.all(o.map((e)=>e())), !0, e);
            }, i.aborted) return void v();
            i.addEventListener("abort", v);
        }
        var w, R, T;
        if (P(t, l._closedPromise, (e)=>(n ? E(!0, e) : q(()=>$97e331d20788a982$var$wt(r, e), !0, e), null)), P(r, s._closedPromise, (e)=>(a ? E(!0, e) : q(()=>$97e331d20788a982$var$Or(t, e), !0, e), null)), w = t, R = l._closedPromise, T = ()=>(o ? E() : q(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $97e331d20788a982$var$qt(t) || "closed" === r ? $97e331d20788a982$var$c(void 0) : "errored" === r ? $97e331d20788a982$var$d(t._storedError) : $97e331d20788a982$var$Bt(e);
                })(s)), null), "closed" === w._state ? T() : $97e331d20788a982$var$h(R, T), $97e331d20788a982$var$qt(r) || "closed" === r._state) {
            const e = new TypeError("the destination writable stream closed before all data could be piped to it");
            a ? E(!0, e) : q(()=>$97e331d20788a982$var$Or(t, e), !0, e);
        }
        function C() {
            const e = y;
            return $97e331d20788a982$var$f(y, ()=>e !== y ? C() : void 0);
        }
        function P(e, t, r) {
            "errored" === e._state ? r(e._storedError) : $97e331d20788a982$var$m(t, r);
        }
        function q(e, t, o) {
            function n() {
                return $97e331d20788a982$var$b(e(), ()=>O(t, o), (e)=>O(!0, e)), null;
            }
            _ || (_ = !0, "writable" !== r._state || $97e331d20788a982$var$qt(r) ? n() : $97e331d20788a982$var$h(C(), n));
        }
        function E(e, t) {
            _ || (_ = !0, "writable" !== r._state || $97e331d20788a982$var$qt(r) ? O(e, t) : $97e331d20788a982$var$h(C(), ()=>O(e, t)));
        }
        function O(e, t) {
            return $97e331d20788a982$var$At(s), $97e331d20788a982$var$W(l), void 0 !== i && i.removeEventListener("abort", v), e ? g(t) : S(void 0), null;
        }
        $97e331d20788a982$var$p($97e331d20788a982$var$u((t, r)=>{
            !function o(n) {
                n ? t() : $97e331d20788a982$var$f(_ ? $97e331d20788a982$var$c(!0) : $97e331d20788a982$var$f(s._readyPromise, ()=>$97e331d20788a982$var$u((t, r)=>{
                        $97e331d20788a982$var$K(l, {
                            _chunkSteps: (r)=>{
                                y = $97e331d20788a982$var$f($97e331d20788a982$var$zt(s, r), void 0, $97e331d20788a982$var$e), t(!1);
                            },
                            _closeSteps: ()=>t(!0),
                            _errorSteps: r
                        });
                    })), o, r);
            }(!1);
        }));
    });
}
class $97e331d20788a982$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$97e331d20788a982$var$lr(this)) throw $97e331d20788a982$var$pr("desiredSize");
        return $97e331d20788a982$var$hr(this);
    }
    close() {
        if (!$97e331d20788a982$var$lr(this)) throw $97e331d20788a982$var$pr("close");
        if (!$97e331d20788a982$var$mr(this)) throw new TypeError("The stream is not in a state that permits close");
        $97e331d20788a982$var$dr(this);
    }
    enqueue(e) {
        if (!$97e331d20788a982$var$lr(this)) throw $97e331d20788a982$var$pr("enqueue");
        if (!$97e331d20788a982$var$mr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $97e331d20788a982$var$fr(this, e);
    }
    error(e) {
        if (!$97e331d20788a982$var$lr(this)) throw $97e331d20788a982$var$pr("error");
        $97e331d20788a982$var$br(this, e);
    }
    [$97e331d20788a982$var$T](e) {
        $97e331d20788a982$var$we(this);
        const t = this._cancelAlgorithm(e);
        return $97e331d20788a982$var$cr(this), t;
    }
    [$97e331d20788a982$var$C](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $97e331d20788a982$var$ge(this);
            this._closeRequested && 0 === this._queue.length ? ($97e331d20788a982$var$cr(this), $97e331d20788a982$var$Br(t)) : $97e331d20788a982$var$sr(this), e._chunkSteps(r);
        } else $97e331d20788a982$var$V(t, e), $97e331d20788a982$var$sr(this);
    }
    [$97e331d20788a982$var$P]() {}
}
function $97e331d20788a982$var$lr(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $97e331d20788a982$export$b0bb6d0989d67700;
}
function $97e331d20788a982$var$sr(e) {
    if (!$97e331d20788a982$var$ur(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $97e331d20788a982$var$b(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $97e331d20788a982$var$sr(e)), null), (t)=>($97e331d20788a982$var$br(e, t), null));
}
function $97e331d20788a982$var$ur(e) {
    const t = e._controlledReadableStream;
    if (!$97e331d20788a982$var$mr(e)) return !1;
    if (!e._started) return !1;
    if ($97e331d20788a982$var$Wr(t) && $97e331d20788a982$var$G(t) > 0) return !0;
    return $97e331d20788a982$var$hr(e) > 0;
}
function $97e331d20788a982$var$cr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $97e331d20788a982$var$dr(e) {
    if (!$97e331d20788a982$var$mr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($97e331d20788a982$var$cr(e), $97e331d20788a982$var$Br(t));
}
function $97e331d20788a982$var$fr(e, t) {
    if (!$97e331d20788a982$var$mr(e)) return;
    const r = e._controlledReadableStream;
    if ($97e331d20788a982$var$Wr(r) && $97e331d20788a982$var$G(r) > 0) $97e331d20788a982$var$U(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $97e331d20788a982$var$br(e, t), t;
        }
        try {
            $97e331d20788a982$var$ve(e, t, r);
        } catch (t) {
            throw $97e331d20788a982$var$br(e, t), t;
        }
    }
    $97e331d20788a982$var$sr(e);
}
function $97e331d20788a982$var$br(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($97e331d20788a982$var$we(e), $97e331d20788a982$var$cr(e), $97e331d20788a982$var$kr(r, t));
}
function $97e331d20788a982$var$hr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $97e331d20788a982$var$mr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $97e331d20788a982$var$_r(e, t, r, o, n, a, i) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $97e331d20788a982$var$we(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = i, t._strategyHWM = a, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $97e331d20788a982$var$b($97e331d20788a982$var$c(r()), ()=>(t._started = !0, $97e331d20788a982$var$sr(t), null), (e)=>($97e331d20788a982$var$br(t, e), null));
}
function $97e331d20788a982$var$pr(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $97e331d20788a982$var$yr(e, t) {
    return $97e331d20788a982$var$Te(e._readableStreamController) ? function(e) {
        let t, r, o, n, a, i = $97e331d20788a982$var$H(e), l = !1, s = !1, d = !1, f = !1, b = !1;
        const h = $97e331d20788a982$var$u((e)=>{
            a = e;
        });
        function _(e) {
            $97e331d20788a982$var$m(e._closedPromise, (t)=>(e !== i || ($97e331d20788a982$var$Ne(o._readableStreamController, t), $97e331d20788a982$var$Ne(n._readableStreamController, t), f && b || a(void 0)), null));
        }
        function p() {
            $97e331d20788a982$var$at(i) && ($97e331d20788a982$var$W(i), i = $97e331d20788a982$var$H(e), _(i));
            $97e331d20788a982$var$K(i, {
                _chunkSteps: (t)=>{
                    $97e331d20788a982$var$y(()=>{
                        s = !1, d = !1;
                        const r = t;
                        let i = t;
                        if (!f && !b) try {
                            i = $97e331d20788a982$var$Se(t);
                        } catch (t) {
                            return $97e331d20788a982$var$Ne(o._readableStreamController, t), $97e331d20788a982$var$Ne(n._readableStreamController, t), void a($97e331d20788a982$var$Or(e, t));
                        }
                        f || $97e331d20788a982$var$Qe(o._readableStreamController, r), b || $97e331d20788a982$var$Qe(n._readableStreamController, i), l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    l = !1, f || $97e331d20788a982$var$xe(o._readableStreamController), b || $97e331d20788a982$var$xe(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $97e331d20788a982$var$Ge(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $97e331d20788a982$var$Ge(n._readableStreamController, 0), f && b || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function S(t, r) {
            $97e331d20788a982$var$J(i) && ($97e331d20788a982$var$W(i), i = $97e331d20788a982$var$tt(e), _(i));
            const u = r ? n : o, c = r ? o : n;
            $97e331d20788a982$var$it(i, t, 1, {
                _chunkSteps: (t)=>{
                    $97e331d20788a982$var$y(()=>{
                        s = !1, d = !1;
                        const o = r ? b : f;
                        if (r ? f : b) o || $97e331d20788a982$var$Xe(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $97e331d20788a982$var$Se(t);
                            } catch (t) {
                                return $97e331d20788a982$var$Ne(u._readableStreamController, t), $97e331d20788a982$var$Ne(c._readableStreamController, t), void a($97e331d20788a982$var$Or(e, t));
                            }
                            o || $97e331d20788a982$var$Xe(u._readableStreamController, t), $97e331d20788a982$var$Qe(c._readableStreamController, r);
                        }
                        l = !1, s ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    l = !1;
                    const t = r ? b : f, o = r ? f : b;
                    t || $97e331d20788a982$var$xe(u._readableStreamController), o || $97e331d20788a982$var$xe(c._readableStreamController), void 0 !== e && (t || $97e331d20788a982$var$Xe(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $97e331d20788a982$var$Ge(c._readableStreamController, 0)), t && o || a(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            });
        }
        function g() {
            if (l) return s = !0, $97e331d20788a982$var$c(void 0);
            l = !0;
            const e = $97e331d20788a982$var$Ve(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $97e331d20788a982$var$c(void 0);
        }
        function v() {
            if (l) return d = !0, $97e331d20788a982$var$c(void 0);
            l = !0;
            const e = $97e331d20788a982$var$Ve(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $97e331d20788a982$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, b) {
                const o = $97e331d20788a982$var$ne([
                    t,
                    r
                ]), n = $97e331d20788a982$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function R(o) {
            if (b = !0, r = o, f) {
                const o = $97e331d20788a982$var$ne([
                    t,
                    r
                ]), n = $97e331d20788a982$var$Or(e, o);
                a(n);
            }
            return h;
        }
        function T() {}
        return o = $97e331d20788a982$var$Pr(T, g, w), n = $97e331d20788a982$var$Pr(T, v, R), _(i), [
            o,
            n
        ];
    }(e) : function(e) {
        const t = $97e331d20788a982$var$H(e);
        let r, o, n, a, i, l = !1, s = !1, d = !1, f = !1;
        const b = $97e331d20788a982$var$u((e)=>{
            i = e;
        });
        function h() {
            if (l) return s = !0, $97e331d20788a982$var$c(void 0);
            l = !0;
            return $97e331d20788a982$var$K(t, {
                _chunkSteps: (e)=>{
                    $97e331d20788a982$var$y(()=>{
                        s = !1;
                        const t = e, r = e;
                        d || $97e331d20788a982$var$fr(n._readableStreamController, t), f || $97e331d20788a982$var$fr(a._readableStreamController, r), l = !1, s && h();
                    });
                },
                _closeSteps: ()=>{
                    l = !1, d || $97e331d20788a982$var$dr(n._readableStreamController), f || $97e331d20788a982$var$dr(a._readableStreamController), d && f || i(void 0);
                },
                _errorSteps: ()=>{
                    l = !1;
                }
            }), $97e331d20788a982$var$c(void 0);
        }
        function _(t) {
            if (d = !0, r = t, f) {
                const t = $97e331d20788a982$var$ne([
                    r,
                    o
                ]), n = $97e331d20788a982$var$Or(e, t);
                i(n);
            }
            return b;
        }
        function p(t) {
            if (f = !0, o = t, d) {
                const t = $97e331d20788a982$var$ne([
                    r,
                    o
                ]), n = $97e331d20788a982$var$Or(e, t);
                i(n);
            }
            return b;
        }
        function S() {}
        return n = $97e331d20788a982$var$Cr(S, h, _), a = $97e331d20788a982$var$Cr(S, h, p), $97e331d20788a982$var$m(t._closedPromise, (e)=>($97e331d20788a982$var$br(n._readableStreamController, e), $97e331d20788a982$var$br(a._readableStreamController, e), d && f || i(void 0), null)), [
            n,
            a
        ];
    }(e);
}
function $97e331d20788a982$var$Sr(r) {
    var o;
    return $97e331d20788a982$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $97e331d20788a982$var$d(e);
            }
            return $97e331d20788a982$var$_(e, (e)=>{
                if (!$97e331d20788a982$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $97e331d20788a982$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $97e331d20788a982$var$fr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            try {
                return $97e331d20788a982$var$c(r.cancel(e));
            } catch (e) {
                return $97e331d20788a982$var$d(e);
            }
        }
        return o = $97e331d20788a982$var$Cr($97e331d20788a982$var$e, n, a, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $97e331d20788a982$var$fe(r, "async");
        function a() {
            let e;
            try {
                e = $97e331d20788a982$var$be(n);
            } catch (e) {
                return $97e331d20788a982$var$d(e);
            }
            return $97e331d20788a982$var$_($97e331d20788a982$var$c(e), (e)=>{
                if (!$97e331d20788a982$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $97e331d20788a982$var$dr(o._readableStreamController);
                else {
                    const t = e.value;
                    $97e331d20788a982$var$fr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            const r = n.iterator;
            let o;
            try {
                o = $97e331d20788a982$var$ue(r, "return");
            } catch (e) {
                return $97e331d20788a982$var$d(e);
            }
            if (void 0 === o) return $97e331d20788a982$var$c(void 0);
            return $97e331d20788a982$var$_($97e331d20788a982$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$97e331d20788a982$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $97e331d20788a982$var$Cr($97e331d20788a982$var$e, a, i, 0), o;
    }(r);
}
function $97e331d20788a982$var$gr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$g(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$vr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$g(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$wr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$S(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$Rr(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $97e331d20788a982$var$Tr(e, t) {
    $97e331d20788a982$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, a = null == e ? void 0 : e.signal;
    return void 0 !== a && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(a, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: a
    };
}
Object.defineProperties($97e331d20788a982$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$b0bb6d0989d67700.prototype.close, "close"), $97e331d20788a982$var$o($97e331d20788a982$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $97e331d20788a982$var$o($97e331d20788a982$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $97e331d20788a982$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $97e331d20788a982$var$I(e, "First parameter");
        const r = $97e331d20788a982$var$dt(t, "Second parameter"), o = function(e, t) {
            $97e331d20788a982$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, a = null == r ? void 0 : r.pull, i = null == r ? void 0 : r.start, l = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $97e331d20788a982$var$Q(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $97e331d20788a982$var$gr(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === a ? void 0 : $97e331d20788a982$var$vr(a, r, `${t} has member 'pull' that`),
                start: void 0 === i ? void 0 : $97e331d20788a982$var$wr(i, r, `${t} has member 'start' that`),
                type: void 0 === l ? void 0 : $97e331d20788a982$var$Rr(l, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($97e331d20788a982$var$qr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($97e331d20788a982$export$2047cf34091e94ac.prototype);
                let n, a, i;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$97e331d20788a982$var$c(void 0), i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$97e331d20788a982$var$c(void 0);
                const l = t.autoAllocateChunkSize;
                if (0 === l) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $97e331d20788a982$var$Je(e, o, n, a, i, r, l);
            }(this, o, $97e331d20788a982$var$ut(r, 0));
        } else {
            const e = $97e331d20788a982$var$ct(r);
            !function(e, t, r, o) {
                const n = Object.create($97e331d20788a982$export$b0bb6d0989d67700.prototype);
                let a, i, l;
                a = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$97e331d20788a982$var$c(void 0), l = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$97e331d20788a982$var$c(void 0), $97e331d20788a982$var$_r(e, n, a, i, l, r, o);
            }(this, o, $97e331d20788a982$var$ut(r, 1), e);
        }
    }
    get locked() {
        if (!$97e331d20788a982$var$Er(this)) throw $97e331d20788a982$var$jr("locked");
        return $97e331d20788a982$var$Wr(this);
    }
    cancel(e) {
        return $97e331d20788a982$var$Er(this) ? $97e331d20788a982$var$Wr(this) ? $97e331d20788a982$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $97e331d20788a982$var$Or(this, e) : $97e331d20788a982$var$d($97e331d20788a982$var$jr("cancel"));
    }
    getReader(e) {
        if (!$97e331d20788a982$var$Er(this)) throw $97e331d20788a982$var$jr("getReader");
        return void 0 === function(e, t) {
            $97e331d20788a982$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $97e331d20788a982$var$et(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $97e331d20788a982$var$H(this) : $97e331d20788a982$var$tt(this);
    }
    pipeThrough(e, t = {}) {
        if (!$97e331d20788a982$var$Er(this)) throw $97e331d20788a982$var$jr("pipeThrough");
        $97e331d20788a982$var$$(e, 1, "pipeThrough");
        const r = function(e, t) {
            $97e331d20788a982$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $97e331d20788a982$var$M(r, "readable", "ReadableWritablePair"), $97e331d20788a982$var$N(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $97e331d20788a982$var$M(o, "writable", "ReadableWritablePair"), $97e331d20788a982$var$pt(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $97e331d20788a982$var$Tr(t, "Second parameter");
        if ($97e331d20788a982$var$Wr(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($97e331d20788a982$var$vt(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $97e331d20788a982$var$p($97e331d20788a982$var$ir(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$97e331d20788a982$var$Er(this)) return $97e331d20788a982$var$d($97e331d20788a982$var$jr("pipeTo"));
        if (void 0 === e) return $97e331d20788a982$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$97e331d20788a982$var$gt(e)) return $97e331d20788a982$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $97e331d20788a982$var$Tr(t, "Second parameter");
        } catch (e) {
            return $97e331d20788a982$var$d(e);
        }
        return $97e331d20788a982$var$Wr(this) ? $97e331d20788a982$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $97e331d20788a982$var$vt(e) ? $97e331d20788a982$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $97e331d20788a982$var$ir(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$97e331d20788a982$var$Er(this)) throw $97e331d20788a982$var$jr("tee");
        return $97e331d20788a982$var$ne($97e331d20788a982$var$yr(this));
    }
    values(e) {
        if (!$97e331d20788a982$var$Er(this)) throw $97e331d20788a982$var$jr("values");
        return function(e, t) {
            const r = $97e331d20788a982$var$H(e), o = new $97e331d20788a982$var$he(r, t), n = Object.create($97e331d20788a982$var$me);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $97e331d20788a982$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$97e331d20788a982$var$de](e) {
        return this.values(e);
    }
    static from(e) {
        return $97e331d20788a982$var$Sr(e);
    }
}
function $97e331d20788a982$var$Cr(e, t, r, o = 1, n = ()=>1) {
    const a = Object.create($97e331d20788a982$export$5d3e1e5268af5f76.prototype);
    $97e331d20788a982$var$qr(a);
    return $97e331d20788a982$var$_r(a, Object.create($97e331d20788a982$export$b0bb6d0989d67700.prototype), e, t, r, o, n), a;
}
function $97e331d20788a982$var$Pr(e, t, r) {
    const o = Object.create($97e331d20788a982$export$5d3e1e5268af5f76.prototype);
    $97e331d20788a982$var$qr(o);
    return $97e331d20788a982$var$Je(o, Object.create($97e331d20788a982$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $97e331d20788a982$var$qr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $97e331d20788a982$var$Er(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $97e331d20788a982$export$5d3e1e5268af5f76;
}
function $97e331d20788a982$var$Wr(e) {
    return void 0 !== e._reader;
}
function $97e331d20788a982$var$Or(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $97e331d20788a982$var$c(void 0);
    if ("errored" === t._state) return $97e331d20788a982$var$d(t._storedError);
    $97e331d20788a982$var$Br(t);
    const o = t._reader;
    if (void 0 !== o && $97e331d20788a982$var$at(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $97e331d20788a982$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $97e331d20788a982$var$_(t._readableStreamController[$97e331d20788a982$var$T](r), $97e331d20788a982$var$e);
}
function $97e331d20788a982$var$Br(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($97e331d20788a982$var$A(t), $97e331d20788a982$var$J(t))) {
        const e = t._readRequests;
        t._readRequests = new $97e331d20788a982$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $97e331d20788a982$var$kr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($97e331d20788a982$var$j(r, t), $97e331d20788a982$var$J(r) ? $97e331d20788a982$var$Z(r, t) : $97e331d20788a982$var$lt(r, t));
}
function $97e331d20788a982$var$jr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $97e331d20788a982$var$Ar(e, t) {
    $97e331d20788a982$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $97e331d20788a982$var$M(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $97e331d20788a982$var$Y(r)
    };
}
Object.defineProperties($97e331d20788a982$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($97e331d20788a982$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.from, "from"), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.prototype.tee, "tee"), $97e331d20788a982$var$o($97e331d20788a982$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($97e331d20788a982$export$5d3e1e5268af5f76.prototype, $97e331d20788a982$var$de, {
    value: $97e331d20788a982$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $97e331d20788a982$var$zr = (e)=>e.byteLength;
$97e331d20788a982$var$o($97e331d20788a982$var$zr, "size");
class $97e331d20788a982$export$d386b5f37d154119 {
    constructor(e){
        $97e331d20788a982$var$$(e, 1, "ByteLengthQueuingStrategy"), e = $97e331d20788a982$var$Ar(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$97e331d20788a982$var$Lr(this)) throw $97e331d20788a982$var$Dr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$97e331d20788a982$var$Lr(this)) throw $97e331d20788a982$var$Dr("size");
        return $97e331d20788a982$var$zr;
    }
}
function $97e331d20788a982$var$Dr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $97e331d20788a982$var$Lr(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $97e331d20788a982$export$d386b5f37d154119;
}
Object.defineProperties($97e331d20788a982$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $97e331d20788a982$var$Fr = ()=>1;
$97e331d20788a982$var$o($97e331d20788a982$var$Fr, "size");
class $97e331d20788a982$export$9ebfec18c2dfc625 {
    constructor(e){
        $97e331d20788a982$var$$(e, 1, "CountQueuingStrategy"), e = $97e331d20788a982$var$Ar(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$97e331d20788a982$var$$r(this)) throw $97e331d20788a982$var$Ir("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$97e331d20788a982$var$$r(this)) throw $97e331d20788a982$var$Ir("size");
        return $97e331d20788a982$var$Fr;
    }
}
function $97e331d20788a982$var$Ir(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $97e331d20788a982$var$$r(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $97e331d20788a982$export$9ebfec18c2dfc625;
}
function $97e331d20788a982$var$Mr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$g(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$Yr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$S(e, t, [
            r
        ]);
}
function $97e331d20788a982$var$xr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r, o)=>$97e331d20788a982$var$g(e, t, [
            r,
            o
        ]);
}
function $97e331d20788a982$var$Qr(e, t, r) {
    return $97e331d20788a982$var$F(e, r), (r)=>$97e331d20788a982$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($97e331d20788a982$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $97e331d20788a982$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $97e331d20788a982$var$dt(t, "Second parameter"), n = $97e331d20788a982$var$dt(r, "Third parameter"), a = function(e, t) {
            $97e331d20788a982$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, a = null == e ? void 0 : e.start, i = null == e ? void 0 : e.transform, l = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $97e331d20788a982$var$Qr(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $97e331d20788a982$var$Mr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === a ? void 0 : $97e331d20788a982$var$Yr(a, e, `${t} has member 'start' that`),
                transform: void 0 === i ? void 0 : $97e331d20788a982$var$xr(i, e, `${t} has member 'transform' that`),
                writableType: l
            };
        }(e, "First parameter");
        if (void 0 !== a.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== a.writableType) throw new RangeError("Invalid writableType specified");
        const i = $97e331d20788a982$var$ut(n, 0), l = $97e331d20788a982$var$ct(n), s = $97e331d20788a982$var$ut(o, 1), f = $97e331d20788a982$var$ct(o);
        let h;
        !function(e, t, r, o, n, a) {
            function i() {
                return t;
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $97e331d20788a982$var$_(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $97e331d20788a982$var$Zr(r, t);
                    });
                    return $97e331d20788a982$var$Zr(r, t);
                }(e, t);
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $97e331d20788a982$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $97e331d20788a982$var$Jr(r), $97e331d20788a982$var$b(n, ()=>("errored" === o._state ? $97e331d20788a982$var$ro(r, o._storedError) : ($97e331d20788a982$var$br(o._readableStreamController, t), $97e331d20788a982$var$to(r)), null), (e)=>($97e331d20788a982$var$br(o._readableStreamController, e), $97e331d20788a982$var$ro(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $97e331d20788a982$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $97e331d20788a982$var$Jr(t), $97e331d20788a982$var$b(o, ()=>("errored" === r._state ? $97e331d20788a982$var$ro(t, r._storedError) : ($97e331d20788a982$var$dr(r._readableStreamController), $97e331d20788a982$var$to(t)), null), (e)=>($97e331d20788a982$var$br(r._readableStreamController, e), $97e331d20788a982$var$ro(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $97e331d20788a982$var$Gr(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $97e331d20788a982$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $97e331d20788a982$var$Jr(r), $97e331d20788a982$var$b(n, ()=>("errored" === o._state ? $97e331d20788a982$var$ro(r, o._storedError) : ($97e331d20788a982$var$Yt(o._writableStreamController, t), $97e331d20788a982$var$Ur(e), $97e331d20788a982$var$to(r)), null), (t)=>($97e331d20788a982$var$Yt(o._writableStreamController, t), $97e331d20788a982$var$Ur(e), $97e331d20788a982$var$ro(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, a = ()=>1) {
                const i = Object.create($97e331d20788a982$export$826849241f7970f8.prototype);
                return $97e331d20788a982$var$St(i), $97e331d20788a982$var$Ft(i, Object.create($97e331d20788a982$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, a), i;
            }(i, l, c, s, r, o), e._readable = $97e331d20788a982$var$Cr(i, d, f, n, a), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $97e331d20788a982$var$Gr(e, !0), e._transformStreamController = void 0;
        }(this, $97e331d20788a982$var$u((e)=>{
            h = e;
        }), s, f, i, l), function(e, t) {
            const r = Object.create($97e331d20788a982$export$a55559184460222.prototype);
            let o, n, a;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $97e331d20788a982$var$Kr(r, e), $97e331d20788a982$var$c(void 0);
                } catch (e) {
                    return $97e331d20788a982$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$97e331d20788a982$var$c(void 0);
            a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$97e331d20788a982$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, a);
        }(this, a), void 0 !== a.start ? h(a.start(this._transformStreamController)) : h(void 0);
    }
    get readable() {
        if (!$97e331d20788a982$var$Nr(this)) throw $97e331d20788a982$var$oo("readable");
        return this._readable;
    }
    get writable() {
        if (!$97e331d20788a982$var$Nr(this)) throw $97e331d20788a982$var$oo("writable");
        return this._writable;
    }
}
function $97e331d20788a982$var$Nr(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $97e331d20788a982$export$d102341634899398;
}
function $97e331d20788a982$var$Hr(e, t) {
    $97e331d20788a982$var$br(e._readable._readableStreamController, t), $97e331d20788a982$var$Vr(e, t);
}
function $97e331d20788a982$var$Vr(e, t) {
    $97e331d20788a982$var$Jr(e._transformStreamController), $97e331d20788a982$var$Yt(e._writable._writableStreamController, t), $97e331d20788a982$var$Ur(e);
}
function $97e331d20788a982$var$Ur(e) {
    e._backpressure && $97e331d20788a982$var$Gr(e, !1);
}
function $97e331d20788a982$var$Gr(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $97e331d20788a982$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($97e331d20788a982$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $97e331d20788a982$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$97e331d20788a982$var$Xr(this)) throw $97e331d20788a982$var$eo("desiredSize");
        return $97e331d20788a982$var$hr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$97e331d20788a982$var$Xr(this)) throw $97e331d20788a982$var$eo("enqueue");
        $97e331d20788a982$var$Kr(this, e);
    }
    error(e) {
        if (!$97e331d20788a982$var$Xr(this)) throw $97e331d20788a982$var$eo("error");
        var t;
        t = e, $97e331d20788a982$var$Hr(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$97e331d20788a982$var$Xr(this)) throw $97e331d20788a982$var$eo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $97e331d20788a982$var$dr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $97e331d20788a982$var$Vr(t, r);
        }(this);
    }
}
function $97e331d20788a982$var$Xr(e) {
    return !!$97e331d20788a982$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $97e331d20788a982$export$a55559184460222;
}
function $97e331d20788a982$var$Jr(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $97e331d20788a982$var$Kr(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$97e331d20788a982$var$mr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $97e331d20788a982$var$fr(o, t);
    } catch (e) {
        throw $97e331d20788a982$var$Vr(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$97e331d20788a982$var$ur(e);
    }(o);
    n !== r._backpressure && $97e331d20788a982$var$Gr(r, !0);
}
function $97e331d20788a982$var$Zr(e, t) {
    return $97e331d20788a982$var$_(e._transformAlgorithm(t), void 0, (t)=>{
        throw $97e331d20788a982$var$Hr(e._controlledTransformStream, t), t;
    });
}
function $97e331d20788a982$var$eo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $97e331d20788a982$var$to(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $97e331d20788a982$var$ro(e, t) {
    void 0 !== e._finishPromise_reject && ($97e331d20788a982$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $97e331d20788a982$var$oo(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($97e331d20788a982$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $97e331d20788a982$var$o($97e331d20788a982$export$a55559184460222.prototype.enqueue, "enqueue"), $97e331d20788a982$var$o($97e331d20788a982$export$a55559184460222.prototype.error, "error"), $97e331d20788a982$var$o($97e331d20788a982$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($97e331d20788a982$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});


parcelRegister("d5I5D", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "autorun", () => autorun);
$parcel$export(module.exports, "action", () => action);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

var $bd1ed0d24b354858$exports = {};
"use strict";
Object.defineProperty($bd1ed0d24b354858$exports, "__esModule", {
    value: true
});
$bd1ed0d24b354858$exports.Fragment = $bd1ed0d24b354858$exports.jsxDEV = $bd1ed0d24b354858$exports.jsxs = void 0;
$bd1ed0d24b354858$exports.jsx = $bd1ed0d24b354858$var$jsx;

var $ceFTv = parcelRequire("ceFTv");

var $8uN2z = parcelRequire("8uN2z");

var $begxM = parcelRequire("begxM");
/**
 * @see {@link https://github.com/reactjs/rfcs/blob/createlement-rfc/text/0000-create-element-changes.md}
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx}
 */ function $bd1ed0d24b354858$var$jsx(type, _a, key) {
    var ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "ref",
        "is",
        "style",
        "children"
    ]);
    if (typeof type === 'function' && (0, $8uN2z.isHTMLElementClass)(type)) type = (0, $8uN2z.tagNameOf)(type);
    children = [
        children
    ].flat(Infinity).map(function(node) {
        return node instanceof Object ? new $begxM.VNode(node) : node === 0 || node ? new $begxM.VNode({
            text: node.toString()
        }) : undefined;
    }).filter(Boolean);
    var commonProps = {
        key: key,
        ref: ref,
        is: is,
        style: style,
        children: children
    };
    return typeof type === 'string' ? new $begxM.VNode($ceFTv.__assign($ceFTv.__assign({}, commonProps), {
        tagName: type,
        props: props
    })) : type($ceFTv.__assign($ceFTv.__assign({}, commonProps), props));
}
$bd1ed0d24b354858$exports.jsxs = $bd1ed0d24b354858$var$jsx;
$bd1ed0d24b354858$exports.jsxDEV = $bd1ed0d24b354858$var$jsx;
/**
 * @see {@link https://babeljs.io/docs/babel-plugin-transform-react-jsx#react-automatic-runtime-1}
 */ var $bd1ed0d24b354858$var$Fragment = function(_a) {
    var key = _a.key, ref = _a.ref, is = _a.is, style = _a.style, children = _a.children, props = $ceFTv.__rest(_a, [
        "key",
        "ref",
        "is",
        "style",
        "children"
    ]);
    return new $begxM.VNode({
        key: key,
        ref: ref,
        is: is,
        props: (0, $8uN2z.isEmpty)(props) ? undefined : props,
        style: style,
        children: children
    });
};
$bd1ed0d24b354858$exports.Fragment = $bd1ed0d24b354858$var$Fragment;


var $5ec47347fc6130b4$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $5ec47347fc6130b4$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $5ec47347fc6130b4$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $5ec47347fc6130b4$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $5ec47347fc6130b4$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $5ec47347fc6130b4$var$InstrumentedPromise$1.prototype;
    return promise;
};
$5ec47347fc6130b4$var$InstrumentedPromise$1.__proto__ = $5ec47347fc6130b4$var$OriginalPromise;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.__proto__ = $5ec47347fc6130b4$var$OriginalPromise.prototype;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $5ec47347fc6130b4$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $5ec47347fc6130b4$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $5ec47347fc6130b4$export$cea1c58a6db52bca() {
    Promise = $5ec47347fc6130b4$var$InstrumentedPromise$1;
}
function $5ec47347fc6130b4$export$dfb5619354ba860() {
    if ($5ec47347fc6130b4$export$baf72085f5fb4df()) $5ec47347fc6130b4$export$cea1c58a6db52bca();
}
var $5ec47347fc6130b4$export$2e2bcd8739ae039 = $5ec47347fc6130b4$var$InstrumentedPromise$1;


var $c6ef78eb3a1442f8$exports = {};
"use strict";
Object.defineProperty($c6ef78eb3a1442f8$exports, "__esModule", {
    value: true
});

var $ceFTv = parcelRequire("ceFTv");

$ceFTv.__exportStar((parcelRequire("begxM")), $c6ef78eb3a1442f8$exports);

$ceFTv.__exportStar((parcelRequire("bGdIT")), $c6ef78eb3a1442f8$exports);



var $d5I5D = parcelRequire("d5I5D");

var $8uN2z = parcelRequire("8uN2z");

var $768425a223677417$var$Pe = Object.defineProperty;
var $768425a223677417$var$a = (e, t)=>$768425a223677417$var$Pe(e, "name", {
        value: t,
        configurable: !0
    });
var $768425a223677417$var$P = class {
    type = 3;
    name = "";
    prefix = "";
    value = "";
    suffix = "";
    modifier = 3;
    constructor(t, r, n, c, l, f){
        this.type = t, this.name = r, this.prefix = n, this.value = c, this.suffix = l, this.modifier = f;
    }
    hasCustomName() {
        return this.name !== "" && typeof this.name != "number";
    }
};
$768425a223677417$var$a($768425a223677417$var$P, "Part");
var $768425a223677417$var$Re = /[$_\p{ID_Start}]/u, $768425a223677417$var$Ee = /[$_\u200C\u200D\p{ID_Continue}]/u, $768425a223677417$var$v = ".*";
function $768425a223677417$var$Oe(e, t) {
    return (t ? /^[\x00-\xFF]*$/ : /^[\x00-\x7F]*$/).test(e);
}
$768425a223677417$var$a($768425a223677417$var$Oe, "isASCII");
function $768425a223677417$var$D(e, t = !1) {
    let r = [], n = 0;
    for(; n < e.length;){
        let c = e[n], l = $768425a223677417$var$a(function(f) {
            if (!t) throw new TypeError(f);
            r.push({
                type: "INVALID_CHAR",
                index: n,
                value: e[n++]
            });
        }, "ErrorOrInvalid");
        if (c === "*") {
            r.push({
                type: "ASTERISK",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === "+" || c === "?") {
            r.push({
                type: "OTHER_MODIFIER",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === "\\") {
            r.push({
                type: "ESCAPED_CHAR",
                index: n++,
                value: e[n++]
            });
            continue;
        }
        if (c === "{") {
            r.push({
                type: "OPEN",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === "}") {
            r.push({
                type: "CLOSE",
                index: n,
                value: e[n++]
            });
            continue;
        }
        if (c === ":") {
            let f = "", s = n + 1;
            for(; s < e.length;){
                let i = e.substr(s, 1);
                if (s === n + 1 && $768425a223677417$var$Re.test(i) || s !== n + 1 && $768425a223677417$var$Ee.test(i)) {
                    f += e[s++];
                    continue;
                }
                break;
            }
            if (!f) {
                l(`Missing parameter name at ${n}`);
                continue;
            }
            r.push({
                type: "NAME",
                index: n,
                value: f
            }), n = s;
            continue;
        }
        if (c === "(") {
            let f = 1, s = "", i = n + 1, o = !1;
            if (e[i] === "?") {
                l(`Pattern cannot start with "?" at ${i}`);
                continue;
            }
            for(; i < e.length;){
                if (!$768425a223677417$var$Oe(e[i], !1)) {
                    l(`Invalid character '${e[i]}' at ${i}.`), o = !0;
                    break;
                }
                if (e[i] === "\\") {
                    s += e[i++] + e[i++];
                    continue;
                }
                if (e[i] === ")") {
                    if (f--, f === 0) {
                        i++;
                        break;
                    }
                } else if (e[i] === "(" && (f++, e[i + 1] !== "?")) {
                    l(`Capturing groups are not allowed at ${i}`), o = !0;
                    break;
                }
                s += e[i++];
            }
            if (o) continue;
            if (f) {
                l(`Unbalanced pattern at ${n}`);
                continue;
            }
            if (!s) {
                l(`Missing pattern at ${n}`);
                continue;
            }
            r.push({
                type: "REGEX",
                index: n,
                value: s
            }), n = i;
            continue;
        }
        r.push({
            type: "CHAR",
            index: n,
            value: e[n++]
        });
    }
    return r.push({
        type: "END",
        index: n,
        value: ""
    }), r;
}
$768425a223677417$var$a($768425a223677417$var$D, "lexer");
function $768425a223677417$var$F(e, t = {}) {
    let r = $768425a223677417$var$D(e);
    t.delimiter ??= "/#?", t.prefixes ??= "./";
    let n = `[^${$768425a223677417$var$x(t.delimiter)}]+?`, c = [], l = 0, f = 0, s = "", i = new Set, o = $768425a223677417$var$a((u)=>{
        if (f < r.length && r[f].type === u) return r[f++].value;
    }, "tryConsume"), h = $768425a223677417$var$a(()=>o("OTHER_MODIFIER") ?? o("ASTERISK"), "tryConsumeModifier"), p = $768425a223677417$var$a((u)=>{
        let d = o(u);
        if (d !== void 0) return d;
        let { type: g, index: y } = r[f];
        throw new TypeError(`Unexpected ${g} at ${y}, expected ${u}`);
    }, "mustConsume"), A = $768425a223677417$var$a(()=>{
        let u = "", d;
        for(; d = o("CHAR") ?? o("ESCAPED_CHAR");)u += d;
        return u;
    }, "consumeText"), xe = $768425a223677417$var$a((u)=>u, "DefaultEncodePart"), N = t.encodePart || xe, H = "", $ = $768425a223677417$var$a((u)=>{
        H += u;
    }, "appendToPendingFixedValue"), M = $768425a223677417$var$a(()=>{
        H.length && (c.push(new $768425a223677417$var$P(3, "", "", N(H), "", 3)), H = "");
    }, "maybeAddPartFromPendingFixedValue"), X = $768425a223677417$var$a((u, d, g, y, Z)=>{
        let m = 3;
        switch(Z){
            case "?":
                m = 1;
                break;
            case "*":
                m = 0;
                break;
            case "+":
                m = 2;
                break;
        }
        if (!d && !g && m === 3) {
            $(u);
            return;
        }
        if (M(), !d && !g) {
            if (!u) return;
            c.push(new $768425a223677417$var$P(3, "", "", N(u), "", m));
            return;
        }
        let S;
        g ? g === "*" ? S = $768425a223677417$var$v : S = g : S = n;
        let k = 2;
        S === n ? (k = 1, S = "") : S === $768425a223677417$var$v && (k = 0, S = "");
        let E;
        if (d ? E = d : g && (E = l++), i.has(E)) throw new TypeError(`Duplicate name '${E}'.`);
        i.add(E), c.push(new $768425a223677417$var$P(k, E, N(u), S, N(y), m));
    }, "addPart");
    for(; f < r.length;){
        let u = o("CHAR"), d = o("NAME"), g = o("REGEX");
        if (!d && !g && (g = o("ASTERISK")), d || g) {
            let m = u ?? "";
            t.prefixes.indexOf(m) === -1 && ($(m), m = ""), M();
            let S = h();
            X(m, d, g, "", S);
            continue;
        }
        let y = u ?? o("ESCAPED_CHAR");
        if (y) {
            $(y);
            continue;
        }
        if (o("OPEN")) {
            let m = A(), S = o("NAME"), k = o("REGEX");
            !S && !k && (k = o("ASTERISK"));
            let E = A();
            p("CLOSE");
            let be = h();
            X(m, S, k, E, be);
            continue;
        }
        M(), p("END");
    }
    return c;
}
$768425a223677417$var$a($768425a223677417$var$F, "parse");
function $768425a223677417$var$x(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
$768425a223677417$var$a($768425a223677417$var$x, "escapeString");
function $768425a223677417$var$B(e) {
    return e && e.ignoreCase ? "ui" : "u";
}
$768425a223677417$var$a($768425a223677417$var$B, "flags");
function $768425a223677417$var$q(e, t, r) {
    return $768425a223677417$var$W($768425a223677417$var$F(e, r), t, r);
}
$768425a223677417$var$a($768425a223677417$var$q, "stringToRegexp");
function $768425a223677417$var$T(e) {
    switch(e){
        case 0:
            return "*";
        case 1:
            return "?";
        case 2:
            return "+";
        case 3:
            return "";
    }
}
$768425a223677417$var$a($768425a223677417$var$T, "modifierToString");
function $768425a223677417$var$W(e, t, r = {}) {
    r.delimiter ??= "/#?", r.prefixes ??= "./", r.sensitive ??= !1, r.strict ??= !1, r.end ??= !0, r.start ??= !0, r.endsWith = "";
    let n = r.start ? "^" : "";
    for (let s of e){
        if (s.type === 3) {
            s.modifier === 3 ? n += $768425a223677417$var$x(s.value) : n += `(?:${$768425a223677417$var$x(s.value)})${$768425a223677417$var$T(s.modifier)}`;
            continue;
        }
        t && t.push(s.name);
        let i = `[^${$768425a223677417$var$x(r.delimiter)}]+?`, o = s.value;
        if (s.type === 1 ? o = i : s.type === 0 && (o = $768425a223677417$var$v), !s.prefix.length && !s.suffix.length) {
            s.modifier === 3 || s.modifier === 1 ? n += `(${o})${$768425a223677417$var$T(s.modifier)}` : n += `((?:${o})${$768425a223677417$var$T(s.modifier)})`;
            continue;
        }
        if (s.modifier === 3 || s.modifier === 1) {
            n += `(?:${$768425a223677417$var$x(s.prefix)}(${o})${$768425a223677417$var$x(s.suffix)})`, n += $768425a223677417$var$T(s.modifier);
            continue;
        }
        n += `(?:${$768425a223677417$var$x(s.prefix)}`, n += `((?:${o})(?:`, n += $768425a223677417$var$x(s.suffix), n += $768425a223677417$var$x(s.prefix), n += `(?:${o}))*)${$768425a223677417$var$x(s.suffix)})`, s.modifier === 0 && (n += "?");
    }
    let c = `[${$768425a223677417$var$x(r.endsWith)}]|$`, l = `[${$768425a223677417$var$x(r.delimiter)}]`;
    if (r.end) return r.strict || (n += `${l}?`), r.endsWith.length ? n += `(?=${c})` : n += "$", new RegExp(n, $768425a223677417$var$B(r));
    r.strict || (n += `(?:${l}(?=${c}))?`);
    let f = !1;
    if (e.length) {
        let s = e[e.length - 1];
        s.type === 3 && s.modifier === 3 && (f = r.delimiter.indexOf(s) > -1);
    }
    return f || (n += `(?=${l}|${c})`), new RegExp(n, $768425a223677417$var$B(r));
}
$768425a223677417$var$a($768425a223677417$var$W, "partsToRegexp");
var $768425a223677417$var$b = {
    delimiter: "",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $768425a223677417$var$J = {
    delimiter: ".",
    prefixes: "",
    sensitive: !0,
    strict: !0
}, $768425a223677417$var$Q = {
    delimiter: "/",
    prefixes: "/",
    sensitive: !0,
    strict: !0
};
function $768425a223677417$var$ee(e, t) {
    return e.length ? e[0] === "/" ? !0 : !t || e.length < 2 ? !1 : (e[0] == "\\" || e[0] == "{") && e[1] == "/" : !1;
}
$768425a223677417$var$a($768425a223677417$var$ee, "isAbsolutePathname");
function $768425a223677417$var$te(e, t) {
    return e.startsWith(t) ? e.substring(t.length, e.length) : e;
}
$768425a223677417$var$a($768425a223677417$var$te, "maybeStripPrefix");
function $768425a223677417$var$ke(e, t) {
    return e.endsWith(t) ? e.substr(0, e.length - t.length) : e;
}
$768425a223677417$var$a($768425a223677417$var$ke, "maybeStripSuffix");
function $768425a223677417$var$_(e) {
    return !e || e.length < 2 ? !1 : e[0] === "[" || (e[0] === "\\" || e[0] === "{") && e[1] === "[";
}
$768425a223677417$var$a($768425a223677417$var$_, "treatAsIPv6Hostname");
var $768425a223677417$var$re = [
    "ftp",
    "file",
    "http",
    "https",
    "ws",
    "wss"
];
function $768425a223677417$var$U(e) {
    if (!e) return !0;
    for (let t of $768425a223677417$var$re)if (e.test(t)) return !0;
    return !1;
}
$768425a223677417$var$a($768425a223677417$var$U, "isSpecialScheme");
function $768425a223677417$var$ne(e, t) {
    if (e = $768425a223677417$var$te(e, "#"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.hash = e, r.hash ? r.hash.substring(1, r.hash.length) : "";
}
$768425a223677417$var$a($768425a223677417$var$ne, "canonicalizeHash");
function $768425a223677417$var$se(e, t) {
    if (e = $768425a223677417$var$te(e, "?"), t || e === "") return e;
    let r = new URL("https://example.com");
    return r.search = e, r.search ? r.search.substring(1, r.search.length) : "";
}
$768425a223677417$var$a($768425a223677417$var$se, "canonicalizeSearch");
function $768425a223677417$var$ie(e, t) {
    return t || e === "" ? e : $768425a223677417$var$_(e) ? $768425a223677417$var$K(e) : $768425a223677417$var$j(e);
}
$768425a223677417$var$a($768425a223677417$var$ie, "canonicalizeHostname");
function $768425a223677417$var$ae(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.password = e, r.password;
}
$768425a223677417$var$a($768425a223677417$var$ae, "canonicalizePassword");
function $768425a223677417$var$oe(e, t) {
    if (t || e === "") return e;
    let r = new URL("https://example.com");
    return r.username = e, r.username;
}
$768425a223677417$var$a($768425a223677417$var$oe, "canonicalizeUsername");
function $768425a223677417$var$ce(e, t, r) {
    if (r || e === "") return e;
    if (t && !$768425a223677417$var$re.includes(t)) return new URL(`${t}:${e}`).pathname;
    let n = e[0] == "/";
    return e = new URL(n ? e : "/-" + e, "https://example.com").pathname, n || (e = e.substring(2, e.length)), e;
}
$768425a223677417$var$a($768425a223677417$var$ce, "canonicalizePathname");
function $768425a223677417$var$le(e, t, r) {
    return $768425a223677417$var$z(t) === e && (e = ""), r || e === "" ? e : $768425a223677417$var$G(e);
}
$768425a223677417$var$a($768425a223677417$var$le, "canonicalizePort");
function $768425a223677417$var$fe(e, t) {
    return e = $768425a223677417$var$ke(e, ":"), t || e === "" ? e : $768425a223677417$var$w(e);
}
$768425a223677417$var$a($768425a223677417$var$fe, "canonicalizeProtocol");
function $768425a223677417$var$z(e) {
    switch(e){
        case "ws":
        case "http":
            return "80";
        case "wws":
        case "https":
            return "443";
        case "ftp":
            return "21";
        default:
            return "";
    }
}
$768425a223677417$var$a($768425a223677417$var$z, "defaultPortForProtocol");
function $768425a223677417$var$w(e) {
    if (e === "") return e;
    if (/^[-+.A-Za-z0-9]*$/.test(e)) return e.toLowerCase();
    throw new TypeError(`Invalid protocol '${e}'.`);
}
$768425a223677417$var$a($768425a223677417$var$w, "protocolEncodeCallback");
function $768425a223677417$var$he(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.username = e, t.username;
}
$768425a223677417$var$a($768425a223677417$var$he, "usernameEncodeCallback");
function $768425a223677417$var$ue(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.password = e, t.password;
}
$768425a223677417$var$a($768425a223677417$var$ue, "passwordEncodeCallback");
function $768425a223677417$var$j(e) {
    if (e === "") return e;
    if (/[\t\n\r #%/:<>?@[\]^\\|]/g.test(e)) throw new TypeError(`Invalid hostname '${e}'`);
    let t = new URL("https://example.com");
    return t.hostname = e, t.hostname;
}
$768425a223677417$var$a($768425a223677417$var$j, "hostnameEncodeCallback");
function $768425a223677417$var$K(e) {
    if (e === "") return e;
    if (/[^0-9a-fA-F[\]:]/g.test(e)) throw new TypeError(`Invalid IPv6 hostname '${e}'`);
    return e.toLowerCase();
}
$768425a223677417$var$a($768425a223677417$var$K, "ipv6HostnameEncodeCallback");
function $768425a223677417$var$G(e) {
    if (e === "" || /^[0-9]*$/.test(e) && parseInt(e) <= 65535) return e;
    throw new TypeError(`Invalid port '${e}'.`);
}
$768425a223677417$var$a($768425a223677417$var$G, "portEncodeCallback");
function $768425a223677417$var$de(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.pathname = e[0] !== "/" ? "/-" + e : e, e[0] !== "/" ? t.pathname.substring(2, t.pathname.length) : t.pathname;
}
$768425a223677417$var$a($768425a223677417$var$de, "standardURLPathnameEncodeCallback");
function $768425a223677417$var$pe(e) {
    return e === "" ? e : new URL(`data:${e}`).pathname;
}
$768425a223677417$var$a($768425a223677417$var$pe, "pathURLPathnameEncodeCallback");
function $768425a223677417$var$ge(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.search = e, t.search.substring(1, t.search.length);
}
$768425a223677417$var$a($768425a223677417$var$ge, "searchEncodeCallback");
function $768425a223677417$var$me(e) {
    if (e === "") return e;
    let t = new URL("https://example.com");
    return t.hash = e, t.hash.substring(1, t.hash.length);
}
$768425a223677417$var$a($768425a223677417$var$me, "hashEncodeCallback");
var $768425a223677417$var$C = class {
    #i;
    #n = [];
    #t = {};
    #e = 0;
    #s = 1;
    #l = 0;
    #o = 0;
    #d = 0;
    #p = 0;
    #g = !1;
    constructor(t){
        this.#i = t;
    }
    get result() {
        return this.#t;
    }
    parse() {
        for(this.#n = $768425a223677417$var$D(this.#i, !0); this.#e < this.#n.length; this.#e += this.#s){
            if (this.#s = 1, this.#n[this.#e].type === "END") {
                if (this.#o === 0) {
                    this.#b(), this.#f() ? this.#r(9, 1) : this.#h() ? this.#r(8, 1) : this.#r(7, 0);
                    continue;
                } else if (this.#o === 2) {
                    this.#u(5);
                    continue;
                }
                this.#r(10, 0);
                break;
            }
            if (this.#d > 0) {
                if (this.#A()) this.#d -= 1;
                else continue;
            }
            if (this.#T()) {
                this.#d += 1;
                continue;
            }
            switch(this.#o){
                case 0:
                    this.#P() && this.#u(1);
                    break;
                case 1:
                    if (this.#P()) {
                        this.#C();
                        let t = 7, r = 1;
                        this.#E() ? (t = 2, r = 3) : this.#g && (t = 2), this.#r(t, r);
                    }
                    break;
                case 2:
                    this.#S() ? this.#u(3) : (this.#x() || this.#h() || this.#f()) && this.#u(5);
                    break;
                case 3:
                    this.#O() ? this.#r(4, 1) : this.#S() && this.#r(5, 1);
                    break;
                case 4:
                    this.#S() && this.#r(5, 1);
                    break;
                case 5:
                    this.#y() ? this.#p += 1 : this.#w() && (this.#p -= 1), this.#k() && !this.#p ? this.#r(6, 1) : this.#x() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 6:
                    this.#x() ? this.#r(7, 0) : this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 7:
                    this.#h() ? this.#r(8, 1) : this.#f() && this.#r(9, 1);
                    break;
                case 8:
                    this.#f() && this.#r(9, 1);
                    break;
                case 9:
                    break;
                case 10:
                    break;
            }
        }
        this.#t.hostname !== void 0 && this.#t.port === void 0 && (this.#t.port = "");
    }
    #r(t, r) {
        switch(this.#o){
            case 0:
                break;
            case 1:
                this.#t.protocol = this.#c();
                break;
            case 2:
                break;
            case 3:
                this.#t.username = this.#c();
                break;
            case 4:
                this.#t.password = this.#c();
                break;
            case 5:
                this.#t.hostname = this.#c();
                break;
            case 6:
                this.#t.port = this.#c();
                break;
            case 7:
                this.#t.pathname = this.#c();
                break;
            case 8:
                this.#t.search = this.#c();
                break;
            case 9:
                this.#t.hash = this.#c();
                break;
            case 10:
                break;
        }
        this.#o !== 0 && t !== 10 && ([
            1,
            2,
            3,
            4
        ].includes(this.#o) && [
            6,
            7,
            8,
            9
        ].includes(t) && (this.#t.hostname ??= ""), [
            1,
            2,
            3,
            4,
            5,
            6
        ].includes(this.#o) && [
            8,
            9
        ].includes(t) && (this.#t.pathname ??= this.#g ? "/" : ""), [
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ].includes(this.#o) && t === 9 && (this.#t.search ??= "")), this.#R(t, r);
    }
    #R(t, r) {
        this.#o = t, this.#l = this.#e + r, this.#e += r, this.#s = 0;
    }
    #b() {
        this.#e = this.#l, this.#s = 0;
    }
    #u(t) {
        this.#b(), this.#o = t;
    }
    #m(t) {
        return t < 0 && (t = this.#n.length - t), t < this.#n.length ? this.#n[t] : this.#n[this.#n.length - 1];
    }
    #a(t, r) {
        let n = this.#m(t);
        return n.value === r && (n.type === "CHAR" || n.type === "ESCAPED_CHAR" || n.type === "INVALID_CHAR");
    }
    #P() {
        return this.#a(this.#e, ":");
    }
    #E() {
        return this.#a(this.#e + 1, "/") && this.#a(this.#e + 2, "/");
    }
    #S() {
        return this.#a(this.#e, "@");
    }
    #O() {
        return this.#a(this.#e, ":");
    }
    #k() {
        return this.#a(this.#e, ":");
    }
    #x() {
        return this.#a(this.#e, "/");
    }
    #h() {
        if (this.#a(this.#e, "?")) return !0;
        if (this.#n[this.#e].value !== "?") return !1;
        let t = this.#m(this.#e - 1);
        return t.type !== "NAME" && t.type !== "REGEX" && t.type !== "CLOSE" && t.type !== "ASTERISK";
    }
    #f() {
        return this.#a(this.#e, "#");
    }
    #T() {
        return this.#n[this.#e].type == "OPEN";
    }
    #A() {
        return this.#n[this.#e].type == "CLOSE";
    }
    #y() {
        return this.#a(this.#e, "[");
    }
    #w() {
        return this.#a(this.#e, "]");
    }
    #c() {
        let t = this.#n[this.#e], r = this.#m(this.#l).index;
        return this.#i.substring(r, t.index);
    }
    #C() {
        let t = {};
        Object.assign(t, $768425a223677417$var$b), t.encodePart = $768425a223677417$var$w;
        let r = $768425a223677417$var$q(this.#c(), void 0, t);
        this.#g = $768425a223677417$var$U(r);
    }
};
$768425a223677417$var$a($768425a223677417$var$C, "Parser");
var $768425a223677417$var$V = [
    "protocol",
    "username",
    "password",
    "hostname",
    "port",
    "pathname",
    "search",
    "hash"
], $768425a223677417$var$O = "*";
function $768425a223677417$var$Se(e, t) {
    if (typeof e != "string") throw new TypeError("parameter 1 is not of type 'string'.");
    let r = new URL(e, t);
    return {
        protocol: r.protocol.substring(0, r.protocol.length - 1),
        username: r.username,
        password: r.password,
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname,
        search: r.search !== "" ? r.search.substring(1, r.search.length) : void 0,
        hash: r.hash !== "" ? r.hash.substring(1, r.hash.length) : void 0
    };
}
$768425a223677417$var$a($768425a223677417$var$Se, "extractValues");
function $768425a223677417$var$R(e, t) {
    return t ? $768425a223677417$var$I(e) : e;
}
$768425a223677417$var$a($768425a223677417$var$R, "processBaseURLString");
function $768425a223677417$var$L(e, t, r) {
    let n;
    if (typeof t.baseURL == "string") try {
        n = new URL(t.baseURL), t.protocol === void 0 && (e.protocol = $768425a223677417$var$R(n.protocol.substring(0, n.protocol.length - 1), r)), !r && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && (e.username = $768425a223677417$var$R(n.username, r)), !r && t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.username === void 0 && t.password === void 0 && (e.password = $768425a223677417$var$R(n.password, r)), t.protocol === void 0 && t.hostname === void 0 && (e.hostname = $768425a223677417$var$R(n.hostname, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && (e.port = $768425a223677417$var$R(n.port, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && (e.pathname = $768425a223677417$var$R(n.pathname, r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && (e.search = $768425a223677417$var$R(n.search.substring(1, n.search.length), r)), t.protocol === void 0 && t.hostname === void 0 && t.port === void 0 && t.pathname === void 0 && t.search === void 0 && t.hash === void 0 && (e.hash = $768425a223677417$var$R(n.hash.substring(1, n.hash.length), r));
    } catch  {
        throw new TypeError(`invalid baseURL '${t.baseURL}'.`);
    }
    if (typeof t.protocol == "string" && (e.protocol = $768425a223677417$var$fe(t.protocol, r)), typeof t.username == "string" && (e.username = $768425a223677417$var$oe(t.username, r)), typeof t.password == "string" && (e.password = $768425a223677417$var$ae(t.password, r)), typeof t.hostname == "string" && (e.hostname = $768425a223677417$var$ie(t.hostname, r)), typeof t.port == "string" && (e.port = $768425a223677417$var$le(t.port, e.protocol, r)), typeof t.pathname == "string") {
        if (e.pathname = t.pathname, n && !$768425a223677417$var$ee(e.pathname, r)) {
            let c = n.pathname.lastIndexOf("/");
            c >= 0 && (e.pathname = $768425a223677417$var$R(n.pathname.substring(0, c + 1), r) + e.pathname);
        }
        e.pathname = $768425a223677417$var$ce(e.pathname, e.protocol, r);
    }
    return typeof t.search == "string" && (e.search = $768425a223677417$var$se(t.search, r)), typeof t.hash == "string" && (e.hash = $768425a223677417$var$ne(t.hash, r)), e;
}
$768425a223677417$var$a($768425a223677417$var$L, "applyInit");
function $768425a223677417$var$I(e) {
    return e.replace(/([+*?:{}()\\])/g, "\\$1");
}
$768425a223677417$var$a($768425a223677417$var$I, "escapePatternString");
function $768425a223677417$var$Te(e) {
    return e.replace(/([.+*?^${}()[\]|/\\])/g, "\\$1");
}
$768425a223677417$var$a($768425a223677417$var$Te, "escapeRegexpString");
function $768425a223677417$var$Ae(e, t) {
    t.delimiter ??= "/#?", t.prefixes ??= "./", t.sensitive ??= !1, t.strict ??= !1, t.end ??= !0, t.start ??= !0, t.endsWith = "";
    let r = ".*", n = `[^${$768425a223677417$var$Te(t.delimiter)}]+?`, c = /[$_\u200C\u200D\p{ID_Continue}]/u, l = "";
    for(let f = 0; f < e.length; ++f){
        let s = e[f];
        if (s.type === 3) {
            if (s.modifier === 3) {
                l += $768425a223677417$var$I(s.value);
                continue;
            }
            l += `{${$768425a223677417$var$I(s.value)}}${$768425a223677417$var$T(s.modifier)}`;
            continue;
        }
        let i = s.hasCustomName(), o = !!s.suffix.length || !!s.prefix.length && (s.prefix.length !== 1 || !t.prefixes.includes(s.prefix)), h = f > 0 ? e[f - 1] : null, p = f < e.length - 1 ? e[f + 1] : null;
        if (!o && i && s.type === 1 && s.modifier === 3 && p && !p.prefix.length && !p.suffix.length) {
            if (p.type === 3) {
                let A = p.value.length > 0 ? p.value[0] : "";
                o = c.test(A);
            } else o = !p.hasCustomName();
        }
        if (!o && !s.prefix.length && h && h.type === 3) {
            let A = h.value[h.value.length - 1];
            o = t.prefixes.includes(A);
        }
        o && (l += "{"), l += $768425a223677417$var$I(s.prefix), i && (l += `:${s.name}`), s.type === 2 ? l += `(${s.value})` : s.type === 1 ? i || (l += `(${n})`) : s.type === 0 && (!i && (!h || h.type === 3 || h.modifier !== 3 || o || s.prefix !== "") ? l += "*" : l += `(${r})`), s.type === 1 && i && s.suffix.length && c.test(s.suffix[0]) && (l += "\\"), l += $768425a223677417$var$I(s.suffix), o && (l += "}"), s.modifier !== 3 && (l += $768425a223677417$var$T(s.modifier));
    }
    return l;
}
$768425a223677417$var$a($768425a223677417$var$Ae, "partsToPattern");
var $768425a223677417$export$a348b14d2b61192c = class {
    #i;
    #n = {};
    #t = {};
    #e = {};
    #s = {};
    #l = !1;
    constructor(t = {}, r, n){
        try {
            let c;
            if (typeof r == "string" ? c = r : n = r, typeof t == "string") {
                let i = new $768425a223677417$var$C(t);
                if (i.parse(), t = i.result, c === void 0 && typeof t.protocol != "string") throw new TypeError("A base URL must be provided for a relative constructor string.");
                t.baseURL = c;
            } else {
                if (!t || typeof t != "object") throw new TypeError("parameter 1 is not of type 'string' and cannot convert to dictionary.");
                if (c) throw new TypeError("parameter 1 is not of type 'string'.");
            }
            typeof n > "u" && (n = {
                ignoreCase: !1
            });
            let l = {
                ignoreCase: n.ignoreCase === !0
            }, f = {
                pathname: $768425a223677417$var$O,
                protocol: $768425a223677417$var$O,
                username: $768425a223677417$var$O,
                password: $768425a223677417$var$O,
                hostname: $768425a223677417$var$O,
                port: $768425a223677417$var$O,
                search: $768425a223677417$var$O,
                hash: $768425a223677417$var$O
            };
            this.#i = $768425a223677417$var$L(f, t, !0), $768425a223677417$var$z(this.#i.protocol) === this.#i.port && (this.#i.port = "");
            let s;
            for (s of $768425a223677417$var$V){
                if (!(s in this.#i)) continue;
                let i = {}, o = this.#i[s];
                switch(this.#t[s] = [], s){
                    case "protocol":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$w;
                        break;
                    case "username":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$he;
                        break;
                    case "password":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$ue;
                        break;
                    case "hostname":
                        Object.assign(i, $768425a223677417$var$J), $768425a223677417$var$_(o) ? i.encodePart = $768425a223677417$var$K : i.encodePart = $768425a223677417$var$j;
                        break;
                    case "port":
                        Object.assign(i, $768425a223677417$var$b), i.encodePart = $768425a223677417$var$G;
                        break;
                    case "pathname":
                        $768425a223677417$var$U(this.#n.protocol) ? (Object.assign(i, $768425a223677417$var$Q, l), i.encodePart = $768425a223677417$var$de) : (Object.assign(i, $768425a223677417$var$b, l), i.encodePart = $768425a223677417$var$pe);
                        break;
                    case "search":
                        Object.assign(i, $768425a223677417$var$b, l), i.encodePart = $768425a223677417$var$ge;
                        break;
                    case "hash":
                        Object.assign(i, $768425a223677417$var$b, l), i.encodePart = $768425a223677417$var$me;
                        break;
                }
                try {
                    this.#s[s] = $768425a223677417$var$F(o, i), this.#n[s] = $768425a223677417$var$W(this.#s[s], this.#t[s], i), this.#e[s] = $768425a223677417$var$Ae(this.#s[s], i), this.#l = this.#l || this.#s[s].some((h)=>h.type === 2);
                } catch  {
                    throw new TypeError(`invalid ${s} pattern '${this.#i[s]}'.`);
                }
            }
        } catch (c) {
            throw new TypeError(`Failed to construct 'URLPattern': ${c.message}`);
        }
    }
    get [Symbol.toStringTag]() {
        return "URLPattern";
    }
    test(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return !1;
        try {
            typeof t == "object" ? n = $768425a223677417$var$L(n, t, !1) : n = $768425a223677417$var$L(n, $768425a223677417$var$Se(t, r), !1);
        } catch  {
            return !1;
        }
        let c;
        for (c of $768425a223677417$var$V)if (!this.#n[c].exec(n[c])) return !1;
        return !0;
    }
    exec(t = {}, r) {
        let n = {
            pathname: "",
            protocol: "",
            username: "",
            password: "",
            hostname: "",
            port: "",
            search: "",
            hash: ""
        };
        if (typeof t != "string" && r) throw new TypeError("parameter 1 is not of type 'string'.");
        if (typeof t > "u") return;
        try {
            typeof t == "object" ? n = $768425a223677417$var$L(n, t, !1) : n = $768425a223677417$var$L(n, $768425a223677417$var$Se(t, r), !1);
        } catch  {
            return null;
        }
        let c = {};
        r ? c.inputs = [
            t,
            r
        ] : c.inputs = [
            t
        ];
        let l;
        for (l of $768425a223677417$var$V){
            let f = this.#n[l].exec(n[l]);
            if (!f) return null;
            let s = {};
            for (let [i, o] of this.#t[l].entries())if (typeof o == "string" || typeof o == "number") {
                let h = f[i + 1];
                s[o] = h;
            }
            c[l] = {
                input: n[l] ?? "",
                groups: s
            };
        }
        return c;
    }
    static compareComponent(t, r, n) {
        let c = $768425a223677417$var$a((i, o)=>{
            for (let h of [
                "type",
                "modifier",
                "prefix",
                "value",
                "suffix"
            ]){
                if (i[h] < o[h]) return -1;
                if (i[h] === o[h]) continue;
                return 1;
            }
            return 0;
        }, "comparePart"), l = new $768425a223677417$var$P(3, "", "", "", "", 3), f = new $768425a223677417$var$P(0, "", "", "", "", 3), s = $768425a223677417$var$a((i, o)=>{
            let h = 0;
            for(; h < Math.min(i.length, o.length); ++h){
                let p = c(i[h], o[h]);
                if (p) return p;
            }
            return i.length === o.length ? 0 : c(i[h] ?? l, o[h] ?? l);
        }, "comparePartList");
        return !r.#e[t] && !n.#e[t] ? 0 : r.#e[t] && !n.#e[t] ? s(r.#s[t], [
            f
        ]) : !r.#e[t] && n.#e[t] ? s([
            f
        ], n.#s[t]) : s(r.#s[t], n.#s[t]);
    }
    get protocol() {
        return this.#e.protocol;
    }
    get username() {
        return this.#e.username;
    }
    get password() {
        return this.#e.password;
    }
    get hostname() {
        return this.#e.hostname;
    }
    get port() {
        return this.#e.port;
    }
    get pathname() {
        return this.#e.pathname;
    }
    get search() {
        return this.#e.search;
    }
    get hash() {
        return this.#e.hash;
    }
    get hasRegExpGroups() {
        return this.#l;
    }
};
$768425a223677417$var$a($768425a223677417$export$a348b14d2b61192c, "URLPattern");


if (!globalThis.URLPattern) globalThis.URLPattern = (0, $768425a223677417$export$a348b14d2b61192c);



var $8uN2z = parcelRequire("8uN2z");

var $d5I5D = parcelRequire("d5I5D");




var $d5I5D = parcelRequire("d5I5D");

var $8uN2z = parcelRequire("8uN2z");

function $6f83f77ba8e7af5c$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $6f83f77ba8e7af5c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$d4436c849e74ae70$exports, "AnimateCSS", function() {
    return $6f83f77ba8e7af5c$export$2e9a7bb10257a509;
});
var $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports, "observer", function() {
    return $6f83f77ba8e7af5c$export$b6ae1bc530f4c149;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports, "attribute", function() {
    return $6f83f77ba8e7af5c$export$af4b9a83f4b00434;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$f0344b6cd718ce24$exports, "reaction", function() {
    return $6f83f77ba8e7af5c$export$7203b476385689ae;
});
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$exports, "FunctionCell", function() {
    return $6f83f77ba8e7af5c$export$62c4dbcb062576f6;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$exports, "lazy", function() {
    return $6f83f77ba8e7af5c$export$488013bae63b21da;
});
var $6f83f77ba8e7af5c$var$$317b1f21909c74b8$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$317b1f21909c74b8$exports, "component", function() {
    return $6f83f77ba8e7af5c$export$d8556a2a8f973135;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$317b1f21909c74b8$exports, "on", function() {
    return $6f83f77ba8e7af5c$export$af631764ddc44097;
});
const $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap = new WeakMap();
function $6f83f77ba8e7af5c$export$d8556a2a8f973135(meta) {
    return (Class, { addInitializer: addInitializer })=>{
        class RendererComponent extends Class {
            get root() {
                return this.shadowRoot || this.internals.shadowRoot || this;
            }
            constructor(){
                var _a;
                super();
                Object.defineProperty(this, "internals", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: this.tagName.includes('-') ? this.attachInternals() : undefined
                });
                Object.defineProperty(this, "renderer", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: new (0, $c6ef78eb3a1442f8$exports.DOMRenderer)()
                });
                Object.defineProperty(this, "mounted", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: false
                });
                if (meta.mode && !((_a = this.internals) === null || _a === void 0 ? void 0 : _a.shadowRoot)) this.attachShadow(meta);
            }
            async connectedCallback() {
                var _a, _b;
                const { mode: mode } = meta;
                const renderChildren = !(mode != null);
                const { root: root } = this, events = $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, selector: selector, handler: handler } of events){
                    if (renderChildren && /^:host/.test(selector)) console.warn(`[WebCell] DOM Event delegation of "${selector}" won't work if you don't invoke "this.attachShadow()" manually.`);
                    root.addEventListener(type, handler);
                }
                (_a = super['connectedCallback']) === null || _a === void 0 || _a.call(this);
                if (this.mounted) return;
                await this.update();
                this.mounted = true;
                (_b = this.mountedCallback) === null || _b === void 0 || _b.call(this);
            }
            updateDOM(content) {
                var _a, _b;
                const result = this.renderer.render(content, this.root, meta.renderMode);
                return result instanceof Promise ? result.then((_a = this.updatedCallback) === null || _a === void 0 ? void 0 : _a.bind(this)) : (_b = this.updatedCallback) === null || _b === void 0 ? void 0 : _b.call(this);
            }
            async update() {
                var _a;
                const vNode = (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this);
                const content = (0, $8uN2z.isEmpty)(vNode) ? meta.mode ? (0, $bd1ed0d24b354858$exports.jsx)("slot", {}) : null : vNode;
                if (!(content != null)) return;
                if (!meta.transitible || typeof document.startViewTransition !== 'function') return this.updateDOM(content);
                const { updateCallbackDone: updateCallbackDone, finished: finished } = document.startViewTransition(()=>this.updateDOM(content));
                try {
                    await finished;
                } catch (_b) {
                    return updateCallbackDone;
                }
            }
            disconnectedCallback() {
                var _a;
                const { root: root } = this, events = $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.get(this) || [];
                for (const { type: type, handler: handler } of events)root.removeEventListener(type, handler);
                (_a = super['disconnectedCallback']) === null || _a === void 0 || _a.call(this);
            }
            emit(event, detail, { cancelable: cancelable, bubbles: bubbles, composed: composed } = {}) {
                return this.dispatchEvent(new CustomEvent(event, {
                    detail: detail,
                    cancelable: cancelable,
                    bubbles: bubbles,
                    composed: composed
                }));
            }
        }
        addInitializer(function() {
            var _a;
            (_a = globalThis.customElements) === null || _a === void 0 || _a.define(meta.tagName, this, meta);
        });
        return RendererComponent;
    };
}
function $6f83f77ba8e7af5c$export$af631764ddc44097(type, selector) {
    return (method, { addInitializer: addInitializer })=>addInitializer(function() {
            const events = $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.get(this) || [], handler = (0, $8uN2z.delegate)(selector, method.bind(this));
            events.push({
                type: type,
                selector: selector,
                handler: handler
            });
            $6f83f77ba8e7af5c$var$$317b1f21909c74b8$var$eventMap.set(this, events);
        });
}
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $6f83f77ba8e7af5c$export$62c4dbcb062576f6 = (()=>{
    var _FunctionCell_component_accessor_storage, _FunctionCell_vNode_accessor_storage;
    let _classDecorators = [
        $6f83f77ba8e7af5c$export$d8556a2a8f973135({
            tagName: 'function-cell'
        }),
        $6f83f77ba8e7af5c$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _component_decorators;
    let _component_initializers = [];
    let _component_extraInitializers = [];
    let _vNode_decorators;
    let _vNode_initializers = [];
    let _vNode_extraInitializers = [];
    var FunctionCell = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _FunctionCell_component_accessor_storage.set(this, $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_initializers, void 0));
            _FunctionCell_vNode_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _component_extraInitializers), $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _vNode_initializers, void 0)));
            Object.defineProperty(this, "disconnectedCallback", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(this, _vNode_extraInitializers), (0, $d5I5D.reaction)(()=>this.component, ()=>this.vNode = undefined))
            });
        }
        get component() {
            return $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _FunctionCell_component_accessor_storage, "f");
        }
        set component(value) {
            $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _FunctionCell_component_accessor_storage, value, "f");
        }
        get vNode() {
            return $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldGet(this, _FunctionCell_vNode_accessor_storage, "f");
        }
        set vNode(value) {
            $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__classPrivateFieldSet(this, _FunctionCell_vNode_accessor_storage, value, "f");
        }
        render() {
            const result = this.vNode || this.component({});
            if (!(result instanceof Promise)) return result;
            result.then((vNode)=>this.vNode = vNode);
        }
    };
    _FunctionCell_component_accessor_storage = new WeakMap();
    _FunctionCell_vNode_accessor_storage = new WeakMap();
    $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__setFunctionName(_classThis, "FunctionCell");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _component_decorators = [
            (0, $d5I5D.observable)
        ];
        _vNode_decorators = [
            (0, $d5I5D.observable)
        ];
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _component_decorators, {
            kind: "accessor",
            name: "component",
            static: false,
            private: false,
            access: {
                has: (obj)=>"component" in obj,
                get: (obj)=>obj.component,
                set: (obj, value)=>{
                    obj.component = value;
                }
            },
            metadata: _metadata
        }, _component_initializers, _component_extraInitializers);
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate(_classThis, null, _vNode_decorators, {
            kind: "accessor",
            name: "vNode",
            static: false,
            private: false,
            access: {
                has: (obj)=>"vNode" in obj,
                get: (obj)=>obj.vNode,
                set: (obj, value)=>{
                    obj.vNode = value;
                }
            },
            metadata: _metadata
        }, _vNode_initializers, _vNode_extraInitializers);
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        FunctionCell = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $6f83f77ba8e7af5c$var$$8acf79bd061a8fc3$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return FunctionCell = _classThis;
})();
const $6f83f77ba8e7af5c$export$488013bae63b21da = (loader)=>(props)=>(0, $bd1ed0d24b354858$exports.jsx)($6f83f77ba8e7af5c$export$62c4dbcb062576f6, {
            component: async ()=>{
                const { default: Tag } = await loader();
                return (0, $bd1ed0d24b354858$exports.jsx)(Tag, Object.assign({}, props));
            }
        });
var $6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports, "Defer", function() {
    return $6f83f77ba8e7af5c$export$c7e91f8aec23ae14;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports, "getMobxData", function() {
    return $6f83f77ba8e7af5c$export$b06b4c21253e26e2;
});
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$552a56cc5ff3f479$exports, "animated", function() {
    return $6f83f77ba8e7af5c$export$4077c0dfbe9c3861;
});
class $6f83f77ba8e7af5c$export$c7e91f8aec23ae14 {
    constructor(){
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Promise((resolve, reject)=>{
                this.resolve = resolve;
                this.reject = reject;
            })
        });
    }
}
function $6f83f77ba8e7af5c$export$b06b4c21253e26e2(observable) {
    var _a;
    for (const key of Object.getOwnPropertySymbols(observable)){
        const store = (_a = observable[key]) === null || _a === void 0 ? void 0 : _a.values_;
        if (store instanceof Map) return Object.fromEntries(Array.from(store, ([key, { value_: value_ }])=>[
                key,
                value_
            ]));
    }
}
const $6f83f77ba8e7af5c$export$4077c0dfbe9c3861 = (root, targetSelector)=>new Promise((resolve)=>{
        const ended = (0, $8uN2z.delegate)(targetSelector, (event)=>{
            root.removeEventListener('animationend', ended);
            root.removeEventListener('animationcancel', ended);
            resolve(event);
        });
        root.addEventListener('animationend', ended);
        root.addEventListener('animationcancel', ended);
    });
var $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
const $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap = new WeakMap();
function $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$wrapClass(Component) {
    var _ObserverComponent_instances, _ObserverComponent_boot;
    class ObserverComponent extends Component {
        get props() {
            return $6f83f77ba8e7af5c$export$b06b4c21253e26e2(this);
        }
        constructor(){
            super();
            _ObserverComponent_instances.add(this);
            Object.defineProperty(this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "update", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const { update: update } = Object.getPrototypeOf(this);
                    return new Promise((resolve)=>this.disposers.push((0, $d5I5D.autorun)(()=>update.call(this).then(resolve))));
                }
            });
            Promise.resolve().then(()=>$6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$__classPrivateFieldGet(this, _ObserverComponent_instances, "m", _ObserverComponent_boot).call(this));
        }
        disconnectedCallback() {
            var _a;
            for (const disposer of this.disposers)disposer();
            this.disposers.length = 0;
            (_a = super['disconnectedCallback']) === null || _a === void 0 || _a.call(this);
        }
        setAttribute(name, value) {
            const old = super.getAttribute(name), names = this.constructor['observedAttributes'];
            super.setAttribute(name, value);
            if (names.includes(name)) this.attributeChangedCallback(name, old, value);
        }
        attributeChangedCallback(name, old, value) {
            var _a;
            this[(0, $8uN2z.toCamelCase)(name)] = (0, $8uN2z.parseJSON)(value);
            (_a = super['attributeChangedCallback']) === null || _a === void 0 || _a.call(this, name, old, value);
        }
        syncPropAttr(name) {
            var _a;
            let value = this[(0, $8uN2z.toCamelCase)(name)];
            if (!(value != null) || value === false) return this.removeAttribute(name);
            value = value === true ? name : value;
            if (typeof value === 'object') {
                value = (_a = value.toJSON) === null || _a === void 0 ? void 0 : _a.call(value);
                value = typeof value === 'object' ? JSON.stringify(value) : value;
            }
            super.setAttribute(name, value);
        }
    }
    _ObserverComponent_instances = new WeakSet(), _ObserverComponent_boot = function _ObserverComponent_boot() {
        const names = this.constructor['observedAttributes'] || [], reactions = $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap.get(this) || [];
        this.disposers.push(...names.map((name)=>(0, $d5I5D.autorun)(()=>this.syncPropAttr(name))), ...reactions.map(({ expression: expression, effect: effect })=>(0, $d5I5D.reaction)((reaction)=>expression(this, reaction), effect.bind(this))));
    };
    Object.defineProperty(ObserverComponent, "observedAttributes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: []
    });
    return ObserverComponent;
}
function $6f83f77ba8e7af5c$export$b6ae1bc530f4c149(func, _) {
    return (0, $8uN2z.isHTMLElementClass)(func) ? $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$wrapClass(func) : (props)=>(0, $bd1ed0d24b354858$exports.jsx)($6f83f77ba8e7af5c$export$62c4dbcb062576f6, {
            component: ()=>func(props)
        });
}
function $6f83f77ba8e7af5c$export$af4b9a83f4b00434(_, { name: name, addInitializer: addInitializer }) {
    addInitializer(function() {
        const names = this.constructor['observedAttributes'], attribute = (0, $8uN2z.toHyphenCase)(name.toString());
        if (!names.includes(attribute)) names.push(attribute);
    });
}
const $6f83f77ba8e7af5c$export$7203b476385689ae = (expression)=>(effect, { addInitializer: addInitializer })=>addInitializer(function() {
            const reactions = $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $6f83f77ba8e7af5c$var$$f0344b6cd718ce24$var$reactionMap.set(this, reactions);
        });
var $6f83f77ba8e7af5c$var$$819b340f625a29f4$exports = {};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $6f83f77ba8e7af5c$export$2e9a7bb10257a509 = (()=>{
    var _AnimateCSS_type_accessor_storage, _AnimateCSS_playing_accessor_storage;
    let _classDecorators = [
        $6f83f77ba8e7af5c$export$d8556a2a8f973135({
            tagName: 'animation-css'
        }),
        $6f83f77ba8e7af5c$export$b6ae1bc530f4c149
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _playing_decorators;
    let _playing_initializers = [];
    let _playing_extraInitializers = [];
    let _typeChanged_decorators;
    var AnimateCSS = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _AnimateCSS_type_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _instanceExtraInitializers), $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _type_initializers, void 0)));
            _AnimateCSS_playing_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _type_extraInitializers), $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_initializers, false)));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(this, _playing_extraInitializers)
            });
        }
        get type() {
            return $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_type_accessor_storage, "f");
        }
        set type(value) {
            $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_type_accessor_storage, value, "f");
        }
        get playing() {
            return $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldGet(this, _AnimateCSS_playing_accessor_storage, "f");
        }
        set playing(value) {
            $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__classPrivateFieldSet(this, _AnimateCSS_playing_accessor_storage, value, "f");
        }
        async connectedCallback() {
            await (0, $8uN2z.importCSS)('https://unpkg.com/animate.css@4/animate.min.css');
            this.typeChanged();
        }
        async typeChanged() {
            this.playing = true;
            await $6f83f77ba8e7af5c$export$4077c0dfbe9c3861(this, '.animate__animated');
            this.playing = false;
        }
        render() {
            const { type: type, playing: playing, component: Tag } = this;
            return playing ? (0, $bd1ed0d24b354858$exports.jsx)(Tag, {
                className: `animate__animated animate__${type}`
            }) : type.includes('Out') ? (0, $bd1ed0d24b354858$exports.jsx)((0, $bd1ed0d24b354858$exports.Fragment), {}) : (0, $bd1ed0d24b354858$exports.jsx)(Tag, {});
        }
    };
    _AnimateCSS_type_accessor_storage = new WeakMap();
    _AnimateCSS_playing_accessor_storage = new WeakMap();
    $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__setFunctionName(_classThis, "AnimateCSS");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
            (0, $d5I5D.observable)
        ];
        _playing_decorators = [
            $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
            (0, $d5I5D.observable)
        ];
        _typeChanged_decorators = [
            $6f83f77ba8e7af5c$export$7203b476385689ae(({ type: type })=>type)
        ];
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _playing_decorators, {
            kind: "accessor",
            name: "playing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"playing" in obj,
                get: (obj)=>obj.playing,
                set: (obj, value)=>{
                    obj.playing = value;
                }
            },
            metadata: _metadata
        }, _playing_initializers, _playing_extraInitializers);
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(_classThis, null, _typeChanged_decorators, {
            kind: "method",
            name: "typeChanged",
            static: false,
            private: false,
            access: {
                has: (obj)=>"typeChanged" in obj,
                get: (obj)=>obj.typeChanged
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        AnimateCSS = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $6f83f77ba8e7af5c$var$$d4436c849e74ae70$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return AnimateCSS = _classThis;
})();
$6f83f77ba8e7af5c$var$$parcel$exportWildcard($6f83f77ba8e7af5c$var$$d4436c849e74ae70$exports, $6f83f77ba8e7af5c$var$$819b340f625a29f4$exports);
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$exports = {};
$6f83f77ba8e7af5c$var$$parcel$export($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$exports, "formField", function() {
    return $6f83f77ba8e7af5c$export$2a668e8d088a0667;
});
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $6f83f77ba8e7af5c$export$2a668e8d088a0667(Class, _) {
    let FormFieldComponent = (()=>{
        var _a, _FormFieldComponent_name_accessor_storage, _FormFieldComponent_value_accessor_storage, _FormFieldComponent_required_accessor_storage, _FormFieldComponent_disabled_accessor_storage, _FormFieldComponent_autofocus_accessor_storage;
        let _classSuper = Class;
        let _instanceExtraInitializers = [];
        let _setValue_decorators;
        let _name_decorators;
        let _name_initializers = [];
        let _name_extraInitializers = [];
        let _value_decorators;
        let _value_initializers = [];
        let _value_extraInitializers = [];
        let _required_decorators;
        let _required_initializers = [];
        let _required_extraInitializers = [];
        let _disabled_decorators;
        let _disabled_initializers = [];
        let _disabled_extraInitializers = [];
        let _autofocus_decorators;
        let _autofocus_initializers = [];
        let _autofocus_extraInitializers = [];
        return _a = class FormFieldComponent extends _classSuper {
            setValue(value) {
                this.internals.setFormValue(value);
            }
            formDisabledCallback(disabled) {
                this.disabled = disabled;
            }
            get name() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_name_accessor_storage, "f");
            }
            set name(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_name_accessor_storage, value, "f");
            }
            get value() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_value_accessor_storage, "f");
            }
            set value(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_value_accessor_storage, value, "f");
            }
            get required() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_required_accessor_storage, "f");
            }
            set required(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_required_accessor_storage, value, "f");
            }
            get disabled() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_disabled_accessor_storage, "f");
            }
            set disabled(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_disabled_accessor_storage, value, "f");
            }
            get autofocus() {
                return $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldGet(this, _FormFieldComponent_autofocus_accessor_storage, "f");
            }
            set autofocus(value) {
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__classPrivateFieldSet(this, _FormFieldComponent_autofocus_accessor_storage, value, "f");
            }
            set defaultValue(raw) {
                var _b;
                this.setAttribute('value', raw);
                (_b = this.value) !== null && _b !== void 0 ? _b : this.value = raw;
            }
            get defaultValue() {
                return this.getAttribute('value');
            }
            get form() {
                return this.internals.form;
            }
            get validity() {
                return this.internals.validity;
            }
            get validationMessage() {
                return this.internals.validationMessage;
            }
            get willValidate() {
                return this.internals.willValidate;
            }
            checkValidity() {
                return this.internals.checkValidity();
            }
            reportValidity() {
                return this.internals.reportValidity();
            }
            constructor(){
                super(...arguments);
                _FormFieldComponent_name_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _instanceExtraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_initializers, void 0)));
                _FormFieldComponent_value_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _name_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_initializers, void 0)));
                _FormFieldComponent_required_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _value_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_initializers, void 0)));
                _FormFieldComponent_disabled_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _required_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_initializers, void 0)));
                _FormFieldComponent_autofocus_accessor_storage.set(this, ($6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _disabled_extraInitializers), $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_initializers, void 0)));
                $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__runInitializers(this, _autofocus_extraInitializers);
            }
        }, _FormFieldComponent_name_accessor_storage = new WeakMap(), _FormFieldComponent_value_accessor_storage = new WeakMap(), _FormFieldComponent_required_accessor_storage = new WeakMap(), _FormFieldComponent_disabled_accessor_storage = new WeakMap(), _FormFieldComponent_autofocus_accessor_storage = new WeakMap(), (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _setValue_decorators = [
                $6f83f77ba8e7af5c$export$7203b476385689ae(({ value: value })=>value)
            ];
            _name_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $d5I5D.observable)
            ];
            _value_decorators = [
                (0, $d5I5D.observable)
            ];
            _required_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $d5I5D.observable)
            ];
            _disabled_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $d5I5D.observable)
            ];
            _autofocus_decorators = [
                $6f83f77ba8e7af5c$export$af4b9a83f4b00434,
                (0, $d5I5D.observable)
            ];
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _setValue_decorators, {
                kind: "method",
                name: "setValue",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"setValue" in obj,
                    get: (obj)=>obj.setValue
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _name_decorators, {
                kind: "accessor",
                name: "name",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"name" in obj,
                    get: (obj)=>obj.name,
                    set: (obj, value)=>{
                        obj.name = value;
                    }
                },
                metadata: _metadata
            }, _name_initializers, _name_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _value_decorators, {
                kind: "accessor",
                name: "value",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"value" in obj,
                    get: (obj)=>obj.value,
                    set: (obj, value)=>{
                        obj.value = value;
                    }
                },
                metadata: _metadata
            }, _value_initializers, _value_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _required_decorators, {
                kind: "accessor",
                name: "required",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"required" in obj,
                    get: (obj)=>obj.required,
                    set: (obj, value)=>{
                        obj.required = value;
                    }
                },
                metadata: _metadata
            }, _required_initializers, _required_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _disabled_decorators, {
                kind: "accessor",
                name: "disabled",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"disabled" in obj,
                    get: (obj)=>obj.disabled,
                    set: (obj, value)=>{
                        obj.disabled = value;
                    }
                },
                metadata: _metadata
            }, _disabled_initializers, _disabled_extraInitializers);
            $6f83f77ba8e7af5c$var$$29675797ddd6c4f7$var$__esDecorate(_a, null, _autofocus_decorators, {
                kind: "accessor",
                name: "autofocus",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"autofocus" in obj,
                    get: (obj)=>obj.autofocus,
                    set: (obj, value)=>{
                        obj.autofocus = value;
                    }
                },
                metadata: _metadata
            }, _autofocus_initializers, _autofocus_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), Object.defineProperty(_a, "formAssociated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        }), _a;
    })();
    return FormFieldComponent;
}


function $bc1cb4598b74b610$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$exports = {};
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$exports, "RouterMode", ()=>$bc1cb4598b74b610$export$fc55ead6785c2297);
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$exports, "History", ()=>$bc1cb4598b74b610$export$84202caead5689ba);
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a, $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b;
const { location: $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location, history: $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$history } = window;
const $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$basePath = ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a = document.querySelector('base')) === null || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a === void 0 ? void 0 : $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_a.getAttribute('href');
const $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$defaultBaseURL = ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$basePath ? new URL($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$basePath, $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.origin) + '' : $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.href.split(/\?|#/)[0]).replace(/\/$/, '');
const $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$originalTitle = ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b = document.querySelector('title')) === null || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b === void 0 ? void 0 : $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$_b.textContent.trim();
var $bc1cb4598b74b610$export$fc55ead6785c2297;
(function(RouterMode) {
    RouterMode["hash"] = "#";
    RouterMode["history"] = "/";
})($bc1cb4598b74b610$export$fc55ead6785c2297 || ($bc1cb4598b74b610$export$fc55ead6785c2297 = {}));
let $bc1cb4598b74b610$export$84202caead5689ba = (()=>{
    var _a, _History_path_accessor_storage, _History_oldPath_accessor_storage;
    let _instanceExtraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _oldPath_decorators;
    let _oldPath_initializers = [];
    let _oldPath_extraInitializers = [];
    let _push_decorators;
    return _a = class History {
        get path() {
            return $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet(this, _History_path_accessor_storage, "f");
        }
        set path(value) {
            $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet(this, _History_path_accessor_storage, value, "f");
        }
        get oldPath() {
            return $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldGet(this, _History_oldPath_accessor_storage, "f");
        }
        set oldPath(value) {
            $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__classPrivateFieldSet(this, _History_oldPath_accessor_storage, value, "f");
        }
        constructor(baseURL = $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$defaultBaseURL, delimiter = $bc1cb4598b74b610$export$fc55ead6785c2297.hash){
            Object.defineProperty(this, "baseURL", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _instanceExtraInitializers), baseURL)
            });
            Object.defineProperty(this, "delimiter", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: delimiter
            });
            _History_path_accessor_storage.set(this, $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _path_initializers, void 0));
            _History_oldPath_accessor_storage.set(this, ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _path_extraInitializers), $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _oldPath_initializers, void 0)));
            Object.defineProperty(this, "restore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__runInitializers(this, _oldPath_extraInitializers), ()=>{
                    const { state: state } = $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$history;
                    this.push();
                    document.title = (state === null || state === void 0 ? void 0 : state.title) || this.titleOf() || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$originalTitle || $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.href;
                })
            });
            Object.defineProperty(this, "handleForm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event, form)=>{
                    const { method: method, target: target } = form;
                    if (method !== 'get' || (target || '_self') !== '_self') return;
                    event.preventDefault();
                    const path = form.getAttribute('action'), data = (0, $8uN2z.buildURLData)((0, $8uN2z.formToJSON)(form));
                    this.push(`${path}?${data}`);
                }
            });
            this.restore();
            window.addEventListener('hashchange', this.restore);
            window.addEventListener('popstate', this.restore);
            document.addEventListener('click', (0, $8uN2z.delegate)('a[href], area[href]', this.handleLink.bind(this)));
            document.addEventListener('submit', (0, $8uN2z.delegate)('form[action]', this.handleForm));
        }
        push(path = $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$location.href) {
            var _b;
            path = path.replace(this.baseURL, '');
            if (this.delimiter === $bc1cb4598b74b610$export$fc55ead6785c2297.hash) path = ((_b = path.match(/#.*/)) === null || _b === void 0 ? void 0 : _b[0]) || $bc1cb4598b74b610$export$fc55ead6785c2297.hash;
            if (path === this.path) return path;
            this.oldPath = this.path;
            return this.path = path;
        }
        static dataOf(path) {
            const [before, after] = path.split('#');
            return (0, $8uN2z.parseURLData)(after || before);
        }
        match(pattern, path = this.path) {
            var _b;
            if (!path) return;
            const { pathname: pathname, hash: hash } = new URLPattern(pattern, this.baseURL).exec(new URL(path.split('?')[0], this.baseURL)) || {};
            return (_b = hash || pathname) === null || _b === void 0 ? void 0 : _b.groups;
        }
        static getTitle(root) {
            return root.title || (0, $8uN2z.getVisibleText)(root);
        }
        titleOf(path = this.path) {
            path = path.replace(/^\//, '');
            if (path) for (const node of document.querySelectorAll(`a[href="${path}"], area[href="${path}"]`)){
                const title = _a.getTitle(node);
                if (title) return title;
            }
        }
        handleLink(event, link) {
            const path = link.getAttribute('href');
            if ((link.target || '_self') !== '_self' || (0, $8uN2z.isXDomain)(path) || link.download) return;
            event.preventDefault();
            if (path.startsWith('#')) try {
                if (document.querySelector(path) || path === '#top') return (0, $8uN2z.scrollTo)(path, event.currentTarget);
            } catch (_b) {}
            const title = _a.getTitle(link);
            $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$history.pushState({
                title: title
            }, document.title = title, path);
            this.push(path);
        }
    }, _History_path_accessor_storage = new WeakMap(), _History_oldPath_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _path_decorators = [
            (0, $d5I5D.observable)
        ];
        _oldPath_decorators = [
            (0, $d5I5D.observable)
        ];
        _push_decorators = [
            (0, $d5I5D.action)
        ];
        $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _oldPath_decorators, {
            kind: "accessor",
            name: "oldPath",
            static: false,
            private: false,
            access: {
                has: (obj)=>"oldPath" in obj,
                get: (obj)=>obj.oldPath,
                set: (obj, value)=>{
                    obj.oldPath = value;
                }
            },
            metadata: _metadata
        }, _oldPath_initializers, _oldPath_extraInitializers);
        $bc1cb4598b74b610$var$$3a2ee75a1759d0d8$var$__esDecorate(_a, null, _push_decorators, {
            kind: "method",
            name: "push",
            static: false,
            private: false,
            access: {
                has: (obj)=>"push" in obj,
                get: (obj)=>obj.push
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$exports = {};
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$exports, "CellRoute", ()=>$bc1cb4598b74b610$export$d6c529ca17cdd16f);
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$exports, "CellRouter", ()=>$bc1cb4598b74b610$export$b1119cfa2764f723);
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $bc1cb4598b74b610$export$d6c529ca17cdd16f = (()=>{
    var _CellRoute_path_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'cell-route'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    var CellRoute = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CellRoute_path_accessor_storage.set(this, $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _path_initializers, void 0));
            Object.defineProperty(this, "component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _path_extraInitializers)
            });
        }
        get path() {
            return $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRoute_path_accessor_storage, "f");
        }
        set path(value) {
            $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRoute_path_accessor_storage, value, "f");
        }
    };
    _CellRoute_path_accessor_storage = new WeakMap();
    $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__setFunctionName(_classThis, "CellRoute");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _path_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CellRoute = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CellRoute = _classThis;
})();
let $bc1cb4598b74b610$export$b1119cfa2764f723 = (()=>{
    var _CellRouter_renderer, _CellRouter_history_accessor_storage, _CellRouter_routes_accessor_storage;
    var _a, _b;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'cell-router',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _history_decorators;
    let _history_initializers = [];
    let _history_extraInitializers = [];
    let _routes_decorators;
    let _routes_initializers = [];
    let _routes_extraInitializers = [];
    let _get_sortedRoutes_decorators;
    let _get_equalRoutes_decorators;
    let _get_matchedRoutes_decorators;
    let _renderChildren_decorators;
    var CellRouter = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CellRouter_history_accessor_storage.set(this, ($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _instanceExtraInitializers), $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _history_initializers, void 0)));
            _CellRouter_routes_accessor_storage.set(this, ($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _history_extraInitializers), $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _routes_initializers, [])));
            _CellRouter_renderer.set(this, ($bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(this, _routes_extraInitializers), new (0, $c6ef78eb3a1442f8$exports.DOMRenderer)()));
            Object.defineProperty(this, "handleSlotChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ currentTarget: currentTarget })=>{
                    const routes = currentTarget.assignedElements().filter((node)=>node instanceof $bc1cb4598b74b610$export$d6c529ca17cdd16f).map(({ path: path, component: component })=>({
                            path: path,
                            component: component
                        }));
                    if (routes[0]) this.routes = routes;
                }
            });
        }
        get history() {
            return $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRouter_history_accessor_storage, "f");
        }
        set history(value) {
            $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRouter_history_accessor_storage, value, "f");
        }
        get routes() {
            return $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRouter_routes_accessor_storage, "f");
        }
        set routes(value) {
            $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldSet(this, _CellRouter_routes_accessor_storage, value, "f");
        }
        get sortedRoutes() {
            return [
                ...this.routes
            ].sort(({ path: a }, { path: b })=>b.split('/').length - a.split('/').length || b.length - a.length);
        }
        get equalRoutes() {
            const { history: history, sortedRoutes: sortedRoutes } = this;
            return !history ? [] : sortedRoutes.filter(({ path: path })=>path === history.path);
        }
        get matchedRoutes() {
            const { history: history, sortedRoutes: sortedRoutes } = this;
            return !history ? [] : sortedRoutes.filter(({ path: path })=>history.match(path));
        }
        mountedCallback() {
            this.history || (this.history = new $bc1cb4598b74b610$export$84202caead5689ba());
            this.renderChildren();
        }
        async renderChildren() {
            var _a;
            const { history: history, equalRoutes: equalRoutes, matchedRoutes: matchedRoutes } = this;
            if (!history) return;
            const { path: path } = history;
            const [_b] = [
                ...equalRoutes,
                ...matchedRoutes
            ].map(({ path: path, component: component })=>{
                const matched = history.match(path);
                return matched && Object.assign({
                    component: component
                }, matched);
            }).filter(Boolean), _c = _b === void 0 ? {} : _b, { component: Tag } = _c, matched = $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__rest(_c, [
                "component"
            ]);
            const vNode = Tag ? (0, $bd1ed0d24b354858$exports.jsx)(Tag, Object.assign({}, matched, $bc1cb4598b74b610$export$84202caead5689ba.dataOf(path), {
                path: path,
                history: history
            })) : (0, $bd1ed0d24b354858$exports.jsx)((0, $bd1ed0d24b354858$exports.Fragment), {});
            const render = ()=>{
                $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__classPrivateFieldGet(this, _CellRouter_renderer, "f").render(vNode, this);
                return {};
            };
            const { finished: finished, updateCallbackDone: updateCallbackDone } = ((_a = document.startViewTransition) === null || _a === void 0 ? void 0 : _a.call(document, render)) || render();
            try {
                await finished;
            } catch (_d) {
                return updateCallbackDone;
            }
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsx)("slot", {
                onSlotChange: this.handleSlotChange
            });
        }
    };
    _CellRouter_renderer = new WeakMap();
    _CellRouter_history_accessor_storage = new WeakMap();
    _CellRouter_routes_accessor_storage = new WeakMap();
    $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__setFunctionName(_classThis, "CellRouter");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _history_decorators = [
            (_a = (0, $d5I5D.observable)).shallow.bind(_a)
        ];
        _routes_decorators = [
            (_b = (0, $d5I5D.observable)).shallow.bind(_b)
        ];
        _get_sortedRoutes_decorators = [
            (0, $d5I5D.computed)
        ];
        _get_equalRoutes_decorators = [
            (0, $d5I5D.computed)
        ];
        _get_matchedRoutes_decorators = [
            (0, $d5I5D.computed)
        ];
        _renderChildren_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ history: history })=>history === null || history === void 0 ? void 0 : history.path)
        ];
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _history_decorators, {
            kind: "accessor",
            name: "history",
            static: false,
            private: false,
            access: {
                has: (obj)=>"history" in obj,
                get: (obj)=>obj.history,
                set: (obj, value)=>{
                    obj.history = value;
                }
            },
            metadata: _metadata
        }, _history_initializers, _history_extraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _routes_decorators, {
            kind: "accessor",
            name: "routes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"routes" in obj,
                get: (obj)=>obj.routes,
                set: (obj, value)=>{
                    obj.routes = value;
                }
            },
            metadata: _metadata
        }, _routes_initializers, _routes_extraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_sortedRoutes_decorators, {
            kind: "getter",
            name: "sortedRoutes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"sortedRoutes" in obj,
                get: (obj)=>obj.sortedRoutes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_equalRoutes_decorators, {
            kind: "getter",
            name: "equalRoutes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"equalRoutes" in obj,
                get: (obj)=>obj.equalRoutes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _get_matchedRoutes_decorators, {
            kind: "getter",
            name: "matchedRoutes",
            static: false,
            private: false,
            access: {
                has: (obj)=>"matchedRoutes" in obj,
                get: (obj)=>obj.matchedRoutes
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(_classThis, null, _renderChildren_decorators, {
            kind: "method",
            name: "renderChildren",
            static: false,
            private: false,
            access: {
                has: (obj)=>"renderChildren" in obj,
                get: (obj)=>obj.renderChildren
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CellRouter = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $bc1cb4598b74b610$var$$0e8e8fd52ec9970a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CellRouter = _classThis;
})();
var $bc1cb4598b74b610$var$$3d03e8579c0b9ff1$exports = {};
var $bc1cb4598b74b610$var$$7b488c9460f448a0$exports = {};
$bc1cb4598b74b610$var$$parcel$export($bc1cb4598b74b610$var$$7b488c9460f448a0$exports, "createRouter", ()=>$bc1cb4598b74b610$export$baddd0131ee8c05b);
var $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $bc1cb4598b74b610$export$baddd0131ee8c05b({ mode: mode = 'hash', linkTags: linkTags } = {}) {
    const prefix = $bc1cb4598b74b610$export$fc55ead6785c2297[mode];
    const extraComponentList = Object.entries(linkTags || {}).map(([name, Component])=>[
            name,
            (_a)=>{
                var { href: href } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                    "href"
                ]);
                return (0, $bd1ed0d24b354858$exports.jsx)(Component, Object.assign({}, props, {
                    href: prefix + (href || '')
                }));
            }
        ]);
    const extraComponentMap = Object.fromEntries(extraComponentList);
    return Object.assign(Object.assign({}, extraComponentMap), {
        Router: (_a)=>{
            var { routes: routes } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "routes"
            ]);
            return (0, $bd1ed0d24b354858$exports.jsx)($bc1cb4598b74b610$export$b1119cfa2764f723, Object.assign({}, props, {
                routes: routes === null || routes === void 0 ? void 0 : routes.map((_a)=>{
                    var { path: path } = _a, route = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                        "path"
                    ]);
                    return Object.assign(Object.assign({}, route), {
                        path: path != null ? `${prefix}${path}` : path
                    });
                })
            }));
        },
        Route: (_a)=>{
            var { path: path } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "path"
            ]);
            return (0, $bd1ed0d24b354858$exports.jsx)($bc1cb4598b74b610$export$d6c529ca17cdd16f, Object.assign({}, props, {
                path: path != null ? `${prefix}${path}` : path
            }));
        },
        Link: (_a)=>{
            var { to: to, children: children } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "to",
                "children"
            ]);
            return (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({}, props, {
                href: prefix + to,
                children: children
            }));
        },
        Form: (_a)=>{
            var { action: action, children: children } = _a, props = $bc1cb4598b74b610$var$$7b488c9460f448a0$var$__rest(_a, [
                "action",
                "children"
            ]);
            return (0, $bd1ed0d24b354858$exports.jsx)("form", Object.assign({}, props, {
                action: prefix + action,
                children: children
            }));
        }
    });
}



var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $8uN2z = parcelRequire("8uN2z");

function $c379f9436bbe0249$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $c379f9436bbe0249$var$$22de11b45b0eeb97$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $c379f9436bbe0249$export$c7e91f8aec23ae14;
});
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $c379f9436bbe0249$export$51ca94569b882c51;
});
class $c379f9436bbe0249$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $c379f9436bbe0249$export$51ca94569b882c51 = ()=>new $c379f9436bbe0249$export$c7e91f8aec23ae14();
var $c379f9436bbe0249$var$$e3640f413e0c36e7$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $c379f9436bbe0249$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
class $c379f9436bbe0249$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $c379f9436bbe0249$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $c379f9436bbe0249$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) queue[queue.length - 1].reject(reason), done = true;
                if (canceler) canceler();
            },
            complete () {
                if (!done) queue[queue.length - 1].resolve(), done = true;
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug);
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error);
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === "function") target.on(name, next).on("error", error);
            else {
                target.addEventListener(name, next);
                target.addEventListener("error", error);
            }
            return ()=>{
                if (typeof target.off === "function") target.off(name, next).off("error", error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener("error", error);
                }
            };
        });
    }
}
var $c379f9436bbe0249$var$$603f33a01a36ab56$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $c379f9436bbe0249$export$d16acf4b6e75743d;
});
function $c379f9436bbe0249$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $c379f9436bbe0249$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $c379f9436bbe0249$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}



var $d5I5D = parcelRequire("d5I5D");
const $ab01173f783f3846$var$types = {
    'application/prs.cww': [
        'cww'
    ],
    'application/prs.xsf+xml': [
        'xsf'
    ],
    'application/vnd.1000minds.decision-model+xml': [
        '1km'
    ],
    'application/vnd.3gpp.pic-bw-large': [
        'plb'
    ],
    'application/vnd.3gpp.pic-bw-small': [
        'psb'
    ],
    'application/vnd.3gpp.pic-bw-var': [
        'pvb'
    ],
    'application/vnd.3gpp2.tcap': [
        'tcap'
    ],
    'application/vnd.3m.post-it-notes': [
        'pwn'
    ],
    'application/vnd.accpac.simply.aso': [
        'aso'
    ],
    'application/vnd.accpac.simply.imp': [
        'imp'
    ],
    'application/vnd.acucobol': [
        'acu'
    ],
    'application/vnd.acucorp': [
        'atc',
        'acutc'
    ],
    'application/vnd.adobe.air-application-installer-package+zip': [
        'air'
    ],
    'application/vnd.adobe.formscentral.fcdt': [
        'fcdt'
    ],
    'application/vnd.adobe.fxp': [
        'fxp',
        'fxpl'
    ],
    'application/vnd.adobe.xdp+xml': [
        'xdp'
    ],
    'application/vnd.adobe.xfdf': [
        '*xfdf'
    ],
    'application/vnd.age': [
        'age'
    ],
    'application/vnd.ahead.space': [
        'ahead'
    ],
    'application/vnd.airzip.filesecure.azf': [
        'azf'
    ],
    'application/vnd.airzip.filesecure.azs': [
        'azs'
    ],
    'application/vnd.amazon.ebook': [
        'azw'
    ],
    'application/vnd.americandynamics.acc': [
        'acc'
    ],
    'application/vnd.amiga.ami': [
        'ami'
    ],
    'application/vnd.android.package-archive': [
        'apk'
    ],
    'application/vnd.anser-web-certificate-issue-initiation': [
        'cii'
    ],
    'application/vnd.anser-web-funds-transfer-initiation': [
        'fti'
    ],
    'application/vnd.antix.game-component': [
        'atx'
    ],
    'application/vnd.apple.installer+xml': [
        'mpkg'
    ],
    'application/vnd.apple.keynote': [
        'key'
    ],
    'application/vnd.apple.mpegurl': [
        'm3u8'
    ],
    'application/vnd.apple.numbers': [
        'numbers'
    ],
    'application/vnd.apple.pages': [
        'pages'
    ],
    'application/vnd.apple.pkpass': [
        'pkpass'
    ],
    'application/vnd.aristanetworks.swi': [
        'swi'
    ],
    'application/vnd.astraea-software.iota': [
        'iota'
    ],
    'application/vnd.audiograph': [
        'aep'
    ],
    'application/vnd.autodesk.fbx': [
        'fbx'
    ],
    'application/vnd.balsamiq.bmml+xml': [
        'bmml'
    ],
    'application/vnd.blueice.multipass': [
        'mpm'
    ],
    'application/vnd.bmi': [
        'bmi'
    ],
    'application/vnd.businessobjects': [
        'rep'
    ],
    'application/vnd.chemdraw+xml': [
        'cdxml'
    ],
    'application/vnd.chipnuts.karaoke-mmd': [
        'mmd'
    ],
    'application/vnd.cinderella': [
        'cdy'
    ],
    'application/vnd.citationstyles.style+xml': [
        'csl'
    ],
    'application/vnd.claymore': [
        'cla'
    ],
    'application/vnd.cloanto.rp9': [
        'rp9'
    ],
    'application/vnd.clonk.c4group': [
        'c4g',
        'c4d',
        'c4f',
        'c4p',
        'c4u'
    ],
    'application/vnd.cluetrust.cartomobile-config': [
        'c11amc'
    ],
    'application/vnd.cluetrust.cartomobile-config-pkg': [
        'c11amz'
    ],
    'application/vnd.commonspace': [
        'csp'
    ],
    'application/vnd.contact.cmsg': [
        'cdbcmsg'
    ],
    'application/vnd.cosmocaller': [
        'cmc'
    ],
    'application/vnd.crick.clicker': [
        'clkx'
    ],
    'application/vnd.crick.clicker.keyboard': [
        'clkk'
    ],
    'application/vnd.crick.clicker.palette': [
        'clkp'
    ],
    'application/vnd.crick.clicker.template': [
        'clkt'
    ],
    'application/vnd.crick.clicker.wordbank': [
        'clkw'
    ],
    'application/vnd.criticaltools.wbs+xml': [
        'wbs'
    ],
    'application/vnd.ctc-posml': [
        'pml'
    ],
    'application/vnd.cups-ppd': [
        'ppd'
    ],
    'application/vnd.curl.car': [
        'car'
    ],
    'application/vnd.curl.pcurl': [
        'pcurl'
    ],
    'application/vnd.dart': [
        'dart'
    ],
    'application/vnd.data-vision.rdz': [
        'rdz'
    ],
    'application/vnd.dbf': [
        'dbf'
    ],
    'application/vnd.dcmp+xml': [
        'dcmp'
    ],
    'application/vnd.dece.data': [
        'uvf',
        'uvvf',
        'uvd',
        'uvvd'
    ],
    'application/vnd.dece.ttml+xml': [
        'uvt',
        'uvvt'
    ],
    'application/vnd.dece.unspecified': [
        'uvx',
        'uvvx'
    ],
    'application/vnd.dece.zip': [
        'uvz',
        'uvvz'
    ],
    'application/vnd.denovo.fcselayout-link': [
        'fe_launch'
    ],
    'application/vnd.dna': [
        'dna'
    ],
    'application/vnd.dolby.mlp': [
        'mlp'
    ],
    'application/vnd.dpgraph': [
        'dpg'
    ],
    'application/vnd.dreamfactory': [
        'dfac'
    ],
    'application/vnd.ds-keypoint': [
        'kpxx'
    ],
    'application/vnd.dvb.ait': [
        'ait'
    ],
    'application/vnd.dvb.service': [
        'svc'
    ],
    'application/vnd.dynageo': [
        'geo'
    ],
    'application/vnd.ecowin.chart': [
        'mag'
    ],
    'application/vnd.enliven': [
        'nml'
    ],
    'application/vnd.epson.esf': [
        'esf'
    ],
    'application/vnd.epson.msf': [
        'msf'
    ],
    'application/vnd.epson.quickanime': [
        'qam'
    ],
    'application/vnd.epson.salt': [
        'slt'
    ],
    'application/vnd.epson.ssf': [
        'ssf'
    ],
    'application/vnd.eszigno3+xml': [
        'es3',
        'et3'
    ],
    'application/vnd.ezpix-album': [
        'ez2'
    ],
    'application/vnd.ezpix-package': [
        'ez3'
    ],
    'application/vnd.fdf': [
        '*fdf'
    ],
    'application/vnd.fdsn.mseed': [
        'mseed'
    ],
    'application/vnd.fdsn.seed': [
        'seed',
        'dataless'
    ],
    'application/vnd.flographit': [
        'gph'
    ],
    'application/vnd.fluxtime.clip': [
        'ftc'
    ],
    'application/vnd.framemaker': [
        'fm',
        'frame',
        'maker',
        'book'
    ],
    'application/vnd.frogans.fnc': [
        'fnc'
    ],
    'application/vnd.frogans.ltf': [
        'ltf'
    ],
    'application/vnd.fsc.weblaunch': [
        'fsc'
    ],
    'application/vnd.fujitsu.oasys': [
        'oas'
    ],
    'application/vnd.fujitsu.oasys2': [
        'oa2'
    ],
    'application/vnd.fujitsu.oasys3': [
        'oa3'
    ],
    'application/vnd.fujitsu.oasysgp': [
        'fg5'
    ],
    'application/vnd.fujitsu.oasysprs': [
        'bh2'
    ],
    'application/vnd.fujixerox.ddd': [
        'ddd'
    ],
    'application/vnd.fujixerox.docuworks': [
        'xdw'
    ],
    'application/vnd.fujixerox.docuworks.binder': [
        'xbd'
    ],
    'application/vnd.fuzzysheet': [
        'fzs'
    ],
    'application/vnd.genomatix.tuxedo': [
        'txd'
    ],
    'application/vnd.geogebra.file': [
        'ggb'
    ],
    'application/vnd.geogebra.slides': [
        'ggs'
    ],
    'application/vnd.geogebra.tool': [
        'ggt'
    ],
    'application/vnd.geometry-explorer': [
        'gex',
        'gre'
    ],
    'application/vnd.geonext': [
        'gxt'
    ],
    'application/vnd.geoplan': [
        'g2w'
    ],
    'application/vnd.geospace': [
        'g3w'
    ],
    'application/vnd.gmx': [
        'gmx'
    ],
    'application/vnd.google-apps.document': [
        'gdoc'
    ],
    'application/vnd.google-apps.drawing': [
        'gdraw'
    ],
    'application/vnd.google-apps.form': [
        'gform'
    ],
    'application/vnd.google-apps.jam': [
        'gjam'
    ],
    'application/vnd.google-apps.map': [
        'gmap'
    ],
    'application/vnd.google-apps.presentation': [
        'gslides'
    ],
    'application/vnd.google-apps.script': [
        'gscript'
    ],
    'application/vnd.google-apps.site': [
        'gsite'
    ],
    'application/vnd.google-apps.spreadsheet': [
        'gsheet'
    ],
    'application/vnd.google-earth.kml+xml': [
        'kml'
    ],
    'application/vnd.google-earth.kmz': [
        'kmz'
    ],
    'application/vnd.gov.sk.xmldatacontainer+xml': [
        'xdcf'
    ],
    'application/vnd.grafeq': [
        'gqf',
        'gqs'
    ],
    'application/vnd.groove-account': [
        'gac'
    ],
    'application/vnd.groove-help': [
        'ghf'
    ],
    'application/vnd.groove-identity-message': [
        'gim'
    ],
    'application/vnd.groove-injector': [
        'grv'
    ],
    'application/vnd.groove-tool-message': [
        'gtm'
    ],
    'application/vnd.groove-tool-template': [
        'tpl'
    ],
    'application/vnd.groove-vcard': [
        'vcg'
    ],
    'application/vnd.hal+xml': [
        'hal'
    ],
    'application/vnd.handheld-entertainment+xml': [
        'zmm'
    ],
    'application/vnd.hbci': [
        'hbci'
    ],
    'application/vnd.hhe.lesson-player': [
        'les'
    ],
    'application/vnd.hp-hpgl': [
        'hpgl'
    ],
    'application/vnd.hp-hpid': [
        'hpid'
    ],
    'application/vnd.hp-hps': [
        'hps'
    ],
    'application/vnd.hp-jlyt': [
        'jlt'
    ],
    'application/vnd.hp-pcl': [
        'pcl'
    ],
    'application/vnd.hp-pclxl': [
        'pclxl'
    ],
    'application/vnd.hydrostatix.sof-data': [
        'sfd-hdstx'
    ],
    'application/vnd.ibm.minipay': [
        'mpy'
    ],
    'application/vnd.ibm.modcap': [
        'afp',
        'listafp',
        'list3820'
    ],
    'application/vnd.ibm.rights-management': [
        'irm'
    ],
    'application/vnd.ibm.secure-container': [
        'sc'
    ],
    'application/vnd.iccprofile': [
        'icc',
        'icm'
    ],
    'application/vnd.igloader': [
        'igl'
    ],
    'application/vnd.immervision-ivp': [
        'ivp'
    ],
    'application/vnd.immervision-ivu': [
        'ivu'
    ],
    'application/vnd.insors.igm': [
        'igm'
    ],
    'application/vnd.intercon.formnet': [
        'xpw',
        'xpx'
    ],
    'application/vnd.intergeo': [
        'i2g'
    ],
    'application/vnd.intu.qbo': [
        'qbo'
    ],
    'application/vnd.intu.qfx': [
        'qfx'
    ],
    'application/vnd.ipunplugged.rcprofile': [
        'rcprofile'
    ],
    'application/vnd.irepository.package+xml': [
        'irp'
    ],
    'application/vnd.is-xpr': [
        'xpr'
    ],
    'application/vnd.isac.fcs': [
        'fcs'
    ],
    'application/vnd.jam': [
        'jam'
    ],
    'application/vnd.jcp.javame.midlet-rms': [
        'rms'
    ],
    'application/vnd.jisp': [
        'jisp'
    ],
    'application/vnd.joost.joda-archive': [
        'joda'
    ],
    'application/vnd.kahootz': [
        'ktz',
        'ktr'
    ],
    'application/vnd.kde.karbon': [
        'karbon'
    ],
    'application/vnd.kde.kchart': [
        'chrt'
    ],
    'application/vnd.kde.kformula': [
        'kfo'
    ],
    'application/vnd.kde.kivio': [
        'flw'
    ],
    'application/vnd.kde.kontour': [
        'kon'
    ],
    'application/vnd.kde.kpresenter': [
        'kpr',
        'kpt'
    ],
    'application/vnd.kde.kspread': [
        'ksp'
    ],
    'application/vnd.kde.kword': [
        'kwd',
        'kwt'
    ],
    'application/vnd.kenameaapp': [
        'htke'
    ],
    'application/vnd.kidspiration': [
        'kia'
    ],
    'application/vnd.kinar': [
        'kne',
        'knp'
    ],
    'application/vnd.koan': [
        'skp',
        'skd',
        'skt',
        'skm'
    ],
    'application/vnd.kodak-descriptor': [
        'sse'
    ],
    'application/vnd.las.las+xml': [
        'lasxml'
    ],
    'application/vnd.llamagraphics.life-balance.desktop': [
        'lbd'
    ],
    'application/vnd.llamagraphics.life-balance.exchange+xml': [
        'lbe'
    ],
    'application/vnd.lotus-1-2-3': [
        '123'
    ],
    'application/vnd.lotus-approach': [
        'apr'
    ],
    'application/vnd.lotus-freelance': [
        'pre'
    ],
    'application/vnd.lotus-notes': [
        'nsf'
    ],
    'application/vnd.lotus-organizer': [
        'org'
    ],
    'application/vnd.lotus-screencam': [
        'scm'
    ],
    'application/vnd.lotus-wordpro': [
        'lwp'
    ],
    'application/vnd.macports.portpkg': [
        'portpkg'
    ],
    'application/vnd.mapbox-vector-tile': [
        'mvt'
    ],
    'application/vnd.mcd': [
        'mcd'
    ],
    'application/vnd.medcalcdata': [
        'mc1'
    ],
    'application/vnd.mediastation.cdkey': [
        'cdkey'
    ],
    'application/vnd.mfer': [
        'mwf'
    ],
    'application/vnd.mfmp': [
        'mfm'
    ],
    'application/vnd.micrografx.flo': [
        'flo'
    ],
    'application/vnd.micrografx.igx': [
        'igx'
    ],
    'application/vnd.mif': [
        'mif'
    ],
    'application/vnd.mobius.daf': [
        'daf'
    ],
    'application/vnd.mobius.dis': [
        'dis'
    ],
    'application/vnd.mobius.mbk': [
        'mbk'
    ],
    'application/vnd.mobius.mqy': [
        'mqy'
    ],
    'application/vnd.mobius.msl': [
        'msl'
    ],
    'application/vnd.mobius.plc': [
        'plc'
    ],
    'application/vnd.mobius.txf': [
        'txf'
    ],
    'application/vnd.mophun.application': [
        'mpn'
    ],
    'application/vnd.mophun.certificate': [
        'mpc'
    ],
    'application/vnd.mozilla.xul+xml': [
        'xul'
    ],
    'application/vnd.ms-artgalry': [
        'cil'
    ],
    'application/vnd.ms-cab-compressed': [
        'cab'
    ],
    'application/vnd.ms-excel': [
        'xls',
        'xlm',
        'xla',
        'xlc',
        'xlt',
        'xlw'
    ],
    'application/vnd.ms-excel.addin.macroenabled.12': [
        'xlam'
    ],
    'application/vnd.ms-excel.sheet.binary.macroenabled.12': [
        'xlsb'
    ],
    'application/vnd.ms-excel.sheet.macroenabled.12': [
        'xlsm'
    ],
    'application/vnd.ms-excel.template.macroenabled.12': [
        'xltm'
    ],
    'application/vnd.ms-fontobject': [
        'eot'
    ],
    'application/vnd.ms-htmlhelp': [
        'chm'
    ],
    'application/vnd.ms-ims': [
        'ims'
    ],
    'application/vnd.ms-lrm': [
        'lrm'
    ],
    'application/vnd.ms-officetheme': [
        'thmx'
    ],
    'application/vnd.ms-outlook': [
        'msg'
    ],
    'application/vnd.ms-pki.seccat': [
        'cat'
    ],
    'application/vnd.ms-pki.stl': [
        '*stl'
    ],
    'application/vnd.ms-powerpoint': [
        'ppt',
        'pps',
        'pot'
    ],
    'application/vnd.ms-powerpoint.addin.macroenabled.12': [
        'ppam'
    ],
    'application/vnd.ms-powerpoint.presentation.macroenabled.12': [
        'pptm'
    ],
    'application/vnd.ms-powerpoint.slide.macroenabled.12': [
        'sldm'
    ],
    'application/vnd.ms-powerpoint.slideshow.macroenabled.12': [
        'ppsm'
    ],
    'application/vnd.ms-powerpoint.template.macroenabled.12': [
        'potm'
    ],
    'application/vnd.ms-project': [
        '*mpp',
        'mpt'
    ],
    'application/vnd.ms-visio.viewer': [
        'vdx'
    ],
    'application/vnd.ms-word.document.macroenabled.12': [
        'docm'
    ],
    'application/vnd.ms-word.template.macroenabled.12': [
        'dotm'
    ],
    'application/vnd.ms-works': [
        'wps',
        'wks',
        'wcm',
        'wdb'
    ],
    'application/vnd.ms-wpl': [
        'wpl'
    ],
    'application/vnd.ms-xpsdocument': [
        'xps'
    ],
    'application/vnd.mseq': [
        'mseq'
    ],
    'application/vnd.musician': [
        'mus'
    ],
    'application/vnd.muvee.style': [
        'msty'
    ],
    'application/vnd.mynfc': [
        'taglet'
    ],
    'application/vnd.nato.bindingdataobject+xml': [
        'bdo'
    ],
    'application/vnd.neurolanguage.nlu': [
        'nlu'
    ],
    'application/vnd.nitf': [
        'ntf',
        'nitf'
    ],
    'application/vnd.noblenet-directory': [
        'nnd'
    ],
    'application/vnd.noblenet-sealer': [
        'nns'
    ],
    'application/vnd.noblenet-web': [
        'nnw'
    ],
    'application/vnd.nokia.n-gage.ac+xml': [
        '*ac'
    ],
    'application/vnd.nokia.n-gage.data': [
        'ngdat'
    ],
    'application/vnd.nokia.n-gage.symbian.install': [
        'n-gage'
    ],
    'application/vnd.nokia.radio-preset': [
        'rpst'
    ],
    'application/vnd.nokia.radio-presets': [
        'rpss'
    ],
    'application/vnd.novadigm.edm': [
        'edm'
    ],
    'application/vnd.novadigm.edx': [
        'edx'
    ],
    'application/vnd.novadigm.ext': [
        'ext'
    ],
    'application/vnd.oasis.opendocument.chart': [
        'odc'
    ],
    'application/vnd.oasis.opendocument.chart-template': [
        'otc'
    ],
    'application/vnd.oasis.opendocument.database': [
        'odb'
    ],
    'application/vnd.oasis.opendocument.formula': [
        'odf'
    ],
    'application/vnd.oasis.opendocument.formula-template': [
        'odft'
    ],
    'application/vnd.oasis.opendocument.graphics': [
        'odg'
    ],
    'application/vnd.oasis.opendocument.graphics-template': [
        'otg'
    ],
    'application/vnd.oasis.opendocument.image': [
        'odi'
    ],
    'application/vnd.oasis.opendocument.image-template': [
        'oti'
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'odp'
    ],
    'application/vnd.oasis.opendocument.presentation-template': [
        'otp'
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'ods'
    ],
    'application/vnd.oasis.opendocument.spreadsheet-template': [
        'ots'
    ],
    'application/vnd.oasis.opendocument.text': [
        'odt'
    ],
    'application/vnd.oasis.opendocument.text-master': [
        'odm'
    ],
    'application/vnd.oasis.opendocument.text-template': [
        'ott'
    ],
    'application/vnd.oasis.opendocument.text-web': [
        'oth'
    ],
    'application/vnd.olpc-sugar': [
        'xo'
    ],
    'application/vnd.oma.dd2+xml': [
        'dd2'
    ],
    'application/vnd.openblox.game+xml': [
        'obgx'
    ],
    'application/vnd.openofficeorg.extension': [
        'oxt'
    ],
    'application/vnd.openstreetmap.data+xml': [
        'osm'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'pptx'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slide': [
        'sldx'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
        'ppsx'
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.template': [
        'potx'
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'xlsx'
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': [
        'xltx'
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'docx'
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': [
        'dotx'
    ],
    'application/vnd.osgeo.mapguide.package': [
        'mgp'
    ],
    'application/vnd.osgi.dp': [
        'dp'
    ],
    'application/vnd.osgi.subsystem': [
        'esa'
    ],
    'application/vnd.palm': [
        'pdb',
        'pqa',
        'oprc'
    ],
    'application/vnd.pawaafile': [
        'paw'
    ],
    'application/vnd.pg.format': [
        'str'
    ],
    'application/vnd.pg.osasli': [
        'ei6'
    ],
    'application/vnd.picsel': [
        'efif'
    ],
    'application/vnd.pmi.widget': [
        'wg'
    ],
    'application/vnd.pocketlearn': [
        'plf'
    ],
    'application/vnd.powerbuilder6': [
        'pbd'
    ],
    'application/vnd.previewsystems.box': [
        'box'
    ],
    'application/vnd.procrate.brushset': [
        'brushset'
    ],
    'application/vnd.procreate.brush': [
        'brush'
    ],
    'application/vnd.procreate.dream': [
        'drm'
    ],
    'application/vnd.proteus.magazine': [
        'mgz'
    ],
    'application/vnd.publishare-delta-tree': [
        'qps'
    ],
    'application/vnd.pvi.ptid1': [
        'ptid'
    ],
    'application/vnd.pwg-xhtml-print+xml': [
        'xhtm'
    ],
    'application/vnd.quark.quarkxpress': [
        'qxd',
        'qxt',
        'qwd',
        'qwt',
        'qxl',
        'qxb'
    ],
    'application/vnd.rar': [
        'rar'
    ],
    'application/vnd.realvnc.bed': [
        'bed'
    ],
    'application/vnd.recordare.musicxml': [
        'mxl'
    ],
    'application/vnd.recordare.musicxml+xml': [
        'musicxml'
    ],
    'application/vnd.rig.cryptonote': [
        'cryptonote'
    ],
    'application/vnd.rim.cod': [
        'cod'
    ],
    'application/vnd.rn-realmedia': [
        'rm'
    ],
    'application/vnd.rn-realmedia-vbr': [
        'rmvb'
    ],
    'application/vnd.route66.link66+xml': [
        'link66'
    ],
    'application/vnd.sailingtracker.track': [
        'st'
    ],
    'application/vnd.seemail': [
        'see'
    ],
    'application/vnd.sema': [
        'sema'
    ],
    'application/vnd.semd': [
        'semd'
    ],
    'application/vnd.semf': [
        'semf'
    ],
    'application/vnd.shana.informed.formdata': [
        'ifm'
    ],
    'application/vnd.shana.informed.formtemplate': [
        'itp'
    ],
    'application/vnd.shana.informed.interchange': [
        'iif'
    ],
    'application/vnd.shana.informed.package': [
        'ipk'
    ],
    'application/vnd.simtech-mindmapper': [
        'twd',
        'twds'
    ],
    'application/vnd.smaf': [
        'mmf'
    ],
    'application/vnd.smart.teacher': [
        'teacher'
    ],
    'application/vnd.software602.filler.form+xml': [
        'fo'
    ],
    'application/vnd.solent.sdkm+xml': [
        'sdkm',
        'sdkd'
    ],
    'application/vnd.spotfire.dxp': [
        'dxp'
    ],
    'application/vnd.spotfire.sfs': [
        'sfs'
    ],
    'application/vnd.stardivision.calc': [
        'sdc'
    ],
    'application/vnd.stardivision.draw': [
        'sda'
    ],
    'application/vnd.stardivision.impress': [
        'sdd'
    ],
    'application/vnd.stardivision.math': [
        'smf'
    ],
    'application/vnd.stardivision.writer': [
        'sdw',
        'vor'
    ],
    'application/vnd.stardivision.writer-global': [
        'sgl'
    ],
    'application/vnd.stepmania.package': [
        'smzip'
    ],
    'application/vnd.stepmania.stepchart': [
        'sm'
    ],
    'application/vnd.sun.wadl+xml': [
        'wadl'
    ],
    'application/vnd.sun.xml.calc': [
        'sxc'
    ],
    'application/vnd.sun.xml.calc.template': [
        'stc'
    ],
    'application/vnd.sun.xml.draw': [
        'sxd'
    ],
    'application/vnd.sun.xml.draw.template': [
        'std'
    ],
    'application/vnd.sun.xml.impress': [
        'sxi'
    ],
    'application/vnd.sun.xml.impress.template': [
        'sti'
    ],
    'application/vnd.sun.xml.math': [
        'sxm'
    ],
    'application/vnd.sun.xml.writer': [
        'sxw'
    ],
    'application/vnd.sun.xml.writer.global': [
        'sxg'
    ],
    'application/vnd.sun.xml.writer.template': [
        'stw'
    ],
    'application/vnd.sus-calendar': [
        'sus',
        'susp'
    ],
    'application/vnd.svd': [
        'svd'
    ],
    'application/vnd.symbian.install': [
        'sis',
        'sisx'
    ],
    'application/vnd.syncml+xml': [
        'xsm'
    ],
    'application/vnd.syncml.dm+wbxml': [
        'bdm'
    ],
    'application/vnd.syncml.dm+xml': [
        'xdm'
    ],
    'application/vnd.syncml.dmddf+xml': [
        'ddf'
    ],
    'application/vnd.tao.intent-module-archive': [
        'tao'
    ],
    'application/vnd.tcpdump.pcap': [
        'pcap',
        'cap',
        'dmp'
    ],
    'application/vnd.tmobile-livetv': [
        'tmo'
    ],
    'application/vnd.trid.tpt': [
        'tpt'
    ],
    'application/vnd.triscape.mxs': [
        'mxs'
    ],
    'application/vnd.trueapp': [
        'tra'
    ],
    'application/vnd.ufdl': [
        'ufd',
        'ufdl'
    ],
    'application/vnd.uiq.theme': [
        'utz'
    ],
    'application/vnd.umajin': [
        'umj'
    ],
    'application/vnd.unity': [
        'unityweb'
    ],
    'application/vnd.uoml+xml': [
        'uoml',
        'uo'
    ],
    'application/vnd.vcx': [
        'vcx'
    ],
    'application/vnd.visio': [
        'vsd',
        'vst',
        'vss',
        'vsw',
        'vsdx',
        'vtx'
    ],
    'application/vnd.visionary': [
        'vis'
    ],
    'application/vnd.vsf': [
        'vsf'
    ],
    'application/vnd.wap.wbxml': [
        'wbxml'
    ],
    'application/vnd.wap.wmlc': [
        'wmlc'
    ],
    'application/vnd.wap.wmlscriptc': [
        'wmlsc'
    ],
    'application/vnd.webturbo': [
        'wtb'
    ],
    'application/vnd.wolfram.player': [
        'nbp'
    ],
    'application/vnd.wordperfect': [
        'wpd'
    ],
    'application/vnd.wqd': [
        'wqd'
    ],
    'application/vnd.wt.stf': [
        'stf'
    ],
    'application/vnd.xara': [
        'xar'
    ],
    'application/vnd.xfdl': [
        'xfdl'
    ],
    'application/vnd.yamaha.hv-dic': [
        'hvd'
    ],
    'application/vnd.yamaha.hv-script': [
        'hvs'
    ],
    'application/vnd.yamaha.hv-voice': [
        'hvp'
    ],
    'application/vnd.yamaha.openscoreformat': [
        'osf'
    ],
    'application/vnd.yamaha.openscoreformat.osfpvg+xml': [
        'osfpvg'
    ],
    'application/vnd.yamaha.smaf-audio': [
        'saf'
    ],
    'application/vnd.yamaha.smaf-phrase': [
        'spf'
    ],
    'application/vnd.yellowriver-custom-menu': [
        'cmp'
    ],
    'application/vnd.zul': [
        'zir',
        'zirz'
    ],
    'application/vnd.zzazz.deck+xml': [
        'zaz'
    ],
    'application/x-7z-compressed': [
        '7z'
    ],
    'application/x-abiword': [
        'abw'
    ],
    'application/x-ace-compressed': [
        'ace'
    ],
    'application/x-apple-diskimage': [
        '*dmg'
    ],
    'application/x-arj': [
        'arj'
    ],
    'application/x-authorware-bin': [
        'aab',
        'x32',
        'u32',
        'vox'
    ],
    'application/x-authorware-map': [
        'aam'
    ],
    'application/x-authorware-seg': [
        'aas'
    ],
    'application/x-bcpio': [
        'bcpio'
    ],
    'application/x-bdoc': [
        '*bdoc'
    ],
    'application/x-bittorrent': [
        'torrent'
    ],
    'application/x-blender': [
        'blend'
    ],
    'application/x-blorb': [
        'blb',
        'blorb'
    ],
    'application/x-bzip': [
        'bz'
    ],
    'application/x-bzip2': [
        'bz2',
        'boz'
    ],
    'application/x-cbr': [
        'cbr',
        'cba',
        'cbt',
        'cbz',
        'cb7'
    ],
    'application/x-cdlink': [
        'vcd'
    ],
    'application/x-cfs-compressed': [
        'cfs'
    ],
    'application/x-chat': [
        'chat'
    ],
    'application/x-chess-pgn': [
        'pgn'
    ],
    'application/x-chrome-extension': [
        'crx'
    ],
    'application/x-cocoa': [
        'cco'
    ],
    'application/x-compressed': [
        '*rar'
    ],
    'application/x-conference': [
        'nsc'
    ],
    'application/x-cpio': [
        'cpio'
    ],
    'application/x-csh': [
        'csh'
    ],
    'application/x-debian-package': [
        '*deb',
        'udeb'
    ],
    'application/x-dgc-compressed': [
        'dgc'
    ],
    'application/x-director': [
        'dir',
        'dcr',
        'dxr',
        'cst',
        'cct',
        'cxt',
        'w3d',
        'fgd',
        'swa'
    ],
    'application/x-doom': [
        'wad'
    ],
    'application/x-dtbncx+xml': [
        'ncx'
    ],
    'application/x-dtbook+xml': [
        'dtb'
    ],
    'application/x-dtbresource+xml': [
        'res'
    ],
    'application/x-dvi': [
        'dvi'
    ],
    'application/x-envoy': [
        'evy'
    ],
    'application/x-eva': [
        'eva'
    ],
    'application/x-font-bdf': [
        'bdf'
    ],
    'application/x-font-ghostscript': [
        'gsf'
    ],
    'application/x-font-linux-psf': [
        'psf'
    ],
    'application/x-font-pcf': [
        'pcf'
    ],
    'application/x-font-snf': [
        'snf'
    ],
    'application/x-font-type1': [
        'pfa',
        'pfb',
        'pfm',
        'afm'
    ],
    'application/x-freearc': [
        'arc'
    ],
    'application/x-futuresplash': [
        'spl'
    ],
    'application/x-gca-compressed': [
        'gca'
    ],
    'application/x-glulx': [
        'ulx'
    ],
    'application/x-gnumeric': [
        'gnumeric'
    ],
    'application/x-gramps-xml': [
        'gramps'
    ],
    'application/x-gtar': [
        'gtar'
    ],
    'application/x-hdf': [
        'hdf'
    ],
    'application/x-httpd-php': [
        'php'
    ],
    'application/x-install-instructions': [
        'install'
    ],
    'application/x-ipynb+json': [
        'ipynb'
    ],
    'application/x-iso9660-image': [
        '*iso'
    ],
    'application/x-iwork-keynote-sffkey': [
        '*key'
    ],
    'application/x-iwork-numbers-sffnumbers': [
        '*numbers'
    ],
    'application/x-iwork-pages-sffpages': [
        '*pages'
    ],
    'application/x-java-archive-diff': [
        'jardiff'
    ],
    'application/x-java-jnlp-file': [
        'jnlp'
    ],
    'application/x-keepass2': [
        'kdbx'
    ],
    'application/x-latex': [
        'latex'
    ],
    'application/x-lua-bytecode': [
        'luac'
    ],
    'application/x-lzh-compressed': [
        'lzh',
        'lha'
    ],
    'application/x-makeself': [
        'run'
    ],
    'application/x-mie': [
        'mie'
    ],
    'application/x-mobipocket-ebook': [
        '*prc',
        'mobi'
    ],
    'application/x-ms-application': [
        'application'
    ],
    'application/x-ms-shortcut': [
        'lnk'
    ],
    'application/x-ms-wmd': [
        'wmd'
    ],
    'application/x-ms-wmz': [
        'wmz'
    ],
    'application/x-ms-xbap': [
        'xbap'
    ],
    'application/x-msaccess': [
        'mdb'
    ],
    'application/x-msbinder': [
        'obd'
    ],
    'application/x-mscardfile': [
        'crd'
    ],
    'application/x-msclip': [
        'clp'
    ],
    'application/x-msdos-program': [
        '*exe'
    ],
    'application/x-msdownload': [
        '*exe',
        '*dll',
        'com',
        'bat',
        '*msi'
    ],
    'application/x-msmediaview': [
        'mvb',
        'm13',
        'm14'
    ],
    'application/x-msmetafile': [
        '*wmf',
        '*wmz',
        '*emf',
        'emz'
    ],
    'application/x-msmoney': [
        'mny'
    ],
    'application/x-mspublisher': [
        'pub'
    ],
    'application/x-msschedule': [
        'scd'
    ],
    'application/x-msterminal': [
        'trm'
    ],
    'application/x-mswrite': [
        'wri'
    ],
    'application/x-netcdf': [
        'nc',
        'cdf'
    ],
    'application/x-ns-proxy-autoconfig': [
        'pac'
    ],
    'application/x-nzb': [
        'nzb'
    ],
    'application/x-perl': [
        'pl',
        'pm'
    ],
    'application/x-pilot': [
        '*prc',
        '*pdb'
    ],
    'application/x-pkcs12': [
        'p12',
        'pfx'
    ],
    'application/x-pkcs7-certificates': [
        'p7b',
        'spc'
    ],
    'application/x-pkcs7-certreqresp': [
        'p7r'
    ],
    'application/x-rar-compressed': [
        '*rar'
    ],
    'application/x-redhat-package-manager': [
        'rpm'
    ],
    'application/x-research-info-systems': [
        'ris'
    ],
    'application/x-sea': [
        'sea'
    ],
    'application/x-sh': [
        'sh'
    ],
    'application/x-shar': [
        'shar'
    ],
    'application/x-shockwave-flash': [
        'swf'
    ],
    'application/x-silverlight-app': [
        'xap'
    ],
    'application/x-sql': [
        '*sql'
    ],
    'application/x-stuffit': [
        'sit'
    ],
    'application/x-stuffitx': [
        'sitx'
    ],
    'application/x-subrip': [
        'srt'
    ],
    'application/x-sv4cpio': [
        'sv4cpio'
    ],
    'application/x-sv4crc': [
        'sv4crc'
    ],
    'application/x-t3vm-image': [
        't3'
    ],
    'application/x-tads': [
        'gam'
    ],
    'application/x-tar': [
        'tar'
    ],
    'application/x-tcl': [
        'tcl',
        'tk'
    ],
    'application/x-tex': [
        'tex'
    ],
    'application/x-tex-tfm': [
        'tfm'
    ],
    'application/x-texinfo': [
        'texinfo',
        'texi'
    ],
    'application/x-tgif': [
        '*obj'
    ],
    'application/x-ustar': [
        'ustar'
    ],
    'application/x-virtualbox-hdd': [
        'hdd'
    ],
    'application/x-virtualbox-ova': [
        'ova'
    ],
    'application/x-virtualbox-ovf': [
        'ovf'
    ],
    'application/x-virtualbox-vbox': [
        'vbox'
    ],
    'application/x-virtualbox-vbox-extpack': [
        'vbox-extpack'
    ],
    'application/x-virtualbox-vdi': [
        'vdi'
    ],
    'application/x-virtualbox-vhd': [
        'vhd'
    ],
    'application/x-virtualbox-vmdk': [
        'vmdk'
    ],
    'application/x-wais-source': [
        'src'
    ],
    'application/x-web-app-manifest+json': [
        'webapp'
    ],
    'application/x-x509-ca-cert': [
        'der',
        'crt',
        'pem'
    ],
    'application/x-xfig': [
        'fig'
    ],
    'application/x-xliff+xml': [
        '*xlf'
    ],
    'application/x-xpinstall': [
        'xpi'
    ],
    'application/x-xz': [
        'xz'
    ],
    'application/x-zip-compressed': [
        '*zip'
    ],
    'application/x-zmachine': [
        'z1',
        'z2',
        'z3',
        'z4',
        'z5',
        'z6',
        'z7',
        'z8'
    ],
    'audio/vnd.dece.audio': [
        'uva',
        'uvva'
    ],
    'audio/vnd.digital-winds': [
        'eol'
    ],
    'audio/vnd.dra': [
        'dra'
    ],
    'audio/vnd.dts': [
        'dts'
    ],
    'audio/vnd.dts.hd': [
        'dtshd'
    ],
    'audio/vnd.lucent.voice': [
        'lvp'
    ],
    'audio/vnd.ms-playready.media.pya': [
        'pya'
    ],
    'audio/vnd.nuera.ecelp4800': [
        'ecelp4800'
    ],
    'audio/vnd.nuera.ecelp7470': [
        'ecelp7470'
    ],
    'audio/vnd.nuera.ecelp9600': [
        'ecelp9600'
    ],
    'audio/vnd.rip': [
        'rip'
    ],
    'audio/x-aac': [
        '*aac'
    ],
    'audio/x-aiff': [
        'aif',
        'aiff',
        'aifc'
    ],
    'audio/x-caf': [
        'caf'
    ],
    'audio/x-flac': [
        'flac'
    ],
    'audio/x-m4a': [
        '*m4a'
    ],
    'audio/x-matroska': [
        'mka'
    ],
    'audio/x-mpegurl': [
        'm3u'
    ],
    'audio/x-ms-wax': [
        'wax'
    ],
    'audio/x-ms-wma': [
        'wma'
    ],
    'audio/x-pn-realaudio': [
        'ram',
        'ra'
    ],
    'audio/x-pn-realaudio-plugin': [
        'rmp'
    ],
    'audio/x-realaudio': [
        '*ra'
    ],
    'audio/x-wav': [
        '*wav'
    ],
    'chemical/x-cdx': [
        'cdx'
    ],
    'chemical/x-cif': [
        'cif'
    ],
    'chemical/x-cmdf': [
        'cmdf'
    ],
    'chemical/x-cml': [
        'cml'
    ],
    'chemical/x-csml': [
        'csml'
    ],
    'chemical/x-xyz': [
        'xyz'
    ],
    'image/prs.btif': [
        'btif',
        'btf'
    ],
    'image/prs.pti': [
        'pti'
    ],
    'image/vnd.adobe.photoshop': [
        'psd'
    ],
    'image/vnd.airzip.accelerator.azv': [
        'azv'
    ],
    'image/vnd.blockfact.facti': [
        'facti'
    ],
    'image/vnd.dece.graphic': [
        'uvi',
        'uvvi',
        'uvg',
        'uvvg'
    ],
    'image/vnd.djvu': [
        'djvu',
        'djv'
    ],
    'image/vnd.dvb.subtitle': [
        '*sub'
    ],
    'image/vnd.dwg': [
        'dwg'
    ],
    'image/vnd.dxf': [
        'dxf'
    ],
    'image/vnd.fastbidsheet': [
        'fbs'
    ],
    'image/vnd.fpx': [
        'fpx'
    ],
    'image/vnd.fst': [
        'fst'
    ],
    'image/vnd.fujixerox.edmics-mmr': [
        'mmr'
    ],
    'image/vnd.fujixerox.edmics-rlc': [
        'rlc'
    ],
    'image/vnd.microsoft.icon': [
        'ico'
    ],
    'image/vnd.ms-dds': [
        'dds'
    ],
    'image/vnd.ms-modi': [
        'mdi'
    ],
    'image/vnd.ms-photo': [
        'wdp'
    ],
    'image/vnd.net-fpx': [
        'npx'
    ],
    'image/vnd.pco.b16': [
        'b16'
    ],
    'image/vnd.tencent.tap': [
        'tap'
    ],
    'image/vnd.valve.source.texture': [
        'vtf'
    ],
    'image/vnd.wap.wbmp': [
        'wbmp'
    ],
    'image/vnd.xiff': [
        'xif'
    ],
    'image/vnd.zbrush.pcx': [
        'pcx'
    ],
    'image/x-3ds': [
        '3ds'
    ],
    'image/x-adobe-dng': [
        'dng'
    ],
    'image/x-cmu-raster': [
        'ras'
    ],
    'image/x-cmx': [
        'cmx'
    ],
    'image/x-freehand': [
        'fh',
        'fhc',
        'fh4',
        'fh5',
        'fh7'
    ],
    'image/x-icon': [
        '*ico'
    ],
    'image/x-jng': [
        'jng'
    ],
    'image/x-mrsid-image': [
        'sid'
    ],
    'image/x-ms-bmp': [
        '*bmp'
    ],
    'image/x-pcx': [
        '*pcx'
    ],
    'image/x-pict': [
        'pic',
        'pct'
    ],
    'image/x-portable-anymap': [
        'pnm'
    ],
    'image/x-portable-bitmap': [
        'pbm'
    ],
    'image/x-portable-graymap': [
        'pgm'
    ],
    'image/x-portable-pixmap': [
        'ppm'
    ],
    'image/x-rgb': [
        'rgb'
    ],
    'image/x-tga': [
        'tga'
    ],
    'image/x-xbitmap': [
        'xbm'
    ],
    'image/x-xpixmap': [
        'xpm'
    ],
    'image/x-xwindowdump': [
        'xwd'
    ],
    'message/vnd.wfa.wsc': [
        'wsc'
    ],
    'model/vnd.bary': [
        'bary'
    ],
    'model/vnd.cld': [
        'cld'
    ],
    'model/vnd.collada+xml': [
        'dae'
    ],
    'model/vnd.dwf': [
        'dwf'
    ],
    'model/vnd.gdl': [
        'gdl'
    ],
    'model/vnd.gtw': [
        'gtw'
    ],
    'model/vnd.mts': [
        '*mts'
    ],
    'model/vnd.opengex': [
        'ogex'
    ],
    'model/vnd.parasolid.transmit.binary': [
        'x_b'
    ],
    'model/vnd.parasolid.transmit.text': [
        'x_t'
    ],
    'model/vnd.pytha.pyox': [
        'pyo',
        'pyox'
    ],
    'model/vnd.sap.vds': [
        'vds'
    ],
    'model/vnd.usda': [
        'usda'
    ],
    'model/vnd.usdz+zip': [
        'usdz'
    ],
    'model/vnd.valve.source.compiled-map': [
        'bsp'
    ],
    'model/vnd.vtu': [
        'vtu'
    ],
    'text/prs.lines.tag': [
        'dsc'
    ],
    'text/vnd.curl': [
        'curl'
    ],
    'text/vnd.curl.dcurl': [
        'dcurl'
    ],
    'text/vnd.curl.mcurl': [
        'mcurl'
    ],
    'text/vnd.curl.scurl': [
        'scurl'
    ],
    'text/vnd.dvb.subtitle': [
        'sub'
    ],
    'text/vnd.familysearch.gedcom': [
        'ged'
    ],
    'text/vnd.fly': [
        'fly'
    ],
    'text/vnd.fmi.flexstor': [
        'flx'
    ],
    'text/vnd.graphviz': [
        'gv'
    ],
    'text/vnd.in3d.3dml': [
        '3dml'
    ],
    'text/vnd.in3d.spot': [
        'spot'
    ],
    'text/vnd.sun.j2me.app-descriptor': [
        'jad'
    ],
    'text/vnd.wap.wml': [
        'wml'
    ],
    'text/vnd.wap.wmlscript': [
        'wmls'
    ],
    'text/x-asm': [
        's',
        'asm'
    ],
    'text/x-c': [
        'c',
        'cc',
        'cxx',
        'cpp',
        'h',
        'hh',
        'dic'
    ],
    'text/x-component': [
        'htc'
    ],
    'text/x-fortran': [
        'f',
        'for',
        'f77',
        'f90'
    ],
    'text/x-handlebars-template': [
        'hbs'
    ],
    'text/x-java-source': [
        'java'
    ],
    'text/x-lua': [
        'lua'
    ],
    'text/x-markdown': [
        'mkd'
    ],
    'text/x-nfo': [
        'nfo'
    ],
    'text/x-opml': [
        'opml'
    ],
    'text/x-org': [
        '*org'
    ],
    'text/x-pascal': [
        'p',
        'pas'
    ],
    'text/x-processing': [
        'pde'
    ],
    'text/x-sass': [
        'sass'
    ],
    'text/x-scss': [
        'scss'
    ],
    'text/x-setext': [
        'etx'
    ],
    'text/x-sfv': [
        'sfv'
    ],
    'text/x-suse-ymp': [
        'ymp'
    ],
    'text/x-uuencode': [
        'uu'
    ],
    'text/x-vcalendar': [
        'vcs'
    ],
    'text/x-vcard': [
        'vcf'
    ],
    'video/vnd.dece.hd': [
        'uvh',
        'uvvh'
    ],
    'video/vnd.dece.mobile': [
        'uvm',
        'uvvm'
    ],
    'video/vnd.dece.pd': [
        'uvp',
        'uvvp'
    ],
    'video/vnd.dece.sd': [
        'uvs',
        'uvvs'
    ],
    'video/vnd.dece.video': [
        'uvv',
        'uvvv'
    ],
    'video/vnd.dvb.file': [
        'dvb'
    ],
    'video/vnd.fvt': [
        'fvt'
    ],
    'video/vnd.mpegurl': [
        'mxu',
        'm4u'
    ],
    'video/vnd.ms-playready.media.pyv': [
        'pyv'
    ],
    'video/vnd.uvvu.mp4': [
        'uvu',
        'uvvu'
    ],
    'video/vnd.vivo': [
        'viv'
    ],
    'video/x-f4v': [
        'f4v'
    ],
    'video/x-fli': [
        'fli'
    ],
    'video/x-flv': [
        'flv'
    ],
    'video/x-m4v': [
        'm4v'
    ],
    'video/x-matroska': [
        'mkv',
        'mk3d',
        'mks'
    ],
    'video/x-mng': [
        'mng'
    ],
    'video/x-ms-asf': [
        'asf',
        'asx'
    ],
    'video/x-ms-vob': [
        'vob'
    ],
    'video/x-ms-wm': [
        'wm'
    ],
    'video/x-ms-wmv': [
        'wmv'
    ],
    'video/x-ms-wmx': [
        'wmx'
    ],
    'video/x-ms-wvx': [
        'wvx'
    ],
    'video/x-msvideo': [
        'avi'
    ],
    'video/x-sgi-movie': [
        'movie'
    ],
    'video/x-smv': [
        'smv'
    ],
    'x-conference/x-cooltalk': [
        'ice'
    ]
};
Object.freeze($ab01173f783f3846$var$types);
var $ab01173f783f3846$export$2e2bcd8739ae039 = $ab01173f783f3846$var$types;


const $442709b248c33acc$var$types = {
    'application/andrew-inset': [
        'ez'
    ],
    'application/appinstaller': [
        'appinstaller'
    ],
    'application/applixware': [
        'aw'
    ],
    'application/appx': [
        'appx'
    ],
    'application/appxbundle': [
        'appxbundle'
    ],
    'application/atom+xml': [
        'atom'
    ],
    'application/atomcat+xml': [
        'atomcat'
    ],
    'application/atomdeleted+xml': [
        'atomdeleted'
    ],
    'application/atomsvc+xml': [
        'atomsvc'
    ],
    'application/atsc-dwd+xml': [
        'dwd'
    ],
    'application/atsc-held+xml': [
        'held'
    ],
    'application/atsc-rsat+xml': [
        'rsat'
    ],
    'application/automationml-aml+xml': [
        'aml'
    ],
    'application/automationml-amlx+zip': [
        'amlx'
    ],
    'application/bdoc': [
        'bdoc'
    ],
    'application/calendar+xml': [
        'xcs'
    ],
    'application/ccxml+xml': [
        'ccxml'
    ],
    'application/cdfx+xml': [
        'cdfx'
    ],
    'application/cdmi-capability': [
        'cdmia'
    ],
    'application/cdmi-container': [
        'cdmic'
    ],
    'application/cdmi-domain': [
        'cdmid'
    ],
    'application/cdmi-object': [
        'cdmio'
    ],
    'application/cdmi-queue': [
        'cdmiq'
    ],
    'application/cpl+xml': [
        'cpl'
    ],
    'application/cu-seeme': [
        'cu'
    ],
    'application/cwl': [
        'cwl'
    ],
    'application/dash+xml': [
        'mpd'
    ],
    'application/dash-patch+xml': [
        'mpp'
    ],
    'application/davmount+xml': [
        'davmount'
    ],
    'application/dicom': [
        'dcm'
    ],
    'application/docbook+xml': [
        'dbk'
    ],
    'application/dssc+der': [
        'dssc'
    ],
    'application/dssc+xml': [
        'xdssc'
    ],
    'application/ecmascript': [
        'ecma'
    ],
    'application/emma+xml': [
        'emma'
    ],
    'application/emotionml+xml': [
        'emotionml'
    ],
    'application/epub+zip': [
        'epub'
    ],
    'application/exi': [
        'exi'
    ],
    'application/express': [
        'exp'
    ],
    'application/fdf': [
        'fdf'
    ],
    'application/fdt+xml': [
        'fdt'
    ],
    'application/font-tdpfr': [
        'pfr'
    ],
    'application/geo+json': [
        'geojson'
    ],
    'application/gml+xml': [
        'gml'
    ],
    'application/gpx+xml': [
        'gpx'
    ],
    'application/gxf': [
        'gxf'
    ],
    'application/gzip': [
        'gz'
    ],
    'application/hjson': [
        'hjson'
    ],
    'application/hyperstudio': [
        'stk'
    ],
    'application/inkml+xml': [
        'ink',
        'inkml'
    ],
    'application/ipfix': [
        'ipfix'
    ],
    'application/its+xml': [
        'its'
    ],
    'application/java-archive': [
        'jar',
        'war',
        'ear'
    ],
    'application/java-serialized-object': [
        'ser'
    ],
    'application/java-vm': [
        'class'
    ],
    'application/javascript': [
        '*js'
    ],
    'application/json': [
        'json',
        'map'
    ],
    'application/json5': [
        'json5'
    ],
    'application/jsonml+json': [
        'jsonml'
    ],
    'application/ld+json': [
        'jsonld'
    ],
    'application/lgr+xml': [
        'lgr'
    ],
    'application/lost+xml': [
        'lostxml'
    ],
    'application/mac-binhex40': [
        'hqx'
    ],
    'application/mac-compactpro': [
        'cpt'
    ],
    'application/mads+xml': [
        'mads'
    ],
    'application/manifest+json': [
        'webmanifest'
    ],
    'application/marc': [
        'mrc'
    ],
    'application/marcxml+xml': [
        'mrcx'
    ],
    'application/mathematica': [
        'ma',
        'nb',
        'mb'
    ],
    'application/mathml+xml': [
        'mathml'
    ],
    'application/mbox': [
        'mbox'
    ],
    'application/media-policy-dataset+xml': [
        'mpf'
    ],
    'application/mediaservercontrol+xml': [
        'mscml'
    ],
    'application/metalink+xml': [
        'metalink'
    ],
    'application/metalink4+xml': [
        'meta4'
    ],
    'application/mets+xml': [
        'mets'
    ],
    'application/mmt-aei+xml': [
        'maei'
    ],
    'application/mmt-usd+xml': [
        'musd'
    ],
    'application/mods+xml': [
        'mods'
    ],
    'application/mp21': [
        'm21',
        'mp21'
    ],
    'application/mp4': [
        '*mp4',
        '*mpg4',
        'mp4s',
        'm4p'
    ],
    'application/msix': [
        'msix'
    ],
    'application/msixbundle': [
        'msixbundle'
    ],
    'application/msword': [
        'doc',
        'dot'
    ],
    'application/mxf': [
        'mxf'
    ],
    'application/n-quads': [
        'nq'
    ],
    'application/n-triples': [
        'nt'
    ],
    'application/node': [
        'cjs'
    ],
    'application/octet-stream': [
        'bin',
        'dms',
        'lrf',
        'mar',
        'so',
        'dist',
        'distz',
        'pkg',
        'bpk',
        'dump',
        'elc',
        'deploy',
        'exe',
        'dll',
        'deb',
        'dmg',
        'iso',
        'img',
        'msi',
        'msp',
        'msm',
        'buffer'
    ],
    'application/oda': [
        'oda'
    ],
    'application/oebps-package+xml': [
        'opf'
    ],
    'application/ogg': [
        'ogx'
    ],
    'application/omdoc+xml': [
        'omdoc'
    ],
    'application/onenote': [
        'onetoc',
        'onetoc2',
        'onetmp',
        'onepkg',
        'one',
        'onea'
    ],
    'application/oxps': [
        'oxps'
    ],
    'application/p2p-overlay+xml': [
        'relo'
    ],
    'application/patch-ops-error+xml': [
        'xer'
    ],
    'application/pdf': [
        'pdf'
    ],
    'application/pgp-encrypted': [
        'pgp'
    ],
    'application/pgp-keys': [
        'asc'
    ],
    'application/pgp-signature': [
        'sig',
        '*asc'
    ],
    'application/pics-rules': [
        'prf'
    ],
    'application/pkcs10': [
        'p10'
    ],
    'application/pkcs7-mime': [
        'p7m',
        'p7c'
    ],
    'application/pkcs7-signature': [
        'p7s'
    ],
    'application/pkcs8': [
        'p8'
    ],
    'application/pkix-attr-cert': [
        'ac'
    ],
    'application/pkix-cert': [
        'cer'
    ],
    'application/pkix-crl': [
        'crl'
    ],
    'application/pkix-pkipath': [
        'pkipath'
    ],
    'application/pkixcmp': [
        'pki'
    ],
    'application/pls+xml': [
        'pls'
    ],
    'application/postscript': [
        'ai',
        'eps',
        'ps'
    ],
    'application/provenance+xml': [
        'provx'
    ],
    'application/pskc+xml': [
        'pskcxml'
    ],
    'application/raml+yaml': [
        'raml'
    ],
    'application/rdf+xml': [
        'rdf',
        'owl'
    ],
    'application/reginfo+xml': [
        'rif'
    ],
    'application/relax-ng-compact-syntax': [
        'rnc'
    ],
    'application/resource-lists+xml': [
        'rl'
    ],
    'application/resource-lists-diff+xml': [
        'rld'
    ],
    'application/rls-services+xml': [
        'rs'
    ],
    'application/route-apd+xml': [
        'rapd'
    ],
    'application/route-s-tsid+xml': [
        'sls'
    ],
    'application/route-usd+xml': [
        'rusd'
    ],
    'application/rpki-ghostbusters': [
        'gbr'
    ],
    'application/rpki-manifest': [
        'mft'
    ],
    'application/rpki-roa': [
        'roa'
    ],
    'application/rsd+xml': [
        'rsd'
    ],
    'application/rss+xml': [
        'rss'
    ],
    'application/rtf': [
        'rtf'
    ],
    'application/sbml+xml': [
        'sbml'
    ],
    'application/scvp-cv-request': [
        'scq'
    ],
    'application/scvp-cv-response': [
        'scs'
    ],
    'application/scvp-vp-request': [
        'spq'
    ],
    'application/scvp-vp-response': [
        'spp'
    ],
    'application/sdp': [
        'sdp'
    ],
    'application/senml+xml': [
        'senmlx'
    ],
    'application/sensml+xml': [
        'sensmlx'
    ],
    'application/set-payment-initiation': [
        'setpay'
    ],
    'application/set-registration-initiation': [
        'setreg'
    ],
    'application/shf+xml': [
        'shf'
    ],
    'application/sieve': [
        'siv',
        'sieve'
    ],
    'application/smil+xml': [
        'smi',
        'smil'
    ],
    'application/sparql-query': [
        'rq'
    ],
    'application/sparql-results+xml': [
        'srx'
    ],
    'application/sql': [
        'sql'
    ],
    'application/srgs': [
        'gram'
    ],
    'application/srgs+xml': [
        'grxml'
    ],
    'application/sru+xml': [
        'sru'
    ],
    'application/ssdl+xml': [
        'ssdl'
    ],
    'application/ssml+xml': [
        'ssml'
    ],
    'application/swid+xml': [
        'swidtag'
    ],
    'application/tei+xml': [
        'tei',
        'teicorpus'
    ],
    'application/thraud+xml': [
        'tfi'
    ],
    'application/timestamped-data': [
        'tsd'
    ],
    'application/toml': [
        'toml'
    ],
    'application/trig': [
        'trig'
    ],
    'application/ttml+xml': [
        'ttml'
    ],
    'application/ubjson': [
        'ubj'
    ],
    'application/urc-ressheet+xml': [
        'rsheet'
    ],
    'application/urc-targetdesc+xml': [
        'td'
    ],
    'application/voicexml+xml': [
        'vxml'
    ],
    'application/wasm': [
        'wasm'
    ],
    'application/watcherinfo+xml': [
        'wif'
    ],
    'application/widget': [
        'wgt'
    ],
    'application/winhlp': [
        'hlp'
    ],
    'application/wsdl+xml': [
        'wsdl'
    ],
    'application/wspolicy+xml': [
        'wspolicy'
    ],
    'application/xaml+xml': [
        'xaml'
    ],
    'application/xcap-att+xml': [
        'xav'
    ],
    'application/xcap-caps+xml': [
        'xca'
    ],
    'application/xcap-diff+xml': [
        'xdf'
    ],
    'application/xcap-el+xml': [
        'xel'
    ],
    'application/xcap-ns+xml': [
        'xns'
    ],
    'application/xenc+xml': [
        'xenc'
    ],
    'application/xfdf': [
        'xfdf'
    ],
    'application/xhtml+xml': [
        'xhtml',
        'xht'
    ],
    'application/xliff+xml': [
        'xlf'
    ],
    'application/xml': [
        'xml',
        'xsl',
        'xsd',
        'rng'
    ],
    'application/xml-dtd': [
        'dtd'
    ],
    'application/xop+xml': [
        'xop'
    ],
    'application/xproc+xml': [
        'xpl'
    ],
    'application/xslt+xml': [
        '*xsl',
        'xslt'
    ],
    'application/xspf+xml': [
        'xspf'
    ],
    'application/xv+xml': [
        'mxml',
        'xhvml',
        'xvml',
        'xvm'
    ],
    'application/yang': [
        'yang'
    ],
    'application/yin+xml': [
        'yin'
    ],
    'application/zip': [
        'zip'
    ],
    'application/zip+dotlottie': [
        'lottie'
    ],
    'audio/3gpp': [
        '*3gpp'
    ],
    'audio/aac': [
        'adts',
        'aac'
    ],
    'audio/adpcm': [
        'adp'
    ],
    'audio/amr': [
        'amr'
    ],
    'audio/basic': [
        'au',
        'snd'
    ],
    'audio/midi': [
        'mid',
        'midi',
        'kar',
        'rmi'
    ],
    'audio/mobile-xmf': [
        'mxmf'
    ],
    'audio/mp3': [
        '*mp3'
    ],
    'audio/mp4': [
        'm4a',
        'mp4a',
        'm4b'
    ],
    'audio/mpeg': [
        'mpga',
        'mp2',
        'mp2a',
        'mp3',
        'm2a',
        'm3a'
    ],
    'audio/ogg': [
        'oga',
        'ogg',
        'spx',
        'opus'
    ],
    'audio/s3m': [
        's3m'
    ],
    'audio/silk': [
        'sil'
    ],
    'audio/wav': [
        'wav'
    ],
    'audio/wave': [
        '*wav'
    ],
    'audio/webm': [
        'weba'
    ],
    'audio/xm': [
        'xm'
    ],
    'font/collection': [
        'ttc'
    ],
    'font/otf': [
        'otf'
    ],
    'font/ttf': [
        'ttf'
    ],
    'font/woff': [
        'woff'
    ],
    'font/woff2': [
        'woff2'
    ],
    'image/aces': [
        'exr'
    ],
    'image/apng': [
        'apng'
    ],
    'image/avci': [
        'avci'
    ],
    'image/avcs': [
        'avcs'
    ],
    'image/avif': [
        'avif'
    ],
    'image/bmp': [
        'bmp',
        'dib'
    ],
    'image/cgm': [
        'cgm'
    ],
    'image/dicom-rle': [
        'drle'
    ],
    'image/dpx': [
        'dpx'
    ],
    'image/emf': [
        'emf'
    ],
    'image/fits': [
        'fits'
    ],
    'image/g3fax': [
        'g3'
    ],
    'image/gif': [
        'gif'
    ],
    'image/heic': [
        'heic'
    ],
    'image/heic-sequence': [
        'heics'
    ],
    'image/heif': [
        'heif'
    ],
    'image/heif-sequence': [
        'heifs'
    ],
    'image/hej2k': [
        'hej2'
    ],
    'image/ief': [
        'ief'
    ],
    'image/jaii': [
        'jaii'
    ],
    'image/jais': [
        'jais'
    ],
    'image/jls': [
        'jls'
    ],
    'image/jp2': [
        'jp2',
        'jpg2'
    ],
    'image/jpeg': [
        'jpg',
        'jpeg',
        'jpe'
    ],
    'image/jph': [
        'jph'
    ],
    'image/jphc': [
        'jhc'
    ],
    'image/jpm': [
        'jpm',
        'jpgm'
    ],
    'image/jpx': [
        'jpx',
        'jpf'
    ],
    'image/jxl': [
        'jxl'
    ],
    'image/jxr': [
        'jxr'
    ],
    'image/jxra': [
        'jxra'
    ],
    'image/jxrs': [
        'jxrs'
    ],
    'image/jxs': [
        'jxs'
    ],
    'image/jxsc': [
        'jxsc'
    ],
    'image/jxsi': [
        'jxsi'
    ],
    'image/jxss': [
        'jxss'
    ],
    'image/ktx': [
        'ktx'
    ],
    'image/ktx2': [
        'ktx2'
    ],
    'image/pjpeg': [
        'jfif'
    ],
    'image/png': [
        'png'
    ],
    'image/sgi': [
        'sgi'
    ],
    'image/svg+xml': [
        'svg',
        'svgz'
    ],
    'image/t38': [
        't38'
    ],
    'image/tiff': [
        'tif',
        'tiff'
    ],
    'image/tiff-fx': [
        'tfx'
    ],
    'image/webp': [
        'webp'
    ],
    'image/wmf': [
        'wmf'
    ],
    'message/disposition-notification': [
        'disposition-notification'
    ],
    'message/global': [
        'u8msg'
    ],
    'message/global-delivery-status': [
        'u8dsn'
    ],
    'message/global-disposition-notification': [
        'u8mdn'
    ],
    'message/global-headers': [
        'u8hdr'
    ],
    'message/rfc822': [
        'eml',
        'mime',
        'mht',
        'mhtml'
    ],
    'model/3mf': [
        '3mf'
    ],
    'model/gltf+json': [
        'gltf'
    ],
    'model/gltf-binary': [
        'glb'
    ],
    'model/iges': [
        'igs',
        'iges'
    ],
    'model/jt': [
        'jt'
    ],
    'model/mesh': [
        'msh',
        'mesh',
        'silo'
    ],
    'model/mtl': [
        'mtl'
    ],
    'model/obj': [
        'obj'
    ],
    'model/prc': [
        'prc'
    ],
    'model/step': [
        'step',
        'stp',
        'stpnc',
        'p21',
        '210'
    ],
    'model/step+xml': [
        'stpx'
    ],
    'model/step+zip': [
        'stpz'
    ],
    'model/step-xml+zip': [
        'stpxz'
    ],
    'model/stl': [
        'stl'
    ],
    'model/u3d': [
        'u3d'
    ],
    'model/vrml': [
        'wrl',
        'vrml'
    ],
    'model/x3d+binary': [
        '*x3db',
        'x3dbz'
    ],
    'model/x3d+fastinfoset': [
        'x3db'
    ],
    'model/x3d+vrml': [
        '*x3dv',
        'x3dvz'
    ],
    'model/x3d+xml': [
        'x3d',
        'x3dz'
    ],
    'model/x3d-vrml': [
        'x3dv'
    ],
    'text/cache-manifest': [
        'appcache',
        'manifest'
    ],
    'text/calendar': [
        'ics',
        'ifb'
    ],
    'text/coffeescript': [
        'coffee',
        'litcoffee'
    ],
    'text/css': [
        'css'
    ],
    'text/csv': [
        'csv'
    ],
    'text/html': [
        'html',
        'htm',
        'shtml'
    ],
    'text/jade': [
        'jade'
    ],
    'text/javascript': [
        'js',
        'mjs'
    ],
    'text/jsx': [
        'jsx'
    ],
    'text/less': [
        'less'
    ],
    'text/markdown': [
        'md',
        'markdown'
    ],
    'text/mathml': [
        'mml'
    ],
    'text/mdx': [
        'mdx'
    ],
    'text/n3': [
        'n3'
    ],
    'text/plain': [
        'txt',
        'text',
        'conf',
        'def',
        'list',
        'log',
        'in',
        'ini'
    ],
    'text/richtext': [
        'rtx'
    ],
    'text/rtf': [
        '*rtf'
    ],
    'text/sgml': [
        'sgml',
        'sgm'
    ],
    'text/shex': [
        'shex'
    ],
    'text/slim': [
        'slim',
        'slm'
    ],
    'text/spdx': [
        'spdx'
    ],
    'text/stylus': [
        'stylus',
        'styl'
    ],
    'text/tab-separated-values': [
        'tsv'
    ],
    'text/troff': [
        't',
        'tr',
        'roff',
        'man',
        'me',
        'ms'
    ],
    'text/turtle': [
        'ttl'
    ],
    'text/uri-list': [
        'uri',
        'uris',
        'urls'
    ],
    'text/vcard': [
        'vcard'
    ],
    'text/vtt': [
        'vtt'
    ],
    'text/wgsl': [
        'wgsl'
    ],
    'text/xml': [
        '*xml'
    ],
    'text/yaml': [
        'yaml',
        'yml'
    ],
    'video/3gpp': [
        '3gp',
        '3gpp'
    ],
    'video/3gpp2': [
        '3g2'
    ],
    'video/h261': [
        'h261'
    ],
    'video/h263': [
        'h263'
    ],
    'video/h264': [
        'h264'
    ],
    'video/iso.segment': [
        'm4s'
    ],
    'video/jpeg': [
        'jpgv'
    ],
    'video/jpm': [
        '*jpm',
        '*jpgm'
    ],
    'video/mj2': [
        'mj2',
        'mjp2'
    ],
    'video/mp2t': [
        'ts',
        'm2t',
        'm2ts',
        'mts'
    ],
    'video/mp4': [
        'mp4',
        'mp4v',
        'mpg4'
    ],
    'video/mpeg': [
        'mpeg',
        'mpg',
        'mpe',
        'm1v',
        'm2v'
    ],
    'video/ogg': [
        'ogv'
    ],
    'video/quicktime': [
        'qt',
        'mov'
    ],
    'video/webm': [
        'webm'
    ]
};
Object.freeze($442709b248c33acc$var$types);
var $442709b248c33acc$export$2e2bcd8739ae039 = $442709b248c33acc$var$types;


var $b294ca6e6831d420$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $b294ca6e6831d420$var$_Mime_extensionToType, $b294ca6e6831d420$var$_Mime_typeToExtension, $b294ca6e6831d420$var$_Mime_typeToExtensions;
class $b294ca6e6831d420$var$Mime {
    constructor(...args){
        $b294ca6e6831d420$var$_Mime_extensionToType.set(this, new Map());
        $b294ca6e6831d420$var$_Mime_typeToExtension.set(this, new Map());
        $b294ca6e6831d420$var$_Mime_typeToExtensions.set(this, new Map());
        for (const arg of args)this.define(arg);
    }
    define(typeMap, force = false) {
        for (let [type, extensions] of Object.entries(typeMap)){
            type = type.toLowerCase();
            extensions = extensions.map((ext)=>ext.toLowerCase());
            if (!$b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtensions, "f").has(type)) $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtensions, "f").set(type, new Set());
            const allExtensions = $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtensions, "f").get(type);
            let first = true;
            for (let extension of extensions){
                const starred = extension.startsWith('*');
                extension = starred ? extension.slice(1) : extension;
                allExtensions?.add(extension);
                if (first) $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtension, "f").set(type, extension);
                first = false;
                if (starred) continue;
                const currentType = $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_extensionToType, "f").get(extension);
                if (currentType && currentType != type && !force) throw new Error(`"${type} -> ${extension}" conflicts with "${currentType} -> ${extension}". Pass \`force=true\` to override this definition.`);
                $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_extensionToType, "f").set(extension, type);
            }
        }
        return this;
    }
    getType(path) {
        if (typeof path !== 'string') return null;
        const last = path.replace(/^.*[/\\]/s, '').toLowerCase();
        const ext = last.replace(/^.*\./s, '').toLowerCase();
        const hasPath = last.length < path.length;
        const hasDot = ext.length < last.length - 1;
        if (!hasDot && hasPath) return null;
        return $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_extensionToType, "f").get(ext) ?? null;
    }
    getExtension(type) {
        if (typeof type !== 'string') return null;
        type = type?.split?.(';')[0];
        return (type && $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtension, "f").get(type.trim().toLowerCase())) ?? null;
    }
    getAllExtensions(type) {
        if (typeof type !== 'string') return null;
        return $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtensions, "f").get(type.toLowerCase()) ?? null;
    }
    _freeze() {
        this.define = ()=>{
            throw new Error('define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances');
        };
        Object.freeze(this);
        for (const extensions of $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtensions, "f").values())Object.freeze(extensions);
        return this;
    }
    _getTestState() {
        return {
            types: $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_extensionToType, "f"),
            extensions: $b294ca6e6831d420$var$__classPrivateFieldGet(this, $b294ca6e6831d420$var$_Mime_typeToExtension, "f")
        };
    }
}
$b294ca6e6831d420$var$_Mime_extensionToType = new WeakMap(), $b294ca6e6831d420$var$_Mime_typeToExtension = new WeakMap(), $b294ca6e6831d420$var$_Mime_typeToExtensions = new WeakMap();
var $b294ca6e6831d420$export$2e2bcd8739ae039 = $b294ca6e6831d420$var$Mime;


var $b0ca40bdc143287e$export$2e2bcd8739ae039 = new (0, $b294ca6e6831d420$export$2e2bcd8739ae039)((0, $442709b248c33acc$export$2e2bcd8739ae039), (0, $ab01173f783f3846$export$2e2bcd8739ae039))._freeze();


var $4799ffc520052701$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $4799ffc520052701$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $4799ffc520052701$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($4799ffc520052701$var$_self);
if ($4799ffc520052701$exports) $4799ffc520052701$exports = $4799ffc520052701$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $4799ffc520052701$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $4799ffc520052701$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$4799ffc520052701$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $4799ffc520052701$var$Prism.languages.markup['entity'];
$4799ffc520052701$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $4799ffc520052701$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$4799ffc520052701$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($4799ffc520052701$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $4799ffc520052701$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $4799ffc520052701$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($4799ffc520052701$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $4799ffc520052701$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $4799ffc520052701$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$4799ffc520052701$var$Prism.languages.html = $4799ffc520052701$var$Prism.languages.markup;
$4799ffc520052701$var$Prism.languages.mathml = $4799ffc520052701$var$Prism.languages.markup;
$4799ffc520052701$var$Prism.languages.svg = $4799ffc520052701$var$Prism.languages.markup;
$4799ffc520052701$var$Prism.languages.xml = $4799ffc520052701$var$Prism.languages.extend('markup', {});
$4799ffc520052701$var$Prism.languages.ssml = $4799ffc520052701$var$Prism.languages.xml;
$4799ffc520052701$var$Prism.languages.atom = $4799ffc520052701$var$Prism.languages.xml;
$4799ffc520052701$var$Prism.languages.rss = $4799ffc520052701$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($4799ffc520052701$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $4799ffc520052701$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $4799ffc520052701$var$Prism.languages.javascript = $4799ffc520052701$var$Prism.languages.extend('clike', {
    'class-name': [
        $4799ffc520052701$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$4799ffc520052701$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$4799ffc520052701$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $4799ffc520052701$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$4799ffc520052701$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $4799ffc520052701$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$4799ffc520052701$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($4799ffc520052701$var$Prism.languages.markup) {
    $4799ffc520052701$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $4799ffc520052701$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$4799ffc520052701$var$Prism.languages.js = $4799ffc520052701$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $4799ffc520052701$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $4799ffc520052701$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $4799ffc520052701$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $4799ffc520052701$var$Prism.util.setLanguage(code, language);
            $4799ffc520052701$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $4799ffc520052701$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $4799ffc520052701$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $4799ffc520052701$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$4799ffc520052701$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $4799ffc520052701$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $4799ffc520052701$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


const $e7fb5080ac3edd96$export$5f747a46dc0eb6ee = (()=>{
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top.window.document._ = 0;
    } catch (e) {
        return !1;
    }
    return "showOpenFilePicker" in self;
})(), $e7fb5080ac3edd96$var$t = $e7fb5080ac3edd96$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$c;
}) : Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$h;
});
async function $e7fb5080ac3edd96$export$c1bd535e520dbbc3(...e) {
    return (await $e7fb5080ac3edd96$var$t).default(...e);
}
const $e7fb5080ac3edd96$var$r = $e7fb5080ac3edd96$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$y;
}) : Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$b;
});
async function $e7fb5080ac3edd96$export$270aed3754275094(...e) {
    return (await $e7fb5080ac3edd96$var$r).default(...e);
}
const $e7fb5080ac3edd96$var$a = $e7fb5080ac3edd96$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$m;
}) : Promise.resolve().then(function() {
    return $e7fb5080ac3edd96$var$_;
});
async function $e7fb5080ac3edd96$export$cf414c79194c40b9(...e) {
    return (await $e7fb5080ac3edd96$var$a).default(...e);
}
const $e7fb5080ac3edd96$var$s = async (e)=>{
    const t = await e.getFile();
    return t.handle = e, t;
};
var $e7fb5080ac3edd96$export$73dd4a3df259d52 = async (e = [
    {}
])=>{
    Array.isArray(e) || (e = [
        e
    ]);
    const t = [];
    e.forEach((e, n)=>{
        t[n] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? e.mimeTypes.map((r)=>{
            t[n].accept[r] = e.extensions || [];
        }) : t[n].accept["*/*"] = e.extensions || [];
    });
    const n = await window.showOpenFilePicker({
        id: e[0].id,
        startIn: e[0].startIn,
        types: t,
        multiple: e[0].multiple || !1,
        excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
    }), r = await Promise.all(n.map($e7fb5080ac3edd96$var$s));
    return e[0].multiple ? r : r[0];
}, $e7fb5080ac3edd96$var$c = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$73dd4a3df259d52
};
function $e7fb5080ac3edd96$var$u(e) {
    function t(e) {
        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
        var t = e.done;
        return Promise.resolve(e.value).then(function(e) {
            return {
                value: e,
                done: t
            };
        });
    }
    return $e7fb5080ac3edd96$var$u = function(e) {
        this.s = e, this.n = e.next;
    }, $e7fb5080ac3edd96$var$u.prototype = {
        s: null,
        n: null,
        next: function() {
            return t(this.n.apply(this.s, arguments));
        },
        return: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.resolve({
                value: e,
                done: !0
            }) : t(n.apply(this.s, arguments));
        },
        throw: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
        }
    }, new $e7fb5080ac3edd96$var$u(e);
}
const $e7fb5080ac3edd96$var$p = async (e, t, n = e.name, r)=>{
    const i = [], a = [];
    var o, s = !1, l = !1;
    try {
        for(var c, d = function(e) {
            var t, n, r, i = 2;
            for("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;){
                if (n && null != (t = e[n])) return t.call(e);
                if (r && null != (t = e[r])) return new $e7fb5080ac3edd96$var$u(t.call(e));
                n = "@@asyncIterator", r = "@@iterator";
            }
            throw new TypeError("Object is not async iterable");
        }(e.values()); s = !(c = await d.next()).done; s = !1){
            const o = c.value, s = `${n}/${o.name}`;
            "file" === o.kind ? a.push(o.getFile().then((t)=>(t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                    configurable: !0,
                    enumerable: !0,
                    get: ()=>s
                })))) : "directory" !== o.kind || !t || r && r(o) || i.push($e7fb5080ac3edd96$var$p(o, t, s, r));
        }
    } catch (e) {
        l = !0, o = e;
    } finally{
        try {
            s && null != d.return && await d.return();
        } finally{
            if (l) throw o;
        }
    }
    return [
        ...(await Promise.all(i)).flat(),
        ...await Promise.all(a)
    ];
};
var $e7fb5080ac3edd96$export$aeb41617a6d6e89 = async (e = {})=>{
    e.recursive = e.recursive || !1, e.mode = e.mode || "read";
    const t = await window.showDirectoryPicker({
        id: e.id,
        startIn: e.startIn,
        mode: e.mode
    });
    return (await (await t.values()).next()).done ? [
        t
    ] : $e7fb5080ac3edd96$var$p(t, e.recursive, void 0, e.skipDirectory);
}, $e7fb5080ac3edd96$var$y = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$aeb41617a6d6e89
}, $e7fb5080ac3edd96$export$ff17ca902e7337af = async (e, t = [
    {}
], n = null, r = !1, i = null)=>{
    Array.isArray(t) || (t = [
        t
    ]), t[0].fileName = t[0].fileName || "Untitled";
    const a = [];
    let o = null;
    if (e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach((e, t)=>{
        a[t] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map((n)=>{
            a[t].accept[n] = e.extensions || [];
        })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
    }), n) try {
        await n.getFile();
    } catch (e) {
        if (n = null, r) throw e;
    }
    const s = n || await window.showSaveFilePicker({
        suggestedName: t[0].fileName,
        id: t[0].id,
        startIn: t[0].startIn,
        types: a,
        excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
    });
    !n && i && i(s);
    const l = await s.createWritable();
    if ("stream" in e) {
        const t = e.stream();
        return await t.pipeTo(l), s;
    }
    return "body" in e ? (await e.body.pipeTo(l), s) : (await l.write(await e), await l.close(), s);
}, $e7fb5080ac3edd96$var$m = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$ff17ca902e7337af
}, $e7fb5080ac3edd96$export$f1c676766788056a = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file";
        const i = [
            ...e.map((e)=>e.mimeTypes || []),
            ...e.map((e)=>e.extensions || [])
        ].join();
        r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove(), t(r.multiple ? Array.from(r.files) : r.files[0]);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $e7fb5080ac3edd96$var$h = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$f1c676766788056a
}, $e7fb5080ac3edd96$export$14ab45eaad58ab5 = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), e[0].recursive = e[0].recursive || !1, new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file", r.webkitdirectory = !0, r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove();
            let n = Array.from(r.files);
            e[0].recursive ? e[0].recursive && e[0].skipDirectory && (n = n.filter((t)=>t.webkitRelativePath.split("/").every((t)=>!e[0].skipDirectory({
                        name: t,
                        kind: "directory"
                    })))) : n = n.filter((e)=>2 === e.webkitRelativePath.split("/").length), t(n);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $e7fb5080ac3edd96$var$b = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$14ab45eaad58ab5
}, $e7fb5080ac3edd96$export$19f956f8dbe9df86 = async (e, t = {})=>{
    Array.isArray(t) && (t = t[0]);
    const n = document.createElement("a");
    let r = e;
    "body" in e && (r = await async function(e, t) {
        const n = e.getReader(), r = new ReadableStream({
            start: (e)=>(async function t() {
                    return n.read().then(({ done: n, value: r })=>{
                        if (!n) return e.enqueue(r), t();
                        e.close();
                    });
                })()
        }), i = new Response(r), a = await i.blob();
        return n.releaseLock(), new Blob([
            a
        ], {
            type: t
        });
    }(e.body, e.headers.get("content-type"))), n.download = t.fileName || "Untitled", n.href = URL.createObjectURL(await r);
    const i = ()=>{
        "function" == typeof a && a();
    }, a = t.legacySetup && t.legacySetup(i, ()=>a(), n);
    return n.addEventListener("click", ()=>{
        setTimeout(()=>URL.revokeObjectURL(n.href), 3e4), i();
    }), n.click(), null;
}, $e7fb5080ac3edd96$var$_ = {
    __proto__: null,
    default: $e7fb5080ac3edd96$export$19f956f8dbe9df86
};


function $5131dddb90b74959$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $5131dddb90b74959$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
var $5131dddb90b74959$var$$63d86f11b44ac799$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$63d86f11b44ac799$exports, "Status", function() {
    return $5131dddb90b74959$export$96e9906d6d93a972;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$63d86f11b44ac799$exports, "Theme", function() {
    return $5131dddb90b74959$export$14faa19a0f3bbeb2;
});
var $5131dddb90b74959$export$96e9906d6d93a972;
(function(Status) {
    Status["primary"] = "primary";
    Status["secondary"] = "secondary";
    Status["tertiary"] = "tertiary";
    Status["success"] = "success";
    Status["info"] = "info";
    Status["warning"] = "warning";
    Status["danger"] = "danger";
})($5131dddb90b74959$export$96e9906d6d93a972 || ($5131dddb90b74959$export$96e9906d6d93a972 = {}));
var $5131dddb90b74959$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})($5131dddb90b74959$export$14faa19a0f3bbeb2 || ($5131dddb90b74959$export$14faa19a0f3bbeb2 = {}));
var $5131dddb90b74959$var$$63c790b9c4a0fb72$exports = {};
var $5131dddb90b74959$var$$bc5b3c994c26f289$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$bc5b3c994c26f289$exports, "Ratio", function() {
    return $5131dddb90b74959$export$438ad6fc467f929b;
});
var $5131dddb90b74959$var$$bc5b3c994c26f289$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$438ad6fc467f929b = (_a)=>{
    var { className: className, style: style, aspectRatio: aspectRatio = '1x1', children: children } = _a, props = $5131dddb90b74959$var$$bc5b3c994c26f289$var$__rest(_a, [
        "className",
        "style",
        "aspectRatio",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('ratio', typeof aspectRatio === 'string' && `ratio-${aspectRatio}`, className),
        style: Object.assign(Object.assign({}, style), typeof aspectRatio === 'number' ? {
            '--bs-aspect-ratio': `${aspectRatio * 100}%`
        } : null)
    }, props, {
        children: children
    }));
};
var $5131dddb90b74959$var$$72880cb85e950d46$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$72880cb85e950d46$exports, "Container", function() {
    return $5131dddb90b74959$export$42a852a2b6b56249;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$72880cb85e950d46$exports, "Row", function() {
    return $5131dddb90b74959$export$b59bdbef9ce70de2;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$72880cb85e950d46$exports, "Col", function() {
    return $5131dddb90b74959$export$963a4b2511a4b70c;
});
var $5131dddb90b74959$var$$72880cb85e950d46$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$42a852a2b6b56249 = (_a)=>{
    var { className: className = '', fluid: fluid, children: children } = _a, props = $5131dddb90b74959$var$$72880cb85e950d46$var$__rest(_a, [
        "className",
        "fluid",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `container${fluid === true ? '-fluid' : fluid ? `-${fluid}` : ''} ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$b59bdbef9ce70de2 = (_a)=>{
    var { className: className, xs: xs, sm: sm, md: md, lg: lg, xl: xl, xxl: xxl, children: children } = _a, props = $5131dddb90b74959$var$$72880cb85e950d46$var$__rest(_a, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "xxl",
        "children"
    ]);
    const size = xs || sm || md || lg || xl || xxl;
    const columnClass = size ? `row-cols${xs ? '' : sm ? '-sm' : md ? '-md' : lg ? '-lg' : xl ? '-xl' : xxl && '-xxl'}-${size}` : '';
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('row', columnClass, className)
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$963a4b2511a4b70c = (_a)=>{
    var { className: className, xs: xs, sm: sm, md: md, lg: lg, xl: xl, xxl: xxl, children: children } = _a, props = $5131dddb90b74959$var$$72880cb85e950d46$var$__rest(_a, [
        "className",
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "xxl",
        "children"
    ]);
    const size = xs || sm || md || lg || xl || xxl;
    const columnClass = size ? `col${xs ? '' : sm ? '-sm' : md ? '-md' : lg ? '-lg' : xl ? '-xl' : xxl && '-xxl'}-${size}` : '';
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('col', columnClass, className)
    }, props, {
        children: children
    }));
};
var $5131dddb90b74959$var$$f09e7170f0f51b36$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f09e7170f0f51b36$exports, "ScrollBoundary", function() {
    return $5131dddb90b74959$export$d086fcc3bc3f366f;
});
function $5131dddb90b74959$var$$f09e7170f0f51b36$var$touch(edge, onTouch) {
    return (node)=>node && new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>isIntersecting && onTouch(edge)).observe(node);
}
const $5131dddb90b74959$export$d086fcc3bc3f366f = ({ className: className, onTouch: onTouch, top: top, left: left, right: right, bottom: bottom, children: children })=>(0, $bd1ed0d24b354858$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('position-relative', className),
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $5131dddb90b74959$var$$f09e7170f0f51b36$var$touch('top', onTouch),
                children: top
            }),
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $5131dddb90b74959$var$$f09e7170f0f51b36$var$touch('left', onTouch),
                children: left
            }),
            children,
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $5131dddb90b74959$var$$f09e7170f0f51b36$var$touch('right', onTouch),
                children: right
            }),
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $5131dddb90b74959$var$$f09e7170f0f51b36$var$touch('bottom', onTouch),
                children: bottom
            })
        ]
    });
var $5131dddb90b74959$var$$afd912368a35cd9a$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$afd912368a35cd9a$exports, "Collapse", function() {
    return $5131dddb90b74959$export$78768a9af065a7b;
});
var $5131dddb90b74959$var$$afd912368a35cd9a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$78768a9af065a7b = (_a)=>{
    var { className: className, dimension: dimension = 'width', in: show, children: children } = _a, props = $5131dddb90b74959$var$$afd912368a35cd9a$var$__rest(_a, [
        "className",
        "dimension",
        "in",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('collapse', {
            'collapse-horizontal': dimension === 'height',
            show: show
        }, className)
    }, props, {
        children: children
    }));
};
var $5131dddb90b74959$var$$f01a97a2de8a9291$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f01a97a2de8a9291$exports, "OffcanvasTitle", function() {
    return $5131dddb90b74959$export$1b33297d19c3da30;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f01a97a2de8a9291$exports, "OffcanvasHeader", function() {
    return $5131dddb90b74959$export$b6c1518fb8dc5e75;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f01a97a2de8a9291$exports, "OffcanvasBody", function() {
    return $5131dddb90b74959$export$c324d20ecc5b7dee;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f01a97a2de8a9291$exports, "Offcanvas", function() {
    return $5131dddb90b74959$export$591ca0244c9dfcd4;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f01a97a2de8a9291$exports, "OffcanvasBox", function() {
    return $5131dddb90b74959$export$1de07a2f4bdee270;
});
var $5131dddb90b74959$var$$c1c7ccde32bca97a$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c1c7ccde32bca97a$exports, "Button", function() {
    return $5131dddb90b74959$export$353f5b6fc5456de1;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c1c7ccde32bca97a$exports, "isButton", function() {
    return $5131dddb90b74959$export$35a0171ee384c875;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c1c7ccde32bca97a$exports, "IconButton", function() {
    return $5131dddb90b74959$export$c25acd513dcc8062;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c1c7ccde32bca97a$exports, "CloseButton", function() {
    return $5131dddb90b74959$export$de65de8213222d10;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c1c7ccde32bca97a$exports, "ToggleButton", function() {
    return $5131dddb90b74959$export$d2b052e7b4be1756;
});
var $5131dddb90b74959$var$$a68e72fb637d83af$exports = {};
var $5131dddb90b74959$var$$4927147f477cca2e$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$4927147f477cca2e$exports, "Badge", function() {
    return $5131dddb90b74959$export$37acb3580601e69a;
});
var $5131dddb90b74959$var$$4927147f477cca2e$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$37acb3580601e69a = (_a)=>{
    var { className: className, bg: bg, text: text, pill: pill, href: href, children: children } = _a, rest = $5131dddb90b74959$var$$4927147f477cca2e$var$__rest(_a, [
        "className",
        "bg",
        "text",
        "pill",
        "href",
        "children"
    ]);
    const Class = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('badge', bg && `text-bg-${bg}`, text && `text-${text}`, pill && `rounded-pill`, href && 'text-decoration-none', className);
    return href ? (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({}, rest, {
        className: Class,
        href: href,
        children: children
    })) : (0, $bd1ed0d24b354858$exports.jsx)("span", Object.assign({}, rest, {
        className: Class,
        children: children
    }));
};
var $5131dddb90b74959$var$$6ed7cbf81486b3b8$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$6ed7cbf81486b3b8$exports, "Icon", function() {
    return $5131dddb90b74959$export$f04a61298a47a40f;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$6ed7cbf81486b3b8$exports, "BGIcon", function() {
    return $5131dddb90b74959$export$af1945c3768d186c;
});
var $5131dddb90b74959$var$$6ed7cbf81486b3b8$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$f04a61298a47a40f = (_a)=>{
    var { className: className, style: style, color: color, name: name, size: size, children: children } = _a, rest = $5131dddb90b74959$var$$6ed7cbf81486b3b8$var$__rest(_a, [
        "className",
        "style",
        "color",
        "name",
        "size",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("i", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`bi-${name}`, color && `text-${color}`, className),
        style: Object.assign(Object.assign({}, style), {
            fontSize: size ? `${size}rem` : undefined
        })
    }, rest));
};
const $5131dddb90b74959$export$af1945c3768d186c = (_a)=>{
    var { className: className = '', type: type = 'square', color: color = 'primary', children: children } = _a, props = $5131dddb90b74959$var$$6ed7cbf81486b3b8$var$__rest(_a, [
        "className",
        "type",
        "color",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('d-inline-block', 'p-3', `bg-${color}`, `rounded${type === 'square' ? '' : '-circle'}`, className)
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$f04a61298a47a40f, Object.assign({
            color: color === 'light' ? 'dark' : 'light'
        }, props))
    }));
};
var $5131dddb90b74959$var$$4720465b54b9bde5$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$4720465b54b9bde5$exports, "FAIcon", function() {
    return $5131dddb90b74959$export$9151c10c0bcf31d3;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$4720465b54b9bde5$exports, "FABGIcon", function() {
    return $5131dddb90b74959$export$bc62d7a28670119b;
});
var $5131dddb90b74959$var$$4720465b54b9bde5$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$9151c10c0bcf31d3 = (_a)=>{
    var { group: group = 'solid', name: name, size: size, fixedWidth: fixedWidth, color: color, inverse: inverse, border: border, rotate: rotate, flip: flip, animation: animation, pull: pull, stack: stack, listItem: listItem, className: className, children: children } = _a, rest = $5131dddb90b74959$var$$4720465b54b9bde5$var$__rest(_a, [
        "group",
        "name",
        "size",
        "fixedWidth",
        "color",
        "inverse",
        "border",
        "rotate",
        "flip",
        "animation",
        "pull",
        "stack",
        "listItem",
        "className",
        "children"
    ]);
    const icon = (0, $bd1ed0d24b354858$exports.jsx)("span", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fa' + group[0], 'fa-' + name, size && 'fa-' + (typeof size === 'number' ? size + 'x' : size), fixedWidth && 'fa-fw', inverse && 'fa-inverse', border && 'fa-border', rotate && 'fa-rotate-' + rotate, flip && 'fa-flip-' + flip, animation && 'fa-' + animation, pull && 'fa-pull-' + pull, stack && `fa-stack-${stack}x`, color && 'text-' + color, className),
        "aria-hidden": "true"
    }, rest));
    return listItem ? (0, $bd1ed0d24b354858$exports.jsx)("span", {
        className: "fa-li",
        children: icon
    }) : icon;
};
const $5131dddb90b74959$export$bc62d7a28670119b = (_a)=>{
    var { size: size, color: color, className: className, type: type } = _a, rest = $5131dddb90b74959$var$$4720465b54b9bde5$var$__rest(_a, [
        "size",
        "color",
        "className",
        "type"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fa-stack', size && 'fa-' + (typeof size === 'number' ? size + 'x' : size), color && 'text-' + color, className),
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$9151c10c0bcf31d3, {
                name: type,
                stack: 2
            }),
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$9151c10c0bcf31d3, Object.assign({}, rest, {
                stack: 1,
                inverse: true
            }))
        ]
    });
};
var $5131dddb90b74959$var$$bdccd8f4843146f6$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$bdccd8f4843146f6$exports, "ProgressBar", function() {
    return $5131dddb90b74959$export$c17561cb55d4db30;
});
const $5131dddb90b74959$export$c17561cb55d4db30 = ({ className: className = '', striped: striped, animated: animated, variant: variant = 'primary', min: min = 0, max: max = 100, now: now = min, label: label, children: children })=>(0, $8uN2z.isEmpty)(children) ? (0, $bd1ed0d24b354858$exports.jsx)("div", {
        className: `progress ${className}`,
        role: "progressbar",
        ariaValueMin: min + '',
        ariaValueMax: max + '',
        ariaValueNow: now + '',
        children: (0, $bd1ed0d24b354858$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('progress-bar', `text-bg-${variant}`, striped && 'progress-bar-striped', animated && `progress-bar-animated`),
            style: {
                width: now + '%'
            },
            children: typeof label === 'function' ? label(now) : label && `${now}%`
        })
    }) : (0, $bd1ed0d24b354858$exports.jsx)("div", {
        className: `progress-stacked ${className}`,
        children: children
    });
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a68e72fb637d83af$exports, $5131dddb90b74959$var$$4927147f477cca2e$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a68e72fb637d83af$exports, $5131dddb90b74959$var$$6ed7cbf81486b3b8$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a68e72fb637d83af$exports, $5131dddb90b74959$var$$4720465b54b9bde5$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a68e72fb637d83af$exports, $5131dddb90b74959$var$$bdccd8f4843146f6$exports);
var $5131dddb90b74959$var$$c1c7ccde32bca97a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$353f5b6fc5456de1 = (_a)=>{
    var { className: className, href: href, variant: variant, size: size, active: active, children: children } = _a, props = $5131dddb90b74959$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "href",
        "variant",
        "size",
        "active",
        "children"
    ]);
    const { disabled: disabled, tabIndex: tabIndex } = props, Class = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('btn', variant && `btn-${variant}`, size && `btn-${size}`, className);
    return href ? (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        role: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(Class, {
            disabled: disabled,
            active: active
        }),
        tabIndex: disabled ? -1 : tabIndex,
        ariaDisabled: disabled === null || disabled === void 0 ? void 0 : disabled.toString(),
        ariaPressed: active === null || active === void 0 ? void 0 : active.toString(),
        href: href
    }, props, {
        children: children
    })) : (0, $bd1ed0d24b354858$exports.jsx)("button", Object.assign({
        className: Class
    }, props, {
        ariaPressed: active === null || active === void 0 ? void 0 : active.toString(),
        children: children
    }));
};
function $5131dddb90b74959$export$35a0171ee384c875(node) {
    var _a;
    const { selector: selector, props: props } = node;
    return /^(a|input|button)/.test(selector) && ((_a = props === null || props === void 0 ? void 0 : props.className) === null || _a === void 0 ? void 0 : _a.btn);
}
const $5131dddb90b74959$export$c25acd513dcc8062 = (_a)=>{
    var { className: className, name: name, color: color, size: size } = _a, button = $5131dddb90b74959$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "name",
        "color",
        "size"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$353f5b6fc5456de1, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('p-1', className),
        style: {
            lineHeight: '0.8'
        }
    }, button, {
        children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$f04a61298a47a40f, {
            name: name,
            color: color,
            size: size
        })
    }));
};
const $5131dddb90b74959$export$de65de8213222d10 = (_a)=>{
    var { className: className = '' } = _a, props = $5131dddb90b74959$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("button", Object.assign({
        className: `btn-close ${className}`,
        type: "button",
        ariaLabel: "Close"
    }, props));
};
const $5131dddb90b74959$export$d2b052e7b4be1756 = (_a)=>{
    var { className: className = '', id: id = (0, $8uN2z.uniqueID)(), variant: variant = 'primary', children: children } = _a, props = $5131dddb90b74959$var$$c1c7ccde32bca97a$var$__rest(_a, [
        "className",
        "id",
        "variant",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("input", Object.assign({
                className: "btn-check",
                id: id,
                autocomplete: "off"
            }, props)),
            (0, $bd1ed0d24b354858$exports.jsx)("label", {
                className: `btn btn-${variant} ${className}`,
                htmlFor: id,
                children: children
            })
        ]
    });
};
var $5131dddb90b74959$var$$f01a97a2de8a9291$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$1b33297d19c3da30 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("h5", Object.assign({
        className: `offcanvas-title ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$b6c1518fb8dc5e75 = (_a)=>{
    var { className: className = '', closeButton: closeButton, children: children, onHide: onHide } = _a, props = $5131dddb90b74959$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "closeButton",
        "children",
        "onHide"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("div", Object.assign({
        className: `offcanvas-header ${className}`
    }, props, {
        children: [
            children,
            closeButton && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$de65de8213222d10, {
                onClick: onHide
            })
        ]
    }));
};
const $5131dddb90b74959$export$c324d20ecc5b7dee = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `offcanvas-body ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$591ca0244c9dfcd4 = (_a)=>{
    var { className: className = '', style: style, backdrop: backdrop = true, show: show, onHide: onHide, children: children } = _a, props = $5131dddb90b74959$var$$f01a97a2de8a9291$var$__rest(_a, [
        "className",
        "style",
        "backdrop",
        "show",
        "onHide",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('offcanvas', show ? 'offcanvas-end show' : 'offcanvas-start', className),
                style: Object.assign({
                    maxWidth: '75vw'
                }, style),
                tabIndex: -1
            }, backdrop === 'static' ? {
                'data-bs-backdrop': 'static'
            } : {}, props, {
                children: children
            })),
            show && (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "offcanvas-backdrop show",
                onClick: onHide
            })
        ]
    });
};
const $5131dddb90b74959$export$1de07a2f4bdee270 = (_a)=>{
    var { title: title, titleId: titleId = (0, $8uN2z.uniqueID)(), closeButton: closeButton, onHide: onHide, children: children } = _a, props = $5131dddb90b74959$var$$f01a97a2de8a9291$var$__rest(_a, [
        "title",
        "titleId",
        "closeButton",
        "onHide",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$591ca0244c9dfcd4, Object.assign({}, props, {
        onHide: onHide,
        "aria-labelledby": titleId,
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$b6c1518fb8dc5e75, {
                closeButton: closeButton,
                onHide: onHide,
                children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$1b33297d19c3da30, {
                    id: titleId,
                    children: title
                })
            }),
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c324d20ecc5b7dee, {
                children: children
            })
        ]
    }));
};
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$63c790b9c4a0fb72$exports, $5131dddb90b74959$var$$bc5b3c994c26f289$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$63c790b9c4a0fb72$exports, $5131dddb90b74959$var$$72880cb85e950d46$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$63c790b9c4a0fb72$exports, $5131dddb90b74959$var$$f09e7170f0f51b36$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$63c790b9c4a0fb72$exports, $5131dddb90b74959$var$$afd912368a35cd9a$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$63c790b9c4a0fb72$exports, $5131dddb90b74959$var$$f01a97a2de8a9291$exports);
var $5131dddb90b74959$var$$a9c2f09022d17944$exports = {};
var $5131dddb90b74959$var$$fe8695acb491e148$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$fe8695acb491e148$exports, "SplitView", function() {
    return $5131dddb90b74959$export$819f802cf9aa78b;
});
var $5131dddb90b74959$var$$fe8695acb491e148$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$fe8695acb491e148$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$fe8695acb491e148$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5131dddb90b74959$var$$fe8695acb491e148$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$fe8695acb491e148$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
let $5131dddb90b74959$export$819f802cf9aa78b = (()=>{
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'split-view',
            mode: 'open'
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var SplitView = _classThis = class extends _classSuper {
        connectedCallback() {
            this.classList.add('d-flex', 'w-100');
        }
        toggleDrag({ type: type, target: target, pointerId: pointerId }) {
            if (type !== 'pointerup') target.setPointerCapture(pointerId);
            else target.releasePointerCapture(pointerId);
        }
        watchLine(element) {
            return $5131dddb90b74959$var$$fe8695acb491e148$var$__awaiter(this, void 0, void 0, function*() {
                var _a, e_1, _b, _c;
                const moving = (0, $c379f9436bbe0249$export$77cea355fa80b5f4).fromEvent(element, 'pointermove'), left = element.previousElementSibling;
                const { style: style } = left, { x: x } = left.getBoundingClientRect();
                try {
                    for(var _d = true, moving_1 = $5131dddb90b74959$var$$fe8695acb491e148$var$__asyncValues(moving), moving_1_1; moving_1_1 = yield moving_1.next(), _a = moving_1_1.done, !_a; _d = true){
                        _c = moving_1_1.value;
                        _d = false;
                        const { pointerId: pointerId, clientX: clientX } = _c;
                        if (element.hasPointerCapture(pointerId)) style.width = clientX - x + 'px';
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = moving_1.return)) yield _b.call(moving_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        style: {
                            width: '25%'
                        },
                        children: (0, $bd1ed0d24b354858$exports.jsx)("slot", {
                            name: "left"
                        })
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "border border-secondary m-1",
                        style: {
                            cursor: 'col-resize'
                        },
                        onPointerDown: this.toggleDrag,
                        onPointerUp: this.toggleDrag,
                        ref: this.watchLine
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "flex-fill",
                        children: (0, $bd1ed0d24b354858$exports.jsx)("slot", {
                            name: "right"
                        })
                    })
                ]
            });
        }
    };
    $5131dddb90b74959$var$$fe8695acb491e148$var$__setFunctionName(_classThis, "SplitView");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $5131dddb90b74959$var$$fe8695acb491e148$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        SplitView = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$fe8695acb491e148$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return SplitView = _classThis;
})();
var $5131dddb90b74959$var$$f7c1ec19aba15bac$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f7c1ec19aba15bac$exports, "ListGroup", function() {
    return $5131dddb90b74959$export$9cc9809463a041c4;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f7c1ec19aba15bac$exports, "ListGroupItem", function() {
    return $5131dddb90b74959$export$3175656842a28549;
});
var $5131dddb90b74959$var$$f7c1ec19aba15bac$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$9cc9809463a041c4 = (_a)=>{
    var { className: className = '', variant: variant, numbered: numbered, horizontal: horizontal, children: children } = _a, props = $5131dddb90b74959$var$$f7c1ec19aba15bac$var$__rest(_a, [
        "className",
        "variant",
        "numbered",
        "horizontal",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('list-group', variant && `list-group-${variant}`, numbered && `list-group-numbered`, horizontal && `list-group-horizontal${horizontal === true ? '' : `-${horizontal}`}`, className)
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$3175656842a28549 = (_a)=>{
    var { className: className = '', variant: variant, href: href, active: active, disabled: disabled, children: children } = _a, props = $5131dddb90b74959$var$$f7c1ec19aba15bac$var$__rest(_a, [
        "className",
        "variant",
        "href",
        "active",
        "disabled",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('list-group-item', variant && `list-group-item-${variant}`, href && 'list-group-item-action', {
            active: active,
            disabled: disabled
        }, disabled && 'pe-none', className),
        ariaCurrent: active ? 'true' : undefined,
        ariaDisabled: disabled ? 'true' : undefined,
        href: href
    }, props, {
        children: children
    }));
};
var $5131dddb90b74959$var$$fae440e6475ac9b3$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$fae440e6475ac9b3$exports, "Table", function() {
    return $5131dddb90b74959$export$54ec01a60f47d33d;
});
var $5131dddb90b74959$var$$fae440e6475ac9b3$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$54ec01a60f47d33d = (_a)=>{
    var { className: className, variant: variant, size: size, responsive: responsive, striped: striped, hover: hover, bordered: bordered, borderless: borderless, caption: caption, children: children } = _a, props = $5131dddb90b74959$var$$fae440e6475ac9b3$var$__rest(_a, [
        "className",
        "variant",
        "size",
        "responsive",
        "striped",
        "hover",
        "bordered",
        "borderless",
        "caption",
        "children"
    ]);
    const table = (0, $bd1ed0d24b354858$exports.jsx)("table", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('table', variant && `table-${variant}`, size && `table-${size}`, striped && `table-striped${striped === 'columns' ? '-columns' : ''}`, hover && 'table-hover', bordered && 'table-bordered', borderless && 'table-borderless', caption && `caption-${caption}`)
    }, props, {
        children: children
    }));
    return responsive ? (0, $bd1ed0d24b354858$exports.jsx)("div", {
        className: `table-responsive${responsive === true ? '' : `-${responsive}`}`,
        children: table
    }) : table;
};
var $5131dddb90b74959$var$$748e31f0f7788c85$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$748e31f0f7788c85$exports, "Jumbotron", function() {
    return $5131dddb90b74959$export$97aba50a380f875b;
});
var $5131dddb90b74959$var$$748e31f0f7788c85$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$97aba50a380f875b = (_a)=>{
    var { fluid: fluid, className: className = `py-5 ${fluid ? '' : 'px-5'}`, bg: bg = 'body-tertiary', rounded: rounded = fluid ? 0 : 3, title: title, description: description, children: children } = _a, props = $5131dddb90b74959$var$$748e31f0f7788c85$var$__rest(_a, [
        "fluid",
        "className",
        "bg",
        "rounded",
        "title",
        "description",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("header", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(bg && `bg-${bg}`, rounded && `rounded-${rounded}`, className)
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$42a852a2b6b56249, {
            fluid: fluid,
            children: [
                (0, $bd1ed0d24b354858$exports.jsx)("h1", {
                    className: "display-4",
                    children: title
                }),
                (0, $bd1ed0d24b354858$exports.jsx)("p", {
                    className: "lead",
                    children: description
                }),
                children && (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                    children: [
                        (0, $bd1ed0d24b354858$exports.jsx)("hr", {
                            className: "my-4"
                        }),
                        children
                    ]
                })
            ]
        })
    }));
};
var $5131dddb90b74959$var$$478aa14554285d4f$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$478aa14554285d4f$exports, "Card", function() {
    return $5131dddb90b74959$export$60332b2344f7fe41;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$478aa14554285d4f$exports, "CardBody", function() {
    return $5131dddb90b74959$export$851de33184ecdac4;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$478aa14554285d4f$exports, "CardHeader", function() {
    return $5131dddb90b74959$export$5665775b26e26c5d;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$478aa14554285d4f$exports, "CardFooter", function() {
    return $5131dddb90b74959$export$e9897d434e0741ee;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$478aa14554285d4f$exports, "CardTitle", function() {
    return $5131dddb90b74959$export$474db65c3c394e1c;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$478aa14554285d4f$exports, "CardImg", function() {
    return $5131dddb90b74959$export$96c5f37208f78bd7;
});
var $5131dddb90b74959$var$$6e5adc7420b5d0fd$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$6e5adc7420b5d0fd$exports, "Image", function() {
    return $5131dddb90b74959$export$3e431a229df88919;
});
var $5131dddb90b74959$var$$6e5adc7420b5d0fd$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$3e431a229df88919 = (_a)=>{
    var { className: className, fluid: fluid, rounded: rounded, roundedCircle: roundedCircle, thumbnail: thumbnail } = _a, props = $5131dddb90b74959$var$$6e5adc7420b5d0fd$var$__rest(_a, [
        "className",
        "fluid",
        "rounded",
        "roundedCircle",
        "thumbnail"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("img", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(fluid && 'img-fluid', thumbnail && `img-thumbnail`, {
            rounded: rounded
        }, roundedCircle && 'rounded-circle', className)
    }, props));
};
var $5131dddb90b74959$var$$478aa14554285d4f$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$60332b2344f7fe41 = (_a)=>{
    var { className: className, bg: bg, text: text, border: border, body: body, children: children } = _a, props = $5131dddb90b74959$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('card', bg && `text-bg-${bg}`, text && `text-${text}`, border && `border-${border}`, className)
    }, props, {
        children: body ? (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$851de33184ecdac4, {
            children: children
        }) : children
    }));
};
const $5131dddb90b74959$export$5665775b26e26c5d = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `card-header ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$851de33184ecdac4 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `card-body ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$e9897d434e0741ee = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `card-footer ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$474db65c3c394e1c = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("h5", Object.assign({
        className: `card-title ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$96c5f37208f78bd7 = (_a)=>{
    var { className: className = '', variant: variant } = _a, props = $5131dddb90b74959$var$$478aa14554285d4f$var$__rest(_a, [
        "className",
        "variant"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$3e431a229df88919, Object.assign({
        className: `card-img${variant ? `-${variant}` : ''} ${className}`
    }, props));
};
var $5131dddb90b74959$var$$165c2960ea0ef6da$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$165c2960ea0ef6da$exports, "MediaObject", function() {
    return $5131dddb90b74959$export$c5be64db09f93414;
});
var $5131dddb90b74959$var$$165c2960ea0ef6da$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$c5be64db09f93414 = (_a)=>{
    var { className: className, listItem: listItem, title: title, image: image, imageRow: imageRow = 'start', imageColumn: imageColumn = 'start', children: children } = _a, rest = $5131dddb90b74959$var$$165c2960ea0ef6da$var$__rest(_a, [
        "className",
        "listItem",
        "title",
        "image",
        "imageRow",
        "imageColumn",
        "children"
    ]);
    const start = imageColumn === 'start';
    const Tag = listItem ? 'li' : 'div', Class = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('d-flex', !start && 'flex-row-reverse', className);
    const body = (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "flex-shrink-0",
                children: typeof image === 'string' ? (0, $bd1ed0d24b354858$exports.jsx)("img", {
                    className: `align-self-${imageRow}`,
                    style: {
                        width: '4rem'
                    },
                    src: image,
                    alt: title
                }) : image
            }),
            (0, $bd1ed0d24b354858$exports.jsxs)("div", {
                className: `flex-grow-1 ${start ? 'ms-3' : 'me-3'}`,
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("h5", {
                        className: "mt-0",
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
    return (0, $bd1ed0d24b354858$exports.jsx)(Tag, Object.assign({}, rest, {
        className: Class,
        children: body
    }));
};
var $5131dddb90b74959$var$$c630f4f8ebbb88df$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c630f4f8ebbb88df$exports, "AccordionItem", function() {
    return $5131dddb90b74959$export$d99097c13d4dac9f;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c630f4f8ebbb88df$exports, "AccordionHeader", function() {
    return $5131dddb90b74959$export$5e3e5deaaf81ee41;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c630f4f8ebbb88df$exports, "AccordionBody", function() {
    return $5131dddb90b74959$export$4f68206c92b94e7b;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c630f4f8ebbb88df$exports, "Accordion", function() {
    return $5131dddb90b74959$export$a766cd26d0d69044;
});
var $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$d99097c13d4dac9f = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `accordion-item ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$5e3e5deaaf81ee41 = (_a)=>{
    var { className: className = '', children: children, onClick: onClick } = _a, props = $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children",
        "onClick"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("h2", Object.assign({
        className: `accordion-header ${className}`
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("button", {
            className: "accordion-button",
            type: "button",
            onClick: onClick,
            children: children
        })
    }));
};
const $5131dddb90b74959$export$4f68206c92b94e7b = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$78768a9af065a7b, Object.assign({
        className: `accordion-collapse ${className}`
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("div", {
            className: "accordion-body",
            children: children
        })
    }));
};
let $5131dddb90b74959$export$a766cd26d0d69044 = (()=>{
    var _Accordion_flush_accessor_storage, _Accordion_alwaysOpen_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'accordion-box',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _flush_decorators;
    let _flush_initializers = [];
    let _flush_extraInitializers = [];
    let _alwaysOpen_decorators;
    let _alwaysOpen_initializers = [];
    let _alwaysOpen_extraInitializers = [];
    let _handleFlush_decorators;
    let _handleClick_decorators;
    var Accordion = _classThis = class extends _classSuper {
        get flush() {
            return $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet(this, _Accordion_flush_accessor_storage, "f");
        }
        set flush(value) {
            $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet(this, _Accordion_flush_accessor_storage, value, "f");
        }
        get alwaysOpen() {
            return $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__classPrivateFieldGet(this, _Accordion_alwaysOpen_accessor_storage, "f");
        }
        set alwaysOpen(value) {
            $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__classPrivateFieldSet(this, _Accordion_alwaysOpen_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.classList.add('accordion');
        }
        handleFlush(flush) {
            this.classList.toggle('accordion-flush', flush);
        }
        handleClick(_, { nextElementSibling: currentCollapse }) {
            if (!this.alwaysOpen) {
                for (const collapse of this.querySelectorAll('.accordion-collapse'))if (collapse !== currentCollapse) {
                    collapse.classList.remove('show');
                    collapse.previousElementSibling.querySelector('button').ariaExpanded = 'false';
                }
            }
            currentCollapse.classList.toggle('show');
            currentCollapse.previousElementSibling.querySelector('button').ariaExpanded = 'false';
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsx)("slot", {});
        }
        constructor(){
            super(...arguments);
            _Accordion_flush_accessor_storage.set(this, ($5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers(this, _flush_initializers, false)));
            _Accordion_alwaysOpen_accessor_storage.set(this, ($5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers(this, _flush_extraInitializers), $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers(this, _alwaysOpen_initializers, false)));
            $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers(this, _alwaysOpen_extraInitializers);
        }
    };
    _Accordion_flush_accessor_storage = new WeakMap();
    _Accordion_alwaysOpen_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__setFunctionName(_classThis, "Accordion");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _flush_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _alwaysOpen_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _handleFlush_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ flush: flush })=>flush)
        ];
        _handleClick_decorators = [
            (0, $6f83f77ba8e7af5c$export$af631764ddc44097)('click', '.accordion-header')
        ];
        $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _flush_decorators, {
            kind: "accessor",
            name: "flush",
            static: false,
            private: false,
            access: {
                has: (obj)=>"flush" in obj,
                get: (obj)=>obj.flush,
                set: (obj, value)=>{
                    obj.flush = value;
                }
            },
            metadata: _metadata
        }, _flush_initializers, _flush_extraInitializers);
        $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _alwaysOpen_decorators, {
            kind: "accessor",
            name: "alwaysOpen",
            static: false,
            private: false,
            access: {
                has: (obj)=>"alwaysOpen" in obj,
                get: (obj)=>obj.alwaysOpen,
                set: (obj, value)=>{
                    obj.alwaysOpen = value;
                }
            },
            metadata: _metadata
        }, _alwaysOpen_initializers, _alwaysOpen_extraInitializers);
        $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _handleFlush_decorators, {
            kind: "method",
            name: "handleFlush",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleFlush" in obj,
                get: (obj)=>obj.handleFlush
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__esDecorate(_classThis, null, _handleClick_decorators, {
            kind: "method",
            name: "handleClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleClick" in obj,
                get: (obj)=>obj.handleClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Accordion = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$c630f4f8ebbb88df$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Accordion = _classThis;
})();
var $5131dddb90b74959$var$$d3445d44d351b213$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$d3445d44d351b213$exports, "Tab", function() {
    return $5131dddb90b74959$export$3e41faf802a29e71;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$d3445d44d351b213$exports, "Tabs", function() {
    return $5131dddb90b74959$export$b2539bed5023c21c;
});
var $5131dddb90b74959$var$$ac181fb217a2566a$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ac181fb217a2566a$exports, "NavLink", function() {
    return $5131dddb90b74959$export$b0d92dbee9b5b60d;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ac181fb217a2566a$exports, "NavDropdown", function() {
    return $5131dddb90b74959$export$461cb598b7fcff7b;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ac181fb217a2566a$exports, "Nav", function() {
    return $5131dddb90b74959$export$39140c7d8b0ba7b3;
});
var $5131dddb90b74959$var$$ecf67e051fd0aa49$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ecf67e051fd0aa49$exports, "Dropdown", function() {
    return $5131dddb90b74959$export$931cbfb6bfb85fc;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ecf67e051fd0aa49$exports, "DropdownToggle", function() {
    return $5131dddb90b74959$export$8d5b7ffbb681f107;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ecf67e051fd0aa49$exports, "DropdownMenu", function() {
    return $5131dddb90b74959$export$e44a253a59704894;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ecf67e051fd0aa49$exports, "DropdownItem", function() {
    return $5131dddb90b74959$export$6648d5fa18559e7f;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ecf67e051fd0aa49$exports, "DropdownButton", function() {
    return $5131dddb90b74959$export$181f40ec41159e56;
});
var $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$931cbfb6bfb85fc = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `dropdown ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$8d5b7ffbb681f107 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$353f5b6fc5456de1, Object.assign({}, props, {
        className: `dropdown-toggle ${className}`,
        type: "button",
        children: children
    }));
};
const $5131dddb90b74959$export$e44a253a59704894 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("nav", Object.assign({
        className: `dropdown-menu ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$6648d5fa18559e7f = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        className: `dropdown-item ${className}`
    }, props, {
        children: children
    }));
};
let $5131dddb90b74959$export$181f40ec41159e56 = (()=>{
    var _DropdownButton_boxClass_accessor_storage, _DropdownButton_buttonClass_accessor_storage, _DropdownButton_variant_accessor_storage, _DropdownButton_size_accessor_storage, _DropdownButton_caption_accessor_storage, _DropdownButton_disabled_accessor_storage, _DropdownButton_show_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'dropdown-button',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _boxClass_decorators;
    let _boxClass_initializers = [];
    let _boxClass_extraInitializers = [];
    let _buttonClass_decorators;
    let _buttonClass_initializers = [];
    let _buttonClass_extraInitializers = [];
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    let _caption_decorators;
    let _caption_initializers = [];
    let _caption_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _show_decorators;
    let _show_initializers = [];
    let _show_extraInitializers = [];
    var DropdownButton = _classThis = class extends _classSuper {
        get boxClass() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_boxClass_accessor_storage, "f");
        }
        set boxClass(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_boxClass_accessor_storage, value, "f");
        }
        get buttonClass() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_buttonClass_accessor_storage, "f");
        }
        set buttonClass(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_buttonClass_accessor_storage, value, "f");
        }
        get variant() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_variant_accessor_storage, "f");
        }
        set variant(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_variant_accessor_storage, value, "f");
        }
        get size() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_size_accessor_storage, "f");
        }
        set size(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_size_accessor_storage, value, "f");
        }
        get caption() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_caption_accessor_storage, "f");
        }
        set caption(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_caption_accessor_storage, value, "f");
        }
        get disabled() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_disabled_accessor_storage, "f");
        }
        set disabled(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_disabled_accessor_storage, value, "f");
        }
        get show() {
            return $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldGet(this, _DropdownButton_show_accessor_storage, "f");
        }
        set show(value) {
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__classPrivateFieldSet(this, _DropdownButton_show_accessor_storage, value, "f");
        }
        renderContent() {
            const { boxClass: boxClass, buttonClass: buttonClass, variant: variant, size: size, caption: caption } = this, { disabled: disabled, show: show } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$931cbfb6bfb85fc, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(boxClass, {
                    show: show
                }),
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$8d5b7ffbb681f107, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(buttonClass, {
                            show: show
                        }),
                        variant: variant,
                        size: size,
                        disabled: disabled,
                        onClick: ()=>this.show = !show,
                        children: caption
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$e44a253a59704894, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
                            show: show
                        }),
                        children: (0, $bd1ed0d24b354858$exports.jsx)("slot", {})
                    })
                ]
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("style", {
                        children: `:host {
                        display: inline-block;
                    }`
                    }),
                    this.renderContent()
                ]
            });
        }
        constructor(){
            super(...arguments);
            _DropdownButton_boxClass_accessor_storage.set(this, $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _boxClass_initializers, void 0));
            _DropdownButton_buttonClass_accessor_storage.set(this, ($5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _boxClass_extraInitializers), $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _buttonClass_initializers, void 0)));
            _DropdownButton_variant_accessor_storage.set(this, ($5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _buttonClass_extraInitializers), $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _variant_initializers, void 0)));
            _DropdownButton_size_accessor_storage.set(this, ($5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _variant_extraInitializers), $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _size_initializers, void 0)));
            _DropdownButton_caption_accessor_storage.set(this, ($5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _size_extraInitializers), $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _caption_initializers, void 0)));
            _DropdownButton_disabled_accessor_storage.set(this, ($5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _caption_extraInitializers), $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _disabled_initializers, false)));
            _DropdownButton_show_accessor_storage.set(this, ($5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _disabled_extraInitializers), $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _show_initializers, false)));
            $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(this, _show_extraInitializers);
        }
    };
    _DropdownButton_boxClass_accessor_storage = new WeakMap();
    _DropdownButton_buttonClass_accessor_storage = new WeakMap();
    _DropdownButton_variant_accessor_storage = new WeakMap();
    _DropdownButton_size_accessor_storage = new WeakMap();
    _DropdownButton_caption_accessor_storage = new WeakMap();
    _DropdownButton_disabled_accessor_storage = new WeakMap();
    _DropdownButton_show_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__setFunctionName(_classThis, "DropdownButton");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _boxClass_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _buttonClass_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _variant_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _size_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _caption_decorators = [
            (0, $d5I5D.observable)
        ];
        _disabled_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _show_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _boxClass_decorators, {
            kind: "accessor",
            name: "boxClass",
            static: false,
            private: false,
            access: {
                has: (obj)=>"boxClass" in obj,
                get: (obj)=>obj.boxClass,
                set: (obj, value)=>{
                    obj.boxClass = value;
                }
            },
            metadata: _metadata
        }, _boxClass_initializers, _boxClass_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _buttonClass_decorators, {
            kind: "accessor",
            name: "buttonClass",
            static: false,
            private: false,
            access: {
                has: (obj)=>"buttonClass" in obj,
                get: (obj)=>obj.buttonClass,
                set: (obj, value)=>{
                    obj.buttonClass = value;
                }
            },
            metadata: _metadata
        }, _buttonClass_initializers, _buttonClass_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _size_decorators, {
            kind: "accessor",
            name: "size",
            static: false,
            private: false,
            access: {
                has: (obj)=>"size" in obj,
                get: (obj)=>obj.size,
                set: (obj, value)=>{
                    obj.size = value;
                }
            },
            metadata: _metadata
        }, _size_initializers, _size_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _caption_decorators, {
            kind: "accessor",
            name: "caption",
            static: false,
            private: false,
            access: {
                has: (obj)=>"caption" in obj,
                get: (obj)=>obj.caption,
                set: (obj, value)=>{
                    obj.caption = value;
                }
            },
            metadata: _metadata
        }, _caption_initializers, _caption_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _disabled_decorators, {
            kind: "accessor",
            name: "disabled",
            static: false,
            private: false,
            access: {
                has: (obj)=>"disabled" in obj,
                get: (obj)=>obj.disabled,
                set: (obj, value)=>{
                    obj.disabled = value;
                }
            },
            metadata: _metadata
        }, _disabled_initializers, _disabled_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(_classThis, null, _show_decorators, {
            kind: "accessor",
            name: "show",
            static: false,
            private: false,
            access: {
                has: (obj)=>"show" in obj,
                get: (obj)=>obj.show,
                set: (obj, value)=>{
                    obj.show = value;
                }
            },
            metadata: _metadata
        }, _show_initializers, _show_extraInitializers);
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        DropdownButton = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$ecf67e051fd0aa49$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return DropdownButton = _classThis;
})();
var $5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$ac181fb217a2566a$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$ac181fb217a2566a$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$ac181fb217a2566a$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$b0d92dbee9b5b60d = (_a)=>{
    var { className: className = '', active: active, children: children } = _a, props = $5131dddb90b74959$var$$ac181fb217a2566a$var$__rest(_a, [
        "className",
        "active",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        className: `nav-link ${active ? 'active' : ''} ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$461cb598b7fcff7b = (_a)=>{
    var { title: title, children: children } = _a, props = $5131dddb90b74959$var$$ac181fb217a2566a$var$__rest(_a, [
        "title",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$181f40ec41159e56, Object.assign({
        boxClass: "nav-item",
        buttonClass: "nav-link",
        caption: title
    }, props, {
        children: children
    }));
};
let $5131dddb90b74959$export$39140c7d8b0ba7b3 = (()=>{
    var _Nav_variant_accessor_storage, _Nav_fill_accessor_storage, _Nav_justify_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'bs-nav',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _fill_decorators;
    let _fill_initializers = [];
    let _fill_extraInitializers = [];
    let _justify_decorators;
    let _justify_initializers = [];
    let _justify_extraInitializers = [];
    let _updateClass_decorators;
    var Nav = _classThis = class extends _classSuper {
        get variant() {
            return $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldGet(this, _Nav_variant_accessor_storage, "f");
        }
        set variant(value) {
            $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldSet(this, _Nav_variant_accessor_storage, value, "f");
        }
        get fill() {
            return $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldGet(this, _Nav_fill_accessor_storage, "f");
        }
        set fill(value) {
            $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldSet(this, _Nav_fill_accessor_storage, value, "f");
        }
        get justify() {
            return $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldGet(this, _Nav_justify_accessor_storage, "f");
        }
        set justify(value) {
            $5131dddb90b74959$var$$ac181fb217a2566a$var$__classPrivateFieldSet(this, _Nav_justify_accessor_storage, value, "f");
        }
        updateClass({ variant: variant, fill: fill, justify: justify } = this) {
            this.className = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('nav', this.className, {
                [`nav-${variant}`]: variant,
                'nav-fill': fill,
                [`nav-justified`]: justify
            });
        }
        connectedCallback() {
            var _a;
            this.updateClass();
            this.role = 'tablist';
            const navBar = this.closest('offcanvas-navbar, .navbar');
            if (!navBar) return;
            const expand = navBar.expand || ((_a = navBar.className.match(/navbar-expand(-(\S+))?/)) === null || _a === void 0 ? void 0 : _a[2]);
            this.classList.add('navbar-nav', 'align-items-center', expand && 'flex-column', expand && `flex-${expand}-row`);
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsx)("slot", {});
        }
        constructor(){
            super(...arguments);
            _Nav_variant_accessor_storage.set(this, ($5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _variant_initializers, void 0)));
            _Nav_fill_accessor_storage.set(this, ($5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _variant_extraInitializers), $5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _fill_initializers, false)));
            _Nav_justify_accessor_storage.set(this, ($5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _fill_extraInitializers), $5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _justify_initializers, false)));
            $5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(this, _justify_extraInitializers);
        }
    };
    _Nav_variant_accessor_storage = new WeakMap();
    _Nav_fill_accessor_storage = new WeakMap();
    _Nav_justify_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$ac181fb217a2566a$var$__setFunctionName(_classThis, "Nav");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _fill_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _justify_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _updateClass_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ variant: variant, fill: fill, justify: justify })=>({
                    variant: variant,
                    fill: fill,
                    justify: justify
                }))
        ];
        $5131dddb90b74959$var$$ac181fb217a2566a$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $5131dddb90b74959$var$$ac181fb217a2566a$var$__esDecorate(_classThis, null, _fill_decorators, {
            kind: "accessor",
            name: "fill",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fill" in obj,
                get: (obj)=>obj.fill,
                set: (obj, value)=>{
                    obj.fill = value;
                }
            },
            metadata: _metadata
        }, _fill_initializers, _fill_extraInitializers);
        $5131dddb90b74959$var$$ac181fb217a2566a$var$__esDecorate(_classThis, null, _justify_decorators, {
            kind: "accessor",
            name: "justify",
            static: false,
            private: false,
            access: {
                has: (obj)=>"justify" in obj,
                get: (obj)=>obj.justify,
                set: (obj, value)=>{
                    obj.justify = value;
                }
            },
            metadata: _metadata
        }, _justify_initializers, _justify_extraInitializers);
        $5131dddb90b74959$var$$ac181fb217a2566a$var$__esDecorate(_classThis, null, _updateClass_decorators, {
            kind: "method",
            name: "updateClass",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateClass" in obj,
                get: (obj)=>obj.updateClass
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$ac181fb217a2566a$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Nav = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$ac181fb217a2566a$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Nav = _classThis;
})();
var $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$d3445d44d351b213$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$d3445d44d351b213$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$d3445d44d351b213$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5131dddb90b74959$export$3e41faf802a29e71 = (()=>{
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'tab-pane'
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var Tab = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "caption", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        connectedCallback() {
            this.classList.add('tab-pane');
            this.role = 'tabpanel';
        }
    };
    $5131dddb90b74959$var$$d3445d44d351b213$var$__setFunctionName(_classThis, "Tab");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Tab = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Tab = _classThis;
})();
let $5131dddb90b74959$export$b2539bed5023c21c = (()=>{
    var _Tabs_tabMeta_accessor_storage, _Tabs_currentIndex_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'tabs-box',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _tabMeta_decorators;
    let _tabMeta_initializers = [];
    let _tabMeta_extraInitializers = [];
    let _currentIndex_decorators;
    let _currentIndex_initializers = [];
    let _currentIndex_extraInitializers = [];
    let _handleTabClick_decorators;
    let _turnPaneTo_decorators;
    var Tabs = _classThis = class extends _classSuper {
        get tabMeta() {
            return $5131dddb90b74959$var$$d3445d44d351b213$var$__classPrivateFieldGet(this, _Tabs_tabMeta_accessor_storage, "f");
        }
        set tabMeta(value) {
            $5131dddb90b74959$var$$d3445d44d351b213$var$__classPrivateFieldSet(this, _Tabs_tabMeta_accessor_storage, value, "f");
        }
        get currentIndex() {
            return $5131dddb90b74959$var$$d3445d44d351b213$var$__classPrivateFieldGet(this, _Tabs_currentIndex_accessor_storage, "f");
        }
        set currentIndex(value) {
            $5131dddb90b74959$var$$d3445d44d351b213$var$__classPrivateFieldSet(this, _Tabs_currentIndex_accessor_storage, value, "f");
        }
        mountedCallback() {
            const tabs = [
                ...this.querySelectorAll('tab-pane')
            ];
            this.tabMeta = tabs.map((tab)=>{
                tab.hidden = true;
                return {
                    caption: tab.caption
                };
            });
            this.turnPaneTo(this.currentIndex);
        }
        handleTabClick(event, { dataset: { index: index } }) {
            event.preventDefault();
            event.stopPropagation();
            this.currentIndex = +index;
        }
        turnPaneTo(index) {
            const previous = this.querySelector('tab-pane.active');
            if (previous) {
                previous.hidden = true;
                previous.classList.remove('active', 'show');
            }
            const next = this.children[index];
            next.hidden = false;
            next.classList.add('active', 'show');
        }
        renderContent() {
            const { tabMeta: tabMeta, currentIndex: currentIndex } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$39140c7d8b0ba7b3, {
                        className: "nav-tabs",
                        role: "tablist",
                        children: tabMeta.map(({ caption: caption }, index)=>(0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$b0d92dbee9b5b60d, {
                                role: "tab",
                                "data-index": index,
                                className: currentIndex === index ? 'active' : '',
                                ariaSelected: `${currentIndex === index}`,
                                children: caption
                            }))
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "tab-content",
                        children: (0, $bd1ed0d24b354858$exports.jsx)("slot", {})
                    })
                ]
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
        constructor(){
            super(...arguments);
            _Tabs_tabMeta_accessor_storage.set(this, ($5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(this, _tabMeta_initializers, [])));
            _Tabs_currentIndex_accessor_storage.set(this, ($5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(this, _tabMeta_extraInitializers), $5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(this, _currentIndex_initializers, 0)));
            $5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(this, _currentIndex_extraInitializers);
        }
    };
    _Tabs_tabMeta_accessor_storage = new WeakMap();
    _Tabs_currentIndex_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$d3445d44d351b213$var$__setFunctionName(_classThis, "Tabs");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _tabMeta_decorators = [
            (0, $d5I5D.observable)
        ];
        _currentIndex_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _handleTabClick_decorators = [
            (0, $6f83f77ba8e7af5c$export$af631764ddc44097)('click', '.nav-tabs > .nav-link')
        ];
        _turnPaneTo_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ currentIndex: currentIndex })=>currentIndex)
        ];
        $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _tabMeta_decorators, {
            kind: "accessor",
            name: "tabMeta",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tabMeta" in obj,
                get: (obj)=>obj.tabMeta,
                set: (obj, value)=>{
                    obj.tabMeta = value;
                }
            },
            metadata: _metadata
        }, _tabMeta_initializers, _tabMeta_extraInitializers);
        $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _currentIndex_decorators, {
            kind: "accessor",
            name: "currentIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentIndex" in obj,
                get: (obj)=>obj.currentIndex,
                set: (obj, value)=>{
                    obj.currentIndex = value;
                }
            },
            metadata: _metadata
        }, _currentIndex_initializers, _currentIndex_extraInitializers);
        $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _handleTabClick_decorators, {
            kind: "method",
            name: "handleTabClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleTabClick" in obj,
                get: (obj)=>obj.handleTabClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate(_classThis, null, _turnPaneTo_decorators, {
            kind: "method",
            name: "turnPaneTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnPaneTo" in obj,
                get: (obj)=>obj.turnPaneTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$d3445d44d351b213$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Tabs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$d3445d44d351b213$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Tabs = _classThis;
})();
var $5131dddb90b74959$var$$75c9fe32db446e0e$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$75c9fe32db446e0e$exports, "CodeBlock", function() {
    return $5131dddb90b74959$export$6c415d1fdae3dfdb;
});
var $5131dddb90b74959$var$$a42a2ada6ce76173$exports = {};
var $5131dddb90b74959$var$$76979d798b5a3bd5$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "FormGroup", function() {
    return $5131dddb90b74959$export$2d00230e1e6f7fbc;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "FormLabel", function() {
    return $5131dddb90b74959$export$842aba50ed0ce9d7;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "FloatingLabel", function() {
    return $5131dddb90b74959$export$8522a2827ec13639;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "InputGroup", function() {
    return $5131dddb90b74959$export$6e5a9cd40e0c9b97;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "InputGroupText", function() {
    return $5131dddb90b74959$export$219ad5c362b47f2f;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "FormControl", function() {
    return $5131dddb90b74959$export$fe5d99d8691b3f62;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "FormCheck", function() {
    return $5131dddb90b74959$export$5cd9378d879de45f;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$76979d798b5a3bd5$exports, "FormField", function() {
    return $5131dddb90b74959$export$56e87bf42978147a;
});
var $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$2d00230e1e6f7fbc = (_a)=>{
    var { children: children } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({}, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$842aba50ed0ce9d7 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("label", Object.assign({
        className: `form-label ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$8522a2827ec13639 = (_a)=>{
    var { className: className = '', style: style, label: label, children: children } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "style",
        "label",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("div", {
        className: `form-floating ${className}`,
        style: style,
        children: [
            children,
            (0, $bd1ed0d24b354858$exports.jsx)("label", Object.assign({}, props, {
                children: label
            }))
        ]
    });
};
const $5131dddb90b74959$export$6e5a9cd40e0c9b97 = (_a)=>{
    var { className: className = '', size: size, children: children } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "size",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('input-group', size && `input-group-${size}`, className)
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$219ad5c362b47f2f = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("span", Object.assign({
        className: `input-group-text ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$fe5d99d8691b3f62 = (_a)=>{
    var { as: Tag = 'input', className: className = '', htmlSize: htmlSize, size: size, plaintext: plaintext } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "as",
        "className",
        "htmlSize",
        "size",
        "plaintext"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)(Tag, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('form-control', size && `form-control-${size}`, props.readOnly && plaintext && `form-control-plaintext`, props.type === 'color' && `form-control-color`, className)
    }, props, {
        size: htmlSize
    }));
};
const $5131dddb90b74959$export$5cd9378d879de45f = (_a)=>{
    var { id: id = (0, $8uN2z.uniqueID)(), className: className = '', style: style, title: title, type: type, inline: inline, reverse: reverse, label: label } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "id",
        "className",
        "style",
        "title",
        "type",
        "inline",
        "reverse",
        "label"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(label && 'form-check', inline && 'form-check-inline', reverse && 'form-check-reverse', type === 'switch' && 'form-switch', className),
        style: style,
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("input", Object.assign({
                className: "form-check-input",
                type: type === 'switch' ? 'checkbox' : type,
                role: type === 'switch' ? 'switch' : undefined,
                id: id
            }, props)),
            label && (0, $bd1ed0d24b354858$exports.jsx)("label", {
                className: "form-check-label",
                htmlFor: id,
                title: title,
                children: label
            })
        ]
    });
};
const $5131dddb90b74959$export$56e87bf42978147a = (_a)=>{
    var { className: className, label: label, labelFloat: labelFloat } = _a, props = $5131dddb90b74959$var$$76979d798b5a3bd5$var$__rest(_a, [
        "className",
        "label",
        "labelFloat"
    ]);
    label || (label = props.title || props.placeholder);
    const field = (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$fe5d99d8691b3f62, Object.assign({}, props));
    return labelFloat ? (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$8522a2827ec13639, {
        className: className,
        label: label,
        children: field
    }) : (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$2d00230e1e6f7fbc, {
        className: className,
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$842aba50ed0ce9d7, {
                children: label
            }),
            field
        ]
    });
};
var $5131dddb90b74959$var$$d6a5aaf30399725f$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$d6a5aaf30399725f$exports, "ButtonGroup", function() {
    return $5131dddb90b74959$export$69b1032f2ecdf404;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$d6a5aaf30399725f$exports, "ButtonToolbar", function() {
    return $5131dddb90b74959$export$478f41ba79e7b570;
});
var $5131dddb90b74959$var$$d6a5aaf30399725f$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$69b1032f2ecdf404 = (_a)=>{
    var { className: className = '', vertical: vertical, size: size, children: children } = _a, props = $5131dddb90b74959$var$$d6a5aaf30399725f$var$__rest(_a, [
        "className",
        "vertical",
        "size",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`btn-group${vertical ? '-vertical' : ''}`, size && `btn-group-${size}`, className),
        role: "group"
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$478f41ba79e7b570 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$d6a5aaf30399725f$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `btn-toolbar ${className}`,
        role: "toolbar"
    }, props, {
        children: children
    }));
};
var $5131dddb90b74959$var$$9c6318c3d1f65d7e$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$9c6318c3d1f65d7e$exports, "RangeInput", function() {
    return $5131dddb90b74959$export$f5603a09670563b9;
});
var $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5131dddb90b74959$export$f5603a09670563b9 = (()=>{
    var _RangeInput_type_accessor_storage, _RangeInput_min_accessor_storage, _RangeInput_max_accessor_storage, _RangeInput_step_accessor_storage, _RangeInput_icon_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'range-input',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$2a668e8d088a0667),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _type_decorators;
    let _type_initializers = [];
    let _type_extraInitializers = [];
    let _min_decorators;
    let _min_initializers = [];
    let _min_extraInitializers = [];
    let _max_decorators;
    let _max_initializers = [];
    let _max_extraInitializers = [];
    let _step_decorators;
    let _step_initializers = [];
    let _step_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    var RangeInput = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _RangeInput_type_accessor_storage.set(this, $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _type_initializers, 'range'));
            _RangeInput_min_accessor_storage.set(this, ($5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _type_extraInitializers), $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _min_initializers, void 0)));
            _RangeInput_max_accessor_storage.set(this, ($5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _min_extraInitializers), $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _max_initializers, void 0)));
            _RangeInput_step_accessor_storage.set(this, ($5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _max_extraInitializers), $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _step_initializers, 1)));
            _RangeInput_icon_accessor_storage.set(this, ($5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _step_extraInitializers), $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _icon_initializers, void 0)));
            Object.defineProperty(this, "handleChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(this, _icon_extraInitializers), ({ currentTarget: currentTarget })=>{
                    this.value = currentTarget.value;
                    this.emit('change');
                })
            });
        }
        get type() {
            return $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldGet(this, _RangeInput_type_accessor_storage, "f");
        }
        set type(value) {
            $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldSet(this, _RangeInput_type_accessor_storage, value, "f");
        }
        get min() {
            return $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldGet(this, _RangeInput_min_accessor_storage, "f");
        }
        set min(value) {
            $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldSet(this, _RangeInput_min_accessor_storage, value, "f");
        }
        get max() {
            return $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldGet(this, _RangeInput_max_accessor_storage, "f");
        }
        set max(value) {
            $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldSet(this, _RangeInput_max_accessor_storage, value, "f");
        }
        get step() {
            return $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldGet(this, _RangeInput_step_accessor_storage, "f");
        }
        set step(value) {
            $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldSet(this, _RangeInput_step_accessor_storage, value, "f");
        }
        get icon() {
            return $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldGet(this, _RangeInput_icon_accessor_storage, "f");
        }
        set icon(value) {
            $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__classPrivateFieldSet(this, _RangeInput_icon_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.classList.add('d-inline-block', 'position-relative');
        }
        renderItem(index) {
            const { icon: icon, step: step, value: value } = this;
            const fullValue = step * index;
            const itemValue = Math.max(Math.min(+value - fullValue, step), 0);
            return (0, $bd1ed0d24b354858$exports.jsx)("li", {
                className: "text-center",
                children: typeof icon === 'function' ? icon(itemValue) : icon
            }, index);
        }
        render() {
            const { icon: icon, min: min, max: max = icon ? 5 : 100, value: value = min || 0 } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("input", {
                        className: icon ? 'opacity-0' : '',
                        style: {
                            margin: '0 -0.5rem',
                            cursor: 'pointer'
                        },
                        type: "range",
                        min: min === null || min === void 0 ? void 0 : min.toString(),
                        max: max === null || max === void 0 ? void 0 : max.toString(),
                        value: value === null || value === void 0 ? void 0 : value.toString(),
                        onChange: this.handleChange
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("ol", {
                        className: "list-unstyled user-select-none position-absolute start-0 top-0 w-100 h-100 pe-none d-flex justify-content-around",
                        children: Array.from({
                            length: max
                        }, (_, index)=>this.renderItem(index))
                    })
                ]
            });
        }
    };
    _RangeInput_type_accessor_storage = new WeakMap();
    _RangeInput_min_accessor_storage = new WeakMap();
    _RangeInput_max_accessor_storage = new WeakMap();
    _RangeInput_step_accessor_storage = new WeakMap();
    _RangeInput_icon_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__setFunctionName(_classThis, "RangeInput");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _type_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _min_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _max_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _step_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _icon_decorators = [
            (0, $d5I5D.observable)
        ];
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate(_classThis, null, _type_decorators, {
            kind: "accessor",
            name: "type",
            static: false,
            private: false,
            access: {
                has: (obj)=>"type" in obj,
                get: (obj)=>obj.type,
                set: (obj, value)=>{
                    obj.type = value;
                }
            },
            metadata: _metadata
        }, _type_initializers, _type_extraInitializers);
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate(_classThis, null, _min_decorators, {
            kind: "accessor",
            name: "min",
            static: false,
            private: false,
            access: {
                has: (obj)=>"min" in obj,
                get: (obj)=>obj.min,
                set: (obj, value)=>{
                    obj.min = value;
                }
            },
            metadata: _metadata
        }, _min_initializers, _min_extraInitializers);
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate(_classThis, null, _max_decorators, {
            kind: "accessor",
            name: "max",
            static: false,
            private: false,
            access: {
                has: (obj)=>"max" in obj,
                get: (obj)=>obj.max,
                set: (obj, value)=>{
                    obj.max = value;
                }
            },
            metadata: _metadata
        }, _max_initializers, _max_extraInitializers);
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate(_classThis, null, _step_decorators, {
            kind: "accessor",
            name: "step",
            static: false,
            private: false,
            access: {
                has: (obj)=>"step" in obj,
                get: (obj)=>obj.step,
                set: (obj, value)=>{
                    obj.step = value;
                }
            },
            metadata: _metadata
        }, _step_initializers, _step_extraInitializers);
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate(_classThis, null, _icon_decorators, {
            kind: "accessor",
            name: "icon",
            static: false,
            private: false,
            access: {
                has: (obj)=>"icon" in obj,
                get: (obj)=>obj.icon,
                set: (obj, value)=>{
                    obj.icon = value;
                }
            },
            metadata: _metadata
        }, _icon_initializers, _icon_extraInitializers);
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        RangeInput = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$9c6318c3d1f65d7e$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return RangeInput = _classThis;
})();
var $5131dddb90b74959$var$$c3a80fb16cbaf6ea$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$c3a80fb16cbaf6ea$exports, "FilePicker", function() {
    return $5131dddb90b74959$export$54dc470bcc5c41d1;
});
var $5131dddb90b74959$var$$9b9a8463439bada6$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$9b9a8463439bada6$exports, "FileTypeMap", function() {
    return $5131dddb90b74959$export$413fb8502ce63cf9;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$9b9a8463439bada6$exports, "FilePreview", function() {
    return $5131dddb90b74959$export$a127194569a41afb;
});
var $5131dddb90b74959$var$$1134373d0203fdc7$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$1134373d0203fdc7$exports, "ImagePreview", function() {
    return $5131dddb90b74959$export$4a96334d5925dbf2;
});
var $5131dddb90b74959$var$$07e74c2207adaaa3$exports = {};
var $5131dddb90b74959$var$$d3540d749a8620d4$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$d3540d749a8620d4$exports, "Spinner", function() {
    return $5131dddb90b74959$export$7f7cbe89f1eacd2;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$d3540d749a8620d4$exports, "SpinnerBox", function() {
    return $5131dddb90b74959$export$d4c790f923031725;
});
var $5131dddb90b74959$var$$d3540d749a8620d4$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$7f7cbe89f1eacd2 = (_a)=>{
    var { className: className, variant: variant, size: size, animation: animation = 'border', children: children = 'Loading...' } = _a, props = $5131dddb90b74959$var$$d3540d749a8620d4$var$__rest(_a, [
        "className",
        "variant",
        "size",
        "animation",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(`spinner-${animation}`, size && `spinner-${animation}-${size}`, variant && `text-${variant}`, className),
        role: "status"
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("span", {
            className: "visually-hidden",
            children: children
        })
    }));
};
const $5131dddb90b74959$export$d4c790f923031725 = (_a)=>{
    var { className: className = '', cover: cover, variant: variant, size: size, animation: animation, role: role, children: children } = _a, props = $5131dddb90b74959$var$$d3540d749a8620d4$var$__rest(_a, [
        "className",
        "cover",
        "variant",
        "size",
        "animation",
        "role",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("div", Object.assign({
        className: `position-relative ${className}`
    }, props, {
        children: [
            children,
            cover && (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "modal-backdrop show d-flex justify-content-center align-items-center",
                children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$7f7cbe89f1eacd2, {
                    variant: variant,
                    size: size,
                    animation: animation,
                    role: role,
                    ariaHidden: 'true'
                })
            })
        ]
    }));
};
var $5131dddb90b74959$var$$95f58925a71cbbe0$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$95f58925a71cbbe0$exports, "Alert", function() {
    return $5131dddb90b74959$export$caec2af78bcc877f;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$95f58925a71cbbe0$exports, "AlertLink", function() {
    return $5131dddb90b74959$export$4b51b857dc7063b8;
});
var $5131dddb90b74959$var$$95f58925a71cbbe0$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$caec2af78bcc877f = ({ className: className, variant: variant = 'primary', title: title, children: children, show: show = true, dismissible: dismissible, onClose: onClose })=>(0, $bd1ed0d24b354858$exports.jsxs)("aside", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('alert', `alert-${variant}`, {
            'alert-dismissible fade': dismissible,
            show: show
        }, className),
        role: "alert",
        children: [
            title && (0, $bd1ed0d24b354858$exports.jsx)("h4", {
                className: "alert-heading",
                children: title
            }),
            children,
            dismissible && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$de65de8213222d10, {
                onClick: onClose
            })
        ]
    });
const $5131dddb90b74959$export$4b51b857dc7063b8 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$95f58925a71cbbe0$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        className: `alert-link ${className}`
    }, props, {
        children: children
    }));
};
var $5131dddb90b74959$var$$a6f317a49298db85$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$a6f317a49298db85$exports, "Tooltip", function() {
    return $5131dddb90b74959$export$28c660c63b792dea;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$a6f317a49298db85$exports, "TooltipBox", function() {
    return $5131dddb90b74959$export$e4d8dc88bb9cc931;
});
var $5131dddb90b74959$var$$a6f317a49298db85$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$a6f317a49298db85$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$a6f317a49298db85$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$a6f317a49298db85$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$a6f317a49298db85$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$a6f317a49298db85$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$28c660c63b792dea = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$a6f317a49298db85$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("div", Object.assign({
        className: `tooltip bs-tooltip show position-absolute ${className}`,
        role: "tooltip"
    }, props, {
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "tooltip-arrow"
            }),
            (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "tooltip-inner",
                children: children
            })
        ]
    }));
};
let $5131dddb90b74959$export$e4d8dc88bb9cc931 = (()=>{
    var _TooltipBox_show_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'tooltip-box',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _show_decorators;
    let _show_initializers = [];
    let _show_extraInitializers = [];
    var TooltipBox = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "content", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _TooltipBox_show_accessor_storage.set(this, $5131dddb90b74959$var$$a6f317a49298db85$var$__runInitializers(this, _show_initializers, false));
            Object.defineProperty(this, "handleToggle", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$a6f317a49298db85$var$__runInitializers(this, _show_extraInitializers), ()=>this.show = !this.show)
            });
        }
        get show() {
            return $5131dddb90b74959$var$$a6f317a49298db85$var$__classPrivateFieldGet(this, _TooltipBox_show_accessor_storage, "f");
        }
        set show(value) {
            $5131dddb90b74959$var$$a6f317a49298db85$var$__classPrivateFieldSet(this, _TooltipBox_show_accessor_storage, value, "f");
        }
        connectedCallback() {
            this.style.display = 'inline-block';
            this.addEventListener('mouseenter', this.handleToggle);
            this.addEventListener('mouseleave', this.handleToggle);
        }
        disconnectedCallback() {
            this.removeEventListener('mouseenter', this.handleToggle);
            this.removeEventListener('mouseleave', this.handleToggle);
        }
        render() {
            const { content: content, show: show } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("slot", {}),
                    show && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$28c660c63b792dea, {
                        children: content
                    })
                ]
            });
        }
    };
    _TooltipBox_show_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$a6f317a49298db85$var$__setFunctionName(_classThis, "TooltipBox");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _show_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        $5131dddb90b74959$var$$a6f317a49298db85$var$__esDecorate(_classThis, null, _show_decorators, {
            kind: "accessor",
            name: "show",
            static: false,
            private: false,
            access: {
                has: (obj)=>"show" in obj,
                get: (obj)=>obj.show,
                set: (obj, value)=>{
                    obj.show = value;
                }
            },
            metadata: _metadata
        }, _show_initializers, _show_extraInitializers);
        $5131dddb90b74959$var$$a6f317a49298db85$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        TooltipBox = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$a6f317a49298db85$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return TooltipBox = _classThis;
})();
var $5131dddb90b74959$var$$99cde405e93e4bfc$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$99cde405e93e4bfc$exports, "DialogClose", function() {
    return $5131dddb90b74959$export$fba2fb7cd781b7ac;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$99cde405e93e4bfc$exports, "Dialog", function() {
    return $5131dddb90b74959$export$3ddf2d174ce01153;
});
var $5131dddb90b74959$var$$99cde405e93e4bfc$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$99cde405e93e4bfc$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$99cde405e93e4bfc$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$99cde405e93e4bfc$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
class $5131dddb90b74959$export$fba2fb7cd781b7ac extends Error {
    constructor(message = 'Dialog closed'){
        super(message);
    }
}
let $5131dddb90b74959$export$3ddf2d174ce01153 = (()=>{
    var _a, _Dialog_defer_accessor_storage;
    let _defer_decorators;
    let _defer_initializers = [];
    let _defer_extraInitializers = [];
    return _a = class Dialog {
        get defer() {
            return $5131dddb90b74959$var$$99cde405e93e4bfc$var$__classPrivateFieldGet(this, _Dialog_defer_accessor_storage, "f");
        }
        set defer(value) {
            $5131dddb90b74959$var$$99cde405e93e4bfc$var$__classPrivateFieldSet(this, _Dialog_defer_accessor_storage, value, "f");
        }
        constructor(Factory){
            _Dialog_defer_accessor_storage.set(this, $5131dddb90b74959$var$$99cde405e93e4bfc$var$__runInitializers(this, _defer_initializers, void 0));
            Object.defineProperty(this, "Component", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $5131dddb90b74959$var$$99cde405e93e4bfc$var$__runInitializers(this, _defer_extraInitializers)
            });
            this.Component = (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)(()=>(0, $bd1ed0d24b354858$exports.jsx)(Factory, {
                    defer: this.defer
                }));
        }
        open() {
            this.defer = new (0, $c379f9436bbe0249$export$c7e91f8aec23ae14)();
            this.defer.promise.finally(()=>this.defer = undefined);
            return this.defer.promise;
        }
    }, _Dialog_defer_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _defer_decorators = [
            (0, $d5I5D.observable)
        ];
        $5131dddb90b74959$var$$99cde405e93e4bfc$var$__esDecorate(_a, null, _defer_decorators, {
            kind: "accessor",
            name: "defer",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defer" in obj,
                get: (obj)=>obj.defer,
                set: (obj, value)=>{
                    obj.defer = value;
                }
            },
            metadata: _metadata
        }, _defer_initializers, _defer_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $5131dddb90b74959$var$$ed39adb4ffdd84c9$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ed39adb4ffdd84c9$exports, "Modal", function() {
    return $5131dddb90b74959$export$2b77a92f1a5ad772;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ed39adb4ffdd84c9$exports, "ModalHeader", function() {
    return $5131dddb90b74959$export$f50a68e3694789ee;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ed39adb4ffdd84c9$exports, "ModalTitle", function() {
    return $5131dddb90b74959$export$b26fae16ba5468aa;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ed39adb4ffdd84c9$exports, "ModalBody", function() {
    return $5131dddb90b74959$export$cb540d8b0ef7906c;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$ed39adb4ffdd84c9$exports, "ModalFooter", function() {
    return $5131dddb90b74959$export$519437715052e656;
});
var $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$emitHideByKeyUp = ()=>document.querySelectorAll('.modal.show').forEach((modal)=>modal.dispatchEvent(new CustomEvent('hide')));
const $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$emitHideByClick = ({ currentTarget: currentTarget })=>currentTarget.closest('.modal').dispatchEvent(new CustomEvent('hide'));
const $5131dddb90b74959$export$2b77a92f1a5ad772 = (_a)=>{
    var { className: className, backdrop: backdrop, size: size, fullscreen: fullscreen, centered: centered, scrollable: scrollable, animation: animation, show: show, ref: ref, children: children } = _a, props = $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "backdrop",
        "size",
        "fullscreen",
        "centered",
        "scrollable",
        "animation",
        "show",
        "ref",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('modal', {
            fade: animation,
            show: show
        }, className),
        "data-bs-backdrop": backdrop != null ? backdrop + '' : undefined,
        tabIndex: -1,
        ariaHidden: !show + '',
        ref: (node)=>{
            var _a, _b;
            return node ? (_a = globalThis.addEventListener) === null || _a === void 0 ? void 0 : _a.call(globalThis, 'keyup', $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$emitHideByKeyUp) : (_b = globalThis.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(globalThis, 'keyup', $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$emitHideByKeyUp);
        }
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('modal-dialog', size && `modal-${size}`, fullscreen && `modal-fullscreen${fullscreen === true ? '' : `-${fullscreen}`}`, centered && 'modal-dialog-centered', scrollable && 'modal-dialog-scrollable'),
            children: (0, $bd1ed0d24b354858$exports.jsx)("div", {
                className: "modal-content",
                children: children
            })
        })
    }));
};
const $5131dddb90b74959$export$f50a68e3694789ee = (_a)=>{
    var { className: className = '', children: children, closeButton: closeButton } = _a, props = $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children",
        "closeButton"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsxs)("div", Object.assign({
        className: `modal-header ${className}`
    }, props, {
        children: [
            children,
            closeButton && (0, $bd1ed0d24b354858$exports.jsx)("button", {
                type: "button",
                className: "btn-close",
                ariaLabel: "Close",
                onClick: $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$emitHideByClick
            })
        ]
    }));
};
const $5131dddb90b74959$export$b26fae16ba5468aa = (_a)=>{
    var { className: className = 'fs-5', children: children } = _a, props = $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("h1", Object.assign({
        className: `modal-title ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$cb540d8b0ef7906c = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `modal-body ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$519437715052e656 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$ed39adb4ffdd84c9$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `modal-footer ${className}`
    }, props, {
        children: children
    }));
};
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$07e74c2207adaaa3$exports, $5131dddb90b74959$var$$d3540d749a8620d4$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$07e74c2207adaaa3$exports, $5131dddb90b74959$var$$95f58925a71cbbe0$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$07e74c2207adaaa3$exports, $5131dddb90b74959$var$$a6f317a49298db85$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$07e74c2207adaaa3$exports, $5131dddb90b74959$var$$99cde405e93e4bfc$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$07e74c2207adaaa3$exports, $5131dddb90b74959$var$$ed39adb4ffdd84c9$exports);
var $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$1134373d0203fdc7$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5131dddb90b74959$var$$1134373d0203fdc7$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5131dddb90b74959$export$4a96334d5925dbf2 = (()=>{
    var _ImagePreview_src_accessor_storage, _ImagePreview_loading_accessor_storage, _ImagePreview_fluid_accessor_storage, _ImagePreview_rounded_accessor_storage, _ImagePreview_roundedCircle_accessor_storage, _ImagePreview_thumbnail_accessor_storage, _ImagePreview_downloading_accessor_storage, _ImagePreview_loadedPath_accessor_storage, _ImagePreview_viewing_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'image-preview'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _src_decorators;
    let _src_initializers = [];
    let _src_extraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _fluid_decorators;
    let _fluid_initializers = [];
    let _fluid_extraInitializers = [];
    let _rounded_decorators;
    let _rounded_initializers = [];
    let _rounded_extraInitializers = [];
    let _roundedCircle_decorators;
    let _roundedCircle_initializers = [];
    let _roundedCircle_extraInitializers = [];
    let _thumbnail_decorators;
    let _thumbnail_initializers = [];
    let _thumbnail_extraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _loadedPath_decorators;
    let _loadedPath_initializers = [];
    let _loadedPath_extraInitializers = [];
    let _viewing_decorators;
    let _viewing_initializers = [];
    let _viewing_extraInitializers = [];
    let _connectedCallback_decorators;
    var ImagePreview = _classThis = class extends _classSuper {
        get src() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_src_accessor_storage, "f");
        }
        set src(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_src_accessor_storage, value, "f");
        }
        get loading() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_loading_accessor_storage, "f");
        }
        set loading(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_loading_accessor_storage, value, "f");
        }
        get fluid() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_fluid_accessor_storage, "f");
        }
        set fluid(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_fluid_accessor_storage, value, "f");
        }
        get rounded() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_rounded_accessor_storage, "f");
        }
        set rounded(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_rounded_accessor_storage, value, "f");
        }
        get roundedCircle() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_roundedCircle_accessor_storage, "f");
        }
        set roundedCircle(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_roundedCircle_accessor_storage, value, "f");
        }
        get thumbnail() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_thumbnail_accessor_storage, "f");
        }
        set thumbnail(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_thumbnail_accessor_storage, value, "f");
        }
        get downloading() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_downloading_accessor_storage, value, "f");
        }
        get loadedPath() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_loadedPath_accessor_storage, "f");
        }
        set loadedPath(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_loadedPath_accessor_storage, value, "f");
        }
        get viewing() {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldGet(this, _ImagePreview_viewing_accessor_storage, "f");
        }
        set viewing(value) {
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__classPrivateFieldSet(this, _ImagePreview_viewing_accessor_storage, value, "f");
        }
        connectedCallback() {
            const { src: src } = this;
            this.loadedPath = '';
            if (src) this.load(src);
        }
        load(path) {
            return $5131dddb90b74959$var$$1134373d0203fdc7$var$__awaiter(this, void 0, void 0, function*() {
                this.downloading = true;
                yield new Promise((resolve, reject)=>{
                    const image = new globalThis.Image();
                    image.onload = resolve;
                    image.onerror = reject;
                    image.src = path;
                });
                this.loadedPath = path;
                this.downloading = false;
            });
        }
        render() {
            const { downloading: downloading, loadedPath: loadedPath, viewing: viewing } = this, { loading: loading, fluid: fluid, rounded: rounded, roundedCircle: roundedCircle, thumbnail: thumbnail } = this;
            const props = {
                loading: loading,
                fluid: fluid,
                rounded: rounded,
                roundedCircle: roundedCircle,
                thumbnail: thumbnail
            };
            return (0, $bd1ed0d24b354858$exports.jsxs)("figure", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('m-0', downloading && 'd-flex justify-content-center align-items-center'),
                children: [
                    downloading ? (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$7f7cbe89f1eacd2, {}) : loadedPath && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$3e431a229df88919, Object.assign({
                        className: "w-100 h-100 object-fit-contain"
                    }, props, {
                        src: loadedPath,
                        onClick: ()=>this.viewing = true
                    })),
                    (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$2b77a92f1a5ad772, {
                        centered: true,
                        show: viewing,
                        onHide: ()=>this.viewing = false,
                        children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$cb540d8b0ef7906c, {
                            children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$3e431a229df88919, {
                                fluid: true,
                                src: loadedPath
                            })
                        })
                    })
                ]
            });
        }
        constructor(){
            super(...arguments);
            _ImagePreview_src_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _src_initializers, '')));
            _ImagePreview_loading_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _src_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _loading_initializers, 'lazy')));
            _ImagePreview_fluid_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _loading_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _fluid_initializers, false)));
            _ImagePreview_rounded_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _fluid_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _rounded_initializers, false)));
            _ImagePreview_roundedCircle_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _rounded_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _roundedCircle_initializers, false)));
            _ImagePreview_thumbnail_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _roundedCircle_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _thumbnail_initializers, false)));
            _ImagePreview_downloading_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _thumbnail_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _downloading_initializers, false)));
            _ImagePreview_loadedPath_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _downloading_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _loadedPath_initializers, '')));
            _ImagePreview_viewing_accessor_storage.set(this, ($5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _loadedPath_extraInitializers), $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _viewing_initializers, false)));
            $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(this, _viewing_extraInitializers);
        }
    };
    _ImagePreview_src_accessor_storage = new WeakMap();
    _ImagePreview_loading_accessor_storage = new WeakMap();
    _ImagePreview_fluid_accessor_storage = new WeakMap();
    _ImagePreview_rounded_accessor_storage = new WeakMap();
    _ImagePreview_roundedCircle_accessor_storage = new WeakMap();
    _ImagePreview_thumbnail_accessor_storage = new WeakMap();
    _ImagePreview_downloading_accessor_storage = new WeakMap();
    _ImagePreview_loadedPath_accessor_storage = new WeakMap();
    _ImagePreview_viewing_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$1134373d0203fdc7$var$__setFunctionName(_classThis, "ImagePreview");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _src_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _loading_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _fluid_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _rounded_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _roundedCircle_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _thumbnail_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _downloading_decorators = [
            (0, $d5I5D.observable)
        ];
        _loadedPath_decorators = [
            (0, $d5I5D.observable)
        ];
        _viewing_decorators = [
            (0, $d5I5D.observable)
        ];
        _connectedCallback_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ src: src })=>src)
        ];
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _src_decorators, {
            kind: "accessor",
            name: "src",
            static: false,
            private: false,
            access: {
                has: (obj)=>"src" in obj,
                get: (obj)=>obj.src,
                set: (obj, value)=>{
                    obj.src = value;
                }
            },
            metadata: _metadata
        }, _src_initializers, _src_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _fluid_decorators, {
            kind: "accessor",
            name: "fluid",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fluid" in obj,
                get: (obj)=>obj.fluid,
                set: (obj, value)=>{
                    obj.fluid = value;
                }
            },
            metadata: _metadata
        }, _fluid_initializers, _fluid_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _rounded_decorators, {
            kind: "accessor",
            name: "rounded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"rounded" in obj,
                get: (obj)=>obj.rounded,
                set: (obj, value)=>{
                    obj.rounded = value;
                }
            },
            metadata: _metadata
        }, _rounded_initializers, _rounded_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _roundedCircle_decorators, {
            kind: "accessor",
            name: "roundedCircle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"roundedCircle" in obj,
                get: (obj)=>obj.roundedCircle,
                set: (obj, value)=>{
                    obj.roundedCircle = value;
                }
            },
            metadata: _metadata
        }, _roundedCircle_initializers, _roundedCircle_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _thumbnail_decorators, {
            kind: "accessor",
            name: "thumbnail",
            static: false,
            private: false,
            access: {
                has: (obj)=>"thumbnail" in obj,
                get: (obj)=>obj.thumbnail,
                set: (obj, value)=>{
                    obj.thumbnail = value;
                }
            },
            metadata: _metadata
        }, _thumbnail_initializers, _thumbnail_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _loadedPath_decorators, {
            kind: "accessor",
            name: "loadedPath",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadedPath" in obj,
                get: (obj)=>obj.loadedPath,
                set: (obj, value)=>{
                    obj.loadedPath = value;
                }
            },
            metadata: _metadata
        }, _loadedPath_initializers, _loadedPath_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _viewing_decorators, {
            kind: "accessor",
            name: "viewing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"viewing" in obj,
                get: (obj)=>obj.viewing,
                set: (obj, value)=>{
                    obj.viewing = value;
                }
            },
            metadata: _metadata
        }, _viewing_initializers, _viewing_extraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(_classThis, null, _connectedCallback_decorators, {
            kind: "method",
            name: "connectedCallback",
            static: false,
            private: false,
            access: {
                has: (obj)=>"connectedCallback" in obj,
                get: (obj)=>obj.connectedCallback
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ImagePreview = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$1134373d0203fdc7$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ImagePreview = _classThis;
})();
var $5131dddb90b74959$var$$9b9a8463439bada6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$413fb8502ce63cf9 = {
    stream: 'binary',
    compressed: 'zip',
    msword: 'doc',
    document: 'docx',
    powerpoint: 'ppt',
    presentation: 'pptx',
    excel: 'xls',
    sheet: 'xlsx'
};
const $5131dddb90b74959$export$a127194569a41afb = (_a)=>{
    var { className: className = '', type: type, path: path } = _a, props = $5131dddb90b74959$var$$9b9a8463439bada6$var$__rest(_a, [
        "className",
        "type",
        "path"
    ]);
    const [category, ...kind] = (type === null || type === void 0 ? void 0 : type.split(/\W+/)) || [], fileName = new URL(path, 'http://localhost').pathname.split('/').at(-1);
    const extension = $5131dddb90b74959$export$413fb8502ce63cf9[kind.at(-1)] || ((fileName === null || fileName === void 0 ? void 0 : fileName.includes('.')) ? fileName.split('.').at(-1) : kind.at(-1));
    return category === 'image' ? (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$4a96334d5925dbf2, Object.assign({
        className: className,
        fluid: true,
        loading: "lazy",
        src: path
    }, props)) : category === 'audio' ? (0, $bd1ed0d24b354858$exports.jsx)("audio", Object.assign({
        className: className,
        controls: true,
        src: path
    }, props)) : category === 'video' ? (0, $bd1ed0d24b354858$exports.jsx)("video", Object.assign({
        className: className,
        muted: true,
        src: path,
        onMouseEnter: ({ currentTarget: currentTarget })=>currentTarget.play(),
        onMouseLeave: ({ currentTarget: currentTarget })=>currentTarget.pause()
    }, props)) : (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        className: `d-inline-flex justify-content-center align-items-center ${className}`,
        download: fileName,
        href: path
    }, props, {
        children: extension ? (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$f04a61298a47a40f, {
            className: "fs-1",
            name: `filetype-${extension}`
        }) : path
    }));
};
var $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5131dddb90b74959$export$54dc470bcc5c41d1 = (()=>{
    var _FilePicker_accept_accessor_storage, _FilePicker_multiple_accessor_storage, _FilePicker_file_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'file-picker',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$2a668e8d088a0667),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _accept_decorators;
    let _accept_initializers = [];
    let _accept_extraInitializers = [];
    let _multiple_decorators;
    let _multiple_initializers = [];
    let _multiple_extraInitializers = [];
    let _file_decorators;
    let _file_initializers = [];
    let _file_extraInitializers = [];
    let _get_fileType_decorators;
    var FilePicker = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _FilePicker_accept_accessor_storage.set(this, ($5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _accept_initializers, '*/*')));
            _FilePicker_multiple_accessor_storage.set(this, ($5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _accept_extraInitializers), $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _multiple_initializers, false)));
            _FilePicker_file_accessor_storage.set(this, ($5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _multiple_extraInitializers), $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _file_initializers, void 0)));
            Object.defineProperty(this, "handleAdd", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(this, _file_extraInitializers), ({ currentTarget: currentTarget })=>{
                    var _a;
                    const file = (_a = currentTarget.files) === null || _a === void 0 ? void 0 : _a[0];
                    this.value = (this.file = file) ? URL.createObjectURL(file) : '';
                    this.emit('change', {
                        value: this.value,
                        file: file
                    });
                })
            });
            Object.defineProperty(this, "handleClear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (event)=>{
                    event.preventDefault();
                    if (this.value) {
                        URL.revokeObjectURL(this.value + '');
                        this.value = '';
                    }
                    this.emit('change', {
                        value: this.value
                    });
                }
            });
        }
        get accept() {
            return $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldGet(this, _FilePicker_accept_accessor_storage, "f");
        }
        set accept(value) {
            $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldSet(this, _FilePicker_accept_accessor_storage, value, "f");
        }
        get multiple() {
            return $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldGet(this, _FilePicker_multiple_accessor_storage, "f");
        }
        set multiple(value) {
            $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldSet(this, _FilePicker_multiple_accessor_storage, value, "f");
        }
        get file() {
            return $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldGet(this, _FilePicker_file_accessor_storage, "f");
        }
        set file(value) {
            $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__classPrivateFieldSet(this, _FilePicker_file_accessor_storage, value, "f");
        }
        get fileType() {
            var _a;
            const { accept: accept, file: file } = this;
            return (file === null || file === void 0 ? void 0 : file.type) || ((_a = file === null || file === void 0 ? void 0 : file.name.match(/\.\w+$/)) === null || _a === void 0 ? void 0 : _a[0]) || accept;
        }
        connectedCallback() {
            this.classList.add('d-block');
            this.style.width = '10rem';
            this.style.height = '10rem';
        }
        renderInput() {
            const { name: name, value: value, required: required, disabled: disabled, accept: accept, multiple: multiple } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("input", {
                        className: "position-absolute start-0 top-0 w-100 h-100 opacity-0",
                        type: "file",
                        name: value ? undefined : name,
                        required: !value && required,
                        disabled: disabled,
                        accept: accept,
                        multiple: multiple,
                        onChange: this.handleAdd
                    }),
                    value && (0, $bd1ed0d24b354858$exports.jsx)("input", {
                        type: "hidden",
                        name: name,
                        value: value
                    })
                ]
            });
        }
        renderContent() {
            const { value: value, fileType: fileType } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)("div", {
                className: "d-inline-block w-100 h-100 border rounded position-relative",
                children: [
                    value ? (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$a127194569a41afb, {
                        className: "w-100 h-100 object-fit-contain",
                        type: fileType,
                        path: value + ''
                    }) : (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "w-100 h-100 d-flex justify-content-center align-items-center display-1",
                        children: "+"
                    }),
                    this.renderInput(),
                    value && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$de65de8213222d10, {
                        className: "position-absolute top-0 end-0",
                        style: {
                            width: '0.5rem',
                            height: '0.5rem'
                        },
                        onClick: this.handleClear
                    })
                ]
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
    };
    _FilePicker_accept_accessor_storage = new WeakMap();
    _FilePicker_multiple_accessor_storage = new WeakMap();
    _FilePicker_file_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__setFunctionName(_classThis, "FilePicker");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _accept_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _multiple_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _file_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_fileType_decorators = [
            (0, $d5I5D.computed)
        ];
        $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__esDecorate(_classThis, null, _accept_decorators, {
            kind: "accessor",
            name: "accept",
            static: false,
            private: false,
            access: {
                has: (obj)=>"accept" in obj,
                get: (obj)=>obj.accept,
                set: (obj, value)=>{
                    obj.accept = value;
                }
            },
            metadata: _metadata
        }, _accept_initializers, _accept_extraInitializers);
        $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__esDecorate(_classThis, null, _multiple_decorators, {
            kind: "accessor",
            name: "multiple",
            static: false,
            private: false,
            access: {
                has: (obj)=>"multiple" in obj,
                get: (obj)=>obj.multiple,
                set: (obj, value)=>{
                    obj.multiple = value;
                }
            },
            metadata: _metadata
        }, _multiple_initializers, _multiple_extraInitializers);
        $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__esDecorate(_classThis, null, _file_decorators, {
            kind: "accessor",
            name: "file",
            static: false,
            private: false,
            access: {
                has: (obj)=>"file" in obj,
                get: (obj)=>obj.file,
                set: (obj, value)=>{
                    obj.file = value;
                }
            },
            metadata: _metadata
        }, _file_initializers, _file_extraInitializers);
        $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__esDecorate(_classThis, null, _get_fileType_decorators, {
            kind: "getter",
            name: "fileType",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fileType" in obj,
                get: (obj)=>obj.fileType
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        FilePicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$c3a80fb16cbaf6ea$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return FilePicker = _classThis;
})();
var $5131dddb90b74959$var$$0abe00e20a7893a6$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$0abe00e20a7893a6$exports, "FileModel", function() {
    return $5131dddb90b74959$export$424c8de2e117ab22;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$0abe00e20a7893a6$exports, "FileUploader", function() {
    return $5131dddb90b74959$export$1a5cb5295a7d2749;
});
var $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$0abe00e20a7893a6$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$0abe00e20a7893a6$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $5131dddb90b74959$export$424c8de2e117ab22 = (()=>{
    var _a, _FileModel_files_accessor_storage;
    let _files_decorators;
    let _files_initializers = [];
    let _files_extraInitializers = [];
    return _a = class FileModel {
        get files() {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldGet(this, _FileModel_files_accessor_storage, "f");
        }
        set files(value) {
            $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldSet(this, _FileModel_files_accessor_storage, value, "f");
        }
        clear() {
            this.files = [];
        }
        /**
             * Override this method for Network calling,
             * then call `super.upload(fileURL)` to update `this.files` array.
             */ upload(file) {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__awaiter(this, void 0, void 0, function*() {
                if (file instanceof Blob) file = URL.createObjectURL(file);
                const { files: files } = this;
                if (!files.includes(file)) this.files = [
                    ...files,
                    file
                ];
                return file;
            });
        }
        /**
             * Override this method for Network calling,
             * then call `super.delete(fileURL)` to update `this.files` array.
             */ delete(file) {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__awaiter(this, void 0, void 0, function*() {
                const { files: files } = this;
                const index = files.indexOf(file);
                this.files = [
                    ...files.slice(0, index),
                    ...files.slice(index + 1)
                ];
            });
        }
        move(sourceIndex, targetIndex) {
            const { files: files } = this;
            const sourceFile = files[sourceIndex], targetFile = files[targetIndex];
            const frontIndex = Math.min(sourceIndex, targetIndex), backIndex = Math.max(sourceIndex, targetIndex);
            const front = files.slice(0, frontIndex), middle = files.slice(frontIndex + 1, backIndex), back = files.slice(backIndex + 1);
            this.files = sourceIndex < targetIndex ? [
                ...front,
                ...middle,
                targetFile,
                sourceFile,
                ...back
            ] : [
                ...front,
                sourceFile,
                targetFile,
                ...middle,
                ...back
            ];
        }
        constructor(){
            _FileModel_files_accessor_storage.set(this, $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _files_initializers, []));
            $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _files_extraInitializers);
        }
    }, _FileModel_files_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _files_decorators = [
            (0, $d5I5D.observable)
        ];
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_a, null, _files_decorators, {
            kind: "accessor",
            name: "files",
            static: false,
            private: false,
            access: {
                has: (obj)=>"files" in obj,
                get: (obj)=>obj.files,
                set: (obj, value)=>{
                    obj.files = value;
                }
            },
            metadata: _metadata
        }, _files_initializers, _files_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
let $5131dddb90b74959$export$1a5cb5295a7d2749 = (()=>{
    var _FileUploader_accept_accessor_storage, _FileUploader_multiple_accessor_storage, _FileUploader_store_accessor_storage, _FileUploader_pickIndex_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'file-uploader',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$2a668e8d088a0667),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _accept_decorators;
    let _accept_initializers = [];
    let _accept_extraInitializers = [];
    let _multiple_decorators;
    let _multiple_initializers = [];
    let _multiple_extraInitializers = [];
    let _store_decorators;
    let _store_initializers = [];
    let _store_extraInitializers = [];
    let _pickIndex_decorators;
    let _pickIndex_initializers = [];
    let _pickIndex_extraInitializers = [];
    let _updateFiles_decorators;
    let _emitFiles_decorators;
    var FileUploader = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _FileUploader_accept_accessor_storage.set(this, ($5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _accept_initializers, '*/*')));
            _FileUploader_multiple_accessor_storage.set(this, ($5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _accept_extraInitializers), $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _multiple_initializers, false)));
            _FileUploader_store_accessor_storage.set(this, ($5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _multiple_extraInitializers), $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _store_initializers, void 0)));
            _FileUploader_pickIndex_accessor_storage.set(this, ($5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _store_extraInitializers), $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _pickIndex_initializers, void 0)));
            Object.defineProperty(this, "handleAdd", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(this, _pickIndex_extraInitializers), ()=>$5131dddb90b74959$var$$0abe00e20a7893a6$var$__awaiter(this, void 0, void 0, function*() {
                        const { accept: accept, multiple: multiple, store: store } = this;
                        const fileOption = accept.split(',').reduce((option, type)=>{
                            type = type.trim();
                            if (type.includes('/')) (option.mimeTypes || (option.mimeTypes = [])).push(type);
                            else (option.extensions || (option.extensions = [])).push(type);
                            return option;
                        }, {});
                        const files = (0, $8uN2z.makeArray)((yield (0, $e7fb5080ac3edd96$export$c1bd535e520dbbc3)(Object.assign({
                            multiple: multiple
                        }, fileOption))));
                        for (const file of files)yield store.upload(file);
                    }))
            });
            Object.defineProperty(this, "handleDrop", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (index)=>(event)=>{
                        event.preventDefault();
                        const { pickIndex: pickIndex } = this;
                        if (pickIndex != null) return this.props.store.move(pickIndex, index);
                    }
            });
            Object.defineProperty(this, "handleChange", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (oldURI = '')=>({ detail: { file: file } })=>{
                        const { store: store } = this;
                        if (oldURI) return store.delete(oldURI);
                        if (file) return store.upload(file);
                    }
            });
        }
        get accept() {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldGet(this, _FileUploader_accept_accessor_storage, "f");
        }
        set accept(value) {
            $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldSet(this, _FileUploader_accept_accessor_storage, value, "f");
        }
        get multiple() {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldGet(this, _FileUploader_multiple_accessor_storage, "f");
        }
        set multiple(value) {
            $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldSet(this, _FileUploader_multiple_accessor_storage, value, "f");
        }
        get store() {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldGet(this, _FileUploader_store_accessor_storage, "f");
        }
        set store(value) {
            $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldSet(this, _FileUploader_store_accessor_storage, value, "f");
        }
        get pickIndex() {
            return $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldGet(this, _FileUploader_pickIndex_accessor_storage, "f");
        }
        set pickIndex(value) {
            $5131dddb90b74959$var$$0abe00e20a7893a6$var$__classPrivateFieldSet(this, _FileUploader_pickIndex_accessor_storage, value, "f");
        }
        mountedCallback() {
            const { defaultValue: defaultValue, store: store } = this;
            store.files = defaultValue instanceof Array ? defaultValue : defaultValue ? [
                defaultValue
            ] : [];
        }
        updateFiles(value) {
            this.store.files = value instanceof Array ? value : value ? [
                value
            ] : [];
        }
        emitFiles(files) {
            if (files) {
                this.value = files[1] ? files : files[0];
                this.emit('change', [
                    ...files
                ]);
            }
        }
        renderContent() {
            const { accept: accept, multiple: multiple } = this, { files: files } = this.store;
            return (0, $bd1ed0d24b354858$exports.jsxs)("ol", {
                className: "list-inline d-flex m-0",
                onDragOver: (event)=>event.preventDefault(),
                children: [
                    files.map((file, index)=>(0, $bd1ed0d24b354858$exports.jsx)("li", {
                            className: "list-inline-item",
                            draggable: true,
                            onDragStart: ()=>this.pickIndex = index,
                            onDrop: this.handleDrop(index),
                            children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$54dc470bcc5c41d1, {
                                accept: accept,
                                value: file,
                                onChange: this.handleChange(file)
                            })
                        }, file)),
                    (multiple || !files[0]) && (0, $bd1ed0d24b354858$exports.jsx)("li", {
                        role: "button",
                        className: "list-inline-item border rounded d-flex justify-content-center align-items-center display-1",
                        style: {
                            width: '10rem',
                            height: '10rem'
                        },
                        onClick: this.handleAdd,
                        children: "+"
                    })
                ]
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
    };
    _FileUploader_accept_accessor_storage = new WeakMap();
    _FileUploader_multiple_accessor_storage = new WeakMap();
    _FileUploader_store_accessor_storage = new WeakMap();
    _FileUploader_pickIndex_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$0abe00e20a7893a6$var$__setFunctionName(_classThis, "FileUploader");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _accept_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _multiple_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _store_decorators = [
            (0, $d5I5D.observable)
        ];
        _pickIndex_decorators = [
            (0, $d5I5D.observable)
        ];
        _updateFiles_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ value: value })=>value)
        ];
        _emitFiles_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ store: store })=>store === null || store === void 0 ? void 0 : store.files)
        ];
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_classThis, null, _accept_decorators, {
            kind: "accessor",
            name: "accept",
            static: false,
            private: false,
            access: {
                has: (obj)=>"accept" in obj,
                get: (obj)=>obj.accept,
                set: (obj, value)=>{
                    obj.accept = value;
                }
            },
            metadata: _metadata
        }, _accept_initializers, _accept_extraInitializers);
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_classThis, null, _multiple_decorators, {
            kind: "accessor",
            name: "multiple",
            static: false,
            private: false,
            access: {
                has: (obj)=>"multiple" in obj,
                get: (obj)=>obj.multiple,
                set: (obj, value)=>{
                    obj.multiple = value;
                }
            },
            metadata: _metadata
        }, _multiple_initializers, _multiple_extraInitializers);
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_classThis, null, _store_decorators, {
            kind: "accessor",
            name: "store",
            static: false,
            private: false,
            access: {
                has: (obj)=>"store" in obj,
                get: (obj)=>obj.store,
                set: (obj, value)=>{
                    obj.store = value;
                }
            },
            metadata: _metadata
        }, _store_initializers, _store_extraInitializers);
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_classThis, null, _pickIndex_decorators, {
            kind: "accessor",
            name: "pickIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pickIndex" in obj,
                get: (obj)=>obj.pickIndex,
                set: (obj, value)=>{
                    obj.pickIndex = value;
                }
            },
            metadata: _metadata
        }, _pickIndex_initializers, _pickIndex_extraInitializers);
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_classThis, null, _updateFiles_decorators, {
            kind: "method",
            name: "updateFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateFiles" in obj,
                get: (obj)=>obj.updateFiles
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(_classThis, null, _emitFiles_decorators, {
            kind: "method",
            name: "emitFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"emitFiles" in obj,
                get: (obj)=>obj.emitFiles
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        FileUploader = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$0abe00e20a7893a6$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return FileUploader = _classThis;
})();
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a42a2ada6ce76173$exports, $5131dddb90b74959$var$$76979d798b5a3bd5$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a42a2ada6ce76173$exports, $5131dddb90b74959$var$$c1c7ccde32bca97a$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a42a2ada6ce76173$exports, $5131dddb90b74959$var$$d6a5aaf30399725f$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a42a2ada6ce76173$exports, $5131dddb90b74959$var$$9c6318c3d1f65d7e$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a42a2ada6ce76173$exports, $5131dddb90b74959$var$$c3a80fb16cbaf6ea$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a42a2ada6ce76173$exports, $5131dddb90b74959$var$$0abe00e20a7893a6$exports);
var $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$75c9fe32db446e0e$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5131dddb90b74959$export$6c415d1fdae3dfdb = (()=>{
    var _CodeBlock_name_accessor_storage, _CodeBlock_value_accessor_storage, _CodeBlock_language_accessor_storage, _CodeBlock_theme_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'code-block',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _language_decorators;
    let _language_initializers = [];
    let _language_extraInitializers = [];
    let _theme_decorators;
    let _theme_initializers = [];
    let _theme_extraInitializers = [];
    let _get_markup_decorators;
    let _get_dataURI_decorators;
    var CodeBlock = _classThis = class extends _classSuper {
        get name() {
            return $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldGet(this, _CodeBlock_name_accessor_storage, "f");
        }
        set name(value) {
            $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldSet(this, _CodeBlock_name_accessor_storage, value, "f");
        }
        get value() {
            return $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldGet(this, _CodeBlock_value_accessor_storage, "f");
        }
        set value(value) {
            $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldSet(this, _CodeBlock_value_accessor_storage, value, "f");
        }
        get language() {
            return $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldGet(this, _CodeBlock_language_accessor_storage, "f");
        }
        set language(value) {
            $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldSet(this, _CodeBlock_language_accessor_storage, value, "f");
        }
        get theme() {
            return $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldGet(this, _CodeBlock_theme_accessor_storage, "f");
        }
        set theme(value) {
            $5131dddb90b74959$var$$75c9fe32db446e0e$var$__classPrivateFieldSet(this, _CodeBlock_theme_accessor_storage, value, "f");
        }
        get markup() {
            const { value: value, language: language } = this;
            return value && language && (0, $4799ffc520052701$exports.highlight)(value, (0, $4799ffc520052701$exports.languages)[language], language);
        }
        get dataURI() {
            return URL.createObjectURL(new Blob([
                this.value
            ], {
                type: (0, $b0ca40bdc143287e$export$2e2bcd8739ae039).getType(this.name)
            }));
        }
        connectedCallback() {
            this.classList.add('d-block', 'bg-dark', 'rounded', 'p-3', 'position-relative');
        }
        render() {
            const { name: name, dataURI: dataURI, theme: theme, markup: markup } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: `https://unpkg.com/prismjs@1.29.0/themes/prism-${theme}.min.css`
                    }),
                    name && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c25acd513dcc8062, {
                        className: "position-absolute top-0 end-0",
                        variant: "warning",
                        name: "download",
                        download: name,
                        href: dataURI
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("pre", {
                        className: "m-0",
                        innerHTML: markup
                    })
                ]
            });
        }
        constructor(){
            super(...arguments);
            _CodeBlock_name_accessor_storage.set(this, ($5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _name_initializers, '')));
            _CodeBlock_value_accessor_storage.set(this, ($5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _name_extraInitializers), $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _value_initializers, '')));
            _CodeBlock_language_accessor_storage.set(this, ($5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _value_extraInitializers), $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _language_initializers, '')));
            _CodeBlock_theme_accessor_storage.set(this, ($5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _language_extraInitializers), $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _theme_initializers, 'okaidia')));
            $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(this, _theme_extraInitializers);
        }
    };
    _CodeBlock_name_accessor_storage = new WeakMap();
    _CodeBlock_value_accessor_storage = new WeakMap();
    _CodeBlock_language_accessor_storage = new WeakMap();
    _CodeBlock_theme_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$75c9fe32db446e0e$var$__setFunctionName(_classThis, "CodeBlock");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _name_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _value_decorators = [
            (0, $d5I5D.observable)
        ];
        _language_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _theme_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _get_markup_decorators = [
            (0, $d5I5D.computed)
        ];
        _get_dataURI_decorators = [
            (0, $d5I5D.computed)
        ];
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(_classThis, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"name" in obj,
                get: (obj)=>obj.name,
                set: (obj, value)=>{
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(_classThis, null, _value_decorators, {
            kind: "accessor",
            name: "value",
            static: false,
            private: false,
            access: {
                has: (obj)=>"value" in obj,
                get: (obj)=>obj.value,
                set: (obj, value)=>{
                    obj.value = value;
                }
            },
            metadata: _metadata
        }, _value_initializers, _value_extraInitializers);
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(_classThis, null, _language_decorators, {
            kind: "accessor",
            name: "language",
            static: false,
            private: false,
            access: {
                has: (obj)=>"language" in obj,
                get: (obj)=>obj.language,
                set: (obj, value)=>{
                    obj.language = value;
                }
            },
            metadata: _metadata
        }, _language_initializers, _language_extraInitializers);
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(_classThis, null, _theme_decorators, {
            kind: "accessor",
            name: "theme",
            static: false,
            private: false,
            access: {
                has: (obj)=>"theme" in obj,
                get: (obj)=>obj.theme,
                set: (obj, value)=>{
                    obj.theme = value;
                }
            },
            metadata: _metadata
        }, _theme_initializers, _theme_extraInitializers);
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(_classThis, null, _get_markup_decorators, {
            kind: "getter",
            name: "markup",
            static: false,
            private: false,
            access: {
                has: (obj)=>"markup" in obj,
                get: (obj)=>obj.markup
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(_classThis, null, _get_dataURI_decorators, {
            kind: "getter",
            name: "dataURI",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dataURI" in obj,
                get: (obj)=>obj.dataURI
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CodeBlock = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$75c9fe32db446e0e$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CodeBlock = _classThis;
})();
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$fe8695acb491e148$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$f7c1ec19aba15bac$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$fae440e6475ac9b3$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$748e31f0f7788c85$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$478aa14554285d4f$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$165c2960ea0ef6da$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$c630f4f8ebbb88df$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$d3445d44d351b213$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$a9c2f09022d17944$exports, $5131dddb90b74959$var$$75c9fe32db446e0e$exports);
var $5131dddb90b74959$var$$3f0c6c9020e942c5$exports = {};
var $5131dddb90b74959$var$$be58a6a40ab07fd2$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$be58a6a40ab07fd2$exports, "CarouselItem", function() {
    return $5131dddb90b74959$export$42c20acb2971398c;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$be58a6a40ab07fd2$exports, "CarouselCaption", function() {
    return $5131dddb90b74959$export$a81c9b47f1cf1e63;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$be58a6a40ab07fd2$exports, "Carousel", function() {
    return $5131dddb90b74959$export$144901db2ea8e967;
});
var $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$42c20acb2971398c = (_a)=>{
    var { className: className = '', interval: interval, children: children } = _a, props = $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__rest(_a, [
        "className",
        "interval",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `carousel-item ${className}`
    }, props, {
        "data-bs-interval": interval,
        children: children
    }));
};
const $5131dddb90b74959$export$a81c9b47f1cf1e63 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: `carousel-caption ${className}`
    }, props, {
        children: children
    }));
};
let $5131dddb90b74959$export$144901db2ea8e967 = (()=>{
    var _Carousel_interval_accessor_storage, _Carousel_itemMeta_accessor_storage, _Carousel_currentIndex_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'carousel-box',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _interval_decorators;
    let _interval_initializers = [];
    let _interval_extraInitializers = [];
    let _itemMeta_decorators;
    let _itemMeta_initializers = [];
    let _itemMeta_extraInitializers = [];
    let _currentIndex_decorators;
    let _currentIndex_initializers = [];
    let _currentIndex_extraInitializers = [];
    let _handleButtonClick_decorators;
    let _handleButtonPress_decorators;
    let _handleIndicatorsButtonClick_decorators;
    let _handleIndicatorsButtonPress_decorators;
    let _handleActiveItem_decorators;
    var Carousel = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _Carousel_interval_accessor_storage.set(this, ($5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _interval_initializers, void 0)));
            _Carousel_itemMeta_accessor_storage.set(this, ($5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _interval_extraInitializers), $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _itemMeta_initializers, [])));
            _Carousel_currentIndex_accessor_storage.set(this, ($5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _itemMeta_extraInitializers), $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _currentIndex_initializers, 0)));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(this, _currentIndex_extraInitializers)
            });
        }
        get interval() {
            return $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_interval_accessor_storage, "f");
        }
        set interval(value) {
            $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_interval_accessor_storage, value, "f");
        }
        get itemMeta() {
            return $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_itemMeta_accessor_storage, "f");
        }
        set itemMeta(value) {
            $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_itemMeta_accessor_storage, value, "f");
        }
        get currentIndex() {
            return $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldGet(this, _Carousel_currentIndex_accessor_storage, "f");
        }
        set currentIndex(value) {
            $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__classPrivateFieldSet(this, _Carousel_currentIndex_accessor_storage, value, "f");
        }
        connectedCallback() {
            if (this.interval) this.timer || (this.timer = window.setInterval(()=>this.turnByOffset(1), this.interval));
            else this.handleActiveItem(this.currentIndex);
        }
        disconnectedCallback() {
            clearInterval(this.timer);
        }
        mountedCallback() {
            const items = [
                ...this.querySelectorAll('.carousel-item')
            ];
            if (this.itemMeta.length !== items.length) this.itemMeta = items.map((item)=>{
                var _a;
                return {
                    caption: (((_a = item.querySelector('.carousel-caption')) === null || _a === void 0 ? void 0 : _a.textContent) || item.textContent).trim()
                };
            });
        }
        turnByOffset(delta) {
            this.currentIndex = (this.currentIndex + delta) % this.itemMeta.length;
        }
        handleButtonClick(_, { dataset: dataset }) {
            this.turnByOffset(dataset.bsSlide === 'next' ? 1 : -1);
        }
        handleButtonPress({ key: key }, { dataset: dataset }) {
            if (key === 'Enter') this.turnByOffset(dataset.bsSlide === 'next' ? 1 : -1);
        }
        handleIndicatorsButtonClick(_, { dataset: dataset }) {
            this.currentIndex = +dataset.bsSlideTo;
        }
        handleIndicatorsButtonPress({ key: key }, { dataset: dataset }) {
            if (key === 'Enter') this.currentIndex = +dataset.bsSlideTo;
        }
        handleActiveItem(currentIndex) {
            var _a;
            (_a = this.querySelector('.carousel-item.active')) === null || _a === void 0 || _a.classList.remove('active');
            this.children[currentIndex].classList.add('active');
        }
        renderContent() {
            const { itemMeta: itemMeta, currentIndex: currentIndex } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)("div", {
                className: "carousel",
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "carousel-indicators",
                        children: itemMeta.map(({ caption: caption }, index)=>(0, $bd1ed0d24b354858$exports.jsx)("button", {
                                type: "button",
                                ariaLabel: caption,
                                "data-bs-slide-to": index,
                                className: currentIndex === index ? 'active' : '',
                                ariaCurrent: currentIndex === index ? 'true' : ''
                            }))
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "carousel-inner",
                        children: (0, $bd1ed0d24b354858$exports.jsx)("slot", {})
                    }),
                    (0, $bd1ed0d24b354858$exports.jsxs)("button", {
                        type: "button",
                        className: "carousel-control-prev",
                        "data-bs-slide": "prev",
                        children: [
                            (0, $bd1ed0d24b354858$exports.jsx)("span", {
                                className: "carousel-control-prev-icon",
                                ariaHidden: "true"
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: "-1"
                            })
                        ]
                    }),
                    (0, $bd1ed0d24b354858$exports.jsxs)("button", {
                        type: "button",
                        className: "carousel-control-next",
                        "data-bs-slide": "next",
                        children: [
                            (0, $bd1ed0d24b354858$exports.jsx)("span", {
                                className: "carousel-control-next-icon",
                                ariaHidden: "true"
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("span", {
                                className: "visually-hidden",
                                children: "+1"
                            })
                        ]
                    })
                ]
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
    };
    _Carousel_interval_accessor_storage = new WeakMap();
    _Carousel_itemMeta_accessor_storage = new WeakMap();
    _Carousel_currentIndex_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__setFunctionName(_classThis, "Carousel");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _interval_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _itemMeta_decorators = [
            (0, $d5I5D.observable)
        ];
        _currentIndex_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _handleButtonClick_decorators = [
            (0, $6f83f77ba8e7af5c$export$af631764ddc44097)('click', '.carousel > button')
        ];
        _handleButtonPress_decorators = [
            (0, $6f83f77ba8e7af5c$export$af631764ddc44097)('keyup', '.carousel > button')
        ];
        _handleIndicatorsButtonClick_decorators = [
            (0, $6f83f77ba8e7af5c$export$af631764ddc44097)('click', '.carousel-indicators button')
        ];
        _handleIndicatorsButtonPress_decorators = [
            (0, $6f83f77ba8e7af5c$export$af631764ddc44097)('keyup', '.carousel-indicators button')
        ];
        _handleActiveItem_decorators = [
            (0, $6f83f77ba8e7af5c$export$7203b476385689ae)(({ currentIndex: currentIndex })=>currentIndex)
        ];
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _interval_decorators, {
            kind: "accessor",
            name: "interval",
            static: false,
            private: false,
            access: {
                has: (obj)=>"interval" in obj,
                get: (obj)=>obj.interval,
                set: (obj, value)=>{
                    obj.interval = value;
                }
            },
            metadata: _metadata
        }, _interval_initializers, _interval_extraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _itemMeta_decorators, {
            kind: "accessor",
            name: "itemMeta",
            static: false,
            private: false,
            access: {
                has: (obj)=>"itemMeta" in obj,
                get: (obj)=>obj.itemMeta,
                set: (obj, value)=>{
                    obj.itemMeta = value;
                }
            },
            metadata: _metadata
        }, _itemMeta_initializers, _itemMeta_extraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _currentIndex_decorators, {
            kind: "accessor",
            name: "currentIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentIndex" in obj,
                get: (obj)=>obj.currentIndex,
                set: (obj, value)=>{
                    obj.currentIndex = value;
                }
            },
            metadata: _metadata
        }, _currentIndex_initializers, _currentIndex_extraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleButtonClick_decorators, {
            kind: "method",
            name: "handleButtonClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleButtonClick" in obj,
                get: (obj)=>obj.handleButtonClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleButtonPress_decorators, {
            kind: "method",
            name: "handleButtonPress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleButtonPress" in obj,
                get: (obj)=>obj.handleButtonPress
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleIndicatorsButtonClick_decorators, {
            kind: "method",
            name: "handleIndicatorsButtonClick",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleIndicatorsButtonClick" in obj,
                get: (obj)=>obj.handleIndicatorsButtonClick
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleIndicatorsButtonPress_decorators, {
            kind: "method",
            name: "handleIndicatorsButtonPress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleIndicatorsButtonPress" in obj,
                get: (obj)=>obj.handleIndicatorsButtonPress
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(_classThis, null, _handleActiveItem_decorators, {
            kind: "method",
            name: "handleActiveItem",
            static: false,
            private: false,
            access: {
                has: (obj)=>"handleActiveItem" in obj,
                get: (obj)=>obj.handleActiveItem
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        Carousel = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$be58a6a40ab07fd2$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return Carousel = _classThis;
})();
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$3f0c6c9020e942c5$exports, $5131dddb90b74959$var$$6e5adc7420b5d0fd$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$3f0c6c9020e942c5$exports, $5131dddb90b74959$var$$1134373d0203fdc7$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$3f0c6c9020e942c5$exports, $5131dddb90b74959$var$$9b9a8463439bada6$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$3f0c6c9020e942c5$exports, $5131dddb90b74959$var$$be58a6a40ab07fd2$exports);
var $5131dddb90b74959$var$$dee4b36d061f65d2$exports = {};
var $5131dddb90b74959$var$$f8620c7b06d525b8$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f8620c7b06d525b8$exports, "BreadCrumb", function() {
    return $5131dddb90b74959$export$717fd9b2f8e29b80;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f8620c7b06d525b8$exports, "BreadcrumbItem", function() {
    return $5131dddb90b74959$export$c13f210c706eb549;
});
var $5131dddb90b74959$var$$f8620c7b06d525b8$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$717fd9b2f8e29b80 = (_a)=>{
    var { children: children } = _a, props = $5131dddb90b74959$var$$f8620c7b06d525b8$var$__rest(_a, [
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("nav", Object.assign({}, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("ol", {
            className: "breadcrumb",
            children: children
        })
    }));
};
const $5131dddb90b74959$export$c13f210c706eb549 = (_a)=>{
    var { className: className = '', href: href, target: target, active: active, children: children } = _a, props = $5131dddb90b74959$var$$f8620c7b06d525b8$var$__rest(_a, [
        "className",
        "href",
        "target",
        "active",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("li", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('breadcrumb-item', {
            active: active
        }, className),
        ariaCurrent: active ? 'page' : undefined
    }, props, {
        children: active ? children : (0, $bd1ed0d24b354858$exports.jsx)("a", {
            href: href,
            target: target,
            children: children
        })
    }));
};
var $5131dddb90b74959$var$$82d51464abe3476f$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$82d51464abe3476f$exports, "Pagination", function() {
    return $5131dddb90b74959$export$68f5e1453c188a82;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$82d51464abe3476f$exports, "PaginationItem", function() {
    return $5131dddb90b74959$export$c82a077939f0464b;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$82d51464abe3476f$exports, "Pager", function() {
    return $5131dddb90b74959$export$57625d62e5386b09;
});
var $5131dddb90b74959$var$$82d51464abe3476f$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$68f5e1453c188a82 = (_a)=>{
    var { size: size, children: children } = _a, props = $5131dddb90b74959$var$$82d51464abe3476f$var$__rest(_a, [
        "size",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("nav", Object.assign({}, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("ol", {
            className: `m-0 pagination ${size ? `pagination-${size}` : ''}`,
            children: children
        })
    }));
};
const $5131dddb90b74959$export$c82a077939f0464b = (_a)=>{
    var { className: className, href: href, active: active, disabled: disabled, children: children } = _a, props = $5131dddb90b74959$var$$82d51464abe3476f$var$__rest(_a, [
        "className",
        "href",
        "active",
        "disabled",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("li", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('page-item', {
            active: active,
            disabled: disabled
        }, className),
        ariaCurrent: active ? 'page' : undefined
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("a", {
            className: "page-link",
            href: href,
            children: children
        })
    }));
};
const $5131dddb90b74959$export$57625d62e5386b09 = ({ pageSize: pageSize, pageIndex: pageIndex, pageCount: pageCount, onChange: onChange })=>{
    function propsOf(pageIndex = 1) {
        const pagination = {
            pageSize: pageSize,
            pageIndex: pageIndex
        };
        return {
            href: `?${(0, $8uN2z.buildURLData)(Object.assign(Object.assign({}, (0, $8uN2z.parseURLData)()), pagination))}`,
            onClick: onChange && ((event)=>{
                event.preventDefault();
                onChange(pagination);
            })
        };
    }
    return (0, $bd1ed0d24b354858$exports.jsxs)("form", {
        className: "m-0 d-flex align-items-center gap-2",
        onSubmit: onChange && ((event)=>event.preventDefault()),
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$fe5d99d8691b3f62, {
                type: "number",
                name: "pageSize",
                defaultValue: pageSize,
                min: 1,
                required: true,
                onChange: ({ currentTarget: currentTarget })=>{
                    const input = currentTarget;
                    input.reportValidity();
                    onChange === null || onChange === void 0 || onChange({
                        pageSize: +input.value,
                        pageIndex: pageIndex
                    });
                }
            }),
            "x",
            (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$fe5d99d8691b3f62, {
                type: "number",
                name: "pageIndex",
                defaultValue: pageIndex || 1,
                min: 1,
                max: pageCount,
                required: true,
                onChange: ({ currentTarget: currentTarget })=>{
                    const input = currentTarget;
                    input.reportValidity();
                    onChange === null || onChange === void 0 || onChange({
                        pageSize: pageSize,
                        pageIndex: +input.value
                    });
                }
            }),
            (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$68f5e1453c188a82, {
                children: [
                    pageIndex > 1 && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, Object.assign({}, propsOf(1), {
                        children: "1"
                    })),
                    pageIndex > 3 && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, {
                        children: "..."
                    }),
                    pageIndex > 2 && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, Object.assign({}, propsOf(pageIndex - 1), {
                        children: pageIndex - 1
                    })),
                    (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, {
                        active: true,
                        children: pageIndex
                    }),
                    pageCount - pageIndex > 1 && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, Object.assign({}, propsOf(pageIndex + 1), {
                        children: pageIndex + 1
                    })),
                    pageCount - pageIndex > 2 && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, {
                        children: "..."
                    }),
                    pageIndex < pageCount && (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c82a077939f0464b, Object.assign({}, propsOf(pageCount), {
                        children: pageCount
                    }))
                ]
            })
        ]
    });
};
var $5131dddb90b74959$var$$97590922d21716c6$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$97590922d21716c6$exports, "NavbarBrand", function() {
    return $5131dddb90b74959$export$2df9f3e5f6d355f6;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$97590922d21716c6$exports, "NavbarToggle", function() {
    return $5131dddb90b74959$export$e018030c18c7f90a;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$97590922d21716c6$exports, "Navbar", function() {
    return $5131dddb90b74959$export$42cfbb80f7861e77;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$97590922d21716c6$exports, "OffcanvasNavbar", function() {
    return $5131dddb90b74959$export$d31319d8cbfdaf50;
});
var $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$97590922d21716c6$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $5131dddb90b74959$var$$97590922d21716c6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5131dddb90b74959$export$2df9f3e5f6d355f6 = (_a)=>{
    var { className: className = '', children: children } = _a, props = $5131dddb90b74959$var$$97590922d21716c6$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("a", Object.assign({
        className: `navbar-brand ${className}`
    }, props, {
        children: children
    }));
};
const $5131dddb90b74959$export$e018030c18c7f90a = (_a)=>{
    var { className: className = '', type: type, children: children } = _a, props = $5131dddb90b74959$var$$97590922d21716c6$var$__rest(_a, [
        "className",
        "type",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("button", Object.assign({
        className: `navbar-toggler ${className}`,
        type: "button"
    }, props, {
        children: (0, $bd1ed0d24b354858$exports.jsx)("span", {
            className: "navbar-toggler-icon"
        })
    }));
};
const $5131dddb90b74959$export$42cfbb80f7861e77 = ({ variant: variant = 'light', bg: bg = 'body-tertiary', fixed: fixed, sticky: sticky, expand: expand, children: children })=>(0, $bd1ed0d24b354858$exports.jsx)("nav", {
        className: `navbar bg-${bg} ${fixed ? `fixed-${fixed}` : ''} ${sticky ? `sticky-${sticky}` : ''} ${expand ? `navbar-expand${expand === true ? '' : `-${expand}`}` : ''}`,
        "data-bs-theme": variant,
        children: children
    });
let $5131dddb90b74959$export$d31319d8cbfdaf50 = (()=>{
    var _OffcanvasNavbar_variant_accessor_storage, _OffcanvasNavbar_bg_accessor_storage, _OffcanvasNavbar_expand_accessor_storage, _OffcanvasNavbar_fixed_accessor_storage, _OffcanvasNavbar_sticky_accessor_storage, _OffcanvasNavbar_fluid_accessor_storage, _OffcanvasNavbar_title_accessor_storage, _OffcanvasNavbar_brand_accessor_storage, _OffcanvasNavbar_open_accessor_storage, _OffcanvasNavbar_closeButton_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'offcanvas-navbar',
            mode: 'open'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _bg_decorators;
    let _bg_initializers = [];
    let _bg_extraInitializers = [];
    let _expand_decorators;
    let _expand_initializers = [];
    let _expand_extraInitializers = [];
    let _fixed_decorators;
    let _fixed_initializers = [];
    let _fixed_extraInitializers = [];
    let _sticky_decorators;
    let _sticky_initializers = [];
    let _sticky_extraInitializers = [];
    let _fluid_decorators;
    let _fluid_initializers = [];
    let _fluid_extraInitializers = [];
    let _title_decorators;
    let _title_initializers = [];
    let _title_extraInitializers = [];
    let _brand_decorators;
    let _brand_initializers = [];
    let _brand_extraInitializers = [];
    let _open_decorators;
    let _open_initializers = [];
    let _open_extraInitializers = [];
    let _closeButton_decorators;
    let _closeButton_initializers = [];
    let _closeButton_extraInitializers = [];
    var OffcanvasNavbar = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _OffcanvasNavbar_variant_accessor_storage.set(this, $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _variant_initializers, void 0));
            _OffcanvasNavbar_bg_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _variant_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _bg_initializers, void 0)));
            _OffcanvasNavbar_expand_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _bg_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _expand_initializers, void 0)));
            _OffcanvasNavbar_fixed_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _expand_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _fixed_initializers, void 0)));
            _OffcanvasNavbar_sticky_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _fixed_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _sticky_initializers, void 0)));
            _OffcanvasNavbar_fluid_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _sticky_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _fluid_initializers, void 0)));
            _OffcanvasNavbar_title_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _fluid_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _title_initializers, void 0)));
            Object.defineProperty(this, "titleId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _title_extraInitializers), (0, $8uN2z.uniqueID)())
            });
            _OffcanvasNavbar_brand_accessor_storage.set(this, $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _brand_initializers, void 0));
            Object.defineProperty(this, "offcanvasId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _brand_extraInitializers), (0, $8uN2z.uniqueID)())
            });
            _OffcanvasNavbar_open_accessor_storage.set(this, $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _open_initializers, false));
            _OffcanvasNavbar_closeButton_accessor_storage.set(this, ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _open_extraInitializers), $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _closeButton_initializers, true)));
            Object.defineProperty(this, "close", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(this, _closeButton_extraInitializers), (event)=>{
                    if (event instanceof KeyboardEvent && ![
                        'Escape',
                        'Enter'
                    ].includes(event.key)) return;
                    this.open = false;
                })
            });
            Object.defineProperty(this, "handleLink", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (0, $8uN2z.delegate)('a[href].nav-link', this.close)
            });
        }
        get variant() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_variant_accessor_storage, "f");
        }
        set variant(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_variant_accessor_storage, value, "f");
        }
        get bg() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_bg_accessor_storage, "f");
        }
        set bg(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_bg_accessor_storage, value, "f");
        }
        get expand() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_expand_accessor_storage, "f");
        }
        set expand(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_expand_accessor_storage, value, "f");
        }
        get fixed() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_fixed_accessor_storage, "f");
        }
        set fixed(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_fixed_accessor_storage, value, "f");
        }
        get sticky() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_sticky_accessor_storage, "f");
        }
        set sticky(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_sticky_accessor_storage, value, "f");
        }
        get fluid() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_fluid_accessor_storage, "f");
        }
        set fluid(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_fluid_accessor_storage, value, "f");
        }
        get title() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_title_accessor_storage, "f");
        }
        set title(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_title_accessor_storage, value, "f");
        }
        get brand() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_brand_accessor_storage, "f");
        }
        set brand(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_brand_accessor_storage, value, "f");
        }
        get open() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_open_accessor_storage, "f");
        }
        set open(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_open_accessor_storage, value, "f");
        }
        get closeButton() {
            return $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldGet(this, _OffcanvasNavbar_closeButton_accessor_storage, "f");
        }
        set closeButton(value) {
            $5131dddb90b74959$var$$97590922d21716c6$var$__classPrivateFieldSet(this, _OffcanvasNavbar_closeButton_accessor_storage, value, "f");
        }
        connectedCallback() {
            var _a;
            (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'keyup', this.close, true);
            this.addEventListener('click', this.handleLink);
        }
        disconnectedCallback() {
            var _a;
            (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'keyup', this.close, true);
            this.addEventListener('click', this.handleLink);
        }
        renderContent() {
            const { variant: variant, bg: bg, expand: expand, fixed: fixed, sticky: sticky, fluid: fluid, brand: brand } = this, { title: title, titleId: titleId, offcanvasId: offcanvasId, open: open, closeButton: closeButton } = this;
            return (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$42cfbb80f7861e77, {
                variant: variant,
                bg: bg,
                expand: expand,
                fixed: fixed,
                sticky: sticky,
                children: (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$42a852a2b6b56249, {
                    fluid: fluid,
                    children: [
                        brand || title,
                        (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$e018030c18c7f90a, {
                            "aria-controls": offcanvasId,
                            ariaLabel: "Toggle navigation",
                            onClick: ()=>this.open = true
                        }),
                        (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$591ca0244c9dfcd4, {
                            id: offcanvasId,
                            "aria-labelledby": titleId,
                            show: open,
                            onHide: this.close,
                            children: [
                                (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$b6c1518fb8dc5e75, {
                                    closeButton: closeButton,
                                    onHide: ()=>this.open = false,
                                    children: (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$1b33297d19c3da30, {
                                        id: titleId,
                                        children: brand || title
                                    })
                                }),
                                (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$c324d20ecc5b7dee, {
                                    children: (0, $bd1ed0d24b354858$exports.jsx)("slot", {})
                                })
                            ]
                        })
                    ]
                })
            });
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/bootstrap@5.3.3/dist/css/bootstrap.min.css"
                    }),
                    this.renderContent()
                ]
            });
        }
    };
    _OffcanvasNavbar_variant_accessor_storage = new WeakMap();
    _OffcanvasNavbar_bg_accessor_storage = new WeakMap();
    _OffcanvasNavbar_expand_accessor_storage = new WeakMap();
    _OffcanvasNavbar_fixed_accessor_storage = new WeakMap();
    _OffcanvasNavbar_sticky_accessor_storage = new WeakMap();
    _OffcanvasNavbar_fluid_accessor_storage = new WeakMap();
    _OffcanvasNavbar_title_accessor_storage = new WeakMap();
    _OffcanvasNavbar_brand_accessor_storage = new WeakMap();
    _OffcanvasNavbar_open_accessor_storage = new WeakMap();
    _OffcanvasNavbar_closeButton_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$97590922d21716c6$var$__setFunctionName(_classThis, "OffcanvasNavbar");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _bg_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _expand_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _fixed_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _sticky_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _fluid_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _title_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _brand_decorators = [
            (0, $d5I5D.observable)
        ];
        _open_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _closeButton_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _bg_decorators, {
            kind: "accessor",
            name: "bg",
            static: false,
            private: false,
            access: {
                has: (obj)=>"bg" in obj,
                get: (obj)=>obj.bg,
                set: (obj, value)=>{
                    obj.bg = value;
                }
            },
            metadata: _metadata
        }, _bg_initializers, _bg_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _expand_decorators, {
            kind: "accessor",
            name: "expand",
            static: false,
            private: false,
            access: {
                has: (obj)=>"expand" in obj,
                get: (obj)=>obj.expand,
                set: (obj, value)=>{
                    obj.expand = value;
                }
            },
            metadata: _metadata
        }, _expand_initializers, _expand_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _fixed_decorators, {
            kind: "accessor",
            name: "fixed",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fixed" in obj,
                get: (obj)=>obj.fixed,
                set: (obj, value)=>{
                    obj.fixed = value;
                }
            },
            metadata: _metadata
        }, _fixed_initializers, _fixed_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _sticky_decorators, {
            kind: "accessor",
            name: "sticky",
            static: false,
            private: false,
            access: {
                has: (obj)=>"sticky" in obj,
                get: (obj)=>obj.sticky,
                set: (obj, value)=>{
                    obj.sticky = value;
                }
            },
            metadata: _metadata
        }, _sticky_initializers, _sticky_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _fluid_decorators, {
            kind: "accessor",
            name: "fluid",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fluid" in obj,
                get: (obj)=>obj.fluid,
                set: (obj, value)=>{
                    obj.fluid = value;
                }
            },
            metadata: _metadata
        }, _fluid_initializers, _fluid_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _title_decorators, {
            kind: "accessor",
            name: "title",
            static: false,
            private: false,
            access: {
                has: (obj)=>"title" in obj,
                get: (obj)=>obj.title,
                set: (obj, value)=>{
                    obj.title = value;
                }
            },
            metadata: _metadata
        }, _title_initializers, _title_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _brand_decorators, {
            kind: "accessor",
            name: "brand",
            static: false,
            private: false,
            access: {
                has: (obj)=>"brand" in obj,
                get: (obj)=>obj.brand,
                set: (obj, value)=>{
                    obj.brand = value;
                }
            },
            metadata: _metadata
        }, _brand_initializers, _brand_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _open_decorators, {
            kind: "accessor",
            name: "open",
            static: false,
            private: false,
            access: {
                has: (obj)=>"open" in obj,
                get: (obj)=>obj.open,
                set: (obj, value)=>{
                    obj.open = value;
                }
            },
            metadata: _metadata
        }, _open_initializers, _open_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(_classThis, null, _closeButton_decorators, {
            kind: "accessor",
            name: "closeButton",
            static: false,
            private: false,
            access: {
                has: (obj)=>"closeButton" in obj,
                get: (obj)=>obj.closeButton,
                set: (obj, value)=>{
                    obj.closeButton = value;
                }
            },
            metadata: _metadata
        }, _closeButton_initializers, _closeButton_extraInitializers);
        $5131dddb90b74959$var$$97590922d21716c6$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        OffcanvasNavbar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$97590922d21716c6$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return OffcanvasNavbar = _classThis;
})();
var $5131dddb90b74959$var$$f46ab18e0f9863a8$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f46ab18e0f9863a8$exports, "Step", function() {
    return $5131dddb90b74959$export$fd55ce593607084a;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f46ab18e0f9863a8$exports, "isStep", function() {
    return $5131dddb90b74959$export$21684750287da054;
});
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$f46ab18e0f9863a8$exports, "Stepper", function() {
    return $5131dddb90b74959$export$ed8ca599049e8881;
});
var $5131dddb90b74959$var$$f46ab18e0f9863a8$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $5131dddb90b74959$export$fd55ce593607084a(_a) {
    var { active: active, disabled: disabled, icon: icon, children: defaultSlot } = _a, rest = $5131dddb90b74959$var$$f46ab18e0f9863a8$var$__rest(_a, [
        "active",
        "disabled",
        "icon",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('step', {
            active: active
        })
    }, rest, {
        children: (0, $bd1ed0d24b354858$exports.jsxs)("button", {
            type: "button",
            className: "step-trigger",
            disabled: disabled,
            role: "tab",
            ariaSelected: !!active + '',
            children: [
                (0, $bd1ed0d24b354858$exports.jsx)("span", {
                    className: "bs-stepper-circle",
                    children: icon
                }),
                defaultSlot[0] && (0, $bd1ed0d24b354858$exports.jsx)("span", {
                    className: "bs-stepper-label",
                    children: defaultSlot
                })
            ]
        })
    }));
}
function $5131dddb90b74959$export$21684750287da054(node) {
    var _a, _b;
    return (_b = (_a = node.props) === null || _a === void 0 ? void 0 : _a.className) === null || _b === void 0 ? void 0 : _b.split(/\s+/).includes('step');
}
function $5131dddb90b74959$export$ed8ca599049e8881(_a) {
    var { className: className, children: children } = _a, rest = $5131dddb90b74959$var$$f46ab18e0f9863a8$var$__rest(_a, [
        "className",
        "children"
    ]);
    return (0, $bd1ed0d24b354858$exports.jsx)("nav", Object.assign({}, rest, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('bs-stepper-header', className),
        children: children.map((node, index)=>(0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    !!index && (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "line"
                    }),
                    node
                ]
            }))
    }));
}
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$dee4b36d061f65d2$exports, $5131dddb90b74959$var$$f8620c7b06d525b8$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$dee4b36d061f65d2$exports, $5131dddb90b74959$var$$82d51464abe3476f$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$dee4b36d061f65d2$exports, $5131dddb90b74959$var$$ac181fb217a2566a$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$dee4b36d061f65d2$exports, $5131dddb90b74959$var$$97590922d21716c6$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$dee4b36d061f65d2$exports, $5131dddb90b74959$var$$f46ab18e0f9863a8$exports);
$5131dddb90b74959$var$$parcel$exportWildcard($5131dddb90b74959$var$$dee4b36d061f65d2$exports, $5131dddb90b74959$var$$ecf67e051fd0aa49$exports);
var $5131dddb90b74959$var$$0ebd9548c1f64027$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$0ebd9548c1f64027$exports, "CountDown", function() {
    return $5131dddb90b74959$export$ddd3857461e99bb8;
});
var $5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$0ebd9548c1f64027$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$0ebd9548c1f64027$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $5131dddb90b74959$var$$0ebd9548c1f64027$var$colors = Object.keys($5131dddb90b74959$export$96e9906d6d93a972).filter((color)=>color !== 'tertiary').slice(0, 4);
let $5131dddb90b74959$export$ddd3857461e99bb8 = (()=>{
    var _CountDown_endTime_accessor_storage, _CountDown_rest_accessor_storage, _CountDown_units_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'count-down'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _endTime_decorators;
    let _endTime_initializers = [];
    let _endTime_extraInitializers = [];
    let _rest_decorators;
    let _rest_initializers = [];
    let _rest_extraInitializers = [];
    let _units_decorators;
    let _units_initializers = [];
    let _units_extraInitializers = [];
    let _get_timeSections_decorators;
    var CountDown = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _CountDown_endTime_accessor_storage.set(this, ($5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _endTime_initializers, Date.now())));
            _CountDown_rest_accessor_storage.set(this, ($5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _endTime_extraInitializers), $5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _rest_initializers, 0)));
            _CountDown_units_accessor_storage.set(this, ($5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _rest_extraInitializers), $5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _units_initializers, [
                {
                    scale: 24,
                    label: 'D'
                },
                {
                    scale: 60,
                    label: 'h'
                },
                {
                    scale: 60,
                    label: 'm'
                },
                {
                    scale: 1000,
                    label: 's'
                }
            ])));
            Object.defineProperty(this, "timer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(this, _units_extraInitializers)
            });
            Object.defineProperty(this, "tick", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    const rest = this.endTime - Date.now();
                    if (rest > 0) {
                        this.rest = rest;
                        if (!this.timer) this.timer = self.setInterval(this.tick, 1000);
                    } else if (this.timer) clearInterval(this.timer);
                }
            });
        }
        get endTime() {
            return $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_endTime_accessor_storage, "f");
        }
        set endTime(value) {
            $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_endTime_accessor_storage, value, "f");
        }
        get rest() {
            return $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_rest_accessor_storage, "f");
        }
        set rest(value) {
            $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_rest_accessor_storage, value, "f");
        }
        get units() {
            return $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldGet(this, _CountDown_units_accessor_storage, "f");
        }
        set units(value) {
            $5131dddb90b74959$var$$0ebd9548c1f64027$var$__classPrivateFieldSet(this, _CountDown_units_accessor_storage, value, "f");
        }
        get timeSections() {
            var { rest: rest } = this;
            return this.units.reduce((list, { label: label }, index, units)=>{
                const scale = units.slice(index).map(({ scale: scale })=>scale).reduce((sum, scale)=>sum * scale, 1);
                const value = ~~(rest / scale);
                rest -= value * scale;
                list.push({
                    value: value,
                    label: label
                });
                return list;
            }, []);
        }
        mountedCallback() {
            if (typeof this.endTime !== 'number') this.endTime = new Date(this.endTime).valueOf();
            this.tick();
        }
        disconnectedCallback() {
            clearInterval(this.timer);
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsx)("ol", {
                className: "list-inline text-white",
                children: this.timeSections.map(({ value: value, label: label }, index)=>(0, $bd1ed0d24b354858$exports.jsx)("li", {
                        className: `list-inline-item fs-1 bg-${$5131dddb90b74959$var$$0ebd9548c1f64027$var$colors[index]} d-inline-flex align-items-center justify-content-center rounded-4`,
                        style: {
                            width: '5.5rem',
                            height: '5.5rem'
                        },
                        children: (0, $bd1ed0d24b354858$exports.jsxs)("small", {
                            children: [
                                (value + '').padStart(2, '0'),
                                (0, $bd1ed0d24b354858$exports.jsx)("sub", {
                                    children: label
                                })
                            ]
                        })
                    }, label))
            });
        }
    };
    _CountDown_endTime_accessor_storage = new WeakMap();
    _CountDown_rest_accessor_storage = new WeakMap();
    _CountDown_units_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$0ebd9548c1f64027$var$__setFunctionName(_classThis, "CountDown");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _endTime_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _rest_decorators = [
            (0, $d5I5D.observable)
        ];
        _units_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_timeSections_decorators = [
            (0, $d5I5D.computed)
        ];
        $5131dddb90b74959$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _endTime_decorators, {
            kind: "accessor",
            name: "endTime",
            static: false,
            private: false,
            access: {
                has: (obj)=>"endTime" in obj,
                get: (obj)=>obj.endTime,
                set: (obj, value)=>{
                    obj.endTime = value;
                }
            },
            metadata: _metadata
        }, _endTime_initializers, _endTime_extraInitializers);
        $5131dddb90b74959$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _rest_decorators, {
            kind: "accessor",
            name: "rest",
            static: false,
            private: false,
            access: {
                has: (obj)=>"rest" in obj,
                get: (obj)=>obj.rest,
                set: (obj, value)=>{
                    obj.rest = value;
                }
            },
            metadata: _metadata
        }, _rest_initializers, _rest_extraInitializers);
        $5131dddb90b74959$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _units_decorators, {
            kind: "accessor",
            name: "units",
            static: false,
            private: false,
            access: {
                has: (obj)=>"units" in obj,
                get: (obj)=>obj.units,
                set: (obj, value)=>{
                    obj.units = value;
                }
            },
            metadata: _metadata
        }, _units_initializers, _units_extraInitializers);
        $5131dddb90b74959$var$$0ebd9548c1f64027$var$__esDecorate(_classThis, null, _get_timeSections_decorators, {
            kind: "getter",
            name: "timeSections",
            static: false,
            private: false,
            access: {
                has: (obj)=>"timeSections" in obj,
                get: (obj)=>obj.timeSections
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$0ebd9548c1f64027$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        CountDown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$0ebd9548c1f64027$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return CountDown = _classThis;
})();
var $5131dddb90b74959$var$$833abb125114b381$exports = {};
$5131dddb90b74959$var$$parcel$export($5131dddb90b74959$var$$833abb125114b381$exports, "MonthCalendar", function() {
    return $5131dddb90b74959$export$d7a7c85c0f5afc4a;
});
var $5131dddb90b74959$var$$833abb125114b381$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $5131dddb90b74959$var$$833abb125114b381$var$__setFunctionName = function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $5131dddb90b74959$export$d7a7c85c0f5afc4a = (()=>{
    var _MonthCalendar_variant_accessor_storage, _MonthCalendar_locale_accessor_storage, _MonthCalendar_value_accessor_storage, _MonthCalendar_currentDate_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'month-calendar'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _variant_decorators;
    let _variant_initializers = [];
    let _variant_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _get_weekFormatter_decorators;
    let _currentDate_decorators;
    let _currentDate_initializers = [];
    let _currentDate_extraInitializers = [];
    let _get_dateGrid_decorators;
    var MonthCalendar = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _MonthCalendar_variant_accessor_storage.set(this, ($5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _instanceExtraInitializers), $5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _variant_initializers, 'primary')));
            _MonthCalendar_locale_accessor_storage.set(this, ($5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _variant_extraInitializers), $5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _locale_initializers, void 0)));
            _MonthCalendar_value_accessor_storage.set(this, ($5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _locale_extraInitializers), $5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _value_initializers, [])));
            _MonthCalendar_currentDate_accessor_storage.set(this, ($5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _value_extraInitializers), $5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _currentDate_initializers, new Date())));
            Object.defineProperty(this, "renderDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(this, _currentDate_extraInitializers), (date)=>{
                    const { value: value } = this, dateText = (0, $8uN2z.formatDate)(date, 'YYYY-MM-DD');
                    const list = value === null || value === void 0 ? void 0 : value.filter(({ date: date })=>(0, $8uN2z.formatDate)(date, 'YYYY-MM-DD') === dateText);
                    return (0, $bd1ed0d24b354858$exports.jsxs)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))({
                            'opacity-50': date.getMonth() !== this.currentDate.getMonth(),
                            'fw-bold': dateText === (0, $8uN2z.formatDate)(new Date(), 'YYYY-MM-DD')
                        }),
                        children: [
                            (0, $bd1ed0d24b354858$exports.jsx)("time", {
                                className: "d-block",
                                dateTime: date.toJSON(),
                                children: date.getDate()
                            }),
                            list === null || list === void 0 ? void 0 : list.map((item)=>typeof item.content === 'object' ? item.content : (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$37acb3580601e69a, {
                                    className: "d-inline-block text-decoration-none w-100 text-truncate",
                                    href: item.link,
                                    onClick: ()=>this.emit('select', item),
                                    children: item.content
                                }))
                        ]
                    }, date + '');
                })
            });
        }
        get variant() {
            return $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_variant_accessor_storage, "f");
        }
        set variant(value) {
            $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_variant_accessor_storage, value, "f");
        }
        get locale() {
            return $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_locale_accessor_storage, "f");
        }
        set locale(value) {
            $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_locale_accessor_storage, value, "f");
        }
        get value() {
            return $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_value_accessor_storage, "f");
        }
        set value(value) {
            $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_value_accessor_storage, value, "f");
        }
        get weekFormatter() {
            var _a;
            const { locale: locale = (_a = globalThis.navigator) === null || _a === void 0 ? void 0 : _a.language } = this;
            return new Intl.DateTimeFormat(locale, {
                weekday: 'long'
            });
        }
        get currentDate() {
            return $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldGet(this, _MonthCalendar_currentDate_accessor_storage, "f");
        }
        set currentDate(value) {
            $5131dddb90b74959$var$$833abb125114b381$var$__classPrivateFieldSet(this, _MonthCalendar_currentDate_accessor_storage, value, "f");
        }
        get dateGrid() {
            let startDate = new Date(this.currentDate);
            startDate.setDate(1);
            startDate = new Date(+startDate - startDate.getDay() * (0, $8uN2z.Day));
            const dateList = Array.from(new Array(42), (_, index)=>new Date(+startDate + index * (0, $8uN2z.Day)));
            return (0, $8uN2z.splitArray)(dateList, 7);
        }
        changeMonth(delta) {
            this.currentDate = (0, $8uN2z.changeMonth)(this.currentDate, delta);
            this.emit('change', this.currentDate);
        }
        render() {
            const { style: style, variant: variant, weekFormatter: weekFormatter, currentDate: currentDate, dateGrid: dateGrid } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)($5131dddb90b74959$export$54ec01a60f47d33d, {
                style: Object.assign({
                    tableLayout: 'fixed'
                }, style),
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("caption", {
                        children: (0, $bd1ed0d24b354858$exports.jsxs)("div", {
                            className: "d-flex justify-content-between align-items-center",
                            children: [
                                (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$353f5b6fc5456de1, {
                                    variant: variant,
                                    onClick: ()=>this.changeMonth(-1),
                                    children: "<"
                                }),
                                (0, $8uN2z.formatDate)(currentDate, 'YYYY-MM'),
                                (0, $bd1ed0d24b354858$exports.jsx)($5131dddb90b74959$export$353f5b6fc5456de1, {
                                    variant: variant,
                                    onClick: ()=>this.changeMonth(1),
                                    children: ">"
                                })
                            ]
                        })
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("thead", {
                        children: (0, $bd1ed0d24b354858$exports.jsx)("tr", {
                            children: dateGrid[0].map((date, index, { length: length })=>(0, $bd1ed0d24b354858$exports.jsx)("td", {
                                    className: `bg-${variant} text-white`,
                                    style: {
                                        width: `calc(100% / ${length})`
                                    },
                                    children: weekFormatter.format(date)
                                }, index))
                        })
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("tbody", {
                        children: dateGrid.map((days)=>(0, $bd1ed0d24b354858$exports.jsx)("tr", {
                                children: days.map(this.renderDate)
                            }, days[0] + ''))
                    })
                ]
            });
        }
    };
    _MonthCalendar_variant_accessor_storage = new WeakMap();
    _MonthCalendar_locale_accessor_storage = new WeakMap();
    _MonthCalendar_value_accessor_storage = new WeakMap();
    _MonthCalendar_currentDate_accessor_storage = new WeakMap();
    $5131dddb90b74959$var$$833abb125114b381$var$__setFunctionName(_classThis, "MonthCalendar");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _variant_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _locale_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _value_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_weekFormatter_decorators = [
            (0, $d5I5D.computed)
        ];
        _currentDate_decorators = [
            (0, $d5I5D.observable)
        ];
        _get_dateGrid_decorators = [
            (0, $d5I5D.computed)
        ];
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(_classThis, null, _variant_decorators, {
            kind: "accessor",
            name: "variant",
            static: false,
            private: false,
            access: {
                has: (obj)=>"variant" in obj,
                get: (obj)=>obj.variant,
                set: (obj, value)=>{
                    obj.variant = value;
                }
            },
            metadata: _metadata
        }, _variant_initializers, _variant_extraInitializers);
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(_classThis, null, _locale_decorators, {
            kind: "accessor",
            name: "locale",
            static: false,
            private: false,
            access: {
                has: (obj)=>"locale" in obj,
                get: (obj)=>obj.locale,
                set: (obj, value)=>{
                    obj.locale = value;
                }
            },
            metadata: _metadata
        }, _locale_initializers, _locale_extraInitializers);
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(_classThis, null, _value_decorators, {
            kind: "accessor",
            name: "value",
            static: false,
            private: false,
            access: {
                has: (obj)=>"value" in obj,
                get: (obj)=>obj.value,
                set: (obj, value)=>{
                    obj.value = value;
                }
            },
            metadata: _metadata
        }, _value_initializers, _value_extraInitializers);
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(_classThis, null, _get_weekFormatter_decorators, {
            kind: "getter",
            name: "weekFormatter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"weekFormatter" in obj,
                get: (obj)=>obj.weekFormatter
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(_classThis, null, _currentDate_decorators, {
            kind: "accessor",
            name: "currentDate",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentDate" in obj,
                get: (obj)=>obj.currentDate,
                set: (obj, value)=>{
                    obj.currentDate = value;
                }
            },
            metadata: _metadata
        }, _currentDate_initializers, _currentDate_extraInitializers);
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(_classThis, null, _get_dateGrid_decorators, {
            kind: "getter",
            name: "dateGrid",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dateGrid" in obj,
                get: (obj)=>obj.dateGrid
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $5131dddb90b74959$var$$833abb125114b381$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        MonthCalendar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $5131dddb90b74959$var$$833abb125114b381$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return MonthCalendar = _classThis;
})();


const $f90ba625f4432b98$export$8633c74c7e537f1f = [
    {
        title: "\u6807\u51C6\u63D0\u6848",
        href: 'proposals'
    },
    {
        title: "\u4E2D\u6587\u8BA8\u8BBA",
        target: '_blank',
        href: 'https://github.com/orgs/JSCIG/discussions'
    },
    {
        title: "\u5F00\u653E\u7EC4\u7EC7",
        target: '_blank',
        href: 'https://github.com/JSCIG'
    },
    {
        title: "\u6B63\u5F0F\u6807\u51C6",
        menu: [
            {
                title: "ECMAScript \u8BED\u8A00",
                target: '_blank',
                href: 'https://tc39.es/ecma262/'
            },
            {
                title: "ECMAScript \u56FD\u9645\u5316 API",
                target: '_blank',
                href: 'https://tc39.es/ecma402/'
            },
            {
                title: "JSON \u6570\u636E\u4EA4\u6362\u8BED\u6CD5",
                target: '_blank',
                href: 'https://ecma-international.org/publications-and-standards/standards/ecma-404/'
            },
            {
                title: "ECMAScript \u89C4\u8303\u5957\u4EF6",
                target: '_blank',
                href: 'https://ecma-international.org/publications-and-standards/standards/ecma-414/'
            }
        ]
    },
    {
        title: "\u517C\u5BB9\u8868\u683C",
        target: '_blank',
        href: 'https://compat-table.github.io/compat-table/es6/'
    },
    {
        title: "ES 6 \u5B66\u4E60",
        target: '_blank',
        href: 'https://rse.github.io/es6-features/'
    },
    {
        title: "\u6280\u672F\u59D4\u5458\u4F1A",
        target: '_blank',
        href: 'https://tc39.es/'
    },
    {
        title: "\u6807\u51C6\u8865\u4E01",
        menu: [
            {
                title: "\u5BA2\u6237\u7AEF\u81EA\u52A8\u52A0\u8F7D",
                target: '_blank',
                href: 'https://polyfill.web-cell.dev/'
            },
            {
                title: "\u670D\u52A1\u7AEF\u81EA\u52A8\u52A0\u8F7D",
                target: '_blank',
                href: 'https://polyfiller.kaiyuanshe.cn/'
            }
        ]
    }
];





var $abbf8297987106c6$exports = {};
$abbf8297987106c6$exports = JSON.parse('[{"name":"\u4E09\u516D\u96F6\u79D1\u6280\u96C6\u56E2\u6709\u9650\u516C\u53F8","logo":"https://p3.ssl.qhimg.com/t011e94f0b9ed8e66b0.png","link":"https://www.360.cn/","membership":"Associate","startDate":"2019-06","gaRep":"\u674E\u667A\u6770","gaAlt":"\u738B\u5148\u5764"},{"name":"\u963F\u91CC\u5DF4\u5DF4\uFF08\u4E2D\u56FD\uFF09\u6709\u9650\u516C\u53F8","logo":"https://www.ecma-international.org/wp-content/uploads/Alibaba-logo.gif","link":"https://www.alibabagroup.com/","membership":"Associate","startDate":"2019-12","gaRep":"\u90D1\u53F6\u98DE"},{"name":"\u817E\u8BAF","logo":"https://www.tencent.com/img/index/tencent_logo.png","link":"https://www.tencent.com/","membership":"Associate","startDate":"2020-06","gaRep":"\u90D1\u82CF\u6CE2"},{"name":"\u534E\u4E3A\u6280\u672F\u6709\u9650\u516C\u53F8","logo":"https://www-file.huawei.com/-/media/corporate/images/home/logo/huawei_logo.png","link":"https://www.huawei.com/","membership":"Associate","startDate":"2019-12","gaRep":"\u4FAF\u51E1","gaAlt":"\u738B\u4E9A\u4E3E"},{"name":"Sujitech","logo":"https://www.ecma-international.org/wp-content/uploads/Sujitech-logo.gif","link":"https://sujitech.com/","membership":"SPC","startDate":"2019-12","gaRep":"\u5218\u603F\u65AF"},{"name":"\u5317\u4EAC\u5B57\u8282\u8DF3\u52A8\u7F51\u7EDC\u6280\u672F\u6709\u9650\u516C\u53F8","logo":"https://www.ecma-international.org/wp-content/uploads/beijing_bytedance-logo.gif","link":"https://www.bytedance.com/","membership":"Associate","startDate":"2021-06","gaRep":"\u5F20\u8363\u5251"}]');



var $d5I5D = parcelRequire("d5I5D");

var $d5I5D = parcelRequire("d5I5D");

var $8uN2z = parcelRequire("8uN2z");
var $74e11e61151bc2f5$exports = {};

$parcel$export($74e11e61151bc2f5$exports, "promisifyRequest", () => $74e11e61151bc2f5$export$b327150396135fe7);
$parcel$export($74e11e61151bc2f5$exports, "createStore", () => $74e11e61151bc2f5$export$f51a9068ac82ea43);
$parcel$export($74e11e61151bc2f5$exports, "get", () => $74e11e61151bc2f5$export$3988ae62b71be9a3);
$parcel$export($74e11e61151bc2f5$exports, "set", () => $74e11e61151bc2f5$export$adaa4cf7ef1b65be);
$parcel$export($74e11e61151bc2f5$exports, "setMany", () => $74e11e61151bc2f5$export$daa0a5170277c7a8);
$parcel$export($74e11e61151bc2f5$exports, "getMany", () => $74e11e61151bc2f5$export$5df405cccea42673);
$parcel$export($74e11e61151bc2f5$exports, "update", () => $74e11e61151bc2f5$export$722fbec263ad908a);
$parcel$export($74e11e61151bc2f5$exports, "del", () => $74e11e61151bc2f5$export$1d2f21e549771e67);
$parcel$export($74e11e61151bc2f5$exports, "delMany", () => $74e11e61151bc2f5$export$c8aa84257229cac8);
$parcel$export($74e11e61151bc2f5$exports, "clear", () => $74e11e61151bc2f5$export$42ffd38884aecdac);
$parcel$export($74e11e61151bc2f5$exports, "keys", () => $74e11e61151bc2f5$export$ed97f33186d4b816);
$parcel$export($74e11e61151bc2f5$exports, "values", () => $74e11e61151bc2f5$export$68c286be0e7e55b7);
$parcel$export($74e11e61151bc2f5$exports, "entries", () => $74e11e61151bc2f5$export$3e9f948b41964866);
function $74e11e61151bc2f5$var$_slicedToArray(r, e) {
    return $74e11e61151bc2f5$var$_arrayWithHoles(r) || $74e11e61151bc2f5$var$_iterableToArrayLimit(r, e) || $74e11e61151bc2f5$var$_unsupportedIterableToArray(r, e) || $74e11e61151bc2f5$var$_nonIterableRest();
}
function $74e11e61151bc2f5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $74e11e61151bc2f5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $74e11e61151bc2f5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $74e11e61151bc2f5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $74e11e61151bc2f5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $74e11e61151bc2f5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $74e11e61151bc2f5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $74e11e61151bc2f5$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $74e11e61151bc2f5$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp;
    var getDB = function getDB() {
        if (dbp) return dbp;
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        dbp = $74e11e61151bc2f5$export$b327150396135fe7(request);
        dbp.then(function(db) {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = function() {
                return dbp = undefined;
            };
        }, function() {});
        return dbp;
    };
    return function(txMode, callback) {
        return getDB().then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $74e11e61151bc2f5$var$defaultGetStoreFunc;
function $74e11e61151bc2f5$var$defaultGetStore() {
    if (!$74e11e61151bc2f5$var$defaultGetStoreFunc) $74e11e61151bc2f5$var$defaultGetStoreFunc = $74e11e61151bc2f5$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $74e11e61151bc2f5$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $74e11e61151bc2f5$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $74e11e61151bc2f5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $74e11e61151bc2f5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $74e11e61151bc2f5$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($74e11e61151bc2f5$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $74e11e61151bc2f5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $74e11e61151bc2f5$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $74e11e61151bc2f5$export$b327150396135fe7(store.transaction);
    });
}
function $74e11e61151bc2f5$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $74e11e61151bc2f5$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $74e11e61151bc2f5$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $74e11e61151bc2f5$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $74e11e61151bc2f5$export$b327150396135fe7(store.getAll());
        var items = [];
        return $74e11e61151bc2f5$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $74e11e61151bc2f5$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $74e11e61151bc2f5$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $74e11e61151bc2f5$export$b327150396135fe7(store.getAllKeys()),
            $74e11e61151bc2f5$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $74e11e61151bc2f5$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore('readonly', function(store) {
            return $74e11e61151bc2f5$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


function $29590480c608918b$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $29590480c608918b$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $29590480c608918b$var$$082ef78710a13331$exports = {};
var $29590480c608918b$var$$80184bab4212ab17$exports = {};
var $29590480c608918b$var$$400caf514fe4dd82$exports = {};
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $29590480c608918b$export$e03c1c3201ee8bb7;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $29590480c608918b$export$6287f85d0f6a9342;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $29590480c608918b$export$d1e7755b007c0847;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "persist", function() {
    return $29590480c608918b$export$9a6132153fba2e0;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "restore", function() {
    return $29590480c608918b$export$db239ef39aadc7fe;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $29590480c608918b$export$b1fb4cac938035f7;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $29590480c608918b$export$8001d3a0cfa5d8fd;
});
var $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $29590480c608918b$var$$400caf514fe4dd82$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $29590480c608918b$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === 'number' ? --value : false);
                }
            });
        };
}
function $29590480c608918b$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === 'granted') return new Notification(typeof message === 'function' ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
class $29590480c608918b$export$d1e7755b007c0847 {
    constructor(meta){
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    static detectIDB() {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            if (this.readyIDB) return this.readyIDB;
            const { get: get } = yield $74e11e61151bc2f5$exports;
            return this.readyIDB = get('ready');
        });
    }
    save(storeKey, value) {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (value != null) this.value = (0, $d5I5D.toJS)((_b = yield (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)) !== null && _b !== void 0 ? _b : value);
            const { set: set } = yield $74e11e61151bc2f5$exports, data = {
                value: this.value,
                expireAt: this.expireIn + Date.now()
            };
            return set(`${storeKey}-${this.key}`, data);
        });
    }
    load(storeKey) {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const { get: get, del: del } = yield $74e11e61151bc2f5$exports;
            storeKey += `-${this.key}`;
            const { value: value, expireAt: expireAt } = (_a = yield get(storeKey)) !== null && _a !== void 0 ? _a : {};
            if (expireAt && expireAt < Date.now()) {
                delete this.value;
                return del(storeKey);
            }
            this.value = value;
            return (_c = value != null ? yield (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value) : value) !== null && _c !== void 0 ? _c : value;
        });
    }
    destroy(storeKey) {
        return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            (_a = this.disposer) === null || _a === void 0 || _a.call(this);
            const { del: del } = yield $74e11e61151bc2f5$exports;
            return del(`${storeKey}-${this.key}`);
        });
    }
}
const $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $29590480c608918b$export$9a6132153fba2e0(_a = {}) {
    var { expireIn: expireIn = Infinity } = _a, meta = $29590480c608918b$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $29590480c608918b$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $29590480c608918b$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield $29590480c608918b$export$d1e7755b007c0847.detectIDB();
        } catch (_a) {
            return console.warn('IndexedDB or its polyfill is not found in this runtime engine, MobX-RESTful persistence is disabled.');
        }
        const list = $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
        for (const item of list){
            const { key: key } = item, value = yield item.load(storeKey);
            if (value != null) {
                Reflect.set(classInstance, key, value);
                restoredData[key] = value;
            }
            item.disposer = (0, $d5I5D.reaction)(()=>classInstance[key], (value)=>item.save(storeKey, value));
        }
        if ((0, $8uN2z.isEmpty)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $29590480c608918b$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $29590480c608918b$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const list = $29590480c608918b$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
        for (const node of list)yield node.destroy(storeKey);
    });
}
function $29590480c608918b$export$8001d3a0cfa5d8fd({ storeKey: storeKey, expireIn: expireIn = Infinity } = {}) {
    return (Super, {})=>(()=>{
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            let _classSuper = Super;
            let _pageIndex_decorators;
            let _pageIndex_initializers = [];
            let _pageIndex_extraInitializers = [];
            let _pageSize_decorators;
            let _pageSize_initializers = [];
            let _pageSize_extraInitializers = [];
            let _filter_decorators;
            let _filter_initializers = [];
            let _filter_extraInitializers = [];
            let _totalCount_decorators;
            let _totalCount_initializers = [];
            let _totalCount_extraInitializers = [];
            let _pageList_decorators;
            let _pageList_initializers = [];
            let _pageList_extraInitializers = [];
            return _a = class PersistListModel extends _classSuper {
                constructor(){
                    super(...arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(this, $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(this, ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_extraInitializers), $29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_initializers, [])));
                    Object.defineProperty(this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($29590480c608918b$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_extraInitializers), globalThis.indexedDB && $29590480c608918b$export$db239ef39aadc7fe(this, typeof storeKey === 'function' ? storeKey(this) : storeKey))
                    });
                }
                get pageIndex() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                }
                set pageIndex(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                }
                get pageSize() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                }
                set pageSize(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                }
                get filter() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                }
                set filter(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                }
                get totalCount() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                }
                set totalCount(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                }
                get pageList() {
                    return $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                }
                set pageList(value) {
                    $29590480c608918b$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                }
            }, _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), (()=>{
                var _b;
                const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _pageSize_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _filter_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _totalCount_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                _pageList_decorators = [
                    $29590480c608918b$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $d5I5D.observable)
                ];
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageIndex" in obj,
                        get: (obj)=>obj.pageIndex,
                        set: (obj, value)=>{
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageSize" in obj,
                        get: (obj)=>obj.pageSize,
                        set: (obj, value)=>{
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"filter" in obj,
                        get: (obj)=>obj.filter,
                        set: (obj, value)=>{
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"totalCount" in obj,
                        get: (obj)=>obj.totalCount,
                        set: (obj, value)=>{
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $29590480c608918b$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageList" in obj,
                        get: (obj)=>obj.pageList,
                        set: (obj, value)=>{
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            })(), _a;
        })();
}
$29590480c608918b$var$$parcel$exportWildcard($29590480c608918b$var$$082ef78710a13331$exports, $29590480c608918b$var$$80184bab4212ab17$exports);
$29590480c608918b$var$$parcel$exportWildcard($29590480c608918b$var$$082ef78710a13331$exports, $29590480c608918b$var$$400caf514fe4dd82$exports);
var $29590480c608918b$var$$16892940cfb7bd51$exports = {};
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $29590480c608918b$export$d12e20a4eec10acf;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $29590480c608918b$export$673dbc4a8d0cb20a;
});
var $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $29590480c608918b$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $d5I5D.observable)
        ];
        _uploading_decorators = [
            (0, $d5I5D.observable)
        ];
        _clear_decorators = [
            (0, $d5I5D.action)
        ];
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $29590480c608918b$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $29590480c608918b$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $29590480c608918b$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $29590480c608918b$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $29590480c608918b$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $d5I5D.observable)
        ];
        _clearCurrent_decorators = [
            (0, $d5I5D.action)
        ];
        _updateOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('uploading')
        ];
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $29590480c608918b$var$$5766c49bacaeb5b8$exports = {};
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $29590480c608918b$export$36e5777a1ba4b7c3;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $29590480c608918b$export$a143d493d941bafc;
});
$29590480c608918b$var$$parcel$export($29590480c608918b$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $29590480c608918b$export$6a4eb2e7fc9e8903;
});
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__await = function(v) {
    return this instanceof $29590480c608918b$var$$5766c49bacaeb5b8$var$__await ? (this.v = v, this) : new $29590480c608918b$var$$5766c49bacaeb5b8$var$__await(v);
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $29590480c608918b$var$$5766c49bacaeb5b8$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $29590480c608918b$var$$5766c49bacaeb5b8$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $29590480c608918b$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage, _b;
    let _classSuper = $29590480c608918b$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            Object.defineProperty(this, _b, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers), this.getAllInStream)
            });
        }
        get pageIndex() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $d5I5D.toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $8uN2z.splitArray)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $8uN2z.splitArray)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAllInStream() {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncGenerator(this, arguments, function* getAllInStream_1(filter = this.filter, pageSize = this.pageSize) {
                this.pageIndex = 0;
                while(!this.noMore)yield $29590480c608918b$var$$5766c49bacaeb5b8$var$__await((yield* $29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncDelegator($29590480c608918b$var$$5766c49bacaeb5b8$var$__asyncValues((yield $29590480c608918b$var$$5766c49bacaeb5b8$var$__await(this.getList(filter, undefined, pageSize)))))));
            });
        }
        getAll(filter = this.filter, pageSize = this.pageSize) {
            return Array.fromAsync(this.getAllInStream(filter, pageSize));
        }
        countAll(keys_1) {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $8uN2z.countBy)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), _b = (_pageIndex_decorators = [
        (0, $d5I5D.observable)
    ], _pageSize_decorators = [
        (0, $d5I5D.observable)
    ], _filter_decorators = [
        (0, $d5I5D.observable)
    ], _totalCount_decorators = [
        (0, $d5I5D.observable)
    ], _pageList_decorators = [
        (0, $d5I5D.observable)
    ], _get_currentPage_decorators = [
        (0, $d5I5D.computed)
    ], _get_pageCount_decorators = [
        (0, $d5I5D.computed)
    ], _get_allItems_decorators = [
        (0, $d5I5D.computed)
    ], _get_noMore_decorators = [
        (0, $d5I5D.computed)
    ], _statistic_decorators = [
        (0, $d5I5D.observable)
    ], _clearList_decorators = [
        (0, $d5I5D.action)
    ], _restoreList_decorators = [
        (0, $d5I5D.action)
    ], _turnTo_decorators = [
        (0, $d5I5D.action)
    ], _getList_decorators = [
        $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
    ], Symbol.asyncIterator), (()=>{
        var _c;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_c = _classSuper[Symbol.metadata]) !== null && _c !== void 0 ? _c : null) : void 0;
        _deleteOne_decorators = [
            $29590480c608918b$export$e03c1c3201ee8bb7('uploading')
        ];
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $29590480c608918b$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $d5I5D.action),
                $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
            ];
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $29590480c608918b$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $29590480c608918b$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $29590480c608918b$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $8uN2z.splitArray)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $29590480c608918b$export$e03c1c3201ee8bb7('downloading')
            ];
            $29590480c608918b$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}



var $8uN2z = parcelRequire("8uN2z");
function $31c1ac8f3ecbd352$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $31c1ac8f3ecbd352$var$$eef213ff4197108b$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$eef213ff4197108b$exports, "Stack", function() {
    return $31c1ac8f3ecbd352$export$694e0d28c7ffc90c;
});
const { push: $31c1ac8f3ecbd352$var$$eef213ff4197108b$var$push } = Array.prototype;
class $31c1ac8f3ecbd352$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $31c1ac8f3ecbd352$var$$eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $31c1ac8f3ecbd352$export$4125cfe7e08e2040;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $31c1ac8f3ecbd352$export$aa9d629c530f62a7;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "headerParser", function() {
    return $31c1ac8f3ecbd352$export$b725a69477e4d33f;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseBody", function() {
    return $31c1ac8f3ecbd352$export$3b629cd0ff482602;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $31c1ac8f3ecbd352$export$4f2a8c8c11a6373a;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $31c1ac8f3ecbd352$export$bda27a3e49197b9;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $31c1ac8f3ecbd352$export$ba14d9a5a581e827;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $31c1ac8f3ecbd352$export$b7b86d31099674dc;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$0fe1f1400993ba8a$exports, "request", function() {
    return $31c1ac8f3ecbd352$export$b5fe3f66a567bec0;
});
var $31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $31c1ac8f3ecbd352$export$5e6a03ce7b01784;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "parseDocument", function() {
    return $31c1ac8f3ecbd352$export$b6a9369736b19f4d;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "makeFormData", function() {
    return $31c1ac8f3ecbd352$export$2c28ab2e118e73f1;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "serializeNode", function() {
    return $31c1ac8f3ecbd352$export$a0beee2e55fb5dd1;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "serialize", function() {
    return $31c1ac8f3ecbd352$export$dfdc1655ccc5b9cb;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $31c1ac8f3ecbd352$export$f8162fcba31fa547;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $31c1ac8f3ecbd352$export$cebfdbc318a33abe;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "FileMethod", function() {
    return $31c1ac8f3ecbd352$export$226b21d2db5eaf9f;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "readAs", function() {
    return $31c1ac8f3ecbd352$export$e209cbb66c5b18c;
});
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $31c1ac8f3ecbd352$export$8fb536984ec8b4d7;
});
function $31c1ac8f3ecbd352$export$5e6a03ce7b01784() {
    return globalThis.ProgressEvent ||= class ProgressEvent1 extends Event {
        constructor(type, { lengthComputable: lengthComputable, total: total, loaded: loaded, ...meta } = {}){
            super(type, meta);
            this.lengthComputable = lengthComputable;
            this.total = total;
            this.loaded = loaded;
        }
    };
}
async function $31c1ac8f3ecbd352$export$b6a9369736b19f4d(text, contentType = '') {
    const [type] = contentType?.split(';') || [];
    return new DOMParser().parseFromString(text, type || 'text/html');
}
function $31c1ac8f3ecbd352$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== 'string' && (0, $8uN2z.likeArray)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === 'object') formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $31c1ac8f3ecbd352$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
        data: (0, $8uN2z.stringifyDOM)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: 'multipart/form-data',
        data: new FormData(root)
    };
    const data = (0, $8uN2z.formToJSON)(root);
    switch(contentType = root.enctype){
        case 'text/plain':
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join('\n')
            };
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        default:
            return {
                contentType: 'application/json',
                data: JSON.stringify(data)
            };
    }
}
function $31c1ac8f3ecbd352$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(';') || [];
    switch(type){
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case 'multipart/form-data':
            return {
                data: $31c1ac8f3ecbd352$export$2c28ab2e118e73f1(data)
            };
        case 'application/json':
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case 'text/html':
        case 'application/xml':
        case 'image/svg':
            return {
                contentType: contentType,
                data: (0, $8uN2z.stringifyDOM)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: 'application/x-www-form-urlencoded',
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $31c1ac8f3ecbd352$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $8uN2z.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: 'application/octet-stream',
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: 'application/json',
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error('Unserialized Object needs a specific Content-Type');
}
const $31c1ac8f3ecbd352$export$f8162fcba31fa547 = (target)=>(0, $8uN2z.createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            next({
                loaded: loaded,
                total: total
            });
            if (loaded >= total) complete();
        };
        target.addEventListener('progress', handleProgress);
        target.addEventListener('error', error);
        return ()=>{
            target.removeEventListener('progress', handleProgress);
            target.removeEventListener('error', error);
        };
    });
async function* $31c1ac8f3ecbd352$export$cebfdbc318a33abe(stream, total, eventTarget) {
    var loaded = 0;
    $31c1ac8f3ecbd352$export$5e6a03ce7b01784();
    for await (const chunk of stream){
        yield chunk;
        loaded += chunk.byteLength;
        const event = new ProgressEvent('progress', {
            lengthComputable: isNaN(total),
            loaded: loaded,
            total: total
        });
        eventTarget.dispatchEvent(event);
    }
}
var $31c1ac8f3ecbd352$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
function $31c1ac8f3ecbd352$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    const result = new Promise((resolve, reject)=>{
        reader.onerror = reject;
        reader.onload = ()=>resolve(reader.result);
        reader[$31c1ac8f3ecbd352$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $31c1ac8f3ecbd352$export$f8162fcba31fa547(reader),
        result: result
    };
}
const $31c1ac8f3ecbd352$var$$22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
async function $31c1ac8f3ecbd352$export$8fb536984ec8b4d7(raw) {
    if (raw instanceof Blob) {
        const text = await $31c1ac8f3ecbd352$export$e209cbb66c5b18c(raw, 'dataURL').result;
        return ($31c1ac8f3ecbd352$var$$22de11b45b0eeb97$var$DataURI.exec(text) || '')[4];
    }
    const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+('0x' + p1)));
    return btoa(text);
}
var $31c1ac8f3ecbd352$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
class $31c1ac8f3ecbd352$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message), this.request = request, this.response = response;
    }
}
const $31c1ac8f3ecbd352$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $31c1ac8f3ecbd352$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $31c1ac8f3ecbd352$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $8uN2z.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return $31c1ac8f3ecbd352$export$b6a9369736b19f4d(raw, contentType);
    } catch  {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $31c1ac8f3ecbd352$export$4f2a8c8c11a6373a({ method: method = 'GET', path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest();
    const header = new Headers(headers);
    const bodyPromise = body instanceof globalThis.ReadableStream ? Array.fromAsync(body).then((parts)=>new Blob(parts)) : Promise.resolve(body);
    const abort = ()=>request.abort();
    signal?.addEventListener('abort', abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
            if (readyState !== 4 || !status && !signal?.aborted) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== 'text' ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        const [MIMEType] = header.get('Accept')?.split(',') || [
            rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
        ];
        if (MIMEType) request.overrideMimeType(MIMEType);
        request.open(method, path + '');
        for (const [key, value] of header)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        bodyPromise.then((body)=>request.send(body));
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader('Content-Type') || '';
        if (typeof body === 'string' && !contentType.includes('text')) body = $31c1ac8f3ecbd352$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener('abort', abort));
    return {
        response: response,
        upload: $31c1ac8f3ecbd352$export$f8162fcba31fa547(request.upload),
        download: $31c1ac8f3ecbd352$export$f8162fcba31fa547(request)
    };
}
function $31c1ac8f3ecbd352$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === 'text' ? {
        ...headers,
        Accept: 'text/plain'
    } : responseType === 'json' ? {
        ...headers,
        Accept: 'application/json'
    } : responseType === 'document' ? {
        ...headers,
        Accept: 'text/html, application/xhtml+xml, application/xml'
    } : responseType === 'arraybuffer' || responseType === 'blob' ? {
        ...headers,
        Accept: 'application/octet-stream'
    } : headers;
    const isStream = body instanceof globalThis.ReadableStream;
    var upload;
    if (isStream) {
        const uploadProgress = new EventTarget();
        body = globalThis.ReadableStream['from']($31c1ac8f3ecbd352$export$cebfdbc318a33abe(body, +headers['Content-Length'], uploadProgress));
        upload = $31c1ac8f3ecbd352$export$f8162fcba31fa547(uploadProgress);
    }
    const downloadProgress = new EventTarget();
    const response = fetch(path + '', {
        method: method,
        headers: headers,
        credentials: withCredentials ? 'include' : 'omit',
        body: body,
        signal: signals[0] && AbortSignal.any(signals),
        // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
        duplex: isStream ? 'half' : undefined
    }).then((response)=>$31c1ac8f3ecbd352$export$ba14d9a5a581e827(response, responseType, downloadProgress));
    return {
        response: response,
        upload: upload,
        download: $31c1ac8f3ecbd352$export$f8162fcba31fa547(downloadProgress)
    };
}
async function $31c1ac8f3ecbd352$export$ba14d9a5a581e827({ status: status, statusText: statusText, headers: headers, body: body }, responseType, downloadProgress) {
    const stream = globalThis.ReadableStream['from']($31c1ac8f3ecbd352$export$cebfdbc318a33abe(body, +headers.get('Content-Length'), downloadProgress));
    const contentType = headers.get('Content-Type') || '';
    const header = $31c1ac8f3ecbd352$export$eea2c1c5e1a37e50([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join('\n'));
    const rBody = status === 204 ? undefined : await $31c1ac8f3ecbd352$export$b7b86d31099674dc(stream, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $31c1ac8f3ecbd352$export$b7b86d31099674dc(stream, contentType, responseType) {
    const blob = new Blob(await Array.fromAsync(stream), {
        type: contentType
    });
    if (responseType === 'blob') return blob;
    if (responseType === 'arraybuffer') return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === 'text') return text;
    return $31c1ac8f3ecbd352$export$3b629cd0ff482602(text, contentType);
}
const $31c1ac8f3ecbd352$export$b5fe3f66a567bec0 = typeof globalThis.XMLHttpRequest === 'function' ? $31c1ac8f3ecbd352$export$4f2a8c8c11a6373a : $31c1ac8f3ecbd352$export$bda27a3e49197b9;
var $31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$exports = {};
$31c1ac8f3ecbd352$var$$parcel$export($31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $31c1ac8f3ecbd352$export$45cf759b359d3d24;
});
const { splice: $31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$var$splice } = Array.prototype;
class $31c1ac8f3ecbd352$export$45cf759b359d3d24 extends $31c1ac8f3ecbd352$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = $31c1ac8f3ecbd352$export$b5fe3f66a567bec0, ...options } = {}){
        super(), this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = 'GET', headers: headers = {}, body: body } = request;
            if (method in $31c1ac8f3ecbd352$export$4125cfe7e08e2040 && body && typeof body === 'object') {
                const { contentType: contentType, data: data } = $31c1ac8f3ecbd352$export$dfdc1655ccc5b9cb(body, headers['Content-Type']);
                if (contentType) headers['Content-Type'] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $31c1ac8f3ecbd352$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + '', this.baseURI) + '';
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $31c1ac8f3ecbd352$var$$cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: 'HEAD',
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: 'GET',
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: 'POST',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: 'PUT',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: 'PATCH',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: 'DELETE',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { 'Content-Length': length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { 'Content-Range': range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split('/').pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}


const $1a63fc32ef3e2cb5$export$6ed414b8d8bead88 = new (0, $31c1ac8f3ecbd352$export$45cf759b359d3d24)({
    baseURI: 'https://tc39.es/',
    responseType: 'json'
});


var $7ebb08724585946c$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7ebb08724585946c$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7ebb08724585946c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7ebb08724585946c$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7ebb08724585946c$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7ebb08724585946c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $7ebb08724585946c$export$b327309c2fad1272 = (()=>{
    var _a, _ProposalModel_list_accessor_storage, _ProposalModel_sortKey_accessor_storage, _ProposalModel_finishedList_accessor_storage;
    let _classSuper = (0, $29590480c608918b$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _list_decorators;
    let _list_initializers = [];
    let _list_extraInitializers = [];
    let _sortKey_decorators;
    let _sortKey_initializers = [];
    let _sortKey_extraInitializers = [];
    let _finishedList_decorators;
    let _finishedList_initializers = [];
    let _finishedList_extraInitializers = [];
    let _getList_decorators;
    return _a = class ProposalModel extends _classSuper {
        get list() {
            return $7ebb08724585946c$var$__classPrivateFieldGet(this, _ProposalModel_list_accessor_storage, "f");
        }
        set list(value) {
            $7ebb08724585946c$var$__classPrivateFieldSet(this, _ProposalModel_list_accessor_storage, value, "f");
        }
        get sortKey() {
            return $7ebb08724585946c$var$__classPrivateFieldGet(this, _ProposalModel_sortKey_accessor_storage, "f");
        }
        set sortKey(value) {
            $7ebb08724585946c$var$__classPrivateFieldSet(this, _ProposalModel_sortKey_accessor_storage, value, "f");
        }
        get finishedList() {
            return $7ebb08724585946c$var$__classPrivateFieldGet(this, _ProposalModel_finishedList_accessor_storage, "f");
        }
        set finishedList(value) {
            $7ebb08724585946c$var$__classPrivateFieldSet(this, _ProposalModel_finishedList_accessor_storage, value, "f");
        }
        constructor(){
            super();
            _ProposalModel_list_accessor_storage.set(this, ($7ebb08724585946c$var$__runInitializers(this, _instanceExtraInitializers), $7ebb08724585946c$var$__runInitializers(this, _list_initializers, [])));
            _ProposalModel_sortKey_accessor_storage.set(this, ($7ebb08724585946c$var$__runInitializers(this, _list_extraInitializers), $7ebb08724585946c$var$__runInitializers(this, _sortKey_initializers, void 0)));
            _ProposalModel_finishedList_accessor_storage.set(this, ($7ebb08724585946c$var$__runInitializers(this, _sortKey_extraInitializers), $7ebb08724585946c$var$__runInitializers(this, _finishedList_initializers, [])));
            $7ebb08724585946c$var$__runInitializers(this, _finishedList_extraInitializers);
            (0, $d5I5D.reaction)(()=>this.sortKey, (key)=>this.sortBy(key));
        }
        getList() {
            return $7ebb08724585946c$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield (0, $1a63fc32ef3e2cb5$export$6ed414b8d8bead88).get('dataset/proposals.min.json');
                const [finished, processing] = body.map((_b)=>{
                    var { tags: tags, authors: authors, champions: champions } = _b, rest = $7ebb08724585946c$var$__rest(_b, [
                        "tags",
                        "authors",
                        "champions"
                    ]);
                    return Object.assign({
                        tags: tags,
                        authors: authors,
                        champions: tags.includes('co-champion') ? authors : champions
                    }, rest);
                }).reduce(([finished, processing], proposal)=>{
                    if (proposal.stage === 4) finished.push(proposal);
                    else processing.push(proposal);
                    return [
                        finished,
                        processing
                    ];
                }, [
                    [],
                    []
                ]);
                return this.finishedList = finished, this.list = processing;
            });
        }
        sortBy(key) {
            return this.list = this.list.sort(({ [key]: A = '' }, { [key]: B = '' })=>{
                switch(typeof B){
                    case 'number':
                        return B - A;
                    case 'string':
                        return B.localeCompare(A);
                    default:
                        return key.endsWith('_at') ? +new Date(B) - +new Date(A) : 0;
                }
            });
        }
    }, _ProposalModel_list_accessor_storage = new WeakMap(), _ProposalModel_sortKey_accessor_storage = new WeakMap(), _ProposalModel_finishedList_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _list_decorators = [
            (0, $d5I5D.observable)
        ];
        _sortKey_decorators = [
            (0, $d5I5D.observable)
        ];
        _finishedList_decorators = [
            (0, $d5I5D.observable)
        ];
        _getList_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $7ebb08724585946c$var$__esDecorate(_a, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: (obj)=>"list" in obj,
                get: (obj)=>obj.list,
                set: (obj, value)=>{
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        $7ebb08724585946c$var$__esDecorate(_a, null, _sortKey_decorators, {
            kind: "accessor",
            name: "sortKey",
            static: false,
            private: false,
            access: {
                has: (obj)=>"sortKey" in obj,
                get: (obj)=>obj.sortKey,
                set: (obj, value)=>{
                    obj.sortKey = value;
                }
            },
            metadata: _metadata
        }, _sortKey_initializers, _sortKey_extraInitializers);
        $7ebb08724585946c$var$__esDecorate(_a, null, _finishedList_decorators, {
            kind: "accessor",
            name: "finishedList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"finishedList" in obj,
                get: (obj)=>obj.finishedList,
                set: (obj, value)=>{
                    obj.finishedList = value;
                }
            },
            metadata: _metadata
        }, _finishedList_initializers, _finishedList_extraInitializers);
        $7ebb08724585946c$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();



var $d5I5D = parcelRequire("d5I5D");


var $c9ddf45d648e1b5b$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c9ddf45d648e1b5b$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c9ddf45d648e1b5b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c9ddf45d648e1b5b$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c9ddf45d648e1b5b$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $c9ddf45d648e1b5b$export$616b42f55bc21bf7 = (()=>{
    var _a, _MemberModel_list_accessor_storage;
    let _classSuper = (0, $29590480c608918b$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _list_decorators;
    let _list_initializers = [];
    let _list_extraInitializers = [];
    let _getList_decorators;
    return _a = class MemberModel extends _classSuper {
        get list() {
            return $c9ddf45d648e1b5b$var$__classPrivateFieldGet(this, _MemberModel_list_accessor_storage, "f");
        }
        set list(value) {
            $c9ddf45d648e1b5b$var$__classPrivateFieldSet(this, _MemberModel_list_accessor_storage, value, "f");
        }
        getList() {
            return $c9ddf45d648e1b5b$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield (0, $1a63fc32ef3e2cb5$export$6ed414b8d8bead88).get('https://jscig.github.io/dataset/members-jscig.json');
                return this.list = body;
            });
        }
        constructor(){
            super(...arguments);
            _MemberModel_list_accessor_storage.set(this, ($c9ddf45d648e1b5b$var$__runInitializers(this, _instanceExtraInitializers), $c9ddf45d648e1b5b$var$__runInitializers(this, _list_initializers, [])));
            $c9ddf45d648e1b5b$var$__runInitializers(this, _list_extraInitializers);
        }
    }, _MemberModel_list_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _list_decorators = [
            (0, $d5I5D.observable)
        ];
        _getList_decorators = [
            (0, $29590480c608918b$export$e03c1c3201ee8bb7)('downloading')
        ];
        $c9ddf45d648e1b5b$var$__esDecorate(_a, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: (obj)=>"list" in obj,
                get: (obj)=>obj.list,
                set: (obj, value)=>{
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        $c9ddf45d648e1b5b$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


const $e99f51b37211aa02$export$2ce2edfe63bacbbd = new (0, $7ebb08724585946c$export$b327309c2fad1272)();
const $e99f51b37211aa02$export$6a0d13241802fe80 = new (0, $c9ddf45d648e1b5b$export$616b42f55bc21bf7)();


var $6a994f43dd133eb9$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $6a994f43dd133eb9$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $6a994f43dd133eb9$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
const $6a994f43dd133eb9$var$thisYear = new Date().getFullYear();
let $6a994f43dd133eb9$export$ceaf35c25d4b1fe2 = (()=>{
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'main-page'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    var MainPage = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "renderMember", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ avatar_url: avatar_url, username: username, url: url, name: name, company: company, location: location, bio: bio })=>(0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-3 my-3",
                        children: (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$60332b2344f7fe41), {
                            className: "h-100",
                            children: [
                                (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$96c5f37208f78bd7), {
                                    variant: "top",
                                    src: avatar_url,
                                    loading: "lazy"
                                }),
                                (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$851de33184ecdac4), {
                                    children: [
                                        (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$474db65c3c394e1c), {
                                            children: (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                                className: "text-decoration-none stretched-link",
                                                title: username,
                                                target: "_blank",
                                                href: url,
                                                children: name
                                            })
                                        }),
                                        (0, $bd1ed0d24b354858$exports.jsxs)("dl", {
                                            children: [
                                                (0, $bd1ed0d24b354858$exports.jsx)("dt", {
                                                    children: "\u7EC4\u7EC7"
                                                }),
                                                (0, $bd1ed0d24b354858$exports.jsx)("dd", {
                                                    children: company
                                                }),
                                                (0, $bd1ed0d24b354858$exports.jsx)("dt", {
                                                    children: "\u5730\u533A"
                                                }),
                                                (0, $bd1ed0d24b354858$exports.jsx)("dd", {
                                                    children: location
                                                }),
                                                (0, $bd1ed0d24b354858$exports.jsx)("dt", {
                                                    children: "\u81EA\u8FF0"
                                                }),
                                                (0, $bd1ed0d24b354858$exports.jsx)("dd", {
                                                    children: bio
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, username)
            });
            Object.defineProperty(this, "renderProposal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ link: link, name: name, tags: tags, edition: edition, authors: authors, champions: champions })=>{
                    const standard = tags[0].split('-')[1];
                    return (0, $bd1ed0d24b354858$exports.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-3 my-3",
                        children: (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$60332b2344f7fe41), {
                            className: "h-100",
                            children: [
                                (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$5665775b26e26c5d), {
                                    className: "d-flex justify-content-around",
                                    children: [
                                        (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$37acb3580601e69a), {
                                            bg: "primary",
                                            target: "_blank",
                                            href: `https://tc39.es/ecma${standard}/`,
                                            children: [
                                                "ECMA-",
                                                standard
                                            ]
                                        }),
                                        standard === '262' && edition <= $6a994f43dd133eb9$var$thisYear && (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$37acb3580601e69a), {
                                            bg: "success",
                                            target: "_blank",
                                            href: `https://www.ecma-international.org/ecma-262/${edition - 2009}.0/`,
                                            children: [
                                                "ES ",
                                                edition
                                            ]
                                        })
                                    ]
                                }),
                                (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$851de33184ecdac4), {
                                    children: [
                                        (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$474db65c3c394e1c), {
                                            children: link ? (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                                target: "_blank",
                                                href: link,
                                                children: name
                                            }) : name
                                        }),
                                        (authors || champions) && (0, $bd1ed0d24b354858$exports.jsxs)("dl", {
                                            children: [
                                                authors && (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                                                    children: [
                                                        (0, $bd1ed0d24b354858$exports.jsx)("dt", {
                                                            children: "\u4F5C\u8005"
                                                        }),
                                                        (0, $bd1ed0d24b354858$exports.jsx)("dd", {
                                                            children: authors.join(', ')
                                                        })
                                                    ]
                                                }),
                                                champions && (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                                                    children: [
                                                        (0, $bd1ed0d24b354858$exports.jsx)("dt", {
                                                            children: "\u8D23\u7F16"
                                                        }),
                                                        (0, $bd1ed0d24b354858$exports.jsx)("dd", {
                                                            children: champions.join(', ')
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            });
        }
        connectedCallback() {
            if ((0, $e99f51b37211aa02$export$6a0d13241802fe80).list.length < 1) (0, $e99f51b37211aa02$export$6a0d13241802fe80).getList();
            if ((0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).finishedList.length < 1) (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).getList();
        }
        render() {
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$97aba50a380f875b), {
                        className: "my-5 p-5 text-center",
                        title: (0, $bd1ed0d24b354858$exports.jsxs)("span", {
                            className: "text-nowrap",
                            children: [
                                "JavaScript\u00A0",
                                (0, $bd1ed0d24b354858$exports.jsx)("wbr", {}),
                                "\u4E2D\u6587\u5174\u8DA3\u7EC4"
                            ]
                        }),
                        description: "\u81F4\u529B\u4E8E\u63D0\u4F9B\u4E00\u4E2A\u52A0\u5F3A\u4E2D\u56FD JavaScript \u793E\u533A\u5BF9 JavaScript \u8BED\u8A00\u6807\u51C6\uFF08ECMAScript\uFF09\u5DE5\u4F5C\u7684\u53C2\u4E0E\u7684\u5E73\u53F0",
                        children: [
                            (0, $bd1ed0d24b354858$exports.jsx)("p", {
                                className: "mb-4",
                                children: "JSCIG \u4E3B\u8981\u4FA7\u91CD\u4E8E\u786E\u5B9A\u4E2D\u56FD JavaScript \u5F00\u53D1\u8005\u7684\u9700\u6C42\u3001\u5E2E\u52A9 Ecma \u7684\u4E2D\u56FD\u6210\u5458\u719F\u6089 TC39 \u6807\u51C6\u6D41\u7A0B\u3001\u8BA8\u8BBA\u53EF\u80FD\u63D0\u4EA4\u7ED9 TC39 \u7684\u63D0\u6848\u3001\u6807\u51C6\u7684\u6D4B\u8BD5\u3001\u5B9E\u73B0\u4EE5\u53CA\u548C JavaScript \u76F8\u5173\u7684\u6807\u51C6\u5316\u673A\u4F1A\uFF0C\u540C\u65F6\u534F\u52A9\u4E2D\u56FD JavaScript \u793E\u533A\u5BF9 JavaScript \u8BED\u8A00\u7684\u53D1\u5C55\u8FDB\u884C\u53C2\u4E0E\u548C\u8D21\u732E\u3002"
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$353f5b6fc5456de1), {
                                className: "me-3",
                                size: "lg",
                                variant: "success",
                                href: "#proposals",
                                children: "\u67E5\u9605\u63D0\u6848"
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$353f5b6fc5456de1), {
                                size: "lg",
                                variant: "primary",
                                target: "_blank",
                                href: "https://github.com/JSCIG/es-discuss/discussions",
                                children: "\u53C2\u4E0E\u8BA8\u8BBA"
                            })
                        ]
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("h2", {
                        className: "my-5 text-center",
                        children: "TC39 \u4E2D\u56FD\u4F1A\u5458"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsxs)("section", {
                        className: "row align-items-center",
                        children: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($abbf8297987106c6$exports))).map(({ link: link, logo: logo, name: name })=>(0, $bd1ed0d24b354858$exports.jsx)("a", {
                                    className: "d-flex col-12 col-sm-4 col-md-3 my-3 flex-column justify-content-between align-items-center text-decoration-none",
                                    target: "_blank",
                                    href: link,
                                    children: (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$3e431a229df88919), {
                                        className: "w-100 object-fit-contain",
                                        style: {
                                            height: '5rem'
                                        },
                                        title: name,
                                        src: logo
                                    })
                                })),
                            (0, $bd1ed0d24b354858$exports.jsx)("footer", {
                                className: "col-12 text-center",
                                children: (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$353f5b6fc5456de1), {
                                    size: "sm",
                                    variant: "outline-primary",
                                    href: "#members",
                                    children: "\u67E5\u770B\u8BE6\u60C5"
                                })
                            })
                        ]
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("h2", {
                        className: "my-5 text-center",
                        children: "JSCIG \u6210\u5458"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$d4c790f923031725), {
                        className: "row",
                        cover: (0, $e99f51b37211aa02$export$6a0d13241802fe80).downloading > 0,
                        children: (0, $e99f51b37211aa02$export$6a0d13241802fe80).list.map(this.renderMember)
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("h2", {
                        className: "my-5 text-center",
                        children: "TC39 \u65E2\u6210\u63D0\u6848"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$d4c790f923031725), {
                        className: "row",
                        cover: (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).downloading > 0,
                        children: (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).finishedList.map(this.renderProposal)
                    })
                ]
            });
        }
    };
    $6a994f43dd133eb9$var$__setFunctionName(_classThis, "MainPage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $6a994f43dd133eb9$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        MainPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $6a994f43dd133eb9$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return MainPage = _classThis;
})();





var $d5I5D = parcelRequire("d5I5D");

var $8uN2z = parcelRequire("8uN2z");




var $4b110b7e9d984908$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4b110b7e9d984908$export$79f6f15df797f8df = (_a)=>{
    var { type: type = 'anchor', filter: filter, value: value, children: children } = _a, rest = $4b110b7e9d984908$var$__rest(_a, [
        "type",
        "filter",
        "value",
        "children"
    ]);
    const Link = type === 'anchor' ? 'a' : (0, $5131dddb90b74959$export$37acb3580601e69a);
    return (0, $bd1ed0d24b354858$exports.jsx)(Link, Object.assign({}, rest, {
        href: `#proposals?${filter}=${value}`,
        children: children
    }));
};


var $bb03c911b0bce0d6$export$827f4ee28efc37;
$bb03c911b0bce0d6$export$827f4ee28efc37 = "box_5be125";



var $311ab7667beffda6$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $311ab7667beffda6$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $311ab7667beffda6$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $311ab7667beffda6$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $311ab7667beffda6$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $311ab7667beffda6$var$StageMap = [
    (0, $5131dddb90b74959$export$96e9906d6d93a972).secondary,
    (0, $5131dddb90b74959$export$96e9906d6d93a972).info,
    (0, $5131dddb90b74959$export$96e9906d6d93a972).danger,
    (0, $5131dddb90b74959$export$96e9906d6d93a972).warning,
    (0, $5131dddb90b74959$export$96e9906d6d93a972).primary,
    (0, $5131dddb90b74959$export$96e9906d6d93a972).success
];
let $311ab7667beffda6$export$52f637db65823275 = (()=>{
    var _ProposalPage_stage_accessor_storage, _ProposalPage_author_accessor_storage, _ProposalPage_champion_accessor_storage;
    let _classDecorators = [
        (0, $6f83f77ba8e7af5c$export$d8556a2a8f973135)({
            tagName: 'proposal-page'
        }),
        (0, $6f83f77ba8e7af5c$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _stage_decorators;
    let _stage_initializers = [];
    let _stage_extraInitializers = [];
    let _author_decorators;
    let _author_initializers = [];
    let _author_extraInitializers = [];
    let _champion_decorators;
    let _champion_initializers = [];
    let _champion_extraInitializers = [];
    let _get_data_decorators;
    var ProposalPage = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _ProposalPage_stage_accessor_storage.set(this, ($311ab7667beffda6$var$__runInitializers(this, _instanceExtraInitializers), $311ab7667beffda6$var$__runInitializers(this, _stage_initializers, void 0)));
            _ProposalPage_author_accessor_storage.set(this, ($311ab7667beffda6$var$__runInitializers(this, _stage_extraInitializers), $311ab7667beffda6$var$__runInitializers(this, _author_initializers, void 0)));
            _ProposalPage_champion_accessor_storage.set(this, ($311ab7667beffda6$var$__runInitializers(this, _author_extraInitializers), $311ab7667beffda6$var$__runInitializers(this, _champion_initializers, void 0)));
            Object.defineProperty(this, "renderRow", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($311ab7667beffda6$var$__runInitializers(this, _champion_extraInitializers), ({ stage: stage, url: url, name: name, authors: authors, champions: champions, stargazers_count: stargazers_count, open_issues_count: open_issues_count, tests: tests, notes: notes })=>(0, $bd1ed0d24b354858$exports.jsxs)("tr", {
                        classList: "align-middle",
                        children: [
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: (0, $bd1ed0d24b354858$exports.jsx)((0, $4b110b7e9d984908$export$79f6f15df797f8df), {
                                    className: "stretched-link",
                                    type: "badge",
                                    // @ts-ignore
                                    bg: $311ab7667beffda6$var$StageMap[stage + 1] || 'dark',
                                    path: "proposals",
                                    filter: "stage",
                                    value: stage,
                                    children: stage < 0 ? "\u975E\u6D3B\u8DC3" : `\u{9636}\u{6BB5}${stage}`
                                })
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: url ? (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                    className: "stretched-link",
                                    target: "_blank",
                                    href: url,
                                    children: name
                                }) : name
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: authors && this.renderNames('author', authors)
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: champions && this.renderNames('champion', champions)
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: stargazers_count != null && (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                    className: "stretched-link",
                                    target: "_blank",
                                    href: url + '/stargazers',
                                    children: stargazers_count
                                })
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: open_issues_count != null && (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                    className: "stretched-link",
                                    target: "_blank",
                                    href: url + '/issues',
                                    children: open_issues_count
                                })
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                children: tests && (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                    className: "stretched-link text-success",
                                    target: "_blank",
                                    href: tests,
                                    children: "\u221A"
                                })
                            }),
                            (0, $bd1ed0d24b354858$exports.jsx)("td", {
                                className: "text-nowrap",
                                children: notes && this.renderNotes(notes)
                            })
                        ]
                    }))
            });
        }
        get stage() {
            return $311ab7667beffda6$var$__classPrivateFieldGet(this, _ProposalPage_stage_accessor_storage, "f");
        }
        set stage(value) {
            $311ab7667beffda6$var$__classPrivateFieldSet(this, _ProposalPage_stage_accessor_storage, value, "f");
        }
        get author() {
            return $311ab7667beffda6$var$__classPrivateFieldGet(this, _ProposalPage_author_accessor_storage, "f");
        }
        set author(value) {
            $311ab7667beffda6$var$__classPrivateFieldSet(this, _ProposalPage_author_accessor_storage, value, "f");
        }
        get champion() {
            return $311ab7667beffda6$var$__classPrivateFieldGet(this, _ProposalPage_champion_accessor_storage, "f");
        }
        set champion(value) {
            $311ab7667beffda6$var$__classPrivateFieldSet(this, _ProposalPage_champion_accessor_storage, value, "f");
        }
        get data() {
            const { stage: stage, author: author, champion: champion } = this, { list: list } = (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd);
            return stage != null ? list.filter((item)=>item.stage === stage) : author ? list.filter(({ authors: authors })=>authors === null || authors === void 0 ? void 0 : authors.includes(author)) : champion ? list.filter(({ champions: champions })=>champions === null || champions === void 0 ? void 0 : champions.includes(champion)) : list;
        }
        connectedCallback() {
            if ((0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).list.length < 1) (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).getList();
        }
        renderHead() {
            const { sortKey: sortKey } = (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd);
            return (0, $bd1ed0d24b354858$exports.jsxs)("tr", {
                className: "text-nowrap text-center",
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('user-select-none', sortKey === 'stage' && 'bg-info'),
                        onClick: ()=>(0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).sortKey = 'stage',
                        children: "\u8FDB\u7A0B"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('user-select-none', sortKey === 'name' && 'bg-info'),
                        onClick: ()=>(0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).sortKey = 'name',
                        children: "\u63D0\u6848\u540D\u79F0"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        children: "\u4F5C\u8005\uFF08Author\uFF09"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        children: "\u8D23\u7F16\uFF08Champion\uFF09"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('user-select-none', sortKey === 'stargazers_count' && 'bg-info'),
                        onClick: ()=>(0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).sortKey = 'stargazers_count',
                        title: "\u661F\u6807\u6570",
                        children: "\u2B50"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('user-select-none', sortKey === 'open_issues_count' && 'bg-info'),
                        onClick: ()=>(0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).sortKey = 'open_issues_count',
                        title: "\u5C1A\u5728\u8BA8\u8BBA\u7684\u95EE\u9898\u6570",
                        children: "\uD83D\uDCC3"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        children: "\u6D4B\u8BD5"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)("th", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('user-select-none', sortKey === 'meeting_at' && 'bg-info'),
                        onClick: ()=>(0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).sortKey = 'meeting_at',
                        children: "\u6700\u8FD1\u4F1A\u8BAE\u8BB0\u5F55"
                    })
                ]
            });
        }
        renderNames(filter, list) {
            switch(list.length){
                case 0:
                    return null;
                case 1:
                    return (0, $bd1ed0d24b354858$exports.jsx)((0, $4b110b7e9d984908$export$79f6f15df797f8df), {
                        className: "stretched-link",
                        path: "proposals",
                        filter: filter,
                        value: list[0],
                        children: list[0]
                    });
                default:
                    return (0, $bd1ed0d24b354858$exports.jsx)("ul", {
                        className: "d-inline-block m-0 text-left",
                        children: list.map((author)=>(0, $bd1ed0d24b354858$exports.jsx)("li", {
                                children: (0, $bd1ed0d24b354858$exports.jsx)((0, $4b110b7e9d984908$export$79f6f15df797f8df), {
                                    path: "proposals",
                                    filter: filter,
                                    value: author,
                                    children: author
                                })
                            }, author))
                    });
            }
        }
        renderNotes(notes) {
            return (0, $bd1ed0d24b354858$exports.jsx)("ol", {
                children: notes.map(({ date: date, url: url })=>(0, $bd1ed0d24b354858$exports.jsx)("li", {
                        children: (0, $bd1ed0d24b354858$exports.jsx)("a", {
                            href: url,
                            children: (0, $8uN2z.formatDate)(date, "YYYY\u5E74M\u6708D\u65E5")
                        })
                    }, url))
            });
        }
        render() {
            const { stage: stage, author: author, champion: champion, data: data } = this;
            return (0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("h1", {
                        className: "text-center py-3",
                        children: "ECMAScript \u6807\u51C6\u63D0\u6848"
                    }),
                    (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$d4c790f923031725), {
                        className: $bb03c911b0bce0d6$export$827f4ee28efc37,
                        cover: (0, $e99f51b37211aa02$export$2ce2edfe63bacbbd).downloading > 0,
                        children: [
                            (0, $bd1ed0d24b354858$exports.jsxs)("p", {
                                className: "text-center text-muted",
                                children: [
                                    stage != null ? `\u{5904}\u{4E8E} Stage ${stage} \u{7684}` : null,
                                    author && `${author} \u{63D0}\u{4EA4}\u{7684}`,
                                    champion && `${champion} \u{63A8}\u{52A8}\u{7684}`,
                                    "\u6D3B\u8DC3\u63D0\u6848\u5171\u8BA1",
                                    ' ',
                                    (0, $bd1ed0d24b354858$exports.jsx)("strong", {
                                        children: data.filter(({ stage: stage })=>stage > -1 && stage < 4).length
                                    }),
                                    ' ',
                                    "\u4E2A"
                                ]
                            }),
                            (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$54ec01a60f47d33d), {
                                striped: true,
                                hover: true,
                                responsive: true,
                                children: [
                                    (0, $bd1ed0d24b354858$exports.jsx)("thead", {
                                        children: this.renderHead()
                                    }),
                                    (0, $bd1ed0d24b354858$exports.jsx)("tbody", {
                                        children: data.map(this.renderRow)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    };
    _ProposalPage_stage_accessor_storage = new WeakMap();
    _ProposalPage_author_accessor_storage = new WeakMap();
    _ProposalPage_champion_accessor_storage = new WeakMap();
    $311ab7667beffda6$var$__setFunctionName(_classThis, "ProposalPage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _stage_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _author_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _champion_decorators = [
            (0, $6f83f77ba8e7af5c$export$af4b9a83f4b00434),
            (0, $d5I5D.observable)
        ];
        _get_data_decorators = [
            (0, $d5I5D.computed)
        ];
        $311ab7667beffda6$var$__esDecorate(_classThis, null, _stage_decorators, {
            kind: "accessor",
            name: "stage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"stage" in obj,
                get: (obj)=>obj.stage,
                set: (obj, value)=>{
                    obj.stage = value;
                }
            },
            metadata: _metadata
        }, _stage_initializers, _stage_extraInitializers);
        $311ab7667beffda6$var$__esDecorate(_classThis, null, _author_decorators, {
            kind: "accessor",
            name: "author",
            static: false,
            private: false,
            access: {
                has: (obj)=>"author" in obj,
                get: (obj)=>obj.author,
                set: (obj, value)=>{
                    obj.author = value;
                }
            },
            metadata: _metadata
        }, _author_initializers, _author_extraInitializers);
        $311ab7667beffda6$var$__esDecorate(_classThis, null, _champion_decorators, {
            kind: "accessor",
            name: "champion",
            static: false,
            private: false,
            access: {
                has: (obj)=>"champion" in obj,
                get: (obj)=>obj.champion,
                set: (obj, value)=>{
                    obj.champion = value;
                }
            },
            metadata: _metadata
        }, _champion_initializers, _champion_extraInitializers);
        $311ab7667beffda6$var$__esDecorate(_classThis, null, _get_data_decorators, {
            kind: "getter",
            name: "data",
            static: false,
            private: false,
            access: {
                has: (obj)=>"data" in obj,
                get: (obj)=>obj.data
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $311ab7667beffda6$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        ProposalPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $311ab7667beffda6$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return ProposalPage = _classThis;
})();





var $8uN2z = parcelRequire("8uN2z");

const $fcce238f03d1127d$export$e374fd2af62ac96a = (props)=>(0, $bd1ed0d24b354858$exports.jsxs)("main", Object.assign({}, props, {
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)("h1", {
                className: "my-5 text-center",
                children: "Ecma\u56FD\u9645 \u4E2D\u56FD\u4F1A\u5458\u5355\u4F4D"
            }),
            (0, $bd1ed0d24b354858$exports.jsx)("ul", {
                className: "list-unstyled row g-3",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($abbf8297987106c6$exports))).map(({ logo: logo, link: link, name: name, gaRep: gaRep, gaAlt: gaAlt, membership: membership, startDate: startDate })=>(0, $bd1ed0d24b354858$exports.jsx)("li", {
                        className: "col-12 col-sm-6 col-md-3 d-flex",
                        children: (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$60332b2344f7fe41), {
                            className: "shadow-sm flex-fill w-100",
                            children: [
                                (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$96c5f37208f78bd7), {
                                    className: "object-fit-contain",
                                    fluid: true,
                                    style: {
                                        height: '5rem',
                                        padding: '0.5rem'
                                    },
                                    src: logo
                                }),
                                (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$851de33184ecdac4), {
                                    children: (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$474db65c3c394e1c), {
                                        children: (0, $bd1ed0d24b354858$exports.jsx)("a", {
                                            className: "text-decoration-none stretched-link",
                                            target: "_blank",
                                            href: link,
                                            children: name
                                        })
                                    })
                                }),
                                (0, $bd1ed0d24b354858$exports.jsxs)((0, $5131dddb90b74959$export$e9897d434e0741ee), {
                                    className: "small",
                                    children: [
                                        (0, $bd1ed0d24b354858$exports.jsxs)("div", {
                                            children: [
                                                "\u81EA",
                                                (0, $8uN2z.formatDate)(startDate, "YYYY\u5E74M\u6708"),
                                                "\u6210\u4E3A",
                                                membership,
                                                "\u4F1A\u5458"
                                            ]
                                        }),
                                        (0, $bd1ed0d24b354858$exports.jsxs)("div", {
                                            children: [
                                                "\u4F1A\u5458\u5927\u4F1A\u4EE3\u8868\uFF1A",
                                                gaRep,
                                                gaAlt && `\u{3001}${gaAlt}`
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }, name))
            })
        ]
    }));


const { Router: $78f15da238736fd2$var$Router, Route: $78f15da238736fd2$var$Route } = (0, $bc1cb4598b74b610$export$baddd0131ee8c05b)();
const $78f15da238736fd2$export$953c2efc134d7f79 = ()=>(0, $bd1ed0d24b354858$exports.jsxs)((0, $bd1ed0d24b354858$exports.Fragment), {
        children: [
            (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$d31319d8cbfdaf50), {
                sticky: "top",
                expand: "md",
                variant: "dark",
                brand: (0, $bd1ed0d24b354858$exports.jsxs)("a", {
                    className: "text-light text-decoration-none",
                    href: "#",
                    children: [
                        (0, $bd1ed0d24b354858$exports.jsx)("img", {
                            alt: "JavaScript \u4E2D\u6587\u5174\u8DA3\u7EC4",
                            src: "https://github.com/JSCIG.png",
                            style: {
                                width: '2rem',
                                marginRight: '0.5rem'
                            }
                        }),
                        "JavaScript \u4E2D\u6587\u5174\u8DA3\u7EC4"
                    ]
                }),
                children: (0, $f90ba625f4432b98$export$8633c74c7e537f1f).map(({ title: title, menu: menu, target: target, href: href })=>!menu ? (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$b0d92dbee9b5b60d), {
                        className: "m-3 my-md-0 mx-md-3",
                        target: target,
                        href: (href === null || href === void 0 ? void 0 : href.startsWith('http')) ? href : `#${href}`,
                        children: title
                    }, href) : (0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$461cb598b7fcff7b), {
                        className: "mx-3",
                        title: title,
                        children: menu.map(({ target: target, href: href, title: title })=>(0, $bd1ed0d24b354858$exports.jsx)((0, $5131dddb90b74959$export$6648d5fa18559e7f), {
                                target: target,
                                href: href,
                                children: title
                            }))
                    }, title))
            }),
            (0, $bd1ed0d24b354858$exports.jsxs)($78f15da238736fd2$var$Router, {
                className: "container",
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)($78f15da238736fd2$var$Route, {
                        path: "",
                        component: (0, $6a994f43dd133eb9$export$ceaf35c25d4b1fe2)
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)($78f15da238736fd2$var$Route, {
                        path: "proposals",
                        component: (0, $311ab7667beffda6$export$52f637db65823275)
                    }),
                    (0, $bd1ed0d24b354858$exports.jsx)($78f15da238736fd2$var$Route, {
                        path: "members",
                        component: (0, $fcce238f03d1127d$export$e374fd2af62ac96a)
                    })
                ]
            }),
            (0, $bd1ed0d24b354858$exports.jsxs)("footer", {
                className: "text-center bg-light py-5",
                children: [
                    (0, $bd1ed0d24b354858$exports.jsx)("img", {
                        style: {
                            width: '2rem',
                            margin: '0 0.25rem'
                        },
                        alt: "WebCell logo",
                        src: "https://github.com/EasyWebApp.png"
                    }),
                    "\u81EA\u8C6A\u5730\u7528",
                    (0, $bd1ed0d24b354858$exports.jsx)("a", {
                        className: "mx-1",
                        target: "_blank",
                        href: "https://web-cell.dev/",
                        children: "WebCell v3"
                    }),
                    "\u548C",
                    (0, $bd1ed0d24b354858$exports.jsx)("a", {
                        className: "mx-1",
                        target: "_blank",
                        href: "https://web-cell.dev/BootCell/",
                        children: "BootCell v2"
                    }),
                    "\u5F00\u53D1"
                ]
            })
        ]
    });


(0, $5ec47347fc6130b4$export$dfb5619354ba860)();
(0, $d5I5D.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', (event)=>{
    const { message: message } = event.reason;
    if (!message) return;
    event.preventDefault();
    self.alert(message);
});
const { serviceWorker: $f64ad2349eb3c2ef$var$serviceWorker } = window.navigator;
$f64ad2349eb3c2ef$var$serviceWorker === null || $f64ad2349eb3c2ef$var$serviceWorker === void 0 || $f64ad2349eb3c2ef$var$serviceWorker.register('sw.js').then((0, $8uN2z.serviceWorkerUpdate)).then((worker)=>{
    if (window.confirm("\u68C0\u6D4B\u5230\u65B0\u7248\u672C\uFF0C\u662F\u5426\u7ACB\u5373\u542F\u7528\uFF1F")) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$f64ad2349eb3c2ef$var$serviceWorker === null || $f64ad2349eb3c2ef$var$serviceWorker === void 0 || $f64ad2349eb3c2ef$var$serviceWorker.addEventListener('controllerchange', ()=>window.location.reload());
(0, $8uN2z.documentReady).then(()=>new (0, $c6ef78eb3a1442f8$exports.DOMRenderer)().render((0, $bd1ed0d24b354858$exports.jsx)((0, $78f15da238736fd2$export$953c2efc134d7f79), {})));


//# sourceMappingURL=source.2f1b2dce.js.map
